import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  AJVSchema: { input: any; output: any; }
  ConfigValueArray: { input: any; output: any; }
  ConfigValueObject: { input: any; output: any; }
  DocumentVariablesInput: { input: any; output: any; }
  /** Custom scalar type for dynamic report data containing headers and rows */
  DynamicReportData: { input: any; output: any; }
  /** Can be a string, number, or boolean */
  FieldValue: { input: any; output: any; }
  HistoryVars: { input: any; output: any; }
  JobChangeEventData: { input: any; output: any; }
  /** Object of keys to denote additional information about an object eg. {testMeta: "test"} */
  Metadata: { input: any; output: any; }
  NotificationDataInput: { input: any; output: any; }
  ReportAggregationOptions: { input: any; output: any; }
  ReportAggregationValue: { input: any; output: any; }
  ReportTypeColumnUnion: { input: any; output: any; }
  RuleConditions: { input: any; output: any; }
  SearchMetadata: { input: any; output: any; }
  /** Object of keys to denote additional information about an object eg. {text: "text"} */
  Summary: { input: any; output: any; }
  Template: { input: any; output: any; }
  V1Dashboard: { input: any; output: any; }
  ValidationSchemaProperties: { input: any; output: any; }
};

export enum Access_Type {
  Any = 'any',
  Commenter = 'commenter',
  Editor = 'editor',
  Manager = 'manager',
  Owner = 'owner',
  Viewer = 'viewer'
}

export type ApiTemplateOutput = {
  __typename?: 'APITemplateOutput';
  download_url: Scalars['String']['output'];
  html_url: Scalars['String']['output'];
  status: Scalars['String']['output'];
  template_id: Scalars['String']['output'];
  transaction_ref: Scalars['String']['output'];
};

export type Access = {
  __typename?: 'Access';
  /** The type of access being granted to the user. Values: "owner", "manager", "editor", "commenter", "viewer" */
  accessType: Access_Type;
  createdAt: Scalars['Int']['output'];
  expiresAt?: Maybe<Scalars['Int']['output']>;
  /** The user that granted the access if applicable */
  grantedBy?: Maybe<User>;
  id: Scalars['String']['output'];
  objectId: Scalars['String']['output'];
  /** The object's label on the database. e.g. "Location" */
  objectLabel: Scalars['String']['output'];
  revokedAt?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type AccessFilter = {
  accessType?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  expiresAfter?: InputMaybe<Scalars['Int']['input']>;
  expiresBefore?: InputMaybe<Scalars['Int']['input']>;
  grantedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  objectLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  showRevoked?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAfter?: InputMaybe<Scalars['Int']['input']>;
  updatedBefore?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type AccessPagination = {
  __typename?: 'AccessPagination';
  accesses?: Maybe<Array<Maybe<Access>>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AddAreaCodesInput = {
  areaCodes: Array<Scalars['String']['input']>;
  country: Scalars['String']['input'];
};

export type AddAttendeeInput = {
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AddAttendeesInput = {
  role?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type AddChargeDiscount = {
  customAmount?: InputMaybe<Scalars['Int']['input']>;
  discountId: Scalars['String']['input'];
};

export type AddCommentInput = {
  addArtifacts?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * A delta representation of the comment (see quill js)
   * in JSON format
   *
   * Includes formatting information but may be difficult
   * to utilize. This is optional and may not be set.
   *
   * If that is the case, use "text" above
   */
  contents?: InputMaybe<Scalars['String']['input']>;
  /**
   * You can specify the ID of the comment for tracking purposes
   * Must be a system unique UUIDv1/v4
   */
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  /** If creating a new thread set the threads mode */
  mode?: InputMaybe<Scalars['String']['input']>;
  objectId: Scalars['String']['input'];
  /** Name of the object type eg. 'appointment' or 'location'. Used to load the object. */
  objectType: Scalars['String']['input'];
  /** Must be on of the Following 'owner', 'manager', 'editor', 'commenter', 'viewer' */
  requiredAccessLevel?: InputMaybe<Access_Type>;
  subject?: InputMaybe<Scalars['String']['input']>;
  /**
   * A plaintext representation of the comment.
   *
   * For formatting, use "delta"
   */
  text: Scalars['String']['input'];
  /**
   * Add this comment to an existing thread or specify a new
   * thread to create
   */
  threadId?: InputMaybe<Scalars['String']['input']>;
  threadMetadata?: InputMaybe<Scalars['Metadata']['input']>;
};

export type AddFormComponentsOutput = {
  __typename?: 'AddFormComponentsOutput';
  componentsAdded?: Maybe<Scalars['Int']['output']>;
  fields?: Maybe<Array<Maybe<FormField>>>;
  sectionFieldsAdded?: Maybe<Scalars['Int']['output']>;
  sections?: Maybe<Array<Maybe<FormType>>>;
};

export type AddJobDiscount = {
  /**
   * The custom amount to be applied with the discount, if any. Represents either a percentage or a flat
   * amount, depending on the discount.
   */
  customAmount?: InputMaybe<Scalars['Int']['input']>;
  discountId: Scalars['String']['input'];
  /** Denotes what specific event the discount will apply to */
  eventId: Scalars['String']['input'];
};

export type AddLocationToJobInput = {
  locationId: Scalars['String']['input'];
  locationType: Scalars['String']['input'];
};

export type AddOverrideInput = {
  /** Dates this template should override, Format as 'YYYY-MM-DD' */
  dates: Array<InputMaybe<Scalars['String']['input']>>;
  templateId: Scalars['String']['input'];
};

export type AddQuillTemplateInput = {
  /**
   * A delta representation of the template (see quill js)
   * in JSON format
   *
   * Includes template variables
   */
  contents: Scalars['String']['input'];
  /** Indicates if this template is the default for its location */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  location: QuillTemplateLocation;
  name: Scalars['String']['input'];
  /** The subject line for email templates. */
  subjectContents?: InputMaybe<Scalars['String']['input']>;
};

export type AddQuillTemplateOutput = {
  __typename?: 'AddQuillTemplateOutput';
  template: QuillTemplate;
};

export type AddSectionFieldsOutput = {
  __typename?: 'AddSectionFieldsOutput';
  fields?: Maybe<Array<Maybe<FormField>>>;
  fieldsAdded?: Maybe<Scalars['Int']['output']>;
};

export type AddTemplateInput = {
  /** Override Value on Template: Format as 'YYYY-MM-DD', leave undefined to make it indefinite  */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /** Override Value on Template: Format as 'YYYY-MM-DD'  */
  startDate?: InputMaybe<Scalars['String']['input']>;
  templateId: Scalars['String']['input'];
};

export type AddTopicInput = {
  topicDetails?: InputMaybe<Scalars['String']['input']>;
  topicId: Scalars['String']['input'];
};

export type AddTopicsInput = {
  topicDetails?: InputMaybe<Scalars['String']['input']>;
  topicId: Scalars['String']['input'];
};

export type AddUserSkillsInput = {
  addedOn?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  form?: InputMaybe<Scalars['String']['input']>;
  rating?: InputMaybe<Scalars['Int']['input']>;
  skillId: Scalars['String']['input'];
};

export type App_Notice = {
  __typename?: 'App_Notice';
  detail?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  notAfter?: Maybe<Scalars['Int']['output']>;
  severity?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type AppliesTo = {
  __typename?: 'AppliesTo';
  products?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AppliesToInput = {
  products?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Artifact = {
  __typename?: 'Artifact';
  accesses?: Maybe<Array<Maybe<Access>>>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  author?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentPagination>;
  contentType: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  fileSize: Scalars['Float']['output'];
  gcsFileName?: Maybe<Scalars['String']['output']>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  public: Scalars['Boolean']['output'];
  relatedObjects?: Maybe<Array<Maybe<RelatedArtifactObject>>>;
  signedPolicy?: Maybe<Scalars['String']['output']>;
  signedUrl?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};


export type ArtifactAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};


export type ArtifactHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type ArtifactEdit = {
  addRelatedObjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** only allowed when reuploading a file */
  contentType?: InputMaybe<Scalars['String']['input']>;
  /** only allowed when reuploading a file */
  fileSize?: InputMaybe<Scalars['Float']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  removeRelatedObjects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** File size and contentType required if reuploading a file */
  reupload?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ArtifactFilter = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasNoneAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  /**  Used to find artifacts by related objects, highly advised to also use relatedObjectLabels  */
  relatedObjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  RECCOMMEND: Used in conjunction with relatedObjectIds to increase query performancy.  */
  relatedObjectLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedToObjectsOfType?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
  viewPrivateForUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ArtifactInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  author?: InputMaybe<Scalars['String']['input']>;
  contentType: Scalars['String']['input'];
  fileSize: Scalars['Float']['input'];
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  public?: InputMaybe<Scalars['Boolean']['input']>;
  relatedObjectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ArtifactUsageOutput = {
  __typename?: 'ArtifactUsageOutput';
  systemUsageBytes?: Maybe<Scalars['Float']['output']>;
  userUsageBytes?: Maybe<Array<Maybe<UserArtifactUsage>>>;
};

export type Asset = {
  __typename?: 'Asset';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  location?: Maybe<Location>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name: Scalars['String']['output'];
  /** @deprecated Assets no longer have owners. */
  owner?: Maybe<User>;
  tags: Array<Maybe<Tag>>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Int']['output']>;
  zones: Array<Maybe<Zone>>;
};

export type AssetsFilter = {
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  hasAllAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAnyAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  owners?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type AssetsPagination = {
  __typename?: 'AssetsPagination';
  assets: Array<Maybe<Asset>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type AssignCrewWithAiInput = {
  availableMembers: Array<Member>;
  jobs: Array<JobInput>;
};

export type AssignCrewWithAiOutput = {
  __typename?: 'AssignCrewWithAIOutput';
  jobAssignments: Array<JobAssignment>;
  reasoning: Scalars['String']['output'];
};

export type AssignObjectsToZonesOutput = {
  __typename?: 'AssignObjectsToZonesOutput';
  objectsAssigned: Scalars['Int']['output'];
  objectsRemoved: Scalars['Int']['output'];
};

export type AssignRolesOutput = {
  __typename?: 'AssignRolesOutput';
  rolesAssigned: Array<Scalars['String']['output']>;
  rolesRemoved: Array<Scalars['String']['output']>;
  usersAssigned: Array<Scalars['String']['output']>;
  zonesAssigned: Array<Scalars['String']['output']>;
};

export type AssignedMember = {
  __typename?: 'AssignedMember';
  memberId: Scalars['String']['output'];
  reasonForSelection: Scalars['String']['output'];
  role: Scalars['String']['output'];
};

export type Attendee = {
  __typename?: 'Attendee';
  role: Scalars['String']['output'];
  user?: Maybe<User>;
};

export type AttentionConfig = {
  __typename?: 'AttentionConfig';
  action: Scalars['String']['output'];
  attentionExplanation: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  grouping?: Maybe<Scalars['String']['output']>;
  label: Scalars['String']['output'];
  logBase?: Maybe<Scalars['Float']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  score: Scalars['Int']['output'];
  scoringFunction?: Maybe<Scalars['String']['output']>;
  timeUnit?: Maybe<Scalars['String']['output']>;
};

export type AttentionItem = CalendarEvent | Job | User;

export type AttentionItemsFilter = {
  attentionExplanation?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type AttentionItemsSummary = {
  __typename?: 'AttentionItemsSummary';
  attentionExplanation: Scalars['String']['output'];
  items: Scalars['Int']['output'];
};

export type AttentionItemsSummaryFilter = {
  zoneDir?: InputMaybe<ZoneDir>;
};

export type AuthMethod = {
  __typename?: 'AuthMethod';
  authMethodType: AuthMethodType;
  createdAt: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  ethereum_network?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  oidc_name?: Maybe<Scalars['String']['output']>;
  oidc_provider?: Maybe<Scalars['String']['output']>;
  password_minLength?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Int']['output'];
  zone: Scalars['String']['output'];
};

export enum AuthMethodType {
  Apikey = 'apikey',
  Ethereum = 'ethereum',
  Oidc = 'oidc',
  Password = 'password'
}

export type AuthenticateOutput = {
  __typename?: 'AuthenticateOutput';
  /**
   * A fixed string representation of the reason the authentication failed.
   * Will stay the same for the lifetime of this version. A human readable
   * version is available with property invalidReason.
   * Possible codes:
   *  * NO_USER - a user does not exist with this email
   *  * NO_PASSWORD - This user does not have a password, but one was provided
   *  * INCORRECT_PASSWORD - This users email was correct, but the password was not.
   *  * LOCKED_OUT - This user is locked out from authentication for a duration of time
   *  * NO_2FA_TOKEN - Did not provide a code, only triggers if the account needs a code
   *  * INVALID_2FA_TOKEN - Provided code is invalid
   *
   * If there is an additional code here you may visit
   * https://gitlab.com/duenorth/domoreplus/plus-backend/-/blob/develop/src/services/auth/authenticate.ts
   * for additional information. See "enum INVALID_CODE"
   */
  invalidCode?: Maybe<Scalars['String']['output']>;
  /**
   * A human readable piece of text to explain the authentication error,
   * usually accompanied by and invalidCode which does not change. This
   * reason is subject to change across the same codes, so do not rely on
   * this for input validation
   */
  invalidReason?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  jwtExpires?: Maybe<Scalars['Int']['output']>;
  lockedOutAttemptsLeft?: Maybe<Scalars['Float']['output']>;
  lockedOutTimeLeft?: Maybe<Scalars['Float']['output']>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  refreshTokenExpires?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  valid2FA?: Maybe<Scalars['Boolean']['output']>;
  validEmail?: Maybe<Scalars['Boolean']['output']>;
  validJWT?: Maybe<Scalars['Boolean']['output']>;
  validPassword?: Maybe<Scalars['Boolean']['output']>;
  validRefreshToken?: Maybe<Scalars['Boolean']['output']>;
};

/**  Denotes a block of time where the user is available  */
export type Availability = {
  __typename?: 'Availability';
  end: Scalars['Int']['output'];
  start: Scalars['Int']['output'];
};

export type AvailabilityByDayOfTheWeek = {
  __typename?: 'AvailabilityByDayOfTheWeek';
  friday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  monday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  saturday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  sunday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  thursday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  tuesday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  wednesday?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
};

export type AvailabilityByDayOfTheWeekInput = {
  friday?: InputMaybe<Array<Scalars['Int']['input']>>;
  monday?: InputMaybe<Array<Scalars['Int']['input']>>;
  saturday?: InputMaybe<Array<Scalars['Int']['input']>>;
  sunday?: InputMaybe<Array<Scalars['Int']['input']>>;
  thursday?: InputMaybe<Array<Scalars['Int']['input']>>;
  tuesday?: InputMaybe<Array<Scalars['Int']['input']>>;
  wednesday?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**  A representation of an assets total availability  */
export type AvailabilityConfiguration = {
  __typename?: 'AvailabilityConfiguration';
  /**  Id of the configuration  */
  id?: Maybe<Scalars['String']['output']>;
  /**  Id of the object with this configuration  */
  objectId?: Maybe<Scalars['String']['output']>;
  /** Availability that overrides regular availability */
  overrides?: Maybe<Array<Maybe<AvailabilityOverride>>>;
  /** Regular availability */
  templates?: Maybe<Array<Maybe<AvailabilityTemplate>>>;
  /**  The name of the timezone this configuration uses eg. 'America/Winnipeg'' */
  timezone?: Maybe<Scalars['String']['output']>;
};

export type AvailabilityOutput = {
  __typename?: 'AvailabilityOutput';
  dayAvailability?: Maybe<Array<DayAvailability>>;
  objectId: Scalars['String']['output'];
};

export type AvailabilityOverride = {
  __typename?: 'AvailabilityOverride';
  dates: Array<Scalars['String']['output']>;
  template?: Maybe<AvailabilityTemplate>;
};

export type AvailabilitySearch = {
  /**  Use international date format 'YYYY-MM-DD, Set it the same as startDate to only query one day' */
  endDate: Scalars['String']['input'];
  excludeEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  objectId: Scalars['String']['input'];
  /**  Use international date format 'YYYY-MM-DD' */
  startDate: Scalars['String']['input'];
  /** The zone the queried availability pertains to */
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type AvailabilityTemplate = {
  __typename?: 'AvailabilityTemplate';
  /**  Availability for this template  */
  availability?: Maybe<AvailabilityByDayOfTheWeek>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  /** End date of the template. Format: 'YYYY-MM-DD' */
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  /**  Nickname for the Template eg. 'The Ol 9-5' */
  name?: Maybe<Scalars['String']['output']>;
  /** Start date of the template. Format: 'YYYY-MM-DD' */
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  /**  The zones which this template (and it's availabilty) applyTo */
  zones?: Maybe<Array<Maybe<Zone>>>;
};

export type AvailabilityTemplateInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type AvailableUsers = {
  __typename?: 'AvailableUsers';
  allOK?: Maybe<Scalars['Boolean']['output']>;
  appointments: Array<Scalars['String']['output']>;
  hasCourse?: Maybe<Scalars['Boolean']['output']>;
  hasUnavailableAppointments?: Maybe<Scalars['Boolean']['output']>;
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  markedAsAvailable?: Maybe<Scalars['Boolean']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

/** Contains content to be displayed on a page */
export type Block = {
  __typename?: 'Block';
  accesses?: Maybe<Array<Maybe<Access>>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /** Specifies how the block should be rendered, handled on the frontend */
  blockType: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Display order of a block on a page, resolves null unless the block is subqueried on a Page
   * or if Blocks are filtered by a single page
   */
  order?: Maybe<Scalars['Float']['output']>;
  pages?: Maybe<Array<Maybe<Page>>>;
  updatedOn: Scalars['Int']['output'];
  user?: Maybe<User>;
};


/** Contains content to be displayed on a page */
export type BlockAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};

export type BlockDeleteOutput = {
  __typename?: 'BlockDeleteOutput';
  blocksDeleted?: Maybe<Scalars['Int']['output']>;
  blocksDetached?: Maybe<Scalars['Int']['output']>;
};

export type BlockEditInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<OrderObject>;
};

export type BlockEditOutput = {
  __typename?: 'BlockEditOutput';
  isSuccess: Scalars['Boolean']['output'];
};

export type BlockInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  blockType: Scalars['String']['input'];
  content?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Input for the placement of the block in the page's block order.
   * Pass in empty value for default order placement
   */
  orderInput: OrderObject;
};

export type BlockSubscriptionOutput = {
  __typename?: 'BlockSubscriptionOutput';
  blockId?: Maybe<Scalars['ID']['output']>;
  blockPages?: Maybe<Array<Scalars['String']['output']>>;
};

export type BookOutput = {
  __typename?: 'BookOutput';
  appointmentIds: Array<Scalars['String']['output']>;
};

export type BookTime = {
  end: Scalars['Int']['input'];
  start: Scalars['Int']['input'];
  userOverride?: InputMaybe<Scalars['String']['input']>;
};

export type BookWindowInput = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set metadata on the object. Must be provided in a valid JSON format
   * otherwise it will throw an error. If using double quotes, make
   * sure you escape the string. Eg:
   *
   * `"{\"x\":2,\"y\":\"NotSoSecret\"}"`
   */
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicText?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type BookingWindow = {
  __typename?: 'BookingWindow';
  assets?: Maybe<Array<Maybe<Asset>>>;
  conflictingEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  end: Scalars['Int']['output'];
  /** Denotes whether the booking window has a conflicting event, Use if you want to know conflicts exists without querying them */
  hasConflict?: Maybe<Scalars['Boolean']['output']>;
  start: Scalars['Int']['output'];
  startTimes: Array<Maybe<Scalars['Int']['output']>>;
  users: Array<Maybe<User>>;
};

export type BulkEditEvents = {
  edits: Array<SingleEditInput>;
};

export type CalculateDistanceOutput = {
  __typename?: 'CalculateDistanceOutput';
  averageTime?: Maybe<Scalars['Int']['output']>;
  distanceUnits?: Maybe<Scalars['String']['output']>;
  distances?: Maybe<Array<Maybe<Distance>>>;
  estimatedTime?: Maybe<Scalars['Int']['output']>;
  flagTrip?: Maybe<Scalars['Boolean']['output']>;
  totalDistance?: Maybe<Scalars['Float']['output']>;
};

export type CalendarEvent = {
  __typename?: 'CalendarEvent';
  /** What action to perform on an event that deserves attention. */
  action?: Maybe<Scalars['String']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  assets?: Maybe<Array<Maybe<Asset>>>;
  /** Id shared between related calendar events */
  associatedId?: Maybe<Scalars['String']['output']>;
  attendees?: Maybe<Array<Maybe<Attendee>>>;
  /** The reasons why this event deserves attention (if any). */
  attentionExplanation?: Maybe<Array<Scalars['String']['output']>>;
  /** A measure of how much attention this event deserves. */
  attentionScore?: Maybe<Scalars['Float']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The calendar event types that would be blocked from taking place concurrently, if any.
   * @deprecated This field is no longer used in the system and will be removed in a future release.
   */
  blocksEventTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  charges?: Maybe<Array<Maybe<Charge>>>;
  colour?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentPagination>;
  createdAt: Scalars['Int']['output'];
  currency?: Maybe<Scalars['String']['output']>;
  damageTotal?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountTotal?: Maybe<Scalars['Int']['output']>;
  discountedSubTotal?: Maybe<Scalars['Int']['output']>;
  discountedSubTotalWithoutDamages?: Maybe<Scalars['Int']['output']>;
  discounts?: Maybe<Array<Maybe<DiscountDetails>>>;
  end?: Maybe<Scalars['Int']['output']>;
  expenseTotal?: Maybe<Scalars['Int']['output']>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  /** All invoices associated with the event, active or otherwise */
  invoices?: Maybe<Array<Maybe<Invoice>>>;
  job?: Maybe<Job>;
  /** @deprecated Use locations instead */
  location?: Maybe<Location>;
  locations?: Maybe<Array<CalendarEventLocation>>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Information regarding the recurrsion of the event, if applicable */
  recurring?: Maybe<Recurring>;
  /** The ids of roles affected by the event, if any. */
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  sequentialOrder?: Maybe<Scalars['Float']['output']>;
  /**  The ids of the zones that this event has been shared with  */
  sharedZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subTotal?: Maybe<Scalars['Int']['output']>;
  taxTotal?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  topicText?: Maybe<Scalars['String']['output']>;
  topics?: Maybe<Array<Maybe<EventTopic>>>;
  total?: Maybe<Scalars['Int']['output']>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  zones?: Maybe<ListZonesOutput>;
};


export type CalendarEventHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};


export type CalendarEventZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEventIdPagination = {
  __typename?: 'CalendarEventIdPagination';
  ids: Array<Maybe<Scalars['String']['output']>>;
  total: Scalars['Int']['output'];
};

export type CalendarEventLocation = {
  __typename?: 'CalendarEventLocation';
  actualTimeAtLocation?: Maybe<Scalars['Int']['output']>;
  actualTimeToNextLocation?: Maybe<Scalars['Int']['output']>;
  distanceToNextLocation?: Maybe<Scalars['Int']['output']>;
  distanceUnits?: Maybe<Scalars['String']['output']>;
  estimatedTimeAtLocation?: Maybe<Scalars['Int']['output']>;
  /** Id of the relationship between a CalendarEvent and location. Used when editing and removing locations on/from events. */
  id: Scalars['String']['output'];
  /** Denotes whether the location should be used when calculating travel time. Default: false */
  ignoreInDuration?: Maybe<Scalars['Boolean']['output']>;
  location?: Maybe<Location>;
  order: Scalars['Float']['output'];
  travelTimeToNextLocation?: Maybe<Scalars['Int']['output']>;
  travelTimeToNextLocationOffset?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type CalendarEventLocationInput = {
  estimatedTimeAtLocation?: InputMaybe<Scalars['Int']['input']>;
  /** Denotes whether the location should be used when calculating travel time. Default: false */
  ignoreInDuration?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['String']['input'];
  /** If none given order will resolve based on the inputted array */
  order?: InputMaybe<Scalars['Float']['input']>;
  travelTimeToNextLocationOffset?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type CalendarEventPagination = {
  __typename?: 'CalendarEventPagination';
  events: Array<CalendarEvent>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type CalendarEventsFilter = {
  associatedIds?: InputMaybe<Array<Scalars['String']['input']>>;
  bookedFromHour?: InputMaybe<HourFilter>;
  bookedOnDaysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  bookedUntilHour?: InputMaybe<HourFilter>;
  chargeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dailyInterval?: InputMaybe<Scalars['Int']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Int']['input']>;
  dayOfYear?: InputMaybe<Scalars['Int']['input']>;
  discountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  distanceMax?: InputMaybe<Scalars['Int']['input']>;
  distanceMin?: InputMaybe<Scalars['Int']['input']>;
  getEventsOfSharedStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  getEventsOfStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  getEventsOfType?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAttendees?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasTopics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  interval?: InputMaybe<Scalars['String']['input']>;
  /** Denotes whether the queried event(s) should have a set start. */
  isScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  max?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  min?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Ids of either users of assets that are to be associated with the queries event(s)
   * Use objectIdLabels to increase performance
   */
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include cancelled events in the results. Default: false */
  showCancelled?: InputMaybe<Scalars['Boolean']['input']>;
  softDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<Scalars['String']['input']>>;
  usesAssets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Default: 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type CallbackDay = {
  __typename?: 'CallbackDay';
  callbackTimes: Array<Scalars['String']['output']>;
  priority: Scalars['Int']['output'];
  ringgroup: Scalars['String']['output'];
};

export type Charge = {
  __typename?: 'Charge';
  amount?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**  The calendar event the charge is associated with.  */
  calendarEvent?: Maybe<CalendarEvent>;
  chargeSubTotal?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  discountTotal?: Maybe<Scalars['Int']['output']>;
  discountedSubTotal?: Maybe<Scalars['Int']['output']>;
  /** Details of discount applied to root charge */
  discounts?: Maybe<Array<Maybe<DiscountDetails>>>;
  /** Denotes the type of event the charge is associated with */
  eventType?: Maybe<Scalars['String']['output']>;
  expenseTotal?: Maybe<Scalars['Int']['output']>;
  /**
   *  The expenses associated with this charge
   * @deprecated Currently, the expense type includes both unitCost and amount fields. Hence, Apollo causes discrepancy in data as objects with the similar id and type (__typename) have different values of their fields. So, use expensesV2 instead
   */
  expenses?: Maybe<Array<Expense>>;
  expensesV2?: Maybe<Array<ChargeExpense>>;
  history: HistoryPagination;
  id: Scalars['String']['output'];
  /**  The job this charge is associated with  */
  job?: Maybe<Job>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  price?: Maybe<Price>;
  product?: Maybe<Product>;
  productName?: Maybe<Scalars['String']['output']>;
  quantity: Scalars['Float']['output'];
  taxTotal?: Maybe<Scalars['Int']['output']>;
  taxes?: Maybe<Array<Maybe<Tax>>>;
  total?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};


export type ChargeHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type ChargeExpense = {
  __typename?: 'ChargeExpense';
  amount: Scalars['Int']['output'];
  expense: Expense;
  unitCost: Scalars['Int']['output'];
};

export type ChargeUpdate = {
  addDiscounts?: InputMaybe<Array<AddChargeDiscount>>;
  addExpenses?: InputMaybe<Array<CreatePriceExpenseInput>>;
  addTaxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Only used if the Charge's product is null */
  amount?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Will assign the charge to the specified event, and set the eventType property
   * accordingly.
   */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Denotes the type of event the charge is associated with. The charge will be
   * assigned to an appropriate event if available.
   */
  eventType?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Only used if the Charge's productName and amount are null */
  priceId?: InputMaybe<Scalars['String']['input']>;
  /** Only used if the Charge's product is null */
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['Float']['input']>;
  removeExpenses?: InputMaybe<Array<Scalars['String']['input']>>;
  removeTaxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  updateExpenses?: InputMaybe<Array<CreatePriceExpenseInput>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChargesFilter = {
  attributesExclusive?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributesInclusive?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  createdById?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discountId?: InputMaybe<Scalars['String']['input']>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Scalars['String']['input']>;
  excludeDamages?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  priceId?: InputMaybe<Scalars['String']['input']>;
  priceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Filters based on the charge's productName property */
  productNameSearch?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  taxIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Denotes whether returned charges should use Price objects on the database or a custom product name and amount */
  usesPrice?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ChargesPagination = {
  __typename?: 'ChargesPagination';
  charges: Array<Maybe<Charge>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ClockFilter = {
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ClockInput = {
  /** Set end time of clock using unix seconds. */
  end?: InputMaybe<Scalars['Int']['input']>;
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  resetEnd?: InputMaybe<Scalars['Boolean']['input']>;
  resetStart?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set start time of clock using unix seconds. */
  start?: InputMaybe<Scalars['Int']['input']>;
  /** Can be missed, confirmed, or cancelled. */
  status?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ClockListInput = {
  filter?: InputMaybe<ClockFilter>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ClockOutput = {
  __typename?: 'ClockOutput';
  clockId?: Maybe<Scalars['String']['output']>;
  end?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ClockStatus = {
  __typename?: 'ClockStatus';
  attributes: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type Clocks = {
  __typename?: 'Clocks';
  clockId?: Maybe<Scalars['String']['output']>;
  clock_end?: Maybe<Scalars['Int']['output']>;
  clock_start?: Maybe<Scalars['Int']['output']>;
  eventId?: Maybe<Scalars['String']['output']>;
  paidOn?: Maybe<Scalars['Int']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ColumnParams = {
  realizedBy?: InputMaybe<Scalars['Int']['input']>;
};

export type Comment = {
  __typename?: 'Comment';
  archivedAt?: Maybe<Scalars['Float']['output']>;
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /** The User who added the comment */
  author?: Maybe<User>;
  /**
   * The name of the author when the comment
   * was created or if no author is set
   * then a name you can use in place of the
   * user, such as an email or phone number
   */
  authorName?: Maybe<Scalars['String']['output']>;
  /**
   * A delta representation of the comment (see quill js)
   * in JSON format
   *
   * Includes formatting information but may be difficult
   * to utilize. This is optional and may not be set.
   *
   * If that is the case, use "text" above
   */
  contents?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['Float']['output']>;
  id: Scalars['String']['output'];
  isReply?: Maybe<Scalars['Boolean']['output']>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  replies?: Maybe<Array<Comment>>;
  replyIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The Required access level on the object with this comment for the user to be able to view this comment. 'owner', 'manager', 'editor', 'commenter', 'viewer' */
  requiredAccessLevel?: Maybe<Access_Type>;
  system?: Maybe<Scalars['Boolean']['output']>;
  tags: Array<Maybe<Tag>>;
  /**
   * A plaintext representation of the comment.
   *
   * For formatting, use "delta"
   */
  text: Scalars['String']['output'];
  thread?: Maybe<CommentThread>;
  updatedAt?: Maybe<Scalars['Float']['output']>;
  zoneIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type CommentMode = {
  __typename?: 'CommentMode';
  description?: Maybe<Scalars['String']['output']>;
  hidden?: Maybe<Scalars['Boolean']['output']>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  showSubject?: Maybe<Scalars['Boolean']['output']>;
  system?: Maybe<Scalars['Boolean']['output']>;
};

export type CommentPagination = {
  __typename?: 'CommentPagination';
  comments?: Maybe<Array<Comment>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type CommentThread = {
  __typename?: 'CommentThread';
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  mode?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type CompanyInfo = {
  __typename?: 'CompanyInfo';
  CompanyAddr?: Maybe<QuickbooksAddress>;
  CompanyName: Scalars['String']['output'];
  CompanyStartDate: Scalars['String']['output'];
  Country: Scalars['String']['output'];
  CustomerCommunicationAddr?: Maybe<QuickbooksAddress>;
  CustomerCommunicationEmailAddr?: Maybe<QuickbooksEmailAddress>;
  Email: QuickbooksEmailAddress;
  FiscalYearStartMonth: Scalars['String']['output'];
  Id: Scalars['String']['output'];
  LegalAddr?: Maybe<QuickbooksAddress>;
  LegalName: Scalars['String']['output'];
  NameValue: Array<NameValuePair>;
  PrimaryPhone?: Maybe<Phone>;
  QuickbooksMetaData: QuickbooksMetaData;
  SupportedLanguages: Scalars['String']['output'];
  SyncToken: Scalars['String']['output'];
  WebAddr?: Maybe<WebAddress>;
  domain: Scalars['String']['output'];
  sparse: Scalars['Boolean']['output'];
};

export type ConfigToResolve = {
  __typename?: 'ConfigToResolve';
  defaultValue?: Maybe<Scalars['String']['output']>;
  key: Scalars['String']['output'];
  localName?: Maybe<Scalars['String']['output']>;
  namespace: Scalars['String']['output'];
};

export type ConfigValue = {
  __typename?: 'ConfigValue';
  createdAt?: Maybe<Scalars['Int']['output']>;
  /** The value that you would get if you were to clear the current config value. */
  fallback?: Maybe<ConfigValue>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<ConfigValue>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type ConfigValueInput = {
  key: Scalars['String']['input'];
  /** Removes the config value from the database and uses the value from higher levels instead */
  reset?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type Config_App_Notice = {
  __typename?: 'Config_App_Notice';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_App_Notice>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_App_Notice>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<App_Notice>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_AttentionConfig = {
  __typename?: 'Config_AttentionConfig';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_AttentionConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_AttentionConfig>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<AttentionConfig>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_Boolean = {
  __typename?: 'Config_Boolean';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_Boolean>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_Boolean>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Boolean']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_ConfigValueArray = {
  __typename?: 'Config_ConfigValueArray';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_ConfigValueArray>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_ConfigValueArray>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['ConfigValueArray']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_ConfigValueObject = {
  __typename?: 'Config_ConfigValueObject';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_ConfigValueObject>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_ConfigValueObject>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['ConfigValueObject']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_Float = {
  __typename?: 'Config_Float';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_Float>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_Float>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_Inventory_Items = {
  __typename?: 'Config_Inventory_Items';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_Inventory_Items>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_Inventory_Items>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Array<Maybe<Inventory_Items>>>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_Jobs_ClosedReasons = {
  __typename?: 'Config_Jobs_ClosedReasons';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_Jobs_ClosedReasons>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_Jobs_ClosedReasons>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Array<Maybe<Jobs_ClosedReasons>>>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_PaymentType = {
  __typename?: 'Config_PaymentType';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_PaymentType>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_PaymentType>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<PaymentType>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_StandardDocumentsConfig = {
  __typename?: 'Config_StandardDocumentsConfig';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_StandardDocumentsConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_StandardDocumentsConfig>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<StandardDocumentsConfig>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_String = {
  __typename?: 'Config_String';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_String>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_String>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_Talkdesk_CallbackConfig = {
  __typename?: 'Config_Talkdesk_CallbackConfig';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_Talkdesk_CallbackConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_Talkdesk_CallbackConfig>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Talkdesk_CallbackConfig>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_TemplateConfig = {
  __typename?: 'Config_TemplateConfig';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_TemplateConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_TemplateConfig>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<TemplateConfig>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type Config_TriggerConfig = {
  __typename?: 'Config_TriggerConfig';
  createdAt?: Maybe<Scalars['Int']['output']>;
  fallback?: Maybe<Config_TriggerConfig>;
  id?: Maybe<Scalars['ID']['output']>;
  key: Scalars['String']['output'];
  overridingConfigs?: Maybe<Array<Config_TriggerConfig>>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<TriggerConfig>;
  zone?: Maybe<Scalars['String']['output']>;
};

export type ConfirmEmailResult = {
  __typename?: 'ConfirmEmailResult';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ConnectAccount = {
  __typename?: 'ConnectAccount';
  account?: Maybe<PaymentAccount>;
  accountLinks?: Maybe<RegisterPaymentAccountLinks>;
};

export type CoordinateInput = {
  height?: InputMaybe<Scalars['Float']['input']>;
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type Coordinates = {
  __typename?: 'Coordinates';
  height?: Maybe<Scalars['Float']['output']>;
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type Coupon = {
  __typename?: 'Coupon';
  /** Amount (in the `currency` specified) that will be taken off the subtotal of any invoices for this customer. */
  amount_off?: Maybe<Scalars['Int']['output']>;
  /** A list of product stripe IDs this coupon applies to */
  applies_to?: Maybe<AppliesTo>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created?: Maybe<Scalars['Int']['output']>;
  /** If `amount_off` has been set, the three-letter [ISO code for the currency](https://stripe.com/docs/currencies) of the amount to take off. */
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** One of `forever`, `once`, and `repeating`. Describes how long a customer who applies this coupon will get the discount. */
  duration?: Maybe<Scalars['String']['output']>;
  /** If `duration` is `repeating`, the number of months the coupon applies. Null if coupon `duration` is `forever` or `once`. */
  duration_in_months?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the object. Generated by Stripe */
  id?: Maybe<Scalars['String']['output']>;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of times this coupon can be redeemed, in total, across all customers, before it is no longer valid. */
  max_redemptions?: Maybe<Scalars['Int']['output']>;
  /** Name of the coupon displayed to customers on for instance invoices or receipts. */
  name?: Maybe<Scalars['String']['output']>;
  /**
   * Percent that will be taken off the subtotal of any invoices for this customer for the duration of the coupon.
   * For example, a coupon with percent_off of 50 will make a %s100 invoice %s50 instead.
   */
  percent_off?: Maybe<Scalars['Int']['output']>;
  /** Date after which the coupon can no longer be redeemed. */
  redeem_by?: Maybe<Scalars['Int']['output']>;
  /** Number of times this coupon has been applied to a customer. */
  times_redeemed?: Maybe<Scalars['Int']['output']>;
  /** Taking account of the above properties, whether this coupon can still be applied to a customer. */
  valid?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateArtifactOutput = {
  __typename?: 'CreateArtifactOutput';
  artifacts: Array<Maybe<Artifact>>;
  total: Scalars['Int']['output'];
};

export type CreateAssetInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name: Scalars['String']['input'];
  ownerId: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateAvailabilityTemplateInput = {
  /**
   * Availability for each day of the week, every two items in the array are the start/end times for that block.
   * eg. [0, 3600, 7200, 10800] -> would be available 12am - 1am and 2am - 3am
   */
  availability?: InputMaybe<AvailabilityByDayOfTheWeekInput>;
  /**  Format: 'YYYY-MM-DD', End date for this template  */
  endDate?: InputMaybe<Scalars['String']['input']>;
  /**  Name for referencing the template  */
  name: Scalars['String']['input'];
  /**  Format: 'YYYY-MM-DD', Start date for this template  */
  startDate: Scalars['String']['input'];
  /** The owner of the template if the template is for an object in the database other than users. */
  templateOwner?: InputMaybe<Scalars['String']['input']>;
  /** The zones that this template availability applies to. */
  zones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateChargeInput = {
  /** Only used if productId is null */
  amount?: InputMaybe<Scalars['Int']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * The currency to use, will be overriden
   * by the prices currency if we are using a price.
   */
  currency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Will assign the charge to the specified event, and set the eventType property
   * accordingly.
   */
  eventId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Denotes the type of event the charge is associated with. The charge will be
   * assigned to an appropriate event if available.
   */
  eventType?: InputMaybe<Scalars['String']['input']>;
  /** Charge id generated on fe */
  id?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  /** Only used if productName and amount are null */
  productId?: InputMaybe<Scalars['String']['input']>;
  /** Only used if productId is null */
  productName?: InputMaybe<Scalars['String']['input']>;
  quantity: Scalars['Float']['input'];
  /** If omitted taxes will be taken from the associated product */
  taxIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateCoupon = {
  /** A positive integer representing the amount to subtract from an invoice total (required if `percent_off` is not passed). */
  amount_off?: InputMaybe<Scalars['Int']['input']>;
  /** A hash containing directions for what this Coupon will apply discounts to. */
  applies_to?: InputMaybe<AppliesToInput>;
  /** Three-letter [ISO code for the currency](https://stripe.com/docs/currencies) of the `amount_off` parameter (required if `amount_off` is passed). */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Specifies how long the discount will be in effect. Can be `forever`, `once`, or `repeating`. */
  duration: Scalars['String']['input'];
  /** Required only if `duration` is `repeating`, in which case it must be a positive integer that specifies the number of months the discount will be in effect. */
  duration_in_months?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A positive integer specifying the number of times the coupon can be redeemed before it's no longer valid.
   * For example, you might have a 50% off coupon that the first 20 readers of your blog can use.
   */
  max_redemptions?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the coupon displayed to customers on, for instance invoices, or receipts. By default the `id` is shown if `name` is not set. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** A positive float larger than 0, and smaller or equal to 100, that represents the discount the coupon will apply (required if `amount_off` is not passed). */
  percent_off?: InputMaybe<Scalars['Int']['input']>;
  /** Unix timestamp specifying the last time at which the coupon can be redeemed. After the redeem_by date, the coupon can no longer be applied to new customers. */
  redeem_by?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDiscountInput = {
  /** Default false */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * If discountType amount value should be in cents e.g. $10 => 1000
   * If discountType percentage value should be out of 100. e.g. 50% => 50
   */
  amount: Scalars['Float']['input'];
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  code: Scalars['String']['input'];
  /**
   * Range for valid custom amounts when applying the discounts. The first value in the array is the
   * lower limit, the second the upper. For amount discount types the values represent cents, for percentage
   * the values represent the percentage out of 100. The upper limit of percentage discounts cannot exceed 100.
   * Omit the second integer to set no limit (percentage discounts will still be capped at 100).
   */
  customAmountRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountType: DiscountTypes;
  /** If null discount will be active until updated */
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name: Scalars['String']['input'];
  /** If null the discount will be immediately active (assuming the active parameter is set to true) */
  startsAt?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateDiscountsInput = {
  discountInput?: InputMaybe<CreateDiscountInput>;
  eventsIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CreateDocumentOutput = {
  __typename?: 'CreateDocumentOutput';
  artifact?: Maybe<Artifact>;
  /** @deprecated Use Query getPandadocDocumentLink */
  docLink?: Maybe<Scalars['String']['output']>;
  recipients: Array<Maybe<DocumentRecipient>>;
};

export type CreateEmailUpdateTokenOutput = {
  __typename?: 'CreateEmailUpdateTokenOutput';
  emailChanged: Scalars['Boolean']['output'];
  emailConfirmationRequired: Scalars['Boolean']['output'];
  user: User;
};

export type CreateFieldsResult = {
  __typename?: 'CreateFieldsResult';
  fields: Array<Field>;
};

export type CreateInvoiceInput = {
  eventIds: Array<Scalars['String']['input']>;
};

export type CreateInvoiceOutput = {
  __typename?: 'CreateInvoiceOutput';
  invoices: Array<Maybe<Invoice>>;
};

export type CreatePriceExpenseInput = {
  expenseId: Scalars['String']['input'];
  unitCost: Scalars['Int']['input'];
};

export type CreatePriceInput = {
  /** Default true */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** In cents (fixed) or percent (percentage) depending on priceType */
  amount: Scalars['Float']['input'];
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** ISO currency code, default: 'CAD' */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Expenses (actual cost to company) for this price. */
  expenses?: InputMaybe<Array<CreatePriceExpenseInput>>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price type specifies whether we are using a 'fixed' price with an amounnt in cents (default) or a 'percentage' price with an amount in percent */
  priceType?: InputMaybe<PriceType>;
  productId: Scalars['String']['input'];
  /**
   * Taxes to use for this price. If set to "undefined" then
   * it will use the default zone prices.
   */
  taxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProductInput = {
  /** Denotes whether the product is available for purchase */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
  /** The description used for credit card staements */
  statementDescription?: InputMaybe<Scalars['String']['input']>;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
};

export type CreatePromotionCodeInput = {
  /** Whether the promotion code is currently active. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The customer-facing code. Regardless of case, this code must be unique across all active promotion codes for a specific customer.
   * If left blank, we will generate one automatically.
   */
  code?: InputMaybe<Scalars['String']['input']>;
  /** The stripe generated coupon ID for this promotion code. */
  coupon: Scalars['String']['input'];
  /** The customer that this promotion code can be used by. If not set, the promotion code can be used by all customers. */
  customer?: InputMaybe<Scalars['String']['input']>;
  /**
   * The timestamp at which this promotion code will expire. If the coupon has specified a `redeems_by`, then this value cannot be
   * after the coupon's `redeems_by`.
   */
  expires_at?: InputMaybe<Scalars['Int']['input']>;
  /**
   * A positive integer specifying the number of times the promotion code can be redeemed. If the coupon has specified a
   * `max_redemptions`, then this value cannot be greater than the coupon's `max_redemptions`.
   */
  max_redemptions?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  /** Settings that restrict the redemption of the promotion code. */
  restrictions?: InputMaybe<PromotionCodeRestrictionsInput>;
  /** The Zones the promotion code will be applicable to */
  zones: Array<Scalars['String']['input']>;
};

export type CreateReportInput = {
  report: CreateReportInputProperties;
  reportType: Scalars['String']['input'];
  scheduledReport?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReportInputProperties = {
  name?: InputMaybe<Scalars['String']['input']>;
  saveAggregations?: InputMaybe<Scalars['Boolean']['input']>;
  saveData?: InputMaybe<Scalars['Boolean']['input']>;
  saveReport?: InputMaybe<Scalars['Boolean']['input']>;
  variables: Scalars['String']['input'];
};

export type CreateRuleInput = {
  properties: CreateRuleInputProperties;
};

export type CreateRuleInputProperties = {
  action: Scalars['String']['input'];
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * A condition string is a JSON string which will
   * resolve to true or false if the provided values match
   * the condition string. See “Condition String Properties” below
   * Each value "AND's" other values unless the OR value is used.
   * See condition string documentation
   */
  condition: Scalars['String']['input'];
  delay?: InputMaybe<Scalars['Int']['input']>;
  delayUnit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  offsetUnit?: InputMaybe<Scalars['String']['input']>;
  /** The name or ID of the trigger to use for this rule */
  trigger: Scalars['String']['input'];
};

export type CreateScheduledReportInput = {
  /** The ID of the dynamic report for this scheduled report. Requires	reportTypes.createScheduled permission */
  dynamicReportId?: InputMaybe<Scalars['String']['input']>;
  /** A list of users to notify upon report generation. Requires roles.notify permission */
  notifyRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A list of users to notify upon report generation. Requires users.notify permission */
  notifyUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The report type to generate for this scheduled report. Requires	reportTypes.createScheduled permission */
  reportType?: InputMaybe<Scalars['String']['input']>;
  scheduledReport: CreateScheduledReportInputProperties;
};

export type CreateScheduledReportInputProperties = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The unix time that this scheduled report should stop running
   * Null if never.
   */
  end?: InputMaybe<Scalars['Int']['input']>;
  /** The scheduled reports name. If this is not provided it will be auto generated. */
  name: Scalars['String']['input'];
  /**
   * Whether to save the artifact for that report.
   * If set to "false," will not save the artifact but it will save aggregates.
   */
  saveData?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The unix time that this scheduled report should start running
   * Null if now.
   */
  start?: InputMaybe<Scalars['Int']['input']>;
  time: Scalars['String']['input'];
  /** The timezone used by the scheduled report to run times */
  tz?: InputMaybe<Scalars['String']['input']>;
  /**
   * A JSON string of hard coded variables to pass to each report.
   *
   * Each report will also be able to access the common variables as outlined in reports.md
   */
  variables?: InputMaybe<Scalars['String']['input']>;
  webhooks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateSkillBase = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  links?: InputMaybe<SkillLinkInput>;
  name: Scalars['String']['input'];
  ratingType?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  skillType: Scalars['String']['input'];
};

export type CreateSkills = {
  skills: Array<CreateSkillBase>;
};

export type CreateSnapshotInput = {
  objectId: Scalars['String']['input'];
  objectLabel: Scalars['String']['input'];
  reason: Scalars['String']['input'];
};

export type CreateSnapshotOutput = {
  __typename?: 'CreateSnapshotOutput';
  artifact: Scalars['String']['output'];
};

export type CreateStripePrice = {
  /** Whether the price can be used for new purchases. Defaults to `true`. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase.
   * Must be a [supported currency](https://stripe.com/docs/currencies).
   */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** A lookup key used to retrieve prices dynamically from a static string. */
  lookup_key?: InputMaybe<Scalars['String']['input']>;
  /** A brief description of the price, hidden from customers. */
  nickname?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the product that this price will belong to. */
  product?: InputMaybe<Scalars['String']['input']>;
  /** These fields can be used to create a new product that this price will belong to. */
  product_data?: InputMaybe<CreateStripeProduct>;
  /** If set to true, will atomically remove the lookup key from the existing price, and assign it to this price. */
  transfer_lookup_key?: InputMaybe<Scalars['Boolean']['input']>;
  /** The unit amount in cents to be charged, represented as a whole integer if possible. */
  unit_amount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateStripeProduct = {
  /** Whether the product is currently available for purchase. Defaults to `true`. */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of up to 5 alphanumeric attributes. Should only be set if type=`good`. */
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A short one-line description of the product, meant to be displayable to the customer. May only be set if type=`good`. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** An array of Connect application names or identifiers that should not be able to order the SKUs for this product. May only be set if type=`good`. */
  deactivate_on?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The product's description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Specifies which fields in the response should be expanded. */
  expand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of up to 8 URLs of images for this product, meant to be displayable to the customer. */
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** The product's name, meant to be displayable to the customer. Whenever this product is sold via a subscription, name will show up on associated invoice line item descriptions. */
  name: Scalars['String']['input'];
  /** Whether this product is shipped (i.e., physical goods). Defaults to `true`. May only be set if type=`good`. */
  shippable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * An arbitrary string to be displayed on your customer's credit card or bank statement. While most banks display this information consistently, some may display it incorrectly or not at all.
   *
   * This may be up to 22 characters. The statement description may not include `<`, `>`, `\`, `"`, `'` characters, and will appear on your customer's statement in capital letters. Non-ASCII characters are automatically stripped.
   * It must contain at least one letter.
   */
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  /**
   * The type of the product. Defaults to `service` if not explicitly specified, enabling use of this product with Subscriptions and Plans.
   * Set this parameter to `good` to use this product with Orders and SKUs. On API versions before `2018-02-05`, this field defaults to `good` for compatibility reasons.
   */
  type?: InputMaybe<StripeProductType>;
  /** A label that represents units of this product in Stripe and on customers' receipts and invoices. When set, this will be included in associated invoice line item descriptions. */
  unit_label?: InputMaybe<Scalars['String']['input']>;
  /** A URL of a publicly-accessible webpage for this product. May only be set if type=`good`. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTagInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  objectType: Scalars['String']['input'];
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateTransactionOutput = {
  __typename?: 'CreateTransactionOutput';
  /** Used to complete a payment with whatever external api is used by the created transaction, if any */
  client_secret?: Maybe<Scalars['String']['output']>;
  transaction: Transaction;
};

export type CreateUserInput = {
  billingAddress?: InputMaybe<LocationCreateBase>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Int']['input']>;
  shiftAvailability?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserInputWithRole = {
  billingAddress?: InputMaybe<LocationCreateBase>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserResult = {
  __typename?: 'CreateUserResult';
  failedUsers?: Maybe<Array<Maybe<FailedUserInput>>>;
  total?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type CreateYemboMoveOutput = {
  __typename?: 'CreateYemboMoveOutput';
  customerLink: Scalars['String']['output'];
  employeeLink: Scalars['String']['output'];
};

export type CreateYemboSelfSurveyOutput = {
  __typename?: 'CreateYemboSelfSurveyOutput';
  customerUser?: Maybe<User>;
  employeeLink?: Maybe<Scalars['String']['output']>;
  jobId: Scalars['String']['output'];
  link: Scalars['String']['output'];
  sendEmail?: Maybe<Scalars['Boolean']['output']>;
  sendSms?: Maybe<Scalars['Boolean']['output']>;
};

export type CrewScheduleDataInput = {
  endTimeStamp: Scalars['Int']['input'];
  startTimeStamp: Scalars['Int']['input'];
};

export type CustomerCharge = {
  __typename?: 'CustomerCharge';
  amount?: Maybe<Scalars['Int']['output']>;
  amount_refunded?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  failure_message?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  receipt_url?: Maybe<Scalars['String']['output']>;
  refunded?: Maybe<Scalars['Boolean']['output']>;
  refunds?: Maybe<Array<Refund>>;
  status?: Maybe<Scalars['String']['output']>;
};

export type CustomerInvoiceSettings = {
  __typename?: 'CustomerInvoiceSettings';
  default_payment_method?: Maybe<Scalars['String']['output']>;
};

export type DashboardInput = {
  aggregateTime: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  dashboardItems: Array<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  tz: Scalars['String']['input'];
};

export type Dashboards = {
  __typename?: 'Dashboards';
  v1: Scalars['V1Dashboard']['output'];
};


export type DashboardsV1Args = {
  input: DashboardInput;
};

export type DateTime = {
  __typename?: 'DateTime';
  date: Scalars['String']['output'];
  fullString: Scalars['String']['output'];
  time: Scalars['String']['output'];
  unix: Scalars['String']['output'];
};

/**  The availaiblity of an entire day  */
export type DayAvailability = {
  __typename?: 'DayAvailability';
  availability?: Maybe<Array<Maybe<Availability>>>;
  conflictingEvents?: Maybe<Array<Maybe<CalendarEvent>>>;
  date?: Maybe<Scalars['String']['output']>;
};

export type DayOfWeekHours = {
  __typename?: 'DayOfWeekHours';
  dayOfWeek: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  minCallbackIntervalHours?: Maybe<Scalars['Int']['output']>;
  startTime: Scalars['String']['output'];
};

export type DeleteCommentInput = {
  /** If true the comment is completely removed from the system. */
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type DeleteCommentsOutput = {
  __typename?: 'DeleteCommentsOutput';
  commentsDeleted: Array<Scalars['String']['output']>;
};

export type DeleteQuillTemplateInput = {
  /** If true the comment is completely removed from the system. */
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['String']['input']>;
};

export type DeleteQuillTemplatesOutput = {
  __typename?: 'DeleteQuillTemplatesOutput';
  templatesDeleted: Array<Scalars['String']['output']>;
};

export type DeleteScheduledReportInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteScheduledReportOutput = {
  __typename?: 'DeleteScheduledReportOutput';
  deleted: Array<Scalars['String']['output']>;
};

export type Discount = {
  __typename?: 'Discount';
  active: Scalars['Boolean']['output'];
  amount: Scalars['Float']['output'];
  /** The number of instances where the discount is used in the database by either a Charge or a Job */
  appliedCount?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  code: Scalars['String']['output'];
  createdAt: Scalars['Int']['output'];
  /**
   * Range for valid custom amounts when applying the discounts. The first value in the array is the lower limit,
   * the second the upper. For amount discount types the values represent cents, for percentage discounts
   * the values represent the percentage out of 100. If the second integer is omitted then there is no upper limit.
   */
  customAmountRange?: Maybe<Array<Scalars['Float']['output']>>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountType: DiscountTypes;
  expiresAt?: Maybe<Scalars['Int']['output']>;
  history: HistoryPagination;
  id: Scalars['String']['output'];
  maxRedemptions?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name: Scalars['String']['output'];
  startsAt?: Maybe<Scalars['Int']['output']>;
  timesRedeemed: Scalars['Int']['output'];
  updatedAt: Scalars['Int']['output'];
  zones: ListZonesOutput;
};


export type DiscountHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type DiscountDetails = {
  __typename?: 'DiscountDetails';
  /** When the discount was applied to the root object */
  appliedAt: Scalars['Int']['output'];
  appliedBy?: Maybe<User>;
  /** The custom amount applied with the discount, if applicable */
  appliedCustomAmount?: Maybe<Scalars['Int']['output']>;
  /** Uniquely identifies one (of possibly many) applications of the same discount to a given object */
  appliedId: Scalars['String']['output'];
  discount: Discount;
  /** The amount of this discount applied to the event */
  discountedAmount?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<CalendarEvent>;
  eventId: Scalars['String']['output'];
  /** When the discount was considered 'redeemed' (i.e. When a payment was made towards the root object) */
  redeemedAt?: Maybe<Scalars['Int']['output']>;
};

export type DiscountFilter = {
  activeAt?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Denotes whether or not the queried discounts should allow for custom amounts. By default this
   * parameter is undefined, thereby not taking custom amounts into account when querying.
   */
  allowsCustomAmount?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether the queried discount(s) are eligable to be applied to either charges or jobs */
  applyable?: InputMaybe<Scalars['Boolean']['input']>;
  codes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  discountIds?: InputMaybe<Array<Scalars['String']['input']>>;
  discountType?: InputMaybe<DiscountTypes>;
  excludeAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether the queried discounts should include the attribute 'single-use' */
  singleUse?: InputMaybe<Scalars['Boolean']['input']>;
  timesRedeemedLessThan?: InputMaybe<Scalars['Int']['input']>;
  timesRedeemedMoreThan?: InputMaybe<Scalars['Int']['input']>;
  /** Will search for discounts that are usable for the object with the given ID */
  usableFor?: InputMaybe<Scalars['String']['input']>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export enum DiscountTypes {
  Amount = 'amount',
  Percentage = 'percentage'
}

export type DispatchCrewDataInput = {
  date: Scalars['String']['input'];
};

export type Distance = {
  __typename?: 'Distance';
  averageTime?: Maybe<Scalars['Int']['output']>;
  distance?: Maybe<Scalars['Float']['output']>;
  distanceUnits?: Maybe<Scalars['String']['output']>;
  endLocation?: Maybe<Scalars['String']['output']>;
  estimatedTime?: Maybe<Scalars['Int']['output']>;
  startLocation?: Maybe<Scalars['String']['output']>;
};

export type DocumentReadyToViewOutput = {
  __typename?: 'DocumentReadyToViewOutput';
  artifactId: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type DocumentRecipient = {
  __typename?: 'DocumentRecipient';
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** The role of the recipient in regards to the document. e.g. 'Client' */
  role?: Maybe<Scalars['String']['output']>;
};

export type DocumentSigned = {
  __typename?: 'DocumentSigned';
  artifactId: Scalars['String']['output'];
  signedByRole: Scalars['String']['output'];
};

export type DynamicReport = {
  __typename?: 'DynamicReport';
  aggregationColumns?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Int']['output'];
  dataColumns?: Maybe<Array<Scalars['String']['output']>>;
  description: Scalars['String']['output'];
  end?: Maybe<Scalars['Int']['output']>;
  filter?: Maybe<Scalars['String']['output']>;
  groupBy: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  period: Scalars['String']['output'];
  periodType: Scalars['String']['output'];
  sort?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Int']['output'];
};

export type DynamicReportParametersInput = {
  aggregationColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  dataColumns?: InputMaybe<Array<Scalars['String']['input']>>;
  end?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  period?: InputMaybe<Scalars['String']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type DynamicReportsFilter = {
  reportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type EditAccess = {
  accessId: Scalars['String']['input'];
  accessType?: InputMaybe<Scalars['String']['input']>;
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
};

export type EditArtifactInput = {
  artifactId: Scalars['String']['input'];
  edit: ArtifactEdit;
};

export type EditBlock = {
  blockEdit?: InputMaybe<BlockEditInput>;
  blockId: Scalars['String']['input'];
};

export type EditCalendarEventLocationInput = {
  actualTimeAtLocation?: InputMaybe<Scalars['Float']['input']>;
  actualTimeToNextLocation?: InputMaybe<Scalars['Float']['input']>;
  estimatedTimeAtLocation?: InputMaybe<Scalars['Float']['input']>;
  /** Id of the CalendarEvent-Location relationship to be edited */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Denotes whether the location should be used when calculating travel time. Default: false */
  ignoreInDuration?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  travelTimeToNextLocationOffset?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EditFields = {
  fieldEdit?: InputMaybe<EditFormFieldBase>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EditFieldsResult = {
  __typename?: 'EditFieldsResult';
  fields: Array<Scalars['String']['output']>;
};

export type EditFormFieldBase = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldName?: InputMaybe<Scalars['String']['input']>;
  fieldType?: InputMaybe<FieldTypeInput>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type EditFormResponseSubscriptionOutput = {
  __typename?: 'EditFormResponseSubscriptionOutput';
  formResponseId: Scalars['String']['output'];
  formTypeId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type EditFormTypeBase = {
  allowAnonymousEntries?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  confirmationPage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editAfterSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  limitToOneResponse?: InputMaybe<Scalars['Boolean']['input']>;
  newFields?: InputMaybe<Array<InputMaybe<FormFieldInput>>>;
  newSections?: InputMaybe<Array<InputMaybe<FormTypeInput>>>;
  permissionsRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  removeComponents?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditFormTypeOutput = {
  __typename?: 'EditFormTypeOutput';
  totalFieldsUpdated: Scalars['Int']['output'];
  totalFormsUpdated: Scalars['Int']['output'];
  totalSectionsUpdated: Scalars['Int']['output'];
};

export type EditPageResult = {
  __typename?: 'EditPageResult';
  blocksAdded?: Maybe<Scalars['Int']['output']>;
  blocksCreated?: Maybe<Scalars['Int']['output']>;
  blocksEdited?: Maybe<Scalars['Int']['output']>;
  blocksRemoved?: Maybe<Scalars['Int']['output']>;
  pageEdited?: Maybe<Scalars['Boolean']['output']>;
};

export type EditRecurringCalendarEventInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  dailyInterval?: InputMaybe<Scalars['Int']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfYear?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  interval?: InputMaybe<Scalars['String']['input']>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type EditSkillBase = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratingType?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  skillType?: InputMaybe<Scalars['String']['input']>;
};

export type EditSkillPagination = {
  __typename?: 'EditSkillPagination';
  ids?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type EditTagInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  category?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type EditUserSkillOutput = {
  __typename?: 'EditUserSkillOutput';
  skills: Array<Maybe<UserSkillOutput>>;
  total: Scalars['Int']['output'];
};

export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  templateId: Scalars['String']['output'];
};

export type EmailUpdateResult = {
  __typename?: 'EmailUpdateResult';
  emailChanged: Scalars['Boolean']['output'];
  emailConfirmationRequired: Scalars['Boolean']['output'];
  user: User;
};

export type EventInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  sequentialOrder?: InputMaybe<Scalars['Float']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type EventTopic = {
  __typename?: 'EventTopic';
  topicDetails?: Maybe<Scalars['String']['output']>;
  topicId: Scalars['String']['output'];
};

export type Expense = {
  __typename?: 'Expense';
  /** @deprecated Use ChargeExpense instead */
  amount?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use PriceExpense instead */
  unitCost?: Maybe<Scalars['Int']['output']>;
  updatedAt: Scalars['Int']['output'];
};

export type ExpensesFilter = {
  expenseNameSearch?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default False */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ExpensesPagination = {
  __typename?: 'ExpensesPagination';
  expenses: Array<Maybe<Expense>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type FailedUser = {
  __typename?: 'FailedUser';
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  password?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type FailedUserInput = {
  __typename?: 'FailedUserInput';
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<FailedUser>;
};

export type FeedbackInput = {
  /** The URL for the route that the user was on when submitting the feedback */
  activeRoute?: InputMaybe<Scalars['String']['input']>;
  /** Details that the user entered when submitting the feedback */
  details?: InputMaybe<Scalars['String']['input']>;
  /** What type of feedback is being submitted, bug, feedback, support' */
  feedbackType?: InputMaybe<FeedbackType>;
  /** Session URL for DataDog */
  sessionURL?: InputMaybe<Scalars['String']['input']>;
};

export enum FeedbackType {
  Bug = 'bug',
  Feedback = 'feedback',
  Support = 'support'
}

export type Field = {
  __typename?: 'Field';
  appliesTo?: Maybe<Array<Scalars['String']['output']>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Int']['output'];
  default?: Maybe<Scalars['FieldValue']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  /** A stringified AJV validation object to be used to validate and given values for the field */
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  /** @deprecated No longer relevant to the current version of the fields service */
  roles?: Maybe<Role>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  value?: Maybe<FieldObjectValue>;
  values?: Maybe<Array<FieldObjectValue>>;
  zones?: Maybe<ListZonesOutput>;
};


export type FieldZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type FieldAndRoleIds = {
  __typename?: 'FieldAndRoleIds';
  fieldIds: Array<Scalars['String']['output']>;
  roleIds: Array<Scalars['String']['output']>;
};

export type FieldEditInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** If edited and there are existing incompatible types, an error will be thrown unless `forceChange` is true. */
  default?: InputMaybe<Scalars['FieldValue']['input']>;
  /** If edited and there are existing incompatible types, an error will be thrown unless `forceChange` is true. */
  format?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FieldFilter = {
  allLabels?: InputMaybe<Array<Scalars['String']['input']>>;
  default?: InputMaybe<Scalars['FieldValue']['input']>;
  hasAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  key?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  namespaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldInput = {
  appliesTo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  default?: InputMaybe<Scalars['FieldValue']['input']>;
  /** A stringified AJV validation object to be used to validate and given values for the field */
  format?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type FieldObjectValue = {
  __typename?: 'FieldObjectValue';
  createdAt?: Maybe<Scalars['Int']['output']>;
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  value?: Maybe<Scalars['FieldValue']['output']>;
};

export type FieldResponse = {
  __typename?: 'FieldResponse';
  dateSubmitted: Scalars['Int']['output'];
  datedEdited: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  fieldId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  savedOn?: Maybe<Scalars['Int']['output']>;
  validated?: Maybe<Scalars['Boolean']['output']>;
  value: Scalars['String']['output'];
};

export type FieldResponseEdit = {
  id: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type FieldResponseInput = {
  fieldId: Scalars['String']['input'];
  savedOn?: InputMaybe<Scalars['Boolean']['input']>;
  validated?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type FieldResult = {
  __typename?: 'FieldResult';
  fields: Array<Field>;
};

export type FieldType = {
  __typename?: 'FieldType';
  format?: Maybe<Scalars['String']['output']>;
  isFieldRequired?: Maybe<Scalars['Boolean']['output']>;
  maxChecked?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minChecked?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  pattern?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  typeName: Scalars['String']['output'];
};

export type FieldTypeInput = {
  format?: InputMaybe<Scalars['String']['input']>;
  isFieldRequired?: InputMaybe<Scalars['Boolean']['input']>;
  maxChecked?: InputMaybe<Scalars['Int']['input']>;
  maxLength?: InputMaybe<Scalars['Int']['input']>;
  minChecked?: InputMaybe<Scalars['Int']['input']>;
  minLength?: InputMaybe<Scalars['Int']['input']>;
  options?: InputMaybe<Array<InputMaybe<OptionInput>>>;
  pattern?: InputMaybe<Scalars['String']['input']>;
  questionText?: InputMaybe<Scalars['String']['input']>;
  typeName: Scalars['String']['input'];
};

export type FilterByNumericalValueInput = {
  greaterThan?: InputMaybe<Scalars['Int']['input']>;
  greaterThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
  lesserThan?: InputMaybe<Scalars['Int']['input']>;
  lesserThanOrEqualTo?: InputMaybe<Scalars['Int']['input']>;
};

export type FindOutput = {
  __typename?: 'FindOutput';
  assetCount: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
  windowCount: Scalars['Int']['output'];
  windows: Array<Maybe<BookingWindow>>;
};

export type FindTimes = {
  findMethod: Scalars['String']['input'];
  periodEnd?: InputMaybe<Scalars['Int']['input']>;
  periodStart?: InputMaybe<Scalars['Int']['input']>;
  preferredUsers?: InputMaybe<Array<Scalars['String']['input']>>;
  timeSearch?: InputMaybe<TimesSearch>;
  times?: InputMaybe<Array<BookTime>>;
};

export type FormField = {
  __typename?: 'FormField';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdOn: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  fieldName: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isFieldRequired?: Maybe<Scalars['Boolean']['output']>;
  maxChecked?: Maybe<Scalars['Int']['output']>;
  maxLength?: Maybe<Scalars['Int']['output']>;
  minChecked?: Maybe<Scalars['Int']['output']>;
  minLength?: Maybe<Scalars['Int']['output']>;
  options?: Maybe<Array<Maybe<Option>>>;
  order?: Maybe<Scalars['Float']['output']>;
  pattern?: Maybe<Scalars['String']['output']>;
  questionText?: Maybe<Scalars['String']['output']>;
  typeName: Scalars['String']['output'];
  updatedOn: Scalars['Int']['output'];
};

export type FormFieldInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldName: Scalars['String']['input'];
  fieldType: FieldTypeInput;
  order?: InputMaybe<Scalars['Float']['input']>;
};

export type FormResponse = {
  __typename?: 'FormResponse';
  accesses?: Maybe<Array<Maybe<Access>>>;
  confirmationPage?: Maybe<Scalars['String']['output']>;
  dateEdited: Scalars['Int']['output'];
  dateStarted?: Maybe<Scalars['Int']['output']>;
  dateSubmitted?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  fieldResponses?: Maybe<Array<Maybe<FieldResponse>>>;
  formSecret?: Maybe<Scalars['String']['output']>;
  formTypeId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  responder?: Maybe<Scalars['String']['output']>;
  sectionResponses?: Maybe<Array<Maybe<FormResponse>>>;
  unAnsweredFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  validated?: Maybe<Scalars['Boolean']['output']>;
};


export type FormResponseAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};

export type FormResponseEdit = {
  formResponseEdit?: InputMaybe<ResponseEditBase>;
  id: Scalars['String']['input'];
  submit?: InputMaybe<Scalars['Boolean']['input']>;
  validateResponse?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormResponseEditOutput = {
  __typename?: 'FormResponseEditOutput';
  isEditSuccessful?: Maybe<Scalars['Boolean']['output']>;
  isSubmitSuccessful?: Maybe<Scalars['Boolean']['output']>;
  validationResult?: Maybe<ValidateFormResponseOutput>;
};

export type FormResponseFilter = {
  formTypeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  getUnansweredFields?: InputMaybe<Scalars['Boolean']['input']>;
  getValid?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type FormResponseInput = {
  confirmationPage?: InputMaybe<Scalars['String']['input']>;
  dateStarted?: InputMaybe<Scalars['Int']['input']>;
  fieldResponses?: InputMaybe<Array<InputMaybe<FieldResponseInput>>>;
  formSecret?: InputMaybe<Scalars['String']['input']>;
  formTypeId: Scalars['String']['input'];
  sectionResponses?: InputMaybe<Array<InputMaybe<FormResponseInput>>>;
};

export type FormResponsePagination = {
  __typename?: 'FormResponsePagination';
  limited?: Maybe<Scalars['Int']['output']>;
  responses: Array<Maybe<FormResponse>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type FormType = {
  __typename?: 'FormType';
  allowAnonymousEntries?: Maybe<Scalars['Boolean']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  confirmationMessage?: Maybe<Scalars['String']['output']>;
  confirmationPage?: Maybe<Scalars['String']['output']>;
  createdOn: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  editAfterSubmit?: Maybe<Scalars['Boolean']['output']>;
  fields?: Maybe<Array<Maybe<FormField>>>;
  id: Scalars['String']['output'];
  limitToOneResponse?: Maybe<Scalars['Boolean']['output']>;
  permissionsRequired?: Maybe<Array<Scalars['String']['output']>>;
  sections?: Maybe<Array<Maybe<FormType>>>;
  title?: Maybe<Scalars['String']['output']>;
  updatedOn: Scalars['Int']['output'];
};

export type FormTypeFilter = {
  hasAllAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAnyAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  sectionOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type FormTypeInput = {
  allowAnonymousEntries?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  confirmationMessage?: InputMaybe<Scalars['String']['input']>;
  confirmationPage?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  editAfterSubmit?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<Array<InputMaybe<FormFieldInput>>>;
  limitToOneResponse?: InputMaybe<Scalars['Boolean']['input']>;
  permissionsRequired?: InputMaybe<Array<Scalars['String']['input']>>;
  sections?: InputMaybe<Array<InputMaybe<FormTypeInput>>>;
  title: Scalars['String']['input'];
};

export type FormTypePagination = {
  __typename?: 'FormTypePagination';
  forms?: Maybe<Array<Maybe<FormType>>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type FullInvoice = {
  __typename?: 'FullInvoice';
  invoice?: Maybe<StripeInvoice>;
  lineItems?: Maybe<Array<InvoiceItem>>;
  paymentIntent?: Maybe<PaymentIntent>;
};

export type GenerateChargesLocation = {
  address?: InputMaybe<Scalars['String']['input']>;
  details?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateChargesWithAiInput = {
  eventId?: InputMaybe<Scalars['String']['input']>;
  instructions?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
};

export type GenerateChargesWithAiOutput = {
  __typename?: 'GenerateChargesWithAIOutput';
  crewSize?: Maybe<Scalars['Float']['output']>;
  crewSizeExplanation?: Maybe<Scalars['String']['output']>;
  itinerary?: Maybe<Array<Maybe<ItineraryItem>>>;
  salesAgentInstructions: Scalars['String']['output'];
  selectedProducts: Array<SelectedProduct>;
};

export type GenerateSecretOutput = {
  __typename?: 'GenerateSecretOutput';
  /**  Link for QR Code with secret encoded. */
  qr: Scalars['String']['output'];
  /**  Secret used for generating codes. */
  secret: Scalars['String']['output'];
  /**  URI to generate a QR Code from. */
  uri: Scalars['String']['output'];
};

export type GrantAccess = {
  accessType: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
  objectId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type History = {
  __typename?: 'History';
  actionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  ip?: Maybe<Scalars['String']['output']>;
  objectId?: Maybe<Scalars['String']['output']>;
  objectLabel?: Maybe<Scalars['String']['output']>;
  /**  Ids of the items related to this history.  */
  related?: Maybe<Array<Maybe<RelatedHistoryItem>>>;
  /**  Field for extra information */
  text?: Maybe<Scalars['String']['output']>;
  /** Action type, eg. 'ADDED_COMMENT', 'REMOVED_ATTENDEE'  */
  type?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vars?: Maybe<Scalars['HistoryVars']['output']>;
  zoneId?: Maybe<Scalars['String']['output']>;
};

export type HistoryFilter = {
  historyIds?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  /**  The ids of Items that are related to the history. Eg. The ID of tag if the type was TAG_ADDED  */
  relatedItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Action type, eg. 'ADDED_COMMENT', 'REMOVED_ATTENDEE'  */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  The users who created the history, Not relatedItems */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HistoryPagination = {
  __typename?: 'HistoryPagination';
  history?: Maybe<Array<History>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type HourFilter = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
};

export type IdWithLabel = {
  __typename?: 'IDWithLabel';
  id: Scalars['String']['output'];
  labels: Array<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type IgnoreAttentionInput = {
  attentionReason: Scalars['String']['input'];
  itemId: Scalars['String']['input'];
  itemLabel?: InputMaybe<Scalars['String']['input']>;
};

export type IntBox = {
  __typename?: 'IntBox';
  value: Scalars['Int']['output'];
};

export type Inventory_Items = {
  __typename?: 'Inventory_Items';
  is3rdPartyServicing?: Maybe<Scalars['Boolean']['output']>;
  isAssembleDisassemble?: Maybe<Scalars['Boolean']['output']>;
  isBulky?: Maybe<Scalars['Boolean']['output']>;
  isProGear?: Maybe<Scalars['Boolean']['output']>;
  isSpecialEquipment?: Maybe<Scalars['Boolean']['output']>;
  isValuable?: Maybe<Scalars['Boolean']['output']>;
  isoCode1?: Maybe<Scalars['String']['output']>;
  isoCode2?: Maybe<Scalars['String']['output']>;
  isoCode3?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  reviewerName?: Maybe<Scalars['String']['output']>;
  volume?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['String']['output']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  /** The artifacts for all PDF documents associated with the invoice */
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  createdAt: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  damageTotal: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  discountTotal: Scalars['Int']['output'];
  discountedSubTotalWithoutDamages: Scalars['Int']['output'];
  dueDate: Scalars['Int']['output'];
  /** All invoiced events */
  events: Array<CalendarEvent>;
  id: Scalars['String']['output'];
  invoiceDate: Scalars['Int']['output'];
  invoiceNumber: Scalars['Int']['output'];
  job: Job;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  openedAt?: Maybe<Scalars['Int']['output']>;
  paidTotal: Scalars['Int']['output'];
  sentAt?: Maybe<Scalars['Int']['output']>;
  subTotal: Scalars['Int']['output'];
  taxTotal: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  /** All transactions applied to the invoice */
  transactions: Array<Transaction>;
  updatedAt: Scalars['String']['output'];
  voidedAt?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceFilter = {
  balance?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dueDate?: InputMaybe<FilterByNumericalValueInput>;
  getInvoiceOfStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceDate?: InputMaybe<FilterByNumericalValueInput>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  userSearch?: InputMaybe<UserSearchInput>;
};

export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discountable?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  tax_amounts?: Maybe<Array<TaxAmount>>;
  tax_rates?: Maybe<Array<TaxRate>>;
  unit_amount?: Maybe<Scalars['Int']['output']>;
};

export type InvoiceItemList = {
  __typename?: 'InvoiceItemList';
  data?: Maybe<Array<InvoiceItem>>;
  has_more?: Maybe<Scalars['Boolean']['output']>;
};

export type InvoicePage = {
  __typename?: 'InvoicePage';
  invoices: Array<Invoice>;
  limited: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total?: Maybe<Scalars['Int']['output']>;
};

export type ItineraryItem = {
  __typename?: 'ItineraryItem';
  description?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Float']['output']>;
  location?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type Job = {
  __typename?: 'Job';
  accesses?: Maybe<Array<Maybe<Access>>>;
  /** What action to perform on a job that deserves attention. */
  action?: Maybe<Scalars['String']['output']>;
  adminSummary?: Maybe<Scalars['Summary']['output']>;
  /**
   * Details of discounts applied to root job and associated charges
   * @deprecated Use discounts instead
   */
  allAppliedDiscountDetails?: Maybe<Array<Maybe<ObjectDiscountDetails>>>;
  /** Unix timestamp of the date and time the job was archived */
  archivedAt?: Maybe<Scalars['Int']['output']>;
  artifacts?: Maybe<Array<Artifact>>;
  /** The reasons why the job deserves attention. */
  attentionExplanation?: Maybe<Array<Scalars['String']['output']>>;
  /** A measure of how much attention the job deserves. */
  attentionScore?: Maybe<Scalars['Float']['output']>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  charges: Array<Maybe<Charge>>;
  closedAt?: Maybe<Scalars['Int']['output']>;
  /**
   * The reason for the job's closure, if any. Note that some closedReason values are only viewable for jobs
   * at certain stages. e.g. A specific closedReason value may only be viewable on jobs at the invoice stage.
   */
  closedReason?: Maybe<Scalars['String']['output']>;
  /**
   * Non-unique identifier for the Job, if autogenerated will use the format xxxx-xxx-xxx.
   * The portion of code preceeding the first dash corresponds to the zone the job is in.
   */
  code?: Maybe<Scalars['String']['output']>;
  /** Unique indentifier for a collection of jobs. When a job transitions it keeps the same collectionId */
  collectionId: Scalars['String']['output'];
  comments?: Maybe<CommentPagination>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  crewSummary?: Maybe<Scalars['Summary']['output']>;
  /** ISO Currency format */
  currency: Scalars['String']['output'];
  customerSummary?: Maybe<Scalars['Summary']['output']>;
  /** Value in cents */
  damageTotal: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  depositRequired?: Maybe<Scalars['Int']['output']>;
  /** The total value of paid transactions of type 'deposit'. Pending transactions are omitted. Value in cents */
  depositTotal?: Maybe<Scalars['Int']['output']>;
  /** Value in cents */
  discountTotal: Scalars['Int']['output'];
  /** Value in cents */
  discountedSubTotal: Scalars['Int']['output'];
  /** Value in cents */
  discountedSubTotalWithoutDamages: Scalars['Int']['output'];
  /** Details of discount applied to root job */
  discounts?: Maybe<Array<Maybe<DiscountDetails>>>;
  distances?: Maybe<RouteDistances>;
  events?: Maybe<Array<Maybe<CalendarEvent>>>;
  /** Flag set when user updated order of events in the job and they are being ordered by custom range instead of start date. */
  eventsOrderChangedByUser?: Maybe<Scalars['Boolean']['output']>;
  /** Value in cents */
  expenseTotal: Scalars['Int']['output'];
  fields?: Maybe<Array<Maybe<Field>>>;
  firstBookedRevenueGeneratingEvent?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Removed job stages */
  followingStages?: Maybe<Array<Maybe<Job>>>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  invoices: Array<Invoice>;
  jobCategory?: Maybe<Scalars['String']['output']>;
  locations?: Maybe<Array<Maybe<JobLocation>>>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  /** Total value of paid transactions for the job, excluding transactions of type 'refund'. Value in cents */
  paidTotal: Scalars['Int']['output'];
  /** Total value of pending transactions for the job. Value in cents */
  pendingTotal: Scalars['Int']['output'];
  /** @deprecated Removed job stages */
  previousStages?: Maybe<Array<Maybe<Job>>>;
  /** The total value of paid transactions of type 'refund'. Pending transactions are omitted. Value in cents */
  refundTotal?: Maybe<Scalars['Int']['output']>;
  /**  The ids of the zones that this job has been shared with  */
  sharedZones?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The stage the Job represents in the overall Job workflow
   * Possible Values: ("lead", “estimate”, “booking”, “invoice”, "cancelled")
   */
  stage: Scalars['String']['output'];
  /**
   * An array of stage names that this job has had, matches the index pair of stageTimes
   * EG stageLabels and stageTimes may look like:
   * [ 'lead', 'estimate' ]
   * [ 1660663115, 1660663117 ]
   */
  stageLabels?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * An array of stage times that this job has had, matches the index pair of stageLabels
   *
   * In unix seconds
   *
   * EG stageLabels and stageTimes may look like:
   * [ 'lead', 'estimate', 'booking' ]
   * [ 1660663115, 1660663117, 1660663119 ]
   *
   * These times are paired with stage_lead, stage_invoice, etc. However, those
   * times are always the first time that a stage occured where there could be multiple instances
   * of a stage
   */
  stageTimes?: Maybe<Array<Scalars['String']['output']>>;
  stage_booking?: Maybe<Scalars['Int']['output']>;
  stage_cancelled?: Maybe<Scalars['Int']['output']>;
  stage_estimate?: Maybe<Scalars['Int']['output']>;
  stage_invoice?: Maybe<Scalars['Int']['output']>;
  stage_lead?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Removed job stages */
  stages?: Maybe<Array<Maybe<JobStage>>>;
  /** The current state of the Job, values: 'open', 'closed', 'archived', 'deleted' */
  state?: Maybe<Scalars['String']['output']>;
  /** Value in cents */
  subTotal: Scalars['Int']['output'];
  tags: Array<Maybe<Tag>>;
  /** Value in cents */
  taxTotal: Scalars['Int']['output'];
  taxesPaid?: Maybe<Array<TaxPaid>>;
  timeline?: Maybe<Scalars['String']['output']>;
  timelineDays?: Maybe<Scalars['Float']['output']>;
  /** Value in cents */
  total: Scalars['Int']['output'];
  /** The number of transactions on the Job */
  transactionCount?: Maybe<Scalars['Int']['output']>;
  transactions?: Maybe<Array<Maybe<Transaction>>>;
  users?: Maybe<Array<Maybe<JobUser>>>;
  zone?: Maybe<Zone>;
};


export type JobAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};


export type JobHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type JobAssignment = {
  __typename?: 'JobAssignment';
  assignedMembers: Array<AssignedMember>;
  jobId: Scalars['String']['output'];
};

export type JobChangedEvent = {
  __typename?: 'JobChangedEvent';
  action: Scalars['String']['output'];
  /**
   * The ID of the action that caused this change
   * Might be undefined as it requires backend logic to pass
   * this in metadata from the frontend as the 'x-actionid' header
   */
  actionId?: Maybe<Scalars['String']['output']>;
  input?: Maybe<Scalars['JobChangeEventData']['output']>;
  job?: Maybe<Job>;
  jobId: Scalars['ID']['output'];
  output?: Maybe<Scalars['JobChangeEventData']['output']>;
  /**
   * The ID of the session that caused this change
   * Might be undefined as it requires backend logic to pass
   * this in metadata from the frontend as the 'x-session' header
   */
  sessionId?: Maybe<Scalars['String']['output']>;
  time: Scalars['Float']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
};

export type JobClosedOutput = {
  __typename?: 'JobClosedOutput';
  jobId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type JobInput = {
  jobId: Scalars['String']['input'];
  requiredCrewSize: Scalars['Int']['input'];
  timeWindow: Scalars['String']['input'];
};

export type JobLocation = {
  __typename?: 'JobLocation';
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
};

export type JobLocationInput = {
  locationId?: InputMaybe<Scalars['String']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  newLocationInput?: InputMaybe<LocationCreateBase>;
  /** Only used if param newLocationInput is used */
  owner?: InputMaybe<Scalars['String']['input']>;
};

export type JobPromotedOutput = {
  __typename?: 'JobPromotedOutput';
  jobId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type JobStage = {
  __typename?: 'JobStage';
  createdAt?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  /**
   * The stage the Job represents in the overall Job workflow
   * Possible Values: ("lead", “estimate”, “booking”, “invoice”, "cancelled")
   */
  stage?: Maybe<Scalars['String']['output']>;
  transitionedAt?: Maybe<Scalars['Int']['output']>;
};

export type JobSummaryDataInput = {
  jobId: Scalars['String']['input'];
};

export type JobUser = {
  __typename?: 'JobUser';
  /** The role a user has on the related job, NOT a system role */
  role?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type JobUserInput = {
  /** The role a user has on the related job, NOT a system role */
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type JobsFilter = {
  appliedTaxes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archived?: InputMaybe<FilterByNumericalValueInput>;
  attentionExplanations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chargeIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  closedAt?: InputMaybe<FilterByNumericalValueInput>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  collectionId?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<FilterByNumericalValueInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  discountIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endLocationSearch?: InputMaybe<Scalars['String']['input']>;
  estimateMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatorIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventsFilter?: InputMaybe<ObjectCalendarEventsFilterInput>;
  excludeClosedReasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Default false */
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  getJobsOfStage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Accepted values: 'open', 'closed', 'archived', 'deleted'
   * Note: If 'deleted' is included, then the filter param getDeleted
   * will be set to true
   */
  getJobsOfState?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Whethere the job has an event of type estimating with completed status */
  hasCompletedEventOfType?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Queries a job by it's ID. If the job exists but it is not the latest job
   * then it will return the latest version of that job.
   *
   * For example, if you have a job with the stages:
   * a->b->c (where a,b, and c are IDs and '->' represents a transition to a different stage)
   *
   * If you query jobAncestorIds for a, b, or c you will receive "c" in all cases.
   */
  jobAncestorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Queries a job by its ID */
  jobIds?: InputMaybe<Array<Scalars['String']['input']>>;
  lastUpdated?: InputMaybe<FilterByNumericalValueInput>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  noAttentionExplanation?: InputMaybe<Scalars['Boolean']['input']>;
  noEstimateMethod?: InputMaybe<Scalars['Boolean']['input']>;
  noEstimator?: InputMaybe<Scalars['Boolean']['input']>;
  noOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  noSalesAgent?: InputMaybe<Scalars['Boolean']['input']>;
  noSource?: InputMaybe<Scalars['Boolean']['input']>;
  noUtmCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  noUtmContents?: InputMaybe<Scalars['Boolean']['input']>;
  noUtmMedium?: InputMaybe<Scalars['Boolean']['input']>;
  noUtmSource?: InputMaybe<Scalars['Boolean']['input']>;
  noUtmTerm?: InputMaybe<Scalars['Boolean']['input']>;
  origins?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  priceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  salesAgentIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Queries based on any associated user's given name, family name, email, and phone number as well as the job stage and code */
  search?: InputMaybe<Scalars['String']['input']>;
  sources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stage?: InputMaybe<Scalars['String']['input']>;
  startLocationSearch?: InputMaybe<Scalars['String']['input']>;
  tagIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactionAmount?: InputMaybe<FilterByNumericalValueInput>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userSearch?: InputMaybe<UserSearchInput>;
  utmCampaigns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmContents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmMedia?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmSources?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  utmTerms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type Jobs_ClosedReasons = {
  __typename?: 'Jobs_ClosedReasons';
  id?: Maybe<Scalars['String']['output']>;
  stages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LeadSourceTokenInput = {
  customerType?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type LinkDetail = {
  __typename?: 'LinkDetail';
  expiresOn?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  startsOn?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type LinkResult = {
  __typename?: 'LinkResult';
  isSuccess: Scalars['Boolean']['output'];
};

export type ListAccessInput = {
  filter?: InputMaybe<AccessFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};

export type ListArtifactsOutput = {
  __typename?: 'ListArtifactsOutput';
  artifacts: Array<Maybe<Artifact>>;
  limited: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListAttentionItemsOutput = {
  __typename?: 'ListAttentionItemsOutput';
  items: Array<Maybe<AttentionItem>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListBlocksOutput = {
  __typename?: 'ListBlocksOutput';
  blocks?: Maybe<Array<Block>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListCommentFilter = {
  artifactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasNoAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  objectType?: InputMaybe<Scalars['String']['input']>;
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  parentsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  threadMode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListDiscountsOutput = {
  __typename?: 'ListDiscountsOutput';
  discounts: Array<Maybe<Discount>>;
  limited: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type ListDynamicReportsOutput = {
  __typename?: 'ListDynamicReportsOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  reports: Array<DynamicReport>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListEntry = {
  __typename?: 'ListEntry';
  baseId: Scalars['String']['output'];
  description: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sourceId: Scalars['String']['output'];
  sourceName: Scalars['String']['output'];
  sourceSize: Scalars['String']['output'];
  sourceTS: Scalars['String']['output'];
  tsLastCounted: Scalars['Int']['output'];
  tsLastModified: Scalars['Int']['output'];
  tsSource: Scalars['Int']['output'];
};

export type ListHistoryFilter = {
  AND?: InputMaybe<ListHistoryFilter>;
  NOT?: InputMaybe<ListHistoryFilter>;
  OR?: InputMaybe<ListHistoryFilter>;
  actionId?: InputMaybe<Scalars['String']['input']>;
  actionId_EQUALS?: InputMaybe<Scalars['String']['input']>;
  actionId_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  actionId_GT?: InputMaybe<Scalars['String']['input']>;
  actionId_GTE?: InputMaybe<Scalars['String']['input']>;
  actionId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionId_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionId_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionId_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actionId_LT?: InputMaybe<Scalars['String']['input']>;
  actionId_LTE?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  createdAt_EQUALS?: InputMaybe<Scalars['Float']['input']>;
  createdAt_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt_GT?: InputMaybe<Scalars['Float']['input']>;
  createdAt_GTE?: InputMaybe<Scalars['Float']['input']>;
  createdAt_IN?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  createdAt_LT?: InputMaybe<Scalars['Float']['input']>;
  createdAt_LTE?: InputMaybe<Scalars['Float']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_EQUALS?: InputMaybe<Scalars['String']['input']>;
  id_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  id_GT?: InputMaybe<Scalars['String']['input']>;
  id_GTE?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id_LT?: InputMaybe<Scalars['String']['input']>;
  id_LTE?: InputMaybe<Scalars['String']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ip_EQUALS?: InputMaybe<Scalars['String']['input']>;
  ip_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  ip_GT?: InputMaybe<Scalars['String']['input']>;
  ip_GTE?: InputMaybe<Scalars['String']['input']>;
  ip_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ip_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ip_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ip_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ip_LT?: InputMaybe<Scalars['String']['input']>;
  ip_LTE?: InputMaybe<Scalars['String']['input']>;
  main?: InputMaybe<Scalars['Boolean']['input']>;
  main_EQUALS?: InputMaybe<Scalars['Boolean']['input']>;
  main_IN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  main_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  main_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  main_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectId_EQUALS?: InputMaybe<Scalars['String']['input']>;
  objectId_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  objectId_GT?: InputMaybe<Scalars['String']['input']>;
  objectId_GTE?: InputMaybe<Scalars['String']['input']>;
  objectId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId_LT?: InputMaybe<Scalars['String']['input']>;
  objectId_LTE?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  objectLabel_EQUALS?: InputMaybe<Scalars['String']['input']>;
  objectLabel_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  objectLabel_GT?: InputMaybe<Scalars['String']['input']>;
  objectLabel_GTE?: InputMaybe<Scalars['String']['input']>;
  objectLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectLabel_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectLabel_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectLabel_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectLabel_LT?: InputMaybe<Scalars['String']['input']>;
  objectLabel_LTE?: InputMaybe<Scalars['String']['input']>;
  relatedId?: InputMaybe<Scalars['String']['input']>;
  relatedId_EQUALS?: InputMaybe<Scalars['String']['input']>;
  relatedId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedId_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedId_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedId_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedLabel?: InputMaybe<Scalars['String']['input']>;
  relatedLabel_EQUALS?: InputMaybe<Scalars['String']['input']>;
  relatedLabel_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedLabel_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedLabel_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedLabel_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedName?: InputMaybe<Scalars['String']['input']>;
  relatedName_EQUALS?: InputMaybe<Scalars['String']['input']>;
  relatedName_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedName_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedName_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedName_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  system_EQUALS?: InputMaybe<Scalars['Boolean']['input']>;
  system_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  system_GT?: InputMaybe<Scalars['Boolean']['input']>;
  system_GTE?: InputMaybe<Scalars['Boolean']['input']>;
  system_IN?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  system_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  system_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  system_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  system_LT?: InputMaybe<Scalars['Boolean']['input']>;
  system_LTE?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  type_EQUALS?: InputMaybe<Scalars['String']['input']>;
  type_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  type_GT?: InputMaybe<Scalars['String']['input']>;
  type_GTE?: InputMaybe<Scalars['String']['input']>;
  type_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type_LT?: InputMaybe<Scalars['String']['input']>;
  type_LTE?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userId_EQUALS?: InputMaybe<Scalars['String']['input']>;
  userId_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  userId_GT?: InputMaybe<Scalars['String']['input']>;
  userId_GTE?: InputMaybe<Scalars['String']['input']>;
  userId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId_LT?: InputMaybe<Scalars['String']['input']>;
  userId_LTE?: InputMaybe<Scalars['String']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
  zoneId_EQUALS?: InputMaybe<Scalars['String']['input']>;
  zoneId_EXISTS?: InputMaybe<Scalars['Boolean']['input']>;
  zoneId_GT?: InputMaybe<Scalars['String']['input']>;
  zoneId_GTE?: InputMaybe<Scalars['String']['input']>;
  zoneId_IN?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneId_INCLUDES_ALL?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneId_INCLUDES_ANY?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneId_INCLUDES_NONE?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zoneId_LT?: InputMaybe<Scalars['String']['input']>;
  zoneId_LTE?: InputMaybe<Scalars['String']['input']>;
};

export type ListHistoryInput = {
  filter?: InputMaybe<ListHistoryFilter>;
  generateAggregates?: InputMaybe<Scalars['Boolean']['input']>;
  generateText?: InputMaybe<Scalars['Boolean']['input']>;
  getRelated?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ListJobsOutput = {
  __typename?: 'ListJobsOutput';
  jobs: Array<Maybe<Job>>;
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListObjectHistoryInput = {
  historyIds?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**  The ids of Items that are related to the history. Eg. The ID of tag if the type was TAG_ADDED  */
  relatedItemIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  /** Action type, eg. 'ADDED_COMMENT', 'REMOVED_ATTENDEE'  */
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**  The users who created the history, Not relatedItems */
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ListPagesOutput = {
  __typename?: 'ListPagesOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  pages?: Maybe<Array<Page>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListPermissionsInput = {
  filter?: InputMaybe<ListPermissionsInputFilter>;
  /** Add object ids here to resolve matching object ids */
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The object label to match for object ids */
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to return objects. Defaults to false unless
   * filter.objectIds or filter.objectLabel is set.
   */
  resolveObjects?: InputMaybe<Scalars['Boolean']['input']>;
  /** Resolves the highest level permission in filter.permissions and returns it in permissionMap */
  resolvePermissions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListPermissionsInputFilter = {
  anonymous?: InputMaybe<Scalars['Boolean']['input']>;
  /** Explicit zone to match for permissions */
  explicitZone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Real permissions to check for. Like `users.view`, `calendarEvents.view`, etc.
   * If `resolvePermissions` is true, these will be placed into `.permissions.map`
   */
  permissions?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The role to check */
  role?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<Scalars['String']['input']>;
  /**
   * Zone (and subzone) to match for permission
   * Defaults to current zone
   */
  zone?: InputMaybe<Scalars['String']['input']>;
};

export type ListPermissionsResult = {
  __typename?: 'ListPermissionsResult';
  /**
   * If resolvePermissions is true, Resolves all permissions in .permissions to
   * the highest level permission in filter.permissions and returns it in permissionMap
   */
  map?: Maybe<Array<Permission>>;
  /** Returns real permissions that match the given filter. */
  permissions: Array<Permission>;
};

export type ListRefreshTokensFilterInput = {
  onlyActive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyExpired?: InputMaybe<Scalars['Boolean']['input']>;
  onlyInactive?: InputMaybe<Scalars['Boolean']['input']>;
  onlyNonExpired?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListReportTypesOutput = {
  __typename?: 'ListReportTypesOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  reportTypes: Array<ReportType>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListReportsOutput = {
  __typename?: 'ListReportsOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  reports: Array<Report>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListResponse = {
  __typename?: 'ListResponse';
  count: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  result: Array<ListEntry>;
  totalCount: Scalars['Int']['output'];
};

export type ListRulesOutput = {
  __typename?: 'ListRulesOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  rules: Array<Maybe<Rule>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type ListScheduledReportAggregatesFilter = {
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ListScheduledReportAggregatesInput = {
  delta?: InputMaybe<ListScheduledReportDeltaInput>;
  filter?: InputMaybe<ListScheduledReportAggregatesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Used to calculate changes over time. */
export type ListScheduledReportDeltaInput = {
  /**
   * The period to calculate the delta from.
   * Positive for past values, negative for future values
   * Defaults to 1 if anchor is "now," otherwise 0
   */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Used to anchor delta's to the `start_of` or `end_of` the specified unit.
   * For example, for the start of the current month, use
   * `anchor = 'start_of'`, `unit = 'month'`, `amount = 0`"
   * Defaults to `now`
   */
  anchor?: InputMaybe<ReportDeltaAnchor>;
  /** How delta is calculated. Defaults to `percentChanged` */
  type?: InputMaybe<ReportDeltaType>;
  /** Timezone to use with anchors. */
  tz?: InputMaybe<Scalars['String']['input']>;
  /** Units to base "amount" from. Defaults to "hour" */
  unit?: InputMaybe<ReportDeltaUnit>;
};

export type ListScheduledReportsOutput = {
  __typename?: 'ListScheduledReportsOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  scheduledReports?: Maybe<Array<ScheduledReport>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListStripeProductsOutput = {
  __typename?: 'ListStripeProductsOutput';
  has_more: Scalars['Boolean']['output'];
  products: Array<Maybe<StripeProduct>>;
};

export type ListTaxesOutput = {
  __typename?: 'ListTaxesOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  taxes: Array<Maybe<Tax>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListTemplatesFilter = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<QuillTemplateLocation>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ListTokensOutput = {
  __typename?: 'ListTokensOutput';
  limited?: Maybe<Scalars['Int']['output']>;
  nodes?: Maybe<Array<Maybe<Token>>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type ListTransactionsOutput = {
  __typename?: 'ListTransactionsOutput';
  limited: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
  transactions: Array<Maybe<Transaction>>;
};

export type ListZonesFilter = {
  contextable?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * A User ID to filter zones by zones that are contextable by a user
   *
   * eg this user has a role that has the zones.contextable permission on a zone.l
   *
   * Used to query availableZones for a specific user
   *
   * Use with showContextableRoles to determine contexts.
   */
  contextableBy?: InputMaybe<Scalars['String']['input']>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  indirectZone?: InputMaybe<Scalars['String']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  objects?: InputMaybe<Array<Scalars['String']['input']>>;
  objectsDeep?: InputMaybe<Array<Scalars['String']['input']>>;
  parent?: InputMaybe<Scalars['String']['input']>;
  parents?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ListZonesObjectFilter = {
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type ListZonesOutput = {
  __typename?: 'ListZonesOutput';
  limited: Scalars['Int']['output'];
  nodes: Array<Maybe<Zone>>;
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Location = {
  __typename?: 'Location';
  accesses?: Maybe<Array<Maybe<Access>>>;
  addressLineOne?: Maybe<Scalars['String']['output']>;
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  areaCode?: Maybe<Scalars['String']['output']>;
  artifacts?: Maybe<Array<Maybe<Artifact>>>;
  assets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  comments?: Maybe<CommentPagination>;
  coordinates?: Maybe<Coordinates>;
  costPerHour?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryJurisdiction?: Maybe<Scalars['String']['output']>;
  eventCapacity?: Maybe<Scalars['Int']['output']>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  individualCapacity?: Maybe<Scalars['Int']['output']>;
  locationType?: Maybe<Scalars['String']['output']>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  minTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  parentId?: Maybe<Scalars['String']['output']>;
  parents?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  public?: Maybe<Scalars['Boolean']['output']>;
  /** Resolves the service area that this location belongs to. Differs from the zone because this location may be created in zone A but geographically belong to zone B */
  serviceArea?: Maybe<Zone>;
  subLocations: Array<Maybe<Location>>;
  /**
   * Returns an array of objects that use this location. For example, a job (with lables ["Job"]) may have
   * a location with the type "HAS_START_LOCATION"
   *
   * If a location is "used" by one or more objects then it will not be able to be updated until that
   * item is HARD deleted. Note: a soft delete will still show up in the "used" array.
   * @deprecated High DB impact, locations are not being reused currently
   */
  used?: Maybe<Array<LocationInUse>>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  zones?: Maybe<ListZonesOutput>;
};


export type LocationAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};


export type LocationHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};


export type LocationZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type LocationBase = {
  __typename?: 'LocationBase';
  addressLineOne?: Maybe<Scalars['String']['output']>;
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  areaCode?: Maybe<Scalars['String']['output']>;
  assets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Coordinates>;
  costPerHour?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryJurisdiction?: Maybe<Scalars['String']['output']>;
  eventCapacity?: Maybe<Scalars['Int']['output']>;
  googlePlaceId?: Maybe<Scalars['String']['output']>;
  individualCapacity?: Maybe<Scalars['Int']['output']>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  minTime?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  public?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type LocationBox = {
  __typename?: 'LocationBox';
  addressLineOne: Scalars['String']['output'];
  addressLineTwo?: Maybe<Scalars['String']['output']>;
  appointmentCapacity?: Maybe<Scalars['Int']['output']>;
  areaCode?: Maybe<Scalars['String']['output']>;
  assets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  city?: Maybe<Scalars['String']['output']>;
  costPerHour?: Maybe<Scalars['Int']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  countryJurisdiction?: Maybe<Scalars['String']['output']>;
  individualCapacity?: Maybe<Scalars['Int']['output']>;
  maxTime?: Maybe<Scalars['Int']['output']>;
  minTime?: Maybe<Scalars['Int']['output']>;
};

export type LocationCreateBase = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinateInput>;
  costPerHour?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryJurisdiction?: InputMaybe<Scalars['String']['input']>;
  eventCapacity?: InputMaybe<Scalars['Int']['input']>;
  individualCapacity?: InputMaybe<Scalars['Int']['input']>;
  locationType?: InputMaybe<Scalars['String']['input']>;
  maxTime?: InputMaybe<Scalars['Int']['input']>;
  minTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationDeleteOutput = {
  __typename?: 'LocationDeleteOutput';
  removedLocations: Array<Maybe<Scalars['String']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LocationEditOutput = {
  __typename?: 'LocationEditOutput';
  editedLocations: Array<Maybe<Location>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LocationInUse = {
  __typename?: 'LocationInUse';
  labels: Array<Scalars['String']['output']>;
  objId: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type LocationPagination = {
  __typename?: 'LocationPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  locations: Array<Maybe<Location>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type LocationsCreateInput = {
  locations: Array<InputMaybe<LocationCreateBase>>;
  owner?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to set the service area for this location, default: TRUE */
  setServiceArea?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationsEditInput = {
  addressLineOne?: InputMaybe<Scalars['String']['input']>;
  addressLineTwo?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  coordinates?: InputMaybe<CoordinateInput>;
  costPerHour?: InputMaybe<Scalars['Int']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryJurisdiction?: InputMaybe<Scalars['String']['input']>;
  eventCapacity?: InputMaybe<Scalars['Int']['input']>;
  individualCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxTime?: InputMaybe<Scalars['Int']['input']>;
  minTime?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type LocationsFilter = {
  address?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<Scalars['String']['input']>;
  assets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  countryJurisdiction?: InputMaybe<Scalars['String']['input']>;
  getUsers?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasAnyAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isSoftDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxCostPerHour?: InputMaybe<Scalars['Int']['input']>;
  maxEventCapacity?: InputMaybe<Scalars['Int']['input']>;
  maxTime?: InputMaybe<Scalars['Int']['input']>;
  minCapacity?: InputMaybe<Scalars['Int']['input']>;
  minCostPerHour?: InputMaybe<Scalars['Int']['input']>;
  minEventCapacity?: InputMaybe<Scalars['Int']['input']>;
  minTime?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /**  Which sub objects to resolve options are: 'users', 'sublocations', 'parents', 'used', 'serviceArea'  */
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scope?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export enum MatchedServiceAreaMatchType {
  AreaCode = 'area_code',
  Distance = 'distance'
}

export type Member = {
  available: Scalars['String']['input'];
  memberId: Scalars['String']['input'];
  role: Scalars['String']['input'];
  salary: Scalars['String']['input'];
};

export type MessageUsersResult = {
  __typename?: 'MessageUsersResult';
  usersSent?: Maybe<Array<Scalars['String']['output']>>;
};

export type MetadataFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  key: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  _blank?: Maybe<Scalars['Boolean']['output']>;
  addComment: Comment;
  addQuillTemplate: AddQuillTemplateOutput;
  /**
   * Add roles to a field.
   * Requires `fields.edit` permission with `roles` property enabled
   * Also Requires `roles.edit` permission on specified roles, with `fields` property enabled.
   */
  addRolesToField?: Maybe<FieldAndRoleIds>;
  addSubLocations?: Maybe<SubLocationEditOutput>;
  /** Adds tags to the desired objects, requires permission 'tags.addTagsToObjects' */
  addTagsToObjects: UseObjectTagResult;
  assignObjectsToZones?: Maybe<AssignObjectsToZonesOutput>;
  assignRoles: AssignRolesOutput;
  /** Generate and verify JWTs and refresh tokens in a given zone */
  authenticate?: Maybe<AuthenticateOutput>;
  /**
   * Edits existing calendar events
   * Requires permission: `calendarEvents.create`
   */
  bulkEditCalendarEvent: CalendarEventPagination;
  clearConfigValues: Scalars['Boolean']['output'];
  /** @deprecated Use Mutation.setConfigValues instead */
  configSet?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Confirms the 2FA secret stored on the user by checking they have the right code thus enabling 2FA
   *
   * Requires credentials to have been validated in last 60 seconds
   */
  confirmSecret: Scalars['Boolean']['output'];
  createArtifacts?: Maybe<CreateArtifactOutput>;
  createAssets: Array<Asset>;
  createAvailabilityTemplate?: Maybe<AvailabilityTemplate>;
  createBlock?: Maybe<Block>;
  /**
   * Creates new calendar events / recurring calender events.
   * Requires permission: `calendarEvents.create`
   */
  createCalendarEvent: CalendarEventPagination;
  createCharges?: Maybe<Array<Charge>>;
  createCoupons: Array<Maybe<Coupon>>;
  createDiscounts: Array<Maybe<Discount>>;
  /**
   * Creates and send documents based on the given input. If a relevent document already exists
   * then the existing document will be sent.
   */
  createDocument: Array<Maybe<CreateDocumentOutput>>;
  createDynamicReport: Scalars['String']['output'];
  /**
   * Create a token to export data from moveright and
   * into a data source such as a google sheet.
   *
   * Needs to then be parsed into the IMPORTDATA function
   * for use in google sheets.
   */
  createDynamicReportExportToken: Token;
  createEmailUpdateToken: CreateEmailUpdateTokenOutput;
  /**
   * Create a token to export data from moveright and
   * into a data source such as a google sheet.
   *
   * Needs to then be parsed into the IMPORTDATA function
   * for use in google sheets.
   */
  createExportToken: Token;
  /**
   * Create fields in the current zone.
   * Requires permission `fields.create`
   *
   * If there is a roles input (uuid of role) then it will assign the roles to each field.
   */
  createFields: CreateFieldsResult;
  createFormTypes: FormTypePagination;
  /** Create a token that can be used to export events to a calendar */
  createIcalToken: Token;
  createInviteToken: Token;
  createInvoice?: Maybe<CreateInvoiceOutput>;
  createJob: Job;
  createLeadSourceToken: Token;
  createLocations: LocationPagination;
  createPage: Page;
  /**
   * Send email to the user with a link to reset their password, if they exist.
   * Must provide either a userId or email.
   */
  createPasswordResetToken: Scalars['Boolean']['output'];
  createPrices: Array<Maybe<Price>>;
  createProducts: Array<Maybe<Product>>;
  createPromotionCodes: Array<Maybe<PromotionCode>>;
  createReport: Report;
  createRoles: Array<Role>;
  createRules: Array<Rule>;
  createScheduledReport: ScheduledReport;
  /** Creates new skills, requires permission 'skills.create' */
  createSkills: SkillPagination;
  /**
   * Create a snapshot for an object at this specific point in time,
   * used to view historical records about an object.
   *
   * This will create an artifact with the json
   */
  createSnapshot: CreateSnapshotOutput;
  createStripePrices: Array<Maybe<Price>>;
  createStripeProducts: Array<Maybe<StripeProduct>>;
  /** Creates tags, requires permission 'tags.create' */
  createTag: TagResult;
  createTax: Tax;
  createTransaction: CreateTransactionOutput;
  createUsers: CreateUserResult;
  createYemboMove: CreateYemboMoveOutput;
  createYemboSelfSurvey: CreateYemboSelfSurveyOutput;
  createZones: Array<Zone>;
  /**
   * if no tokenId is provided deactivates / signs user out of all sessions and signs the user out.
   * If a tokenId is provided, deactivates the individual session provided and does not sign out.
   *
   * Requires permission: auth.deactivateRefreshTokens
   */
  deactivateRefreshTokens: Scalars['Int']['output'];
  /** Removes HTTPOnly cookies */
  deauthenticate?: Maybe<Scalars['Boolean']['output']>;
  deleteArtifacts?: Maybe<Scalars['Boolean']['output']>;
  deleteAssets: Scalars['Boolean']['output'];
  deleteAvailabilityTemplates?: Maybe<Scalars['Boolean']['output']>;
  deleteBlocks?: Maybe<BlockDeleteOutput>;
  deleteCharges?: Maybe<Scalars['Boolean']['output']>;
  deleteComments: DeleteCommentsOutput;
  deleteCoupon?: Maybe<Scalars['Boolean']['output']>;
  deleteDiscounts: Scalars['Boolean']['output'];
  deleteInvoices: Scalars['Boolean']['output'];
  deleteJobs: Scalars['Boolean']['output'];
  deletePrices: Scalars['Boolean']['output'];
  deleteProducts: Scalars['Boolean']['output'];
  deleteQuillTemplate: DeleteQuillTemplatesOutput;
  deleteRules: Array<Scalars['String']['output']>;
  deleteScheduledReports: DeleteScheduledReportOutput;
  deleteStripeProduct: Scalars['Boolean']['output'];
  deleteTaxes: Scalars['Boolean']['output'];
  deleteTokens: Scalars['Boolean']['output'];
  deleteTransactions: Scalars['Boolean']['output'];
  deleteUsers: Scalars['Boolean']['output'];
  /**
   * Disable 2FA for the logged in user.
   * Requires credentials to have been validated in last 60 seconds
   */
  disable2FA: Scalars['Boolean']['output'];
  disconnectFromQuickbooks: Scalars['Boolean']['output'];
  editAccesses: Scalars['Boolean']['output'];
  editArtifacts?: Maybe<CreateArtifactOutput>;
  editBlock?: Maybe<BlockEditOutput>;
  /**
   * Edits existing calendar events
   * Requires permission: `calendarEvents.create`
   */
  editCalendarEvent: Scalars['Boolean']['output'];
  /**
   * Edit multiple fields at once
   * Requires permission `fields.edit`
   *
   * Addition Restrictions:
   *  - allowForce
   *  - Restrict Properties
   */
  editFields: EditFieldsResult;
  editFormResponse: FormResponseEditOutput;
  editFormTypes: EditFormTypeOutput;
  editLocations: LocationEditOutput;
  editPage?: Maybe<EditPageResult>;
  /**
   * Edits existing recurring calendar events
   * Requires permission: `recurringCalendarEvents.create`
   */
  editRecurringCalendarEvent: Scalars['Boolean']['output'];
  /** Edits existing skills, requires permission 'skills.edit' */
  editSkills: EditSkillPagination;
  editUserPassword: Scalars['Boolean']['output'];
  exportInvoiceToQuickbooks: Scalars['String']['output'];
  /** 2FA: Generates and returns a secret for the user to input into Google Authenticator or other supported apps. */
  generateSecret: GenerateSecretOutput;
  getLinks: Array<Scalars['String']['output']>;
  grantAccess?: Maybe<Array<Maybe<Access>>>;
  ignoreAttention?: Maybe<Scalars['Boolean']['output']>;
  /** Links a single base skill with multiple related skills, requires permission 'skills.linkSkills' */
  linkSkills: LinkResult;
  /**
   * Creates a placeholder event to reserve the desired time. Events created this way are meant to eventually
   * be updated into proper events, else they are deleted after an hour.
   */
  lockWindow: CalendarEvent;
  logInToActOn: Scalars['Boolean']['output'];
  me: UserMutator;
  messageUsers: MessageUsersResult;
  newFormResponse: FormResponse;
  notify: Scalars['Boolean']['output'];
  paymentConnectAccount?: Maybe<ConnectAccount>;
  redeemEmailUpdateToken: RedeemEmailUpdateTokenOutput;
  redeemInviteToken: RedeemInviteTokenOutput;
  redeemPasswordResetToken: Scalars['Boolean']['output'];
  /**  Allows you to refund a specific transaction, if you are trying to refund without a specific transaction use createTransaction */
  refundTransaction: Scalars['Boolean']['output'];
  /**
   * Removes existing calendar events
   * Requires permission: `calendarEvents.remove`
   */
  removeCalendarEvent: Scalars['Boolean']['output'];
  /**
   * Soft and hard remove fields from database.
   * Requires permission `fields.remove`
   *
   * Addition Restrictions:
   *  - hardDelete
   */
  removeFields: RemoveFieldsResult;
  removeFormResponses: Scalars['Boolean']['output'];
  removeFormTypes: Scalars['Boolean']['output'];
  removeLocations?: Maybe<LocationDeleteOutput>;
  removePages?: Maybe<RemovePageResult>;
  /**
   * Removes existing recurring calendar events
   * Requires permission: `recurringCalendarEvents.remove`
   */
  removeRecurringEvents: Scalars['Boolean']['output'];
  /**
   * Add roles to a field.
   * Requires `fields.edit` permission with `roles` property enabled
   * Also Requires `roles.edit` permission on specified roles, with `fields` property enabled.
   */
  removeRolesFromField?: Maybe<FieldAndRoleIds>;
  /** Deletes existing skills, requires permission 'skills.delete' */
  removeSkills: EditSkillPagination;
  removeSubLocations?: Maybe<SubLocationEditOutput>;
  /** Removes tags from the desired objects, requires permission 'tags.removeTagsFromObjects' */
  removeTagsFromObjects: UseObjectTagResult;
  removeZones?: Maybe<RemoveZonesOutput>;
  resendDocument: Scalars['Boolean']['output'];
  restoreJobs: Scalars['Boolean']['output'];
  restoreUsers: Scalars['Boolean']['output'];
  revokeAccesses: Scalars['Boolean']['output'];
  roles: RoleMutator;
  sendDocument: Scalars['Boolean']['output'];
  sendInvoices: SendInvoiceOutput;
  /** Sends a token to either the given emails or the email to the token's associated user */
  sendToken: Scalars['Boolean']['output'];
  /**
   * Capable of setting multiple config values at once. These config values will be set
   * for the users currently contexted zone.
   * Keys are in the format namespace.key
   * User must have that key explicited listed in the config.set keys restriction, or *.*
   *
   * If you must set a system-wide configuration, set omitZone to true.
   * If omitZone is true, this will still return the values in relation to your current zone.
   *
   * You can reset configurations only if you are directly in that zone.
   */
  setConfigValues?: Maybe<Array<ConfigValue>>;
  /**
   * Set field values for users
   * Requires `fields.setValue` and `users.editFields` - Will only set values for users that match users.editFields
   * and which field values are returned by fields.setValue
   */
  setFieldsValues: SetFieldValueResult;
  setUserLocations?: Maybe<SetUserLocationsOutput>;
  /** Sets the skills of multiple users, requires permission 'skills.setUserSkills' */
  setUsersSkills: Scalars['Boolean']['output'];
  /**  Submit feedback on the application. */
  submitFeedback?: Maybe<Scalars['Boolean']['output']>;
  /** Queries tags to be mutated, requires permission 'tags.view' */
  tags: TagMutator;
  testScheduledDynamicReport: Scalars['Boolean']['output'];
  /** Unlinks a single base skill with multiple related skills, requires permission 'skills.unlinkSkills' */
  unlinkSkills: LinkResult;
  updateAppliedCustomAmount: Scalars['Boolean']['output'];
  updateAssets: Scalars['Boolean']['output'];
  updateAttentionScore?: Maybe<Scalars['Boolean']['output']>;
  /**  Updates the availability configuration for an object, creates one if the object doesn't have one yet  */
  updateAvailabilityConfiguration?: Maybe<Scalars['Boolean']['output']>;
  updateAvailabilityTemplate?: Maybe<Scalars['Boolean']['output']>;
  updateCharges?: Maybe<Scalars['Boolean']['output']>;
  updateComments: Array<Comment>;
  updateCoupon?: Maybe<Scalars['Boolean']['output']>;
  updateDiscounts: Scalars['Boolean']['output'];
  updateDynamicReport: Scalars['Boolean']['output'];
  updateInvoices: Scalars['Boolean']['output'];
  updateJobs: UpdateJobsOutput;
  updateNotificationAction: Notification;
  updatePrices: Scalars['Boolean']['output'];
  updateProducts: Scalars['Boolean']['output'];
  updatePromotionCodes?: Maybe<Scalars['Boolean']['output']>;
  updateQuillTemplate: UpdateQuillTemplateOutput;
  updateRules: Array<Rule>;
  updateScheduledReports: Array<ScheduledReport>;
  updateStripePrice: Scalars['Boolean']['output'];
  updateStripeProduct: Scalars['Boolean']['output'];
  updateTax: Scalars['Boolean']['output'];
  updateTransaction: Transaction;
  updateZones: Array<Zone>;
  users: UserMutator;
};


export type MutationAddCommentArgs = {
  input?: InputMaybe<AddCommentInput>;
};


export type MutationAddQuillTemplateArgs = {
  input?: InputMaybe<AddQuillTemplateInput>;
};


export type MutationAddRolesToFieldArgs = {
  fieldIds: Array<InputMaybe<Scalars['String']['input']>>;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationAddSubLocationsArgs = {
  parentId: Scalars['String']['input'];
  subLocations: Array<Scalars['String']['input']>;
};


export type MutationAddTagsToObjectsArgs = {
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  objects: Array<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationAssignObjectsToZonesArgs = {
  addObjects: Array<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  removeObjects: Array<Scalars['String']['input']>;
  zoneIds: Array<Scalars['String']['input']>;
};


export type MutationAssignRolesArgs = {
  inheritZones?: InputMaybe<Scalars['Boolean']['input']>;
  roles: Array<Scalars['String']['input']>;
  unassignMissing?: InputMaybe<Scalars['Boolean']['input']>;
  users: Array<Scalars['String']['input']>;
};


export type MutationAuthenticateArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
  rememberLength?: InputMaybe<Scalars['Int']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  twoFactorAuthenticationToken?: InputMaybe<Scalars['String']['input']>;
  useCookies?: InputMaybe<Scalars['Boolean']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationBulkEditCalendarEventArgs = {
  edits: Array<SingleEditInput>;
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationClearConfigValuesArgs = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  keys?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationConfigSetArgs = {
  input?: InputMaybe<SetConfig>;
};


export type MutationConfirmSecretArgs = {
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateArtifactsArgs = {
  artifacts: Array<ArtifactInput>;
};


export type MutationCreateAssetsArgs = {
  assets: Array<InputMaybe<CreateAssetInput>>;
};


export type MutationCreateAvailabilityTemplateArgs = {
  input: CreateAvailabilityTemplateInput;
};


export type MutationCreateBlockArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  block: BlockInput;
  pageId: Scalars['String']['input'];
};


export type MutationCreateCalendarEventArgs = {
  calendarEvents: Array<InputMaybe<CreateCalendarEventInput>>;
  effectSubZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipTotalUpdate?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateChargesArgs = {
  charges: Array<CreateChargeInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateCouponsArgs = {
  coupons?: InputMaybe<Array<InputMaybe<CreateCoupon>>>;
};


export type MutationCreateDiscountsArgs = {
  createDiscounts: Array<CreateDiscountInput>;
};


export type MutationCreateDocumentArgs = {
  awaitDocumentCreation?: InputMaybe<Scalars['Boolean']['input']>;
  commentWithArtifactOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  documentsToSend?: InputMaybe<Array<Scalars['String']['input']>>;
  saveArtifact?: InputMaybe<Scalars['Boolean']['input']>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
  sendDocumentExternally?: InputMaybe<Scalars['Boolean']['input']>;
  sendDocumentInternally?: InputMaybe<Scalars['Boolean']['input']>;
  sendStandardDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  sender?: InputMaybe<Scalars['String']['input']>;
  serviceToUse: Scalars['String']['input'];
  templateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['DocumentVariablesInput']['input']>;
};


export type MutationCreateDynamicReportArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<DynamicReportParametersInput>;
};


export type MutationCreateDynamicReportExportTokenArgs = {
  dynamicReportId: Scalars['String']['input'];
  performance?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateEmailUpdateTokenArgs = {
  doNotAlert?: InputMaybe<Scalars['Boolean']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
  newEmail: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationCreateExportTokenArgs = {
  reportTypeId: Scalars['String']['input'];
};


export type MutationCreateFieldsArgs = {
  fields: Array<FieldInput>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateFormTypesArgs = {
  forms?: InputMaybe<Array<InputMaybe<FormTypeInput>>>;
};


export type MutationCreateIcalTokenArgs = {
  assetIds?: InputMaybe<Array<Scalars['String']['input']>>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  name: Scalars['String']['input'];
};


export type MutationCreateInviteTokenArgs = {
  applyRoleZones?: InputMaybe<Scalars['Boolean']['input']>;
  emailsToInvite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  expiration?: InputMaybe<Scalars['Int']['input']>;
  maxUses?: InputMaybe<Scalars['Int']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  sendToken?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  validOn?: InputMaybe<Scalars['Int']['input']>;
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateInvoiceArgs = {
  invoices: Array<CreateInvoiceInput>;
};


export type MutationCreateJobArgs = {
  adminSummary?: InputMaybe<Scalars['Summary']['input']>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  crewSummary?: InputMaybe<Scalars['Summary']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerSummary?: InputMaybe<Scalars['Summary']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  events?: InputMaybe<Array<InputMaybe<EventInput>>>;
  fields?: InputMaybe<SetFieldsValuesInput>;
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<JobLocationInput>>>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  newCustomers?: InputMaybe<Array<InputMaybe<CreateUserInputWithRole>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sendSelfSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  stage: Scalars['String']['input'];
  timeline?: InputMaybe<Scalars['String']['input']>;
  timelineDays?: InputMaybe<Scalars['Float']['input']>;
  users?: InputMaybe<Array<InputMaybe<JobUserInput>>>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateLeadSourceTokenArgs = {
  input: LeadSourceTokenInput;
};


export type MutationCreateLocationsArgs = {
  input: LocationsCreateInput;
};


export type MutationCreatePageArgs = {
  author?: InputMaybe<Scalars['String']['input']>;
  page: PageInput;
};


export type MutationCreatePasswordResetTokenArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreatePricesArgs = {
  prices: Array<CreatePriceInput>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateProductsArgs = {
  products: Array<CreateProductInput>;
};


export type MutationCreatePromotionCodesArgs = {
  promoCodes?: InputMaybe<Array<InputMaybe<CreatePromotionCodeInput>>>;
};


export type MutationCreateReportArgs = {
  input: CreateReportInput;
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateRolesArgs = {
  input: Array<RoleInput>;
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateRulesArgs = {
  rules: Array<CreateRuleInput>;
};


export type MutationCreateScheduledReportArgs = {
  input: CreateScheduledReportInput;
};


export type MutationCreateSkillsArgs = {
  input: CreateSkills;
};


export type MutationCreateSnapshotArgs = {
  input: CreateSnapshotInput;
};


export type MutationCreateStripePricesArgs = {
  prices?: InputMaybe<Array<InputMaybe<CreateStripePrice>>>;
};


export type MutationCreateStripeProductsArgs = {
  products?: InputMaybe<Array<InputMaybe<CreateStripeProduct>>>;
};


export type MutationCreateTagArgs = {
  owner?: InputMaybe<Scalars['String']['input']>;
  private: Scalars['Boolean']['input'];
  tags: Array<CreateTagInput>;
};


export type MutationCreateTaxArgs = {
  active: Scalars['Boolean']['input'];
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isZoneDefault: Scalars['Boolean']['input'];
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name: Scalars['String']['input'];
  percentage: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  zoneIds: Array<Scalars['String']['input']>;
};


export type MutationCreateTransactionArgs = {
  amount: Scalars['Int']['input'];
  customerId: Scalars['String']['input'];
  disableSendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  paidAt?: InputMaybe<Scalars['Int']['input']>;
  paymentTypeId: Scalars['String']['input'];
  stage?: InputMaybe<TransactionStage>;
  type: TransactionType;
};


export type MutationCreateUsersArgs = {
  inheritRoleZones?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  users?: InputMaybe<Array<CreateUserInput>>;
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateYemboMoveArgs = {
  jobId: Scalars['String']['input'];
};


export type MutationCreateYemboSelfSurveyArgs = {
  jobId: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationCreateZonesArgs = {
  parent: Scalars['String']['input'];
  zones: Array<ZoneInput>;
};


export type MutationDeactivateRefreshTokensArgs = {
  tokenId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationDeleteArtifactsArgs = {
  artifactIds: Array<Scalars['String']['input']>;
  deleteResource?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAssetsArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<InputMaybe<Scalars['String']['input']>>;
  restore?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteAvailabilityTemplatesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationDeleteBlocksArgs = {
  blockIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteChargesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationDeleteCommentsArgs = {
  input?: InputMaybe<DeleteCommentInput>;
};


export type MutationDeleteCouponArgs = {
  stripeId: Scalars['String']['input'];
};


export type MutationDeleteDiscountsArgs = {
  discountIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteInvoicesArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteJobsArgs = {
  jobIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeletePricesArgs = {
  ids: Array<Scalars['String']['input']>;
  restore?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteProductsArgs = {
  ids: Array<Scalars['String']['input']>;
  restore?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationDeleteQuillTemplateArgs = {
  input?: InputMaybe<DeleteQuillTemplateInput>;
};


export type MutationDeleteRulesArgs = {
  ruleIds: Array<Scalars['String']['input']>;
};


export type MutationDeleteScheduledReportsArgs = {
  input: DeleteScheduledReportInput;
};


export type MutationDeleteStripeProductArgs = {
  stripeId: Scalars['String']['input'];
};


export type MutationDeleteTaxesArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteTokensArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteTransactionsArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationDeleteUsersArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  userIds: Array<Scalars['String']['input']>;
};


export type MutationEditAccessesArgs = {
  editAccesses: Array<EditAccess>;
};


export type MutationEditArtifactsArgs = {
  artifactEdits: Array<EditArtifactInput>;
};


export type MutationEditBlockArgs = {
  blockEdit: BlockEditInput;
  blockId: Scalars['ID']['input'];
};


export type MutationEditCalendarEventArgs = {
  assocIds?: InputMaybe<Array<Scalars['String']['input']>>;
  disablePropogation?: InputMaybe<Scalars['Boolean']['input']>;
  edit: EditCalendarEventInput;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  notifyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationEditFieldsArgs = {
  addRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  edit: FieldEditInput;
  fields: Array<Scalars['String']['input']>;
  forceChange?: InputMaybe<Scalars['Boolean']['input']>;
  removeRoles?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationEditFormResponseArgs = {
  input: FormResponseEdit;
};


export type MutationEditFormTypesArgs = {
  editFormFields?: InputMaybe<EditFields>;
  formTypeEdit?: InputMaybe<EditFormTypeBase>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationEditLocationsArgs = {
  edit?: InputMaybe<LocationsEditInput>;
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationEditPageArgs = {
  addBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  deleteBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  pageEdit?: InputMaybe<PageInputEdit>;
  pageId: Scalars['String']['input'];
};


export type MutationEditRecurringCalendarEventArgs = {
  assocIds: Array<Scalars['String']['input']>;
  edit: EditRecurringCalendarEventInput;
};


export type MutationEditSkillsArgs = {
  edit: EditSkillBase;
  ids: Array<Scalars['String']['input']>;
};


export type MutationEditUserPasswordArgs = {
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationExportInvoiceToQuickbooksArgs = {
  invoiceId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationGetLinksArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
  role: Scalars['String']['input'];
};


export type MutationGrantAccessArgs = {
  grantAccess: Array<GrantAccess>;
};


export type MutationIgnoreAttentionArgs = {
  input: IgnoreAttentionInput;
};


export type MutationLinkSkillsArgs = {
  baseSkill: Scalars['String']['input'];
  relatedSkills: Array<Scalars['String']['input']>;
  relationshipType: Scalars['String']['input'];
};


export type MutationLockWindowArgs = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  jobId: Scalars['String']['input'];
  locations?: InputMaybe<Array<InputMaybe<CalendarEventLocationInput>>>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  modifyEndForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  modifyStartForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  overrideAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  overrideUnavailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  start: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicText?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  updateEventSequentialOrder?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLogInToActOnArgs = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};


export type MutationMessageUsersArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};


export type MutationNewFormResponseArgs = {
  input: FormResponseInput;
};


export type MutationNotifyArgs = {
  data?: InputMaybe<Scalars['NotificationDataInput']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  onReply?: InputMaybe<Scalars['String']['input']>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<NotifyUserInput>>>;
};


export type MutationPaymentConnectAccountArgs = {
  links?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRedeemEmailUpdateTokenArgs = {
  token: Scalars['String']['input'];
};


export type MutationRedeemInviteTokenArgs = {
  businessAddress?: InputMaybe<Scalars['String']['input']>;
  businessCode?: InputMaybe<Scalars['String']['input']>;
  businessID?: InputMaybe<Scalars['String']['input']>;
  businessName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
};


export type MutationRedeemPasswordResetTokenArgs = {
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationRefundTransactionArgs = {
  transactionId: Scalars['String']['input'];
};


export type MutationRemoveCalendarEventArgs = {
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
  ids: Array<Scalars['String']['input']>;
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  notifyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveFieldsArgs = {
  fields: Array<Scalars['String']['input']>;
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveFormResponsesArgs = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRemoveFormTypesArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type MutationRemoveLocationsArgs = {
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRemovePagesArgs = {
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationRemoveRecurringEventsArgs = {
  assocIds: Array<Scalars['String']['input']>;
  detach?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveRolesFromFieldArgs = {
  fieldIds: Array<InputMaybe<Scalars['String']['input']>>;
  roleIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRemoveSkillsArgs = {
  ids: Array<Scalars['String']['input']>;
  removeRelations?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationRemoveSubLocationsArgs = {
  parentId: Scalars['String']['input'];
  subLocations: Array<Scalars['String']['input']>;
};


export type MutationRemoveTagsFromObjectsArgs = {
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  objects: Array<Scalars['String']['input']>;
  tags: Array<Scalars['String']['input']>;
};


export type MutationRemoveZonesArgs = {
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  ids: Array<Scalars['String']['input']>;
};


export type MutationResendDocumentArgs = {
  artifactId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  subject: Scalars['String']['input'];
};


export type MutationRestoreJobsArgs = {
  jobIds: Array<InputMaybe<Scalars['String']['input']>>;
};


export type MutationRestoreUsersArgs = {
  userIds: Array<Scalars['String']['input']>;
};


export type MutationRevokeAccessesArgs = {
  ids: Array<Scalars['String']['input']>;
};


export type MutationRolesArgs = {
  search?: InputMaybe<RoleSearch>;
};


export type MutationSendDocumentArgs = {
  artifactId: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
  recipientRole: Scalars['String']['input'];
};


export type MutationSendInvoicesArgs = {
  invoiceIds: Array<Scalars['String']['input']>;
};


export type MutationSendTokenArgs = {
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tokenId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetConfigValuesArgs = {
  configs: Array<ConfigValueInput>;
  omitZone?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSetFieldsValuesArgs = {
  fields: Array<SetFieldValueInput>;
  objectLabel: Scalars['String']['input'];
  objects?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationSetUserLocationsArgs = {
  addLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId: Scalars['String']['input'];
};


export type MutationSetUsersSkillsArgs = {
  input: SetUsersSkills;
};


export type MutationSubmitFeedbackArgs = {
  feedback?: InputMaybe<FeedbackInput>;
};


export type MutationTagsArgs = {
  filter?: InputMaybe<TagFilter>;
};


export type MutationTestScheduledDynamicReportArgs = {
  reportId: Scalars['String']['input'];
};


export type MutationUnlinkSkillsArgs = {
  baseSkill: Scalars['String']['input'];
  relatedSkills: Array<Scalars['String']['input']>;
};


export type MutationUpdateAppliedCustomAmountArgs = {
  appliedId: Scalars['String']['input'];
  customAmount: Scalars['Int']['input'];
};


export type MutationUpdateAssetsArgs = {
  assets: Array<InputMaybe<UpdateAssetInput>>;
};


export type MutationUpdateAvailabilityConfigurationArgs = {
  input: UpdateAvailabilityConfigurationInput;
};


export type MutationUpdateAvailabilityTemplateArgs = {
  input: UpdateAvailabilityTemplateInput;
};


export type MutationUpdateChargesArgs = {
  charges: Array<ChargeUpdate>;
};


export type MutationUpdateCommentsArgs = {
  input?: InputMaybe<UpdateCommentInput>;
};


export type MutationUpdateCouponArgs = {
  name?: InputMaybe<Scalars['String']['input']>;
  stripeId: Scalars['String']['input'];
};


export type MutationUpdateDiscountsArgs = {
  updateDiscounts: Array<UpdateDiscountsInput>;
};


export type MutationUpdateDynamicReportArgs = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<DynamicReportParametersInput>;
  reportId: Scalars['String']['input'];
};


export type MutationUpdateInvoicesArgs = {
  invoices: Array<UpdateInvoiceInput>;
};


export type MutationUpdateJobsArgs = {
  updateJobs?: InputMaybe<Array<InputMaybe<UpdateJobInput>>>;
};


export type MutationUpdateNotificationActionArgs = {
  action: Scalars['String']['input'];
  disableActions?: InputMaybe<Scalars['Boolean']['input']>;
  extraInfo?: InputMaybe<Scalars['String']['input']>;
  notification: Scalars['String']['input'];
  value: Scalars['String']['input'];
};


export type MutationUpdatePricesArgs = {
  effectExistingCharges?: InputMaybe<Scalars['Boolean']['input']>;
  prices: Array<UpdatePriceInput>;
};


export type MutationUpdateProductsArgs = {
  products: Array<UpdateProductInput>;
};


export type MutationUpdatePromotionCodesArgs = {
  promotionCodes: Array<InputMaybe<UpdatePromotionCodeInput>>;
};


export type MutationUpdateQuillTemplateArgs = {
  input?: InputMaybe<UpdateQuillTemplateInput>;
};


export type MutationUpdateRulesArgs = {
  rules?: InputMaybe<Array<UpdateRuleInput>>;
};


export type MutationUpdateScheduledReportsArgs = {
  input: UpdateScheduledReportInput;
};


export type MutationUpdateStripePriceArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  lookup_key?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  stripeId: Scalars['String']['input'];
  transfer_lookup_key?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdateStripeProductArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  caption?: InputMaybe<Scalars['String']['input']>;
  deactivate_on?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  expand?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  shippable?: InputMaybe<Scalars['Boolean']['input']>;
  statement_descriptor?: InputMaybe<Scalars['String']['input']>;
  stripeId: Scalars['String']['input'];
  unit_label?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateTaxArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  isZoneDefault?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  taxId: Scalars['String']['input'];
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationUpdateTransactionArgs = {
  disableSendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  paidAt?: InputMaybe<Scalars['Int']['input']>;
  stage?: InputMaybe<TransactionStage>;
  transactionId: Scalars['String']['input'];
};


export type MutationUpdateZonesArgs = {
  edit: ZoneInput;
  ids: Array<Scalars['String']['input']>;
  parent?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUsersArgs = {
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

export type NameValuePair = {
  __typename?: 'NameValuePair';
  Name: Scalars['String']['output'];
  Value: Scalars['String']['output'];
};

export type NewChargesInput = {
  charges: Array<CreateChargeInput>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type NewFormResponseSubscriptionOutput = {
  __typename?: 'NewFormResponseSubscriptionOutput';
  formResponseId: Scalars['String']['output'];
  formTypeId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type Node = {
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use deletedAt */
  deletedOn?: Maybe<DateTime>;
  id: Scalars['ID']['output'];
  updatedAt: DateTime;
};

export type Notification = {
  __typename?: 'Notification';
  actions?: Maybe<Array<NotificationAction>>;
  actionsDisabled?: Maybe<Scalars['Boolean']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  createdAt: DateTime;
  data?: Maybe<Scalars['String']['output']>;
  expiresIn?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  recipients: Array<NotificationRecipient>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<DateTime>;
  url?: Maybe<Scalars['String']['output']>;
};

export type NotificationAction = {
  __typename?: 'NotificationAction';
  extraInfo?: Maybe<Scalars['String']['output']>;
  extraInfoQuickOptions?: Maybe<Array<Scalars['String']['output']>>;
  extraInfoType?: Maybe<Scalars['String']['output']>;
  formattedName: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  valueType?: Maybe<Scalars['String']['output']>;
};

export type NotificationRecipient = {
  __typename?: 'NotificationRecipient';
  push?: Maybe<Scalars['Boolean']['output']>;
  readAt?: Maybe<Scalars['Int']['output']>;
  recipientId: Scalars['String']['output'];
};

export type NotificationTemplate = {
  __typename?: 'NotificationTemplate';
  allowManual?: Maybe<Scalars['Boolean']['output']>;
  disabled?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Template']['output']>;
  excludeRoot?: Maybe<Scalars['Boolean']['output']>;
  force?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  resolveConfig?: Maybe<Array<Maybe<ConfigToResolve>>>;
  schema?: Maybe<Scalars['AJVSchema']['output']>;
  skipLocalWait?: Maybe<Scalars['Boolean']['output']>;
  sms?: Maybe<Scalars['Template']['output']>;
  templateName?: Maybe<Scalars['String']['output']>;
  variables?: Maybe<Scalars['NotificationDataInput']['output']>;
};

export type NotificationsFilter = {
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  hasBeenRead?: InputMaybe<Scalars['Boolean']['input']>;
  notificationIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type NotificationsPagination = {
  __typename?: 'NotificationsPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  notifications: Array<Maybe<Notification>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type NotifyUserInput = {
  data?: InputMaybe<Scalars['NotificationDataInput']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

/** Used to filter the objects based on whether they are associated with events that meet the given criteria */
export type ObjectCalendarEventsFilterInput = {
  createdAt?: InputMaybe<FilterByNumericalValueInput>;
  end?: InputMaybe<FilterByNumericalValueInput>;
  start?: InputMaybe<FilterByNumericalValueInput>;
  status?: InputMaybe<Scalars['String']['input']>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<FilterByNumericalValueInput>;
};

export type ObjectDiscountDetails = {
  __typename?: 'ObjectDiscountDetails';
  details?: Maybe<DiscountDetails>;
  objectId?: Maybe<Scalars['String']['output']>;
};

export type Option = {
  __typename?: 'Option';
  label: Scalars['String']['output'];
  option: Scalars['String']['output'];
  optionText: Scalars['String']['output'];
  optionValue: Scalars['String']['output'];
};

export type OptionInput = {
  optionText: Scalars['String']['input'];
  optionValue: Scalars['String']['input'];
};

export type OrderObject = {
  /**
   * Valid values: 'first', 'last', 'before', 'after'
   * default value: 'last'
   */
  placement?: InputMaybe<Scalars['String']['input']>;
  /**
   * Only required if placement value is either 'before' or
   * 'after', the blockId the placement value is in reference to
   */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type OwnedSkill = {
  __typename?: 'OwnedSkill';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<DateTime>;
  description?: Maybe<Scalars['String']['output']>;
  details?: Maybe<SkillDetails>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ratingType?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  skillType: Scalars['String']['output'];
  updatedAt: DateTime;
};

export type Page = {
  __typename?: 'Page';
  accesses?: Maybe<Array<Maybe<Access>>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  blocks?: Maybe<Array<Block>>;
  createdOn: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The path to the page, e.g. 'aboutus' */
  path: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedOn: Scalars['Int']['output'];
  user?: Maybe<User>;
};


export type PageAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};

export type PageInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  blocks?: InputMaybe<Array<BlockInput>>;
  path: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type PageInputEdit = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  path?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PageSubscriptionOutput = {
  __typename?: 'PageSubscriptionOutput';
  pageId: Scalars['ID']['output'];
  pagePath: Scalars['String']['output'];
};

export type Pandadoc = {
  __typename?: 'Pandadoc';
  date_created?: Maybe<Scalars['String']['output']>;
  date_modified?: Maybe<Scalars['String']['output']>;
  expiration_date?: Maybe<Scalars['String']['output']>;
  /** Id generated by Pandadoc */
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PandadocDocument = {
  __typename?: 'PandadocDocument';
  dateCreated?: Maybe<Scalars['String']['output']>;
  dateModified?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PandadocFilterInput = {
  /** Return results where the `date_completed` field (ISO 8601) is greater than or equal to this value. (optional) */
  completedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Return results where the `date_completed` field (ISO 8601) is less than or equal to this value. (optional) */
  completedTo?: InputMaybe<Scalars['String']['input']>;
  /** string | Returns results where 'contact_id' is present in document as recipient or approver (optional) */
  contactId?: InputMaybe<Scalars['String']['input']>;
  /** number | Specify how many document results to return. Default is 50 documents, maximum is 100 documents. (optional) */
  count?: InputMaybe<Scalars['Int']['input']>;
  /** string | Return results where the `date_created` field (ISO 8601) is greater than or equal to this value. (optional) */
  createdFrom?: InputMaybe<Scalars['String']['input']>;
  /** string | Return results where the `date_created` field (ISO 8601) is less than this value. (optional) */
  createdTo?: InputMaybe<Scalars['String']['input']>;
  /** boolean | Returns only the deleted documents. (optional) */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** The pandadoc UUID of the folder where the documents are stored. (optional) */
  folderUuid?: InputMaybe<Scalars['String']['input']>;
  /** Specify the form used for documents creation. This parameter can't be used with template_id. (optional) */
  formId?: InputMaybe<Scalars['String']['input']>;
  /** Pandadoc id of a specific document to retrieve */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Returns results where 'membership_id' is present in document as owner (should be member uuid) */
  membershipId?: InputMaybe<Scalars['String']['input']>;
  /** Specify metadata to filter by in the format of `metadata_{metadata-key}={metadata-value}` such as `metadata_opportunity_id=2181432`. The `metadata_` prefix is always required. */
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  /** Return results where the `date_modified` field (iso-8601) is greater than or equal to this value. */
  modifiedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Return results where the `date_modified` field (iso-8601) is less than this value. */
  modifiedTo?: InputMaybe<Scalars['String']['input']>;
  /** Specify the order of documents to return. Use `value` (for example, `date_created`) for ASC and `-value` (for example, `-date_created`) for DESC. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Specify which page of the dataset to return. */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search query. Filter by document reference number (this token is stored on the template level) or name. */
  q?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify the status of documents to return.
   * * 0: document.draft
   * * 1: document.sent
   * * 2: document.completed
   * * 3: document.uploaded
   * * 4: document.error
   * * 5: document.viewed
   * * 6: document.waiting_approval
   * * 7: document.approved
   * * 8: document.rejected
   * * 9: document.waiting_pay
   * * 10: document.paid
   * * 11: document.voided
   * * 12: document.declined
   * * 13: document.external_review
   */
  status?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Specify the status of documents to return (exclude).
   * * 0: document.draft
   * * 1: document.sent
   * * 2: document.completed
   * * 3: document.uploaded
   * * 4: document.error
   * * 5: document.viewed
   * * 6: document.waiting_approval
   * * 7: document.approved
   * * 8: document.rejected
   * * 9: document.waiting_pay
   * * 10: document.paid
   * * 11: document.voided
   * * 12: document.declined
   * * 13: document.external_review
   */
  statusNe?: InputMaybe<Scalars['Int']['input']>;
  /** Search tag. Filter by document tag. */
  tag?: InputMaybe<Scalars['String']['input']>;
  /** Specify the template used for documents creation. Parameter can't be used with form_id. */
  templateId?: InputMaybe<Scalars['String']['input']>;
};

export type PandadocTemplate = {
  __typename?: 'PandadocTemplate';
  dateCreated?: Maybe<Scalars['String']['output']>;
  dateModified?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type PaymentAccount = {
  __typename?: 'PaymentAccount';
  charges_enabled?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  default_currency?: Maybe<Scalars['String']['output']>;
  details_submitted?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<StripeInvoice>>;
  loginLink?: Maybe<Scalars['String']['output']>;
};

export type PaymentCard = {
  __typename?: 'PaymentCard';
  brand?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  funding?: Maybe<Scalars['String']['output']>;
  last4?: Maybe<Scalars['String']['output']>;
};

export type PaymentCustomer = {
  __typename?: 'PaymentCustomer';
  balance?: Maybe<Scalars['Float']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  delinquent?: Maybe<Scalars['Boolean']['output']>;
  discount?: Maybe<StripeDiscount>;
  id: Scalars['String']['output'];
  invoice_settings?: Maybe<CustomerInvoiceSettings>;
  name?: Maybe<Scalars['String']['output']>;
};

export type PaymentIntent = {
  __typename?: 'PaymentIntent';
  amount?: Maybe<Scalars['Int']['output']>;
  amount_capturable?: Maybe<Scalars['Int']['output']>;
  amount_received?: Maybe<Scalars['Int']['output']>;
  client_secret?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  payment_method?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  card?: Maybe<PaymentCard>;
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type PaymentType = {
  __typename?: 'PaymentType';
  createdAt?: Maybe<Scalars['Int']['output']>;
  /**  True if this payment type is currently enabled */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['String']['output'];
  /**  The config key for this payment type  */
  key?: Maybe<Scalars['String']['output']>;
  /**  Name to display for this config */
  name?: Maybe<Scalars['String']['output']>;
  /**  The provider for this payment type */
  provider?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  createdAt?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  /** @deprecated No longer in use */
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated No longer in use */
  ids?: Maybe<Array<IdWithLabel>>;
  /**
   * If within permissionMap, this is the value of the permission requested.
   * Will always be a full permission name (like users.view, availability.create, etc)
   */
  mappedPermission?: Maybe<Scalars['String']['output']>;
  matchingObjects?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The permissions name.
   * Could be *.*, users.*, users.view, *.view, etc.
   */
  permission: Scalars['String']['output'];
  /** The restrictions of the permission, as a JSON blob */
  restrictions?: Maybe<Scalars['String']['output']>;
  role: Scalars['String']['output'];
  /** @deprecated No longer in use */
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  zone: Scalars['String']['output'];
  zoneDepth: Scalars['Int']['output'];
};

export type Phone = {
  __typename?: 'Phone';
  FreeFormNumber?: Maybe<Scalars['String']['output']>;
};

export type PreviewReportFilter = {
  charge?: InputMaybe<ChargesFilter>;
  event?: InputMaybe<CalendarEventsFilter>;
  invoice?: InputMaybe<InvoiceFilter>;
  job?: InputMaybe<JobsFilter>;
};

export type PreviewReportOutput = {
  __typename?: 'PreviewReportOutput';
  aggregationData?: Maybe<Scalars['DynamicReportData']['output']>;
  data?: Maybe<Scalars['DynamicReportData']['output']>;
  groupBy: Scalars['String']['output'];
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type Price = {
  __typename?: 'Price';
  /**
   * Denotes whether is price is to be used when charging for the corresponding product.
   * Note only one price can be active for a product at a time, unless they are a custom user price.
   */
  active: Scalars['Boolean']['output'];
  /** In cents or percent */
  amount: Scalars['Float']['output'];
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: Scalars['Int']['output'];
  /** ISO Currency format */
  currency: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Currently, the expense type includes both unitCost and amount fields. Hence, Apollo causes discrepancy in data as objects with the similar id and type (__typename) have different values of their fields. So, use expensesV2 instead */
  expenses?: Maybe<Array<Expense>>;
  expensesV2?: Maybe<Array<PriceExpense>>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** Price type specifies whether we are using a 'fixed' price with an amounnt in cents (default) or a 'percentage' price with an amount in percent */
  priceType?: Maybe<PriceType>;
  product: Product;
  taxes?: Maybe<Array<Tax>>;
  updatedAt: Scalars['Int']['output'];
  /** The corresponding user, if applicable. */
  user?: Maybe<User>;
  zone?: Maybe<Zone>;
};

export type PriceExpense = {
  __typename?: 'PriceExpense';
  expense: Expense;
  unitCost: Scalars['Int']['output'];
};

export enum PriceType {
  Fixed = 'fixed',
  Percentage = 'percentage'
}

export type PricesFilter = {
  amount?: InputMaybe<FilterByNumericalValueInput>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default true */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default False */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type PricesPagination = {
  __typename?: 'PricesPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  prices: Array<Maybe<Price>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Product = {
  __typename?: 'Product';
  /** Denotes whether the product is available for purchase */
  active: Scalars['Boolean']['output'];
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  prices: Array<Price>;
  /** The description used for credit card staements */
  statementDescription?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use price taxes instead */
  taxes: Array<Tax>;
  unitLabel?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
  zones: Array<Maybe<Zone>>;
};


export type ProductPricesArgs = {
  filter?: InputMaybe<PricesFilter>;
};

export type ProductsFilter = {
  category?: InputMaybe<Scalars['String']['input']>;
  /** If true the query will only return products with an active price. Default: true */
  hasActivePrice?: InputMaybe<Scalars['Boolean']['input']>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  priceIds?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Default false */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** Default: any */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ProductsPagination = {
  __typename?: 'ProductsPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  products: Array<Maybe<Product>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total: Scalars['Int']['output'];
};

export type PromotionCode = {
  __typename?: 'PromotionCode';
  /** Whether the promotion code is currently active. A promotion code is only active if the coupon is also valid. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The customer-facing code. Regardless of case, this code must be unique across all active promotion codes for each customer. */
  code?: Maybe<Scalars['String']['output']>;
  /**
   * A coupon contains information about a percent-off or amount-off discount you
   * might want to apply to a customer. Coupons may be applied to [invoices](https://stripe.com/docs/api#invoices) or
   * [orders](https://stripe.com/docs/api#create_order-coupon). Coupons do not work with conventional one-off [charges](https://stripe.com/docs/api#create_charge).
   */
  coupon?: Maybe<Coupon>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created?: Maybe<Scalars['Int']['output']>;
  /** The customer that this promotion code can be used by. Stripe customer Id */
  customer?: Maybe<Scalars['String']['output']>;
  /** Date at which the promotion code can no longer be redeemed. */
  expires_at?: Maybe<Scalars['Int']['output']>;
  /** Unique identifier for the object. Generated by Stripe */
  id?: Maybe<Scalars['String']['output']>;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum number of times this promotion code can be redeemed. */
  max_redemptions?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  restrictions?: Maybe<PromotionCodeRestrictions>;
  /** Number of times this promotion code has been used. */
  times_redeemed?: Maybe<Scalars['Int']['output']>;
  /** The zones the promotion code is applicable to */
  zones: Array<Maybe<Zone>>;
};

export type PromotionCodeRestrictions = {
  __typename?: 'PromotionCodeRestrictions';
  /** A Boolean indicating if the Promotion Code should only be redeemed for Customers without any successful payments or invoices */
  first_time_transaction?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum amount required to redeem this Promotion Code into a Coupon (e.g., a purchase must be $100 or more to work). */
  minimum_amount?: Maybe<Scalars['Int']['output']>;
  /** Three-letter [ISO code](https://stripe.com/docs/currencies) for minimum_amount */
  minimum_amount_currency?: Maybe<Scalars['String']['output']>;
};

export type PromotionCodeRestrictionsInput = {
  /** A Boolean indicating if the Promotion Code should only be redeemed for Customers without any successful payments or invoices */
  first_time_transaction?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum amount required to redeem this Promotion Code into a Coupon (e.g., a purchase must be $100 or more to work). */
  minimum_amount?: InputMaybe<Scalars['Int']['input']>;
  /** Three-letter [ISO code](https://stripe.com/docs/currencies) for minimum_amount */
  minimum_amount_currency?: InputMaybe<Scalars['String']['input']>;
};

export type Query = {
  __typename?: 'Query';
  accesses: AccessPagination;
  aggregationColumns?: Maybe<Array<Option>>;
  /** Valid sort options: id, name, createdAt, updatedAt, namespace */
  artifacts?: Maybe<ListArtifactsOutput>;
  artifactsUsage?: Maybe<ArtifactUsageOutput>;
  assets: AssetsPagination;
  assignCrewWithAI: AssignCrewWithAiOutput;
  attentionItems: ListAttentionItemsOutput;
  attentionItemsSummary: Array<AttentionItemsSummary>;
  /** Return supported auth methods for the current zone */
  authMethods: Array<AuthMethod>;
  /** Used to retrive the availability of multiple objects */
  availabilities: Array<Maybe<AvailabilityOutput>>;
  /** List the availability confgiurations for the objects, if no id's are provided defaults to the authenticated user  */
  availabilityConfigurations?: Maybe<Array<Maybe<AvailabilityConfiguration>>>;
  availabilityTemplates?: Maybe<Array<AvailabilityTemplate>>;
  availableClockStatuses: Array<ClockStatus>;
  /**
   * Resolves zones that are available to the user, whether
   * they are authenticated or not.
   */
  availableZones?: Maybe<Array<Zone>>;
  blocks: ListBlocksOutput;
  /**
   * Resolve branding from either:
   *
   * 1. the provided zone
   * 2. the currently context zone
   * 3. the root zone
   * 4. environment configuration
   */
  branding: ZoneBranding;
  calculateDistance?: Maybe<CalculateDistanceOutput>;
  /**
   * Query individual calender events.
   * Requires permission `calendarEvents.view`
   */
  calendarEvents: CalendarEventPagination;
  charges: ChargesPagination;
  checkConnection?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Will return boolean of whether the user has the permission, no matter the restrictions.
   * Guaranteed to be in same order of array.
   */
  checkPermissions: Array<Scalars['Boolean']['output']>;
  clocks?: Maybe<Array<Clocks>>;
  commentModes?: Maybe<Array<CommentMode>>;
  comments: CommentPagination;
  companyInfo: CompanyInfo;
  /** @deprecated Use Query.listConfig instead */
  config?: Maybe<Scalars['String']['output']>;
  contactLists?: Maybe<ListResponse>;
  coupons: Array<Maybe<Coupon>>;
  currentZone: Zone;
  dashboards: Dashboards;
  dataColumns?: Maybe<Array<Option>>;
  discounts: ListDiscountsOutput;
  dynamicReports?: Maybe<ListDynamicReportsOutput>;
  expenses: ExpensesPagination;
  features: Array<Scalars['String']['output']>;
  /**
   * Retrive field and field values.
   * Requires `fields.list` to view fields
   * Requires `users.viewFields` to view field values
   * These restrictions apply to READ, UPDATE, DELETE, unless otherwise noted
   *
   * Restrictions available:
   *  - zone restrictions
   *  - onlySelf
   *  - attributes
   *  - allUsersNamespaces - Listable namespaces for other users
   *  - selfNamespaces - Listable namespaces for self
   */
  fields: FieldResult;
  find: FindOutput;
  formResponses: FormResponsePagination;
  formTypes: FormTypePagination;
  generateChargesWithAI: GenerateChargesWithAiOutput;
  /**
   * Retrieve server config values from the database. Can use regex to match different values.
   * Server will check keys restriction on config.view permission to see if requested
   * values match
   *
   * Must be nullable in case user doesn't have permissions
   */
  getConfigValues?: Maybe<Array<ConfigValue>>;
  getInvoicePdf: ApiTemplateOutput;
  getNiceJobsRefreshToken?: Maybe<Scalars['String']['output']>;
  getPandadocDocumentLink: Scalars['String']['output'];
  getZoneConfigValues?: Maybe<ZoneConfigValue>;
  getZoneConfigs?: Maybe<ZoneConfig>;
  groupByOptions?: Maybe<Array<Option>>;
  history?: Maybe<HistoryPagination>;
  invoices?: Maybe<InvoicePage>;
  isAuthenticated: Scalars['Boolean']['output'];
  isAuthenticatedToActOn: Scalars['Boolean']['output'];
  jobs: ListJobsOutput;
  /**
   * Retrieve configuration by namespace.
   *
   * Requires permission `config.view+namespace+key`
   * Where namespace and key is the input value.
   *
   * For example, the permission config.view+tutor+tutorId is
   * required to access the config value find.tutorId
   *
   * If the user has the permission config.view+namespace, they will have permission to access all keys.
   *
   * If the user has the permission config.view, they will have permission to access all keys in all namespaces.
   *
   * The namespace public does not require the user to be logged in to access the configuration value, so they do not need permission.
   *
   * The namespace loggedIn does not require any permission to access the configuration value, but requires the user to be logged in.
   */
  keys?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locations: LocationPagination;
  /**
   * Access the currently logged in user.
   *
   * Will throw an error if no user is logged in.
   */
  me: User;
  notificationTemplates?: Maybe<Array<Maybe<NotificationTemplate>>>;
  pages: ListPagesOutput;
  pandadocTemplates?: Maybe<Array<Maybe<PandadocTemplate>>>;
  paymentAccount?: Maybe<PaymentAccount>;
  periodTypeOptions?: Maybe<Array<Option>>;
  permissions: ListPermissionsResult;
  previewReport: PreviewReportOutput;
  prices: PricesPagination;
  products: ProductsPagination;
  promotionCodes: Array<Maybe<PromotionCode>>;
  quickbooksAccounts: Array<QuickbooksAccount>;
  quickbooksAuthUri: Scalars['String']['output'];
  quickbooksItems: Array<QuickbooksItem>;
  quickbooksTaxCodes: Array<QuickbooksTaxCode>;
  /**
   * Query recurring calender events.
   * Requires permission `recurringCalendarEvents.view`
   */
  recurringCalendarEvents: RecurringCalendarEventPagination;
  reportTypes: ListReportTypesOutput;
  reports: ListReportsOutput;
  /**
   * Returns the zone that is the best match to service a given location, based on zone territory
   * locations and distances between them.
   */
  resolveServiceArea: ServiceAreaQueryResult;
  retrieveCoupon: Coupon;
  retrievePromotionCode: PromotionCode;
  roles: Array<Role>;
  ruleOptions: RuleOptions;
  rules: ListRulesOutput;
  scheduledReports: ListScheduledReportsOutput;
  search: SearchOutput;
  /** Lists skills, requires permission 'skills.view' */
  skills: SkillPagination;
  stripeInvoices?: Maybe<Array<Maybe<StripeInvoice>>>;
  stripePrices: Array<Maybe<StripePrice>>;
  stripeProducts: ListStripeProductsOutput;
  /** Queries tags, requires permission 'tags.view' */
  tags: TagResult;
  tawkToSecret?: Maybe<Scalars['String']['output']>;
  taxes: ListTaxesOutput;
  templates: QuillTemplatesPagination;
  tokens: ListTokensOutput;
  transactions: ListTransactionsOutput;
  users: Array<User>;
  usersv2?: Maybe<UserPagination>;
  /**
   * Checks if the token is valid and returns associated metadata
   * with that token.
   */
  validateToken?: Maybe<ValidateTokenOutput>;
  yemboMove: Scalars['Boolean']['output'];
  zones?: Maybe<ListZonesOutput>;
};


export type QueryAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};


export type QueryArtifactsArgs = {
  filter?: InputMaybe<ArtifactFilter>;
  getPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryArtifactsUsageArgs = {
  authors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contentType?: InputMaybe<Scalars['String']['input']>;
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  getSystemUsageBytes?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
  privacyType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssetsArgs = {
  filter?: InputMaybe<AssetsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAssignCrewWithAiArgs = {
  input: AssignCrewWithAiInput;
};


export type QueryAttentionItemsArgs = {
  filter?: InputMaybe<AttentionItemsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryAttentionItemsSummaryArgs = {
  filter?: InputMaybe<AttentionItemsSummaryFilter>;
};


export type QueryAuthMethodsArgs = {
  authMethodType?: InputMaybe<AuthMethodType>;
  showOverridenAuthMethods?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailabilitiesArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  excludeEvents?: InputMaybe<Array<Scalars['String']['input']>>;
  objectIds: Array<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailabilityConfigurationsArgs = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAvailabilityTemplatesArgs = {
  input?: InputMaybe<AvailabilityTemplateInput>;
};


export type QueryAvailableZonesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryBlocksArgs = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  blockType?: InputMaybe<Scalars['String']['input']>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  inPages?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryBrandingArgs = {
  zoneId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalculateDistanceArgs = {
  locationIds: Array<Scalars['String']['input']>;
  startingTime?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCalendarEventsArgs = {
  filter?: InputMaybe<CalendarEventsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryChargesArgs = {
  filter?: InputMaybe<ChargesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCheckPermissionsArgs = {
  permissions: Array<Scalars['String']['input']>;
};


export type QueryClocksArgs = {
  input: ClockListInput;
};


export type QueryCommentsArgs = {
  filter?: InputMaybe<ListCommentFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  resolve?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
};


export type QueryConfigArgs = {
  key?: InputMaybe<Scalars['String']['input']>;
  namespace?: InputMaybe<Scalars['String']['input']>;
};


export type QueryCouponsArgs = {
  created?: InputMaybe<RangeQueryParam>;
  ending_before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};


export type QueryDataColumnsArgs = {
  groupBy: Scalars['String']['input'];
};


export type QueryDiscountsArgs = {
  filter?: InputMaybe<DiscountFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryDynamicReportsArgs = {
  filter?: InputMaybe<DynamicReportsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryExpensesArgs = {
  filter?: InputMaybe<ExpensesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFeaturesArgs = {
  features: Array<Scalars['String']['input']>;
};


export type QueryFieldsArgs = {
  filter?: InputMaybe<FieldFilter>;
  ignoreDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitValues?: InputMaybe<Scalars['Int']['input']>;
  objectLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  showAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  skipValues?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFindArgs = {
  assetsFilter?: InputMaybe<AssetsFilter>;
  excludedEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  minNumAssets?: InputMaybe<Scalars['Int']['input']>;
  minNumUsers?: InputMaybe<Scalars['Int']['input']>;
  overrideAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  overrideUnavailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  timeWindow: WindowInput;
  usersFilter?: InputMaybe<UserSearch>;
  zoneInput?: InputMaybe<Scalars['String']['input']>;
};


export type QueryFormResponsesArgs = {
  filter?: InputMaybe<FormResponseFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryFormTypesArgs = {
  filter?: InputMaybe<FormTypeFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGenerateChargesWithAiArgs = {
  input: GenerateChargesWithAiInput;
};


export type QueryGetConfigValuesArgs = {
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  omitZone?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryGetInvoicePdfArgs = {
  jobId: Scalars['String']['input'];
};


export type QueryGetNiceJobsRefreshTokenArgs = {
  authorizationCode: Scalars['String']['input'];
};


export type QueryGetPandadocDocumentLinkArgs = {
  artifactId: Scalars['String']['input'];
  role: Scalars['String']['input'];
};


export type QueryGetZoneConfigValuesArgs = {
  keys: Array<ZoneConfigKey>;
};


export type QueryGetZoneConfigsArgs = {
  getOverridingConfigs?: InputMaybe<Scalars['Boolean']['input']>;
  keys: Array<ZoneConfigKey>;
};


export type QueryHistoryArgs = {
  input?: InputMaybe<ListHistoryInput>;
};


export type QueryInvoicesArgs = {
  filter?: InputMaybe<InvoiceFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryJobsArgs = {
  filter?: InputMaybe<JobsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryKeysArgs = {
  namespace?: InputMaybe<Scalars['String']['input']>;
};


export type QueryLocationsArgs = {
  filter?: InputMaybe<LocationsFilter>;
};


export type QueryNotificationTemplatesArgs = {
  isManual?: InputMaybe<Scalars['Boolean']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryPagesArgs = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasBlocks?: InputMaybe<Array<Scalars['String']['input']>>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPandadocTemplatesArgs = {
  count?: InputMaybe<Scalars['Int']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  folderUuid?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  q?: InputMaybe<Scalars['String']['input']>;
  shared?: InputMaybe<Scalars['Boolean']['input']>;
  tag?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPermissionsArgs = {
  input?: InputMaybe<ListPermissionsInput>;
};


export type QueryPreviewReportArgs = {
  aggregationColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  columnParams?: InputMaybe<ColumnParams>;
  dataColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  end: Scalars['Int']['input'];
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkFormat?: InputMaybe<Scalars['String']['input']>;
  performance?: InputMaybe<Scalars['String']['input']>;
  periodType?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPricesArgs = {
  filter?: InputMaybe<PricesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryProductsArgs = {
  filter?: InputMaybe<ProductsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryPromotionCodesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  created?: InputMaybe<RangeQueryParam>;
  customer?: InputMaybe<Scalars['String']['input']>;
  ending_before?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
  zones?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryQuickbooksAccountsArgs = {
  filter: QuickbooksAccountFilter;
};


export type QueryQuickbooksItemsArgs = {
  filter: QuickbooksItemFilter;
};


export type QueryRecurringCalendarEventsArgs = {
  filter?: InputMaybe<RecurringCalendarEventsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryReportTypesArgs = {
  filter?: InputMaybe<ReportTypesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryReportsArgs = {
  filter?: InputMaybe<ReportsFilter>;
  getData?: InputMaybe<Array<ReportGetDataOptions>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryResolveServiceAreaArgs = {
  areaCode?: InputMaybe<Scalars['String']['input']>;
  query: Scalars['String']['input'];
};


export type QueryRetrieveCouponArgs = {
  stripeId: Scalars['String']['input'];
};


export type QueryRetrievePromotionCodeArgs = {
  stripeId: Scalars['String']['input'];
};


export type QueryRolesArgs = {
  search?: InputMaybe<RoleSearch>;
};


export type QueryRulesArgs = {
  filter?: InputMaybe<RulesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryScheduledReportsArgs = {
  aggregations?: InputMaybe<ListScheduledReportAggregatesInput>;
  filter?: InputMaybe<ScheduledReportsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchArgs = {
  input: SearchInput;
};


export type QuerySkillsArgs = {
  filter?: InputMaybe<SkillFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStripeInvoicesArgs = {
  createdAfter?: InputMaybe<Scalars['String']['input']>;
  createdBefore?: InputMaybe<Scalars['String']['input']>;
  directZone?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userSearch?: InputMaybe<UserSearch>;
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStripePricesArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<RangeQueryParam>;
  currency?: InputMaybe<Scalars['String']['input']>;
  lookup_keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product?: InputMaybe<Scalars['String']['input']>;
};


export type QueryStripeProductsArgs = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<RangeQueryParam>;
  ending_before?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTagsArgs = {
  filter?: InputMaybe<TagFilter>;
  objectLimit?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<Scalars['String']['input']>;
  showObjects?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryTaxesArgs = {
  filter?: InputMaybe<TaxesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTemplatesArgs = {
  filter?: InputMaybe<ListTemplatesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTokensArgs = {
  filter?: InputMaybe<TokensFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryTransactionsArgs = {
  filter?: InputMaybe<TransactionsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryUsersArgs = {
  filter?: InputMaybe<UserSearch>;
};


export type QueryUsersv2Args = {
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type QueryValidateTokenArgs = {
  id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  tokenType?: InputMaybe<Scalars['String']['input']>;
};


export type QueryYemboMoveArgs = {
  jobId?: InputMaybe<Scalars['String']['input']>;
  yemboMoveKey?: InputMaybe<Scalars['String']['input']>;
};


export type QueryZonesArgs = {
  deepResolveObjects?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  objectFilter?: InputMaybe<ListZonesObjectFilter>;
  resolveObjects?: InputMaybe<Scalars['Boolean']['input']>;
  showContextableRoles?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type QuickbooksAccount = {
  __typename?: 'QuickbooksAccount';
  AccountSubType?: Maybe<Scalars['String']['output']>;
  AccountType: Scalars['String']['output'];
  Active: Scalars['Boolean']['output'];
  Classification: Scalars['String']['output'];
  CurrencyBalanceWithSubAccounts: Scalars['Float']['output'];
  CurrentBalance: Scalars['Float']['output'];
  FullQualifiedName?: Maybe<Scalars['String']['output']>;
  Id: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  SubAccount: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  sparse: Scalars['Boolean']['output'];
};

export type QuickbooksAccountFilter = {
  accountSubTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  accountTypes: Array<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type QuickbooksAddress = {
  __typename?: 'QuickbooksAddress';
  City: Scalars['String']['output'];
  CountrySubDivisionCode: Scalars['String']['output'];
  Id: Scalars['String']['output'];
  Lat?: Maybe<Scalars['String']['output']>;
  Line1: Scalars['String']['output'];
  Long?: Maybe<Scalars['String']['output']>;
  PostalCode: Scalars['String']['output'];
};

export type QuickbooksEmailAddress = {
  __typename?: 'QuickbooksEmailAddress';
  Address: Scalars['String']['output'];
};

export type QuickbooksItem = {
  __typename?: 'QuickbooksItem';
  Active: Scalars['Boolean']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  FullyQualifiedName: Scalars['String']['output'];
  Id: Scalars['String']['output'];
  IncomeAccountRef: NameValuePair;
  Name: Scalars['String']['output'];
  PurchaseCost: Scalars['Float']['output'];
  QuickbooksMetaData: QuickbooksMetaData;
  Taxable: Scalars['Boolean']['output'];
  TrackQtyOnHand: Scalars['Boolean']['output'];
  Type: Scalars['String']['output'];
  UnitPrice: Scalars['Float']['output'];
  domain: Scalars['String']['output'];
  sparse: Scalars['Boolean']['output'];
};

export type QuickbooksItemFilter = {
  itemTypes: Array<Scalars['String']['input']>;
};

export type QuickbooksMetaData = {
  __typename?: 'QuickbooksMetaData';
  CreateTime: Scalars['String']['output'];
  LastUpdatedTime: Scalars['String']['output'];
};

export type QuickbooksTaxCode = {
  __typename?: 'QuickbooksTaxCode';
  Active: Scalars['Boolean']['output'];
  Description?: Maybe<Scalars['String']['output']>;
  Hidden?: Maybe<Scalars['Boolean']['output']>;
  Id: Scalars['String']['output'];
  Name: Scalars['String']['output'];
  PurchaseTaxRateList: QuickbooksTaxRateList;
  QuickbooksMetaData: QuickbooksMetaData;
  SalesTaxRateList: QuickbooksTaxRateList;
  SyncToken: Scalars['String']['output'];
  TaxGroup: Scalars['Boolean']['output'];
  Taxable: Scalars['Boolean']['output'];
  domain: Scalars['String']['output'];
  sparse: Scalars['Boolean']['output'];
};

export type QuickbooksTaxRateDetail = {
  __typename?: 'QuickbooksTaxRateDetail';
  TaxOrder: Scalars['Int']['output'];
  TaxRateRef: ReferenceType;
  TaxTypeApplicable: Scalars['String']['output'];
};

export type QuickbooksTaxRateList = {
  __typename?: 'QuickbooksTaxRateList';
  TaxRateDetail: Array<QuickbooksTaxRateDetail>;
};

export type QuillTemplate = {
  __typename?: 'QuillTemplate';
  /**
   * A delta representation of the template (see quill js)
   * in JSON format
   *
   * Includes template variables
   */
  contents?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  /** Indicates if this template is the default for its location */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The location where the template is used.
   *
   * We use quill editor in Job Comments, Dispatch Page Comments and
   * sending crew schedule from dispatch page.
   */
  location?: Maybe<QuillTemplateLocation>;
  name?: Maybe<Scalars['String']['output']>;
  /** The subject line for email templates. */
  subjectContents?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Int']['output']>;
  /** The zone id where the template is stored. */
  zoneId?: Maybe<Scalars['String']['output']>;
};

export enum QuillTemplateLocation {
  DispatchComment = 'DISPATCH_COMMENT',
  DispatchSchedule = 'DISPATCH_SCHEDULE',
  GenericJobComment = 'GENERIC_JOB_COMMENT',
  JobAdminSummary = 'JOB_ADMIN_SUMMARY',
  JobCommentAskBee = 'JOB_COMMENT_ASK_BEE',
  JobCommentNotifyJobWatchers = 'JOB_COMMENT_NOTIFY_JOB_WATCHERS',
  JobCommentScheduleCommunication = 'JOB_COMMENT_SCHEDULE_COMMUNICATION',
  JobCommentSendEmailToCustomer = 'JOB_COMMENT_SEND_EMAIL_TO_CUSTOMER',
  JobCommentSendSmsToCustomer = 'JOB_COMMENT_SEND_SMS_TO_CUSTOMER',
  JobCrewSummary = 'JOB_CREW_SUMMARY',
  JobCustomerSummary = 'JOB_CUSTOMER_SUMMARY',
  JobSummary = 'JOB_SUMMARY'
}

export type QuillTemplatesPagination = {
  __typename?: 'QuillTemplatesPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  templates?: Maybe<Array<QuillTemplate>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type RangeQueryParam = {
  /** Minimum value to filter by (exclusive) */
  gt?: InputMaybe<Scalars['Int']['input']>;
  /** Minimum value to filter by (inclusive) */
  gte?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum value to filter by (exclusive) */
  lt?: InputMaybe<Scalars['Int']['input']>;
  /** Maximum value to filter by (inclusive) */
  lte?: InputMaybe<Scalars['Int']['input']>;
};

export type Recurring = {
  __typename?: 'Recurring';
  dailyInterval?: Maybe<Scalars['Int']['output']>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfYear?: Maybe<Scalars['Int']['output']>;
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  /** The ending time of the event, in minutes since midnight. */
  endTime?: Maybe<Scalars['Int']['output']>;
  interval?: Maybe<Scalars['String']['output']>;
  /** The starting time of the event, in minutes since midnight. */
  startTime?: Maybe<Scalars['Int']['output']>;
};

export type RecurringCalendarEvent = {
  __typename?: 'RecurringCalendarEvent';
  associatedId?: Maybe<Scalars['String']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** @deprecated This field is no longer used in the system and will be removed in a future release. */
  blocksEventTypes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  calendarEventIds: Array<Scalars['String']['output']>;
  calendarEvents?: Maybe<CalendarEventPagination>;
  colour?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Int']['output'];
  dailyInterval?: Maybe<Scalars['Int']['output']>;
  dayOfMonth?: Maybe<Scalars['Int']['output']>;
  dayOfYear?: Maybe<Scalars['Int']['output']>;
  daysOfWeek?: Maybe<Array<Scalars['Int']['output']>>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  end: Scalars['Int']['output'];
  endTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  interval?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  notes?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  shortTitle?: Maybe<Scalars['String']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  startTime?: Maybe<Scalars['Int']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  zones?: Maybe<ListZonesOutput>;
};


export type RecurringCalendarEventCalendarEventsArgs = {
  filter?: InputMaybe<CalendarEventsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type RecurringCalendarEventZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type RecurringCalendarEventPagination = {
  __typename?: 'RecurringCalendarEventPagination';
  events: Array<RecurringCalendarEvent>;
  limited: Scalars['Int']['output'];
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type RecurringCalendarEventsFilter = {
  assocIds?: InputMaybe<Array<Scalars['String']['input']>>;
  eventIds?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Scalars['String']['input']>;
  maxDate?: InputMaybe<Scalars['Int']['input']>;
  minDate?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};

export type RedeemEmailUpdateTokenOutput = {
  __typename?: 'RedeemEmailUpdateTokenOutput';
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type RedeemInviteTokenOutput = {
  __typename?: 'RedeemInviteTokenOutput';
  emailConfirmationRequired?: Maybe<Scalars['Boolean']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ReferenceType = {
  __typename?: 'ReferenceType';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type RefreshTokenDetails = {
  __typename?: 'RefreshTokenDetails';
  active?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['Int']['output']>;
  deviceType?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  lastUsed?: Maybe<Scalars['Int']['output']>;
  lifetime?: Maybe<Scalars['Int']['output']>;
};

export type RefreshTokensPagination = {
  __typename?: 'RefreshTokensPagination';
  limited: Scalars['Int']['output'];
  refreshTokens: Array<RefreshTokenDetails>;
  skipped: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type Refund = {
  __typename?: 'Refund';
  amount?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export type RegisterPaymentAccountLinks = {
  __typename?: 'RegisterPaymentAccountLinks';
  created?: Maybe<Scalars['Int']['output']>;
  expires_at?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type RelatedArtifactObject = {
  __typename?: 'RelatedArtifactObject';
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

export type RelatedHistoryItem = {
  __typename?: 'RelatedHistoryItem';
  name?: Maybe<Scalars['String']['output']>;
  obj?: Maybe<RelatedHistoryObject>;
};

export type RelatedHistoryObject = {
  __typename?: 'RelatedHistoryObject';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
};

export type RemoveFieldsResult = {
  __typename?: 'RemoveFieldsResult';
  fieldsDeleted: Array<Scalars['String']['output']>;
};

export type RemoveFormComponentsOutput = {
  __typename?: 'RemoveFormComponentsOutput';
  componentsDeleted: Scalars['Int']['output'];
  componentsDetached: Scalars['Int']['output'];
};

export type RemoveFormTypesOutput = {
  __typename?: 'RemoveFormTypesOutput';
  total: Scalars['Int']['output'];
};

export type RemoveOverrideInput = {
  /** Dates this template should be removed from, Format as 'YYYY-MM-DD' */
  dates: Array<InputMaybe<Scalars['String']['input']>>;
  templateId: Scalars['String']['input'];
};

export type RemoveRecurringOutput = {
  __typename?: 'RemoveRecurringOutput';
  eventsDetached: Scalars['Int']['output'];
  eventsRemoved: Scalars['Int']['output'];
  recurringRemoved: Scalars['Int']['output'];
};

export type RemoveSectionFieldsOutput = {
  __typename?: 'RemoveSectionFieldsOutput';
  totalDeleted?: Maybe<Scalars['Int']['output']>;
  totalDetached?: Maybe<Scalars['Int']['output']>;
};

export type RemoveTagsResult = {
  __typename?: 'RemoveTagsResult';
  tagsDeleted: Scalars['Int']['output'];
};

export type RemoveUserSkillsOutput = {
  __typename?: 'RemoveUserSkillsOutput';
  skills: Array<Maybe<RemoveUserSkillsOutputBase>>;
  total: Scalars['Int']['output'];
};

export type RemoveUserSkillsOutputBase = {
  __typename?: 'RemoveUserSkillsOutputBase';
  skill: Scalars['String']['output'];
  user: Scalars['String']['output'];
};

export type RemoveZonesOutput = {
  __typename?: 'RemoveZonesOutput';
  zonesRemoved: Scalars['Int']['output'];
};

export type Report = {
  __typename?: 'Report';
  aggregations?: Maybe<Array<ReportAggregationResult>>;
  artifact?: Maybe<Artifact>;
  createdAt: Scalars['Int']['output'];
  createdBy?: Maybe<User>;
  csv?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  jsonURL?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  reportType: ReportType;
  saveAggregations?: Maybe<Scalars['Boolean']['output']>;
  saveData?: Maybe<Scalars['Boolean']['output']>;
  saveReport?: Maybe<Scalars['Boolean']['output']>;
  scheduledReport?: Maybe<ScheduledReport>;
  status: ReportStatus;
  updatedAt: Scalars['Int']['output'];
  variables?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
  zones?: Maybe<ListZonesOutput>;
};


export type ReportZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ReportAggregation = {
  __typename?: 'ReportAggregation';
  filters?: Maybe<Array<Maybe<ReportAggregationFilter>>>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['ReportAggregationOptions']['output']>;
  otherKeys?: Maybe<Array<Scalars['String']['output']>>;
  secondaryType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ReportAggregationDelta = {
  __typename?: 'ReportAggregationDelta';
  delta?: Maybe<Scalars['ReportAggregationValue']['output']>;
  deltaName?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<ReportAggregationFilter>>>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  options?: Maybe<Scalars['ReportAggregationOptions']['output']>;
  otherKeys?: Maybe<Array<Scalars['String']['output']>>;
  secondaryType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<ScheduledReportAggregateValue>>;
};

export type ReportAggregationFilter = {
  __typename?: 'ReportAggregationFilter';
  contains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  endsWith?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  exactly?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  gt?: Maybe<Scalars['Float']['output']>;
  gte?: Maybe<Scalars['Float']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  lt?: Maybe<Scalars['Float']['output']>;
  lte?: Maybe<Scalars['Float']['output']>;
  matches?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  startsWith?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  typeIs?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ReportAggregationResult = {
  __typename?: 'ReportAggregationResult';
  error?: Maybe<Scalars['String']['output']>;
  filters?: Maybe<Array<Maybe<ReportAggregationFilter>>>;
  format?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  key?: Maybe<Scalars['String']['output']>;
  labels?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  options?: Maybe<Scalars['ReportAggregationOptions']['output']>;
  otherKeys?: Maybe<Array<Scalars['String']['output']>>;
  secondaryType?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['ReportAggregationValue']['output']>;
};

export enum ReportDeltaAnchor {
  EndOf = 'end_of',
  Now = 'now',
  StartOf = 'start_of'
}

export enum ReportDeltaType {
  Difference = 'difference',
  PercentChanged = 'percentChanged',
  /**
   * Calculates the derivative of the percentChanged deltas between two adjacent time periods.
   *
   * For example, if Jan 1 - Jan 31 saw a user percentChanged of 5% and Feb 1 - 31 saw a percentChanged of 6%
   * then this will return (6%-5%)/5% ~= 20%
   */
  PercentChangedFromLastPeriod = 'percentChangedFromLastPeriod'
}

export enum ReportDeltaUnit {
  Aggregate = 'aggregate',
  Day = 'day',
  Hour = 'hour',
  Minute = 'minute',
  Month = 'month',
  Quarter = 'quarter',
  Second = 'second',
  Week = 'week',
  Year = 'year'
}

export enum ReportGetDataOptions {
  Csv = 'csv',
  Json = 'json',
  Pdf = 'pdf'
}

export enum ReportStatus {
  Completed = 'completed',
  Error = 'error',
  Generating = 'generating',
  Pending = 'pending'
}

export type ReportType = {
  __typename?: 'ReportType';
  aggregations: Array<ReportAggregation>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  columns?: Maybe<Array<Scalars['ReportTypeColumnUnion']['output']>>;
  createdAt: Scalars['Int']['output'];
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reports: ListReportsOutput;
  returnValue?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
  variableSchema: Scalars['String']['output'];
  version?: Maybe<Scalars['Float']['output']>;
  zones?: Maybe<ListZonesOutput>;
};


export type ReportTypeReportsArgs = {
  filter?: InputMaybe<ReportsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type ReportTypeZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ReportTypeColumn = {
  __typename?: 'ReportTypeColumn';
  currencyKey?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  format?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ReportTypesFilter = {
  attributes_INCLUDES_ALL?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes_INCLUDES_ANY?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes_INCLUDES_NONE?: InputMaybe<Array<Scalars['String']['input']>>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ReportsFilter = {
  createdBy?: InputMaybe<Scalars['String']['input']>;
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  reportTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ResolveConfig = {
  __typename?: 'ResolveConfig';
  defaultValue: Scalars['String']['output'];
  key: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
};

export type ResponseEditBase = {
  fieldEdits?: InputMaybe<Array<InputMaybe<FieldResponseEdit>>>;
  newFieldResponses?: InputMaybe<Array<InputMaybe<FieldResponseInput>>>;
  newSectionResponses?: InputMaybe<Array<InputMaybe<FormResponseInput>>>;
  sectionFieldResponseEdits?: InputMaybe<Array<InputMaybe<FormResponseEdit>>>;
};

export type Role = Node & {
  __typename?: 'Role';
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<DateTime>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: ListPermissionsResult;
  updatedAt: DateTime;
  zones?: Maybe<ListZonesOutput>;
};


export type RolePermissionsArgs = {
  input?: InputMaybe<ListPermissionsInput>;
};


export type RoleZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type RoleInput = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RoleMutator = {
  __typename?: 'RoleMutator';
  /** @deprecated Moved to root mutation */
  create?: Maybe<Array<Maybe<Role>>>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  edit: Array<Role>;
};


export type RoleMutatorCreateArgs = {
  input: Array<RoleInput>;
  zone?: InputMaybe<Scalars['String']['input']>;
};


export type RoleMutatorEditArgs = {
  input: RoleInput;
};

export type RoleSearch = {
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  directZone?: InputMaybe<Scalars['String']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type RouteDistances = {
  __typename?: 'RouteDistances';
  dock_start?: Maybe<CalculateDistanceOutput>;
  /** @deprecated Calculate with dock_start, start_end and end_dock instead */
  dock_start_end_dock?: Maybe<CalculateDistanceOutput>;
  end_dock?: Maybe<CalculateDistanceOutput>;
  start_dock?: Maybe<CalculateDistanceOutput>;
  start_end?: Maybe<CalculateDistanceOutput>;
};

export type Rule = {
  __typename?: 'Rule';
  action: RuleAction;
  actionDescription: Scalars['String']['output'];
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * A condition string is a JSON string which will
   * resolve to true or false if the provided values match
   * the condition string. See “Condition String Properties” below
   * Each value "AND's" other values unless the OR value is used.
   * See condition string documentation
   */
  condition: Scalars['RuleConditions']['output'];
  createdAt: Scalars['Int']['output'];
  delay?: Maybe<Scalars['Int']['output']>;
  delayUnit?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  describedConditions?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  offsetUnit?: Maybe<Scalars['String']['output']>;
  trigger: RuleTrigger;
  triggerDescription: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  zones?: Maybe<ListZonesOutput>;
};


export type RuleZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type RuleAction = {
  __typename?: 'RuleAction';
  /** @deprecated Use Rule.actionDescription */
  describedForRule?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['AJVSchema']['output']>;
};

export type RuleOptions = {
  __typename?: 'RuleOptions';
  actions: Array<RuleAction>;
  triggers: Array<RuleTrigger>;
};

export type RuleTrigger = {
  __typename?: 'RuleTrigger';
  /** @deprecated Use Rule.triggerDescription */
  describedForRule?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['AJVSchema']['output']>;
};

export type RulesFilter = {
  action?: InputMaybe<Scalars['String']['input']>;
  action_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes_INCLUDES_ALL?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes_INCLUDES_ANY?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes_INCLUDES_NONE?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAtMax?: InputMaybe<Scalars['Int']['input']>;
  createdAtMin?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set to nothing to
   * True to show only deleted
   * False to show only existing, deleted
   * null to show deleted and existing
   */
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAtMax?: InputMaybe<Scalars['Int']['input']>;
  deletedAtMin?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  id_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  trigger?: InputMaybe<Scalars['String']['input']>;
  trigger_IN?: InputMaybe<Array<Scalars['String']['input']>>;
  updatedAtMax?: InputMaybe<Scalars['Int']['input']>;
  updatedAtMin?: InputMaybe<Scalars['Int']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type ScheduledReport = {
  __typename?: 'ScheduledReport';
  /**
   * A list of aggregation results generated by the scheduled reports.
   *
   * Can also access "delta" to generate delta values from the aggregation results.
   *
   * If no reports have been run this will be an empty array.
   */
  aggregations?: Maybe<Array<ReportAggregationDelta>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Int']['output'];
  /** Who this scheduled report was created by. Empty if it was by the system. */
  createdBy?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  dynamicReport?: Maybe<DynamicReport>;
  /**
   * The unix time that this scheduled report should stop running
   * Null if never.
   */
  end?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The last time that this report ran at */
  lastRun?: Maybe<Scalars['Int']['output']>;
  /** The scheduled reports name. If this is not provided it will be auto generated. */
  name: Scalars['String']['output'];
  /** The next unix time that this report will/should be run. */
  nextRun?: Maybe<Scalars['Int']['output']>;
  /** A list of roles to notify upon report generation */
  notifyRoles?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of users to notify upon report generation */
  notifyUsers?: Maybe<Array<Scalars['String']['output']>>;
  /** The report type for the scheduled report */
  reportType?: Maybe<ReportType>;
  /**
   * Whether to save the artifact for that report.
   * If set to "false," will not save the artifact but it will save aggregates.
   */
  saveData?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The unix time that this scheduled report should start running
   * Null if now.
   */
  start?: Maybe<Scalars['Int']['output']>;
  time: Scalars['String']['output'];
  /** The timezone used by the scheduled report to run times */
  tz?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
  /**
   * A JSON string of hard coded variables to pass to each report.
   *
   * Each report will also be able to access the common variables as outlined in reports.md
   */
  variables?: Maybe<Scalars['String']['output']>;
  /**
   * An array of secure (starts with HTTPS) urls to send webhooks to
   * following successful report generation. The webhook will have report
   * metadata, variables, data, and aggregations in a JSON format. It also has a signed
   * link to the generated report information.
   *
   * Use https://webhook.site to view an example.
   */
  webhooks?: Maybe<Array<Scalars['String']['output']>>;
  zones?: Maybe<ListZonesOutput>;
};


export type ScheduledReportZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type ScheduledReportAggregateValue = {
  __typename?: 'ScheduledReportAggregateValue';
  createdAt?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  reportId?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Scalars['ReportAggregationValue']['output']>;
};

export type ScheduledReportsFilter = {
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  dynamicReportIds?: InputMaybe<Array<Scalars['String']['input']>>;
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  reportTypeIds?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type SearchInput = {
  search: Scalars['String']['input'];
};

export type SearchNode = {
  __typename?: 'SearchNode';
  label: Scalars['String']['output'];
  metadata?: Maybe<Scalars['SearchMetadata']['output']>;
  objectID: Scalars['String']['output'];
  score: Scalars['Float']['output'];
  subtitle?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  zone: Scalars['String']['output'];
  zoneId: Scalars['String']['output'];
};

export type SearchOutput = {
  __typename?: 'SearchOutput';
  results: Array<SearchNode>;
};

export type SelectedProduct = {
  __typename?: 'SelectedProduct';
  /** The ID of the product to add */
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  /** The price ID of the product to add */
  priceId: Scalars['String']['output'];
  quantity: Scalars['Float']['output'];
  reason: Scalars['String']['output'];
};

export type SendInvoiceOutput = {
  __typename?: 'SendInvoiceOutput';
  sent: Scalars['Boolean']['output'];
  updated: Scalars['Boolean']['output'];
};

export type ServiceAreaQueryMatch = {
  __typename?: 'ServiceAreaQueryMatch';
  /**
   * The distance, in meters, that the *nearest* territory/location (with coordinates)
   *  is from the provided "query" location. Note that this is the geographic distance
   *  and not the travel distance.
   */
  distance?: Maybe<Scalars['Float']['output']>;
  /** The type of match that the result is */
  matchType?: Maybe<MatchedServiceAreaMatchType>;
  /** Names of territories / locations that match in this area. */
  territoryMatches?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the zone where the zone.type is equal to "area" */
  zoneId: Scalars['String']['output'];
  /** Name of this zone, eg "Winnipeg Area 1" */
  zoneName?: Maybe<Scalars['String']['output']>;
  /** ID of the parent of this zone, likely a franchise or business unit */
  zoneParentId?: Maybe<Scalars['String']['output']>;
};

export type ServiceAreaQueryResult = {
  __typename?: 'ServiceAreaQueryResult';
  /**
   * Other potential closest matches, ordered by their relevancy then distance. The order is as follows:
   *
   *  1. All areas that match an area_code within your *current* zone
   *
   *  1.1 Ordered by how much the postal code matches (eg, R3T4G3 matches more than R3T)
   *
   *  1.2 Ordered by how close the postal code is to your provided location
   *
   *  2. All areas that match an area_code within your *domain* zone
   *
   *  2.1 Ordered by how much the postal code matches (eg, R3T4G3 matches more than R3T)
   *
   *  2.2 Ordered by how close the postal code is to your provided location
   *
   *  3. Top 5 closest areas in your *current* zone, ordered by closest zones first
   *
   *  4. Top 5 closest areas in your *domain* zone, ordered by closest zones first
   *
   *  If you would prefer these areas to be ordered by distance, first sort by areas
   *  that match based on postal codes, then sort by distance. Postal code matches are supposed to
   *  be weighted higher than distance matches.
   */
  closestAreas?: Maybe<Array<ServiceAreaQueryMatch>>;
  /** The coordinates of the place that the `query` resolved from Google */
  coordinates?: Maybe<Coordinates>;
  locationBase?: Maybe<LocationBase>;
  /**
   * An area that matches a territory within your current domain. If the area directly resolves,
   * eg an area code match, then "matchType" is set to "area_code." If it is resolved based on distance,
   * then "matchType" is set to "distance." Note that distance will only be resolved for areas that are within
   * the area-resolve.radius config for the zone. If no config is set, then a default of 100km's will be used.
   *
   * If nothing is found in matchedArea, then you can use "closestAreas" to determine other potential matches
   * not within the radius
   */
  matchedArea?: Maybe<ServiceAreaQueryMatch>;
  /** The place_id of the place that the `query` resolved from Google */
  placeId?: Maybe<Scalars['String']['output']>;
  /** The name of the place that the `query` resolved from Google */
  placeName?: Maybe<Scalars['String']['output']>;
  /** The "query" property passed to resolveServiceArea */
  query: Scalars['String']['output'];
};

export type SetAssets = {
  addAssets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeAssets?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SetChargesInput = {
  addExistingCharges?: InputMaybe<Array<Scalars['String']['input']>>;
  removeCharges?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SetEventAttendeesInput = {
  addAttendees?: InputMaybe<Array<InputMaybe<AddAttendeesInput>>>;
  removeAttendees?: InputMaybe<Array<InputMaybe<AddAttendeesInput>>>;
};

export type SetEventLocationsInput = {
  addLocations?: InputMaybe<Array<InputMaybe<CalendarEventLocationInput>>>;
  editLocations?: InputMaybe<Array<InputMaybe<EditCalendarEventLocationInput>>>;
  removeLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SetEventTopicsInput = {
  addTopics?: InputMaybe<Array<InputMaybe<AddTopicsInput>>>;
  removeTopics?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SetFieldValueInput = {
  /**  Id of the field, must be included if fieldName is not  */
  fieldId?: InputMaybe<Scalars['String']['input']>;
  /**  The name of the field, must be included if fieldId is not  */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['FieldValue']['input']>;
};

export type SetFieldValueResult = {
  __typename?: 'SetFieldValueResult';
  fields: Array<Field>;
};

export type SetFieldsValuesInput = {
  fields?: InputMaybe<Array<InputMaybe<SetFieldValueInput>>>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserSkills = {
  addSkills?: InputMaybe<Array<AddUserSkillsInput>>;
  removeSkills?: InputMaybe<Array<Scalars['String']['input']>>;
  userId: Scalars['String']['input'];
};

export type SetUsersSkills = {
  edits?: InputMaybe<Array<InputMaybe<SetUserSkills>>>;
};

/** Used to apply single 'edit' to multiple calendar events. */
export type SingleEditInput = {
  assocId?: InputMaybe<Scalars['String']['input']>;
  /** If true will disable the molecular event that triggers at the end of the edit action, disabling all related functionality (e.g. notifications). Default: false */
  disablePropogation?: InputMaybe<Scalars['Boolean']['input']>;
  edit: EditCalendarEventInput;
  id: Scalars['String']['input'];
  /** Denotes whether event attendees should be notified. Default: true */
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  /** Denotes whether users with relevant 'dispatch' roles should be notified. Default: true */
  notifyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Skill = Node & {
  __typename?: 'Skill';
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<DateTime>;
  description?: Maybe<Scalars['String']['output']>;
  equivalentOf?: Maybe<Array<Maybe<Skill>>>;
  equivalents?: Maybe<Array<Maybe<Skill>>>;
  fields?: Maybe<Array<Maybe<Field>>>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  postrequisites?: Maybe<Array<Maybe<Skill>>>;
  prerequisites?: Maybe<Array<Maybe<Skill>>>;
  ratingType?: Maybe<Scalars['String']['output']>;
  shortName?: Maybe<Scalars['String']['output']>;
  skillDetails?: Maybe<SkillDetails>;
  skillType: Scalars['String']['output'];
  updatedAt: DateTime;
  users?: Maybe<Array<Maybe<UserSkillOutput>>>;
  zones?: Maybe<ListZonesOutput>;
};


export type SkillFieldsArgs = {
  names: Array<Scalars['String']['input']>;
};


export type SkillHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

/**
 * attributes: identifiers for advanced filtering,
 * rating is based on the rating type ex. rating type grade/100 the rating 76 would be valid,
 * form is relationship to the skill, ex. tutor, tutee, completed, required etc.
 */
export type SkillDetails = {
  __typename?: 'SkillDetails';
  addedOn: Scalars['Int']['output'];
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  form?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedOn: Scalars['Int']['output'];
};

/**
 * getUsers: Required or users will be null.
 *
 * getLinked: Enables Linked Skills to display (pre, post, eqv, eqvOf). Return Null for those fields if false.
 *
 * getDeepLinked: Will Display every linked skill based on realtionships of other skills ex. Year 4 course requires Year 3 => Year 2 etc.
 */
export type SkillFilter = {
  containsAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  getDeepLinked?: InputMaybe<Scalars['Boolean']['input']>;
  getLinked?: InputMaybe<Scalars['Boolean']['input']>;
  /** retrieves user skills for users that match this criteria */
  getUsers?: InputMaybe<SkillUserFilter>;
  hasAttributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** filters skills where at least one user matches the criteria */
  heldByUsers?: InputMaybe<SkillUserFilter>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ratingType?: InputMaybe<Scalars['String']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  shortName?: InputMaybe<Scalars['String']['input']>;
  skillType?: InputMaybe<Scalars['String']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SkillLinkInput = {
  equivalentOf?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  equivalents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  postrequisites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  prerequisites?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type SkillPagination = {
  __typename?: 'SkillPagination';
  limit?: Maybe<Scalars['Int']['output']>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

/**
 * This filters the users that appear (must be present for users to resolve)
 *
 * userIdsIntersectional: Whether or not
 */
export type SkillUserFilter = {
  MaxRating?: InputMaybe<Scalars['Int']['input']>;
  forms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formsIntersectional?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  maxExclusiveRating?: InputMaybe<Scalars['Int']['input']>;
  minExclusiveRating?: InputMaybe<Scalars['Int']['input']>;
  minRating?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  userIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userIdsIntersectional?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StandardDocumentsConfig = {
  __typename?: 'StandardDocumentsConfig';
  name: Scalars['String']['output'];
  signable: Scalars['Boolean']['output'];
  templateId: Scalars['String']['output'];
  type: Scalars['String']['output'];
  validationSchema: ValidationSchema;
};

export type StringArrayBox = {
  __typename?: 'StringArrayBox';
  value: Array<Maybe<Scalars['String']['output']>>;
};

export type StringBox = {
  __typename?: 'StringBox';
  value: Scalars['String']['output'];
};

export type StripeDiscount = {
  __typename?: 'StripeDiscount';
  coupon?: Maybe<Coupon>;
  end?: Maybe<Scalars['Int']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  subscription?: Maybe<Scalars['String']['output']>;
};

export type StripeInvoice = {
  __typename?: 'StripeInvoice';
  account_country?: Maybe<Scalars['String']['output']>;
  account_name?: Maybe<Scalars['String']['output']>;
  amount_due?: Maybe<Scalars['Int']['output']>;
  amount_paid?: Maybe<Scalars['Int']['output']>;
  amount_remaining?: Maybe<Scalars['Int']['output']>;
  application_fee_amount?: Maybe<Scalars['Int']['output']>;
  attempt_count?: Maybe<Scalars['Int']['output']>;
  attempted?: Maybe<Scalars['Int']['output']>;
  charge?: Maybe<Scalars['String']['output']>;
  closed?: Maybe<Scalars['Boolean']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<Scalars['String']['output']>;
  default_payment_method?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Discount>;
  due_date?: Maybe<Scalars['Int']['output']>;
  ending_balance?: Maybe<Scalars['Int']['output']>;
  hosted_invoice_url?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  invoice_pdf?: Maybe<Scalars['String']['output']>;
  lines?: Maybe<InvoiceItemList>;
  next_payment_attempt?: Maybe<Scalars['Int']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  paid?: Maybe<Scalars['Boolean']['output']>;
  payment_intent?: Maybe<Scalars['String']['output']>;
  period_end?: Maybe<Scalars['Int']['output']>;
  period_start?: Maybe<Scalars['Int']['output']>;
  starting_balance?: Maybe<Scalars['Int']['output']>;
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subtotal?: Maybe<Scalars['Int']['output']>;
  tax?: Maybe<Scalars['Int']['output']>;
  tax_percent?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
};

export type StripePrice = {
  __typename?: 'StripePrice';
  /** Whether the price can be used for new purchases. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created?: Maybe<Scalars['Int']['output']>;
  /**
   * Three-letter [ISO currency code](https://www.iso.org/iso-4217-currency-codes.html), in lowercase.
   * Must be a [supported currency](https://stripe.com/docs/currencies).
   */
  currency?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** Unique identifier for the object. Generated by Stripe */
  id?: Maybe<Scalars['String']['output']>;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode?: Maybe<Scalars['Boolean']['output']>;
  /** A lookup key used to retrieve prices dynamically from a static string. */
  lookup_key?: Maybe<Scalars['String']['output']>;
  /** A brief description of the plan, hidden from customers. */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The ID of the product this price is associated with. */
  product?: Maybe<Product>;
  /** The unit amount in cents to be charged, represented as a whole integer if possible. */
  unit_amount?: Maybe<Scalars['Int']['output']>;
};

export type StripeProduct = {
  __typename?: 'StripeProduct';
  /** Whether the product is currently available for purchase. */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** A list of up to 5 attributes that each SKU can provide values for (e.g., `["color", "size"]`). */
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A short one-line description of the product, meant to be displayable to the customer. Only applicable to products of `type=good`. */
  caption?: Maybe<Scalars['String']['output']>;
  /** Time at which the object was created. Measured in seconds since the Unix epoch. */
  created?: Maybe<Scalars['Int']['output']>;
  /** An array of connect application identifiers that cannot purchase this product. Only applicable to products of `type=good`. */
  deactivate_on?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  /** The product's description, meant to be displayable to the customer. Use this field to optionally store a long form explanation of the product being sold for your own rendering purposes. */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the object. Generated by Stripe */
  id?: Maybe<Scalars['String']['output']>;
  /** A list of up to 8 URLs of images for this product, meant to be displayable to the customer. */
  images?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Has the value `true` if the object exists in live mode or the value `false` if the object exists in test mode. */
  livemode?: Maybe<Scalars['Boolean']['output']>;
  /** The product's name, meant to be displayable to the customer. Whenever this product is sold via a subscription, name will show up on associated invoice line item descriptions. */
  name?: Maybe<Scalars['String']['output']>;
  prices?: Maybe<Array<Maybe<Price>>>;
  /** Whether this product is a shipped good. Only applicable to products of `type=good`. */
  shippable?: Maybe<Scalars['Boolean']['output']>;
  /** Extra information about a product which will appear on your customer's credit card statement. In the case that multiple products are billed at once, the first statement descriptor will be used. */
  statement_descriptor?: Maybe<Scalars['String']['output']>;
  /** The type of the product. The product is either of type `good`, which is eligible for use with Orders and SKUs, or `service`, which is eligible for use with Subscriptions and Plans. */
  type?: Maybe<StripeProductType>;
  /** A label that represents units of this product in Stripe and on customers' receipts and invoices. When set, this will be included in associated invoice line item descriptions. */
  unit_label?: Maybe<Scalars['String']['output']>;
  /** Time at which the object was last updated. Measured in seconds since the Unix epoch. */
  updated?: Maybe<Scalars['Int']['output']>;
  /** A URL of a publicly-accessible webpage for this product. Only applicable to products of `type=good`. */
  url?: Maybe<Scalars['String']['output']>;
};

export enum StripeProductType {
  Good = 'good',
  Service = 'service'
}

export type SubLocationEditOutput = {
  __typename?: 'SubLocationEditOutput';
  parent?: Maybe<Scalars['String']['output']>;
  subLocations: Array<Maybe<Scalars['String']['output']>>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Subscription = {
  __typename?: 'Subscription';
  _blank?: Maybe<Scalars['Boolean']['output']>;
  clockUpdated: Clocks;
  documentReadyToView: DocumentReadyToViewOutput;
  documentSigned: DocumentSigned;
  job: JobChangedEvent;
  jobClosed: JobClosedOutput;
  jobPromoted: JobPromotedOutput;
  newNotification: Notification;
  onBlockEdit: BlockSubscriptionOutput;
  onEditFormResponse: EditFormResponseSubscriptionOutput;
  onNewFormResponse: NewFormResponseSubscriptionOutput;
  onPageEdit: PageSubscriptionOutput;
};


export type SubscriptionClockUpdatedArgs = {
  eventId: Scalars['String']['input'];
};


export type SubscriptionJobArgs = {
  jobId: Scalars['String']['input'];
};

export type Tag = Node & {
  __typename?: 'Tag';
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /**  Category of the tag, only one tag from each category can be applied at a time */
  category?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<DateTime>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  objectType: Scalars['String']['output'];
  /**
   * Objects with this tag. Only shown if showObjects arg is true
   * Limited by objectLimit arg
   */
  objects?: Maybe<Array<Maybe<TaggedObject>>>;
  order?: Maybe<Scalars['Float']['output']>;
  owner?: Maybe<Scalars['String']['output']>;
  private?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: DateTime;
};


export type TagHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type TagFilter = {
  /**  Will search for tags with a matching category name  */
  categories_INCLUDES_ANY?: InputMaybe<Array<Scalars['String']['input']>>;
  color?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  objectIds?: InputMaybe<Array<Scalars['String']['input']>>;
  objectTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  owners?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  showPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  showPublic?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  tagIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Deault 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type TagMutator = {
  __typename?: 'TagMutator';
  /** Deletes the queried tags, requires permission 'tags.delete' */
  delete: Scalars['Boolean']['output'];
  /** Edits the queried tags, requires permission 'tags.edit' */
  edit: Scalars['Boolean']['output'];
  /** Adds tags to the given object, requires permission 'tags.setObjectTags' */
  setObjectTags?: Maybe<Scalars['Boolean']['output']>;
};


export type TagMutatorEditArgs = {
  input?: InputMaybe<EditTagInput>;
};


export type TagMutatorSetObjectTagsArgs = {
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<TagRelationship>>>;
};

export type TagRelationship = {
  private?: InputMaybe<Scalars['Boolean']['input']>;
  tagId?: InputMaybe<Scalars['String']['input']>;
};

export type TagResult = {
  __typename?: 'TagResult';
  filtered?: Maybe<Scalars['Int']['output']>;
  returned?: Maybe<Scalars['Int']['output']>;
  tags: Array<Tag>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type TaggedObject = {
  __typename?: 'TaggedObject';
  id: Scalars['String']['output'];
  order?: Maybe<Scalars['Float']['output']>;
  taggedBy: Scalars['String']['output'];
  taggedPrivately: Scalars['Boolean']['output'];
};

export type TagsInput = {
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  private?: InputMaybe<Scalars['Boolean']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Talkdesk_CallbackConfig = {
  __typename?: 'Talkdesk_CallbackConfig';
  businessHours?: Maybe<Array<DayOfWeekHours>>;
  days: Array<CallbackDay>;
  minCallbackIntervalHours: Scalars['Int']['output'];
  timezone: Scalars['String']['output'];
};

export type Tax = {
  __typename?: 'Tax';
  active: Scalars['Boolean']['output'];
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isZoneDefault: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['Int']['output'];
  zones?: Maybe<ListZonesOutput>;
};

export type TaxAmount = {
  __typename?: 'TaxAmount';
  amount?: Maybe<Scalars['Int']['output']>;
  inclusive?: Maybe<Scalars['Boolean']['output']>;
  tax_rate?: Maybe<Scalars['String']['output']>;
};

export type TaxPaid = {
  __typename?: 'TaxPaid';
  /** Value in cents */
  paid: Scalars['Int']['output'];
  tax: Tax;
};

export type TaxRate = {
  __typename?: 'TaxRate';
  active?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  display_name?: Maybe<Scalars['String']['output']>;
  inclusive?: Maybe<Scalars['Boolean']['output']>;
  jurisdiction?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['Float']['output']>;
};

export type TaxesFilter = {
  chargeId?: InputMaybe<Scalars['String']['input']>;
  hasAllAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  hasAnyAttributes?: InputMaybe<Array<Scalars['String']['input']>>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isZoneDefault?: InputMaybe<Scalars['Boolean']['input']>;
  nameSearch?: InputMaybe<Scalars['String']['input']>;
  /** Default false */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  taxIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type TemplateConfig = {
  __typename?: 'TemplateConfig';
  email: EmailTemplate;
  force: Array<Scalars['String']['output']>;
  resolveConfig: Array<ResolveConfig>;
  schema: ValidationSchema;
  skipLocalWait: Scalars['Boolean']['output'];
};

export type TimesSearch = {
  calendarEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  daysOfWeek?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type Token = {
  __typename?: 'Token';
  createdAt?: Maybe<Scalars['Int']['output']>;
  emails?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  expiration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  isValid?: Maybe<Scalars['Boolean']['output']>;
  maxUses?: Maybe<Scalars['Int']['output']>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  roles?: Maybe<Array<Maybe<Role>>>;
  title?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  used?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  validOn?: Maybe<Scalars['Int']['output']>;
  zones?: Maybe<Array<Maybe<Zone>>>;
};

export type TokensFilter = {
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  expiresAfter?: InputMaybe<Scalars['Int']['input']>;
  expiresBefore?: InputMaybe<Scalars['Int']['input']>;
  getSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tokenType?: InputMaybe<Scalars['String']['input']>;
  tokens?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  transactions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  users?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Transaction = {
  __typename?: 'Transaction';
  amount?: Maybe<Scalars['Int']['output']>;
  archivedAt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Int']['output'];
  currency: Scalars['String']['output'];
  customer?: Maybe<User>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  history: HistoryPagination;
  id: Scalars['String']['output'];
  /** The transaction's place on the job in respect to other transactions */
  increment?: Maybe<Scalars['Int']['output']>;
  invoice?: Maybe<Invoice>;
  job: Job;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  paidAt?: Maybe<Scalars['Int']['output']>;
  /**  The payment type for the transaction  */
  paymentType?: Maybe<PaymentType>;
  /** pending, paid, cancelled */
  stage: TransactionStage;
  /**  The type of the transaction */
  type?: Maybe<TransactionType>;
};


export type TransactionHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export enum TransactionStage {
  Cancelled = 'cancelled',
  Paid = 'paid',
  Pending = 'pending'
}

export enum TransactionType {
  /**  A deposit for a job, allows it to exceed the balance of the job as it will be recorded before the job isfinalized  */
  Deposit = 'deposit',
  /**  A regular payment, cannot be larger than the balance for the job */
  Payment = 'payment',
  /**  A payment to the customer, must be a negative value  */
  Refund = 'refund'
}

export type TransactionsFilter = {
  amountGreaterThan?: InputMaybe<Scalars['Int']['input']>;
  amountLowerThan?: InputMaybe<Scalars['Int']['input']>;
  createdAfter?: InputMaybe<Scalars['Int']['input']>;
  createdBefore?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Array<MetadataFilter>>;
  /** Default false */
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  /** pending, paid, cancelled */
  stage?: InputMaybe<TransactionStage>;
  transactionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<TransactionType>;
  /** Default 'any' */
  zoneDir?: InputMaybe<ZoneDir>;
};

export type TransitionedJob = {
  __typename?: 'TransitionedJob';
  newJobId: Scalars['String']['output'];
  oldJobId: Scalars['String']['output'];
};

export type TriggerConfig = {
  __typename?: 'TriggerConfig';
  triggerCalc?: Maybe<Scalars['String']['output']>;
  triggerCalcValue?: Maybe<Scalars['String']['output']>;
  triggerDescription?: Maybe<Scalars['String']['output']>;
  triggerMetaKey?: Maybe<Scalars['String']['output']>;
  triggerMsgLevel?: Maybe<Scalars['String']['output']>;
  triggerPrettyName?: Maybe<Scalars['String']['output']>;
  triggerType?: Maybe<Scalars['String']['output']>;
};

export type UpdateAssetInput = {
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  locationId?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAvailabilityConfigurationInput = {
  /**  An array of templates ids and dates, these templates will override the normal availability  */
  addOverrides?: InputMaybe<Array<InputMaybe<AddOverrideInput>>>;
  /**  An array of template ids to add as well as optional parameters to override the dates */
  addTemplates?: InputMaybe<Array<InputMaybe<AddTemplateInput>>>;
  objectId: Scalars['String']['input'];
  /**  An array of templates id and which dates they should be removed from */
  removeOverrides?: InputMaybe<Array<RemoveOverrideInput>>;
  /**  An array of the template ids you want to remove */
  removeTemplates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAvailabilityTemplateInput = {
  /**
   * Availability for each day of the week, every two items in the array are the start/end times for that block.
   * eg. [0, 3600, 7200, 10800] -> would be available 12am - 1am and 2am - 3am
   */
  availability?: InputMaybe<AvailabilityByDayOfTheWeekInput>;
  /**  Format: 'YYYY-MM-DD', End date for this template  */
  endDate?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  /**  Name for referencing the template  */
  name: Scalars['String']['input'];
  /**  Format: 'YYYY-MM-DD', Start date for this template  */
  startDate?: InputMaybe<Scalars['String']['input']>;
  /** The owner of the template if the template is for an object in the database other than users. */
  templateOwner?: InputMaybe<Scalars['String']['input']>;
  /** The zones that this template availability applies to. */
  zones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateChargesInput = {
  charges: Array<ChargeUpdate>;
};

export type UpdateCommentInput = {
  ids: Array<Scalars['String']['input']>;
  update: UpdateCommentPartial;
};

export type UpdateCommentOutput = {
  __typename?: 'UpdateCommentOutput';
  commentIds: Array<Maybe<Scalars['String']['output']>>;
  newARtifacts?: Maybe<Array<Maybe<Artifact>>>;
};

export type UpdateCommentPartial = {
  addArtifacts?: InputMaybe<Array<Scalars['String']['input']>>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  contents?: InputMaybe<Scalars['String']['input']>;
  removeArtifacts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Must be on of the Following 'owner', 'manager', 'editor', 'commenter', 'viewer' */
  requiredAccessLevel?: InputMaybe<Access_Type>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateDiscountsInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Range for valid custom amounts when applying the discounts. The first value in the array is the
   * lower limit, the second the upper. For amount discount types the values represent cents, for percentage
   * the values represent the percentage out of 100. The upper limit of percentage discounts cannot exceed 100.
   * Omit the second integer to set no limit (percentage discounts will still be capped at 100).
   */
  customAmountRange?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountId: Scalars['String']['input'];
  expiresAt?: InputMaybe<Scalars['Int']['input']>;
  maxRedemptions?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  startsAt?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateInvoiceInput = {
  addTransactions?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId: Scalars['String']['input'];
  removeTransactions?: InputMaybe<Array<Scalars['String']['input']>>;
  updatePricingTables?: InputMaybe<Scalars['Boolean']['input']>;
  voided?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateJobInput = {
  addDiscounts?: InputMaybe<Array<AddJobDiscount>>;
  addEvents?: InputMaybe<Array<InputMaybe<EventInput>>>;
  /**  Adds a location of the designated type to the job. If a location of that type already exists it is removed */
  addLocations?: InputMaybe<Array<InputMaybe<JobLocationInput>>>;
  addUsers?: InputMaybe<Array<InputMaybe<JobUserInput>>>;
  adminSummary?: InputMaybe<Scalars['Summary']['input']>;
  /**
   * If set to true the job will be archived. If false then the job will be unarchived.
   * Unarchiving a job requires the restriction "updateArchived"
   */
  archiveJob?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * If set to true then the job will be closed, if able to. If set to false then the job
   * will be reopened.
   */
  closeJob?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional, denotes the reason for the job's closure. Note that this input must match
   * one of the values set in the config 'jobs.closedReasons'. example values: 'complete',
   * 'issue_with_price', 'other'
   */
  closedReason?: InputMaybe<Scalars['String']['input']>;
  createDiscounts?: InputMaybe<Array<CreateDiscountsInput>>;
  crewSummary?: InputMaybe<Scalars['Summary']['input']>;
  customerSummary?: InputMaybe<Scalars['Summary']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  editCalendarEvents?: InputMaybe<BulkEditEvents>;
  eventsOrderChangedByUser?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<SetFieldsValuesInput>;
  jobId: Scalars['String']['input'];
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  newCharges?: InputMaybe<NewChargesInput>;
  newCustomers?: InputMaybe<Array<InputMaybe<CreateUserInputWithRole>>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The reason you are changing this jobs stage */
  promoteReason?: InputMaybe<Scalars['String']['input']>;
  removeCalendarEvents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeCharges?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeDiscounts?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeLocations?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  removeUsers?: InputMaybe<Array<InputMaybe<JobUserInput>>>;
  sendSelfSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  setSharedZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Change this jobs zone and update its job code */
  setZone?: InputMaybe<Scalars['String']['input']>;
  /**
   * If set will cause the job to be cloned on the database, preserving the previous state of the job.
   * Possible Values: ("lead", “estimate”, “booking”, “invoice”, "cancelled")
   */
  stage?: InputMaybe<Scalars['String']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  timelineDays?: InputMaybe<Scalars['Float']['input']>;
  updateCharges?: InputMaybe<UpdateChargesInput>;
};

export type UpdateJobsOutput = {
  __typename?: 'UpdateJobsOutput';
  fields?: Maybe<Array<Maybe<Field>>>;
  isSuccess: Scalars['Boolean']['output'];
  jobs?: Maybe<Array<Maybe<Job>>>;
  transitionedJobs?: Maybe<Array<Maybe<TransitionedJob>>>;
};

export type UpdatePriceInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addExpenses?: InputMaybe<Array<CreatePriceExpenseInput>>;
  addTaxes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Change this price. For all charges, that price will
   * stay the same until the job is manually updated in any way.
   *
   * Requires the restriction pricesOverrideAmounts set to true
   */
  amount?: InputMaybe<Scalars['Float']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /**
   * Change this currency. For all charges, that currency will
   * stay the same until the job is manually updated in any way.
   *
   * Requires the restriction pricesOverrideAmounts set to true
   */
  currency?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  priceId: Scalars['String']['input'];
  priceType?: InputMaybe<PriceType>;
  removeExpenses?: InputMaybe<Array<Scalars['String']['input']>>;
  removeTaxes?: InputMaybe<Array<Scalars['String']['input']>>;
  updateExpenses?: InputMaybe<Array<CreatePriceExpenseInput>>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateProductInput = {
  /** Denotes whether the product is available for purchase */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  productId: Scalars['String']['input'];
  /** The description used for credit card staements */
  statementDescription?: InputMaybe<Scalars['String']['input']>;
  unitLabel?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePromotionCodeInput = {
  /**
   * Whether the promotion code is currently active. A promotion code can only be reactivated when the coupon is still valid and the
   * promotion code is otherwise redeemable.
   */
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addToZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
  removeFromZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stripeId: Scalars['String']['input'];
};

export type UpdateQuillTemplateInput = {
  ids: Array<Scalars['String']['input']>;
  update: UpdateQuillTemplatePatch;
};

export type UpdateQuillTemplateOutput = {
  __typename?: 'UpdateQuillTemplateOutput';
  templates?: Maybe<Array<QuillTemplate>>;
};

export type UpdateQuillTemplatePatch = {
  contents?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if this template is the default for its location */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<QuillTemplateLocation>;
  name?: InputMaybe<Scalars['String']['input']>;
  /** The subject line for email templates. */
  subjectContents?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateRuleInput = {
  id: Scalars['String']['input'];
  properties?: InputMaybe<UpdateRuleInputProperties>;
};

export type UpdateRuleInputProperties = {
  action?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  condition?: InputMaybe<Scalars['String']['input']>;
  delay?: InputMaybe<Scalars['Int']['input']>;
  delayUnit?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  offsetUnit?: InputMaybe<Scalars['String']['input']>;
  trigger?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScheduledReportInput = {
  ids: Array<Scalars['String']['input']>;
  rels?: InputMaybe<UpdateScheduledReportInputRels>;
  update?: InputMaybe<UpdateScheduledReportInputProperties>;
};

export type UpdateScheduledReportInputProperties = {
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  end?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  saveData?: InputMaybe<Scalars['Boolean']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  time?: InputMaybe<Scalars['String']['input']>;
  tz?: InputMaybe<Scalars['String']['input']>;
  variables?: InputMaybe<Scalars['String']['input']>;
  webhooks?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateScheduledReportInputRels = {
  notifyRoles?: InputMaybe<Array<Scalars['String']['input']>>;
  notifyUsers?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UploadToPandadocOutput = {
  __typename?: 'UploadToPandadocOutput';
  artifactId: Scalars['String']['output'];
  pandadocId: Scalars['String']['output'];
};

export type UseObjectTagResult = {
  __typename?: 'UseObjectTagResult';
  objects: Array<Scalars['String']['output']>;
  tags: Array<Scalars['String']['output']>;
};

export type User = Node & {
  __typename?: 'User';
  accesses: AccessPagination;
  /** What action to perform on a user that deserves attention. */
  action?: Maybe<Scalars['String']['output']>;
  artifacts?: Maybe<Array<Artifact>>;
  /** The reasons why this user deserves attention (if any). */
  attentionExplanation?: Maybe<Array<Scalars['String']['output']>>;
  /** A measure of how much attention this user currently deserves. */
  attentionScore?: Maybe<Scalars['Float']['output']>;
  availabilities?: Maybe<Array<Availability>>;
  /** @deprecated replaced by availabilities */
  availability?: Maybe<Array<DayAvailability>>;
  billingAddress?: Maybe<Location>;
  /**
   * Will return boolean of whether the user has the permission, no matter the restrictions.
   * Guaranteed to be in same order of array.
   */
  checkPermissions: Array<Scalars['Boolean']['output']>;
  comments?: Maybe<CommentPagination>;
  company?: Maybe<Scalars['String']['output']>;
  createdAt: DateTime;
  deletedAt?: Maybe<DateTime>;
  /** @deprecated Use property deletedAt */
  deletedOn?: Maybe<DateTime>;
  email?: Maybe<Scalars['String']['output']>;
  familyName?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  jobs: Array<Maybe<Job>>;
  locations?: Maybe<Array<Maybe<Location>>>;
  metadata?: Maybe<Scalars['Metadata']['output']>;
  /** Retrieve this users local notifications.  */
  notifications: NotificationsPagination;
  payment: UserPayment;
  permissions: ListPermissionsResult;
  phone?: Maybe<Scalars['String']['output']>;
  refreshTokens: RefreshTokensPagination;
  roles?: Maybe<Array<Role>>;
  salary?: Maybe<Scalars['Int']['output']>;
  shiftAvailability?: Maybe<Scalars['String']['output']>;
  skills?: Maybe<Array<Maybe<Skill>>>;
  stats: UserStats;
  tokens?: Maybe<Array<Maybe<Token>>>;
  /**  True if the user has 2FA enabled, false if they do not. */
  twoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
  updatedAt: DateTime;
  zones?: Maybe<ListZonesOutput>;
};


export type UserAccessesArgs = {
  input?: InputMaybe<ListAccessInput>;
};


export type UserAvailabilitiesArgs = {
  search?: InputMaybe<AvailabilitySearch>;
};


export type UserAvailabilityArgs = {
  endDate: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};


export type UserCheckPermissionsArgs = {
  permissions: Array<Scalars['String']['input']>;
};


export type UserHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};


export type UserNotificationsArgs = {
  filter?: InputMaybe<NotificationsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  setRead?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type UserPermissionsArgs = {
  input?: InputMaybe<ListPermissionsInput>;
};


export type UserRefreshTokensArgs = {
  filter?: InputMaybe<ListRefreshTokensFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


export type UserZonesArgs = {
  filter?: InputMaybe<ListZonesFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
};

export type UserAppointmentAndAdjustmentCollection = {
  adjustments: Array<Scalars['String']['input']>;
  appointments: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};

export type UserArtifactUsage = {
  __typename?: 'UserArtifactUsage';
  usageBytes: Scalars['Float']['output'];
  userId: Scalars['String']['output'];
};

export type UserFoundTime = {
  __typename?: 'UserFoundTime';
  availableUsers?: Maybe<Array<Maybe<AvailableUsers>>>;
  end?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<CalendarEvent>;
  maxAppointments?: Maybe<Scalars['Int']['output']>;
  nAvailableUsers?: Maybe<Scalars['Int']['output']>;
  rank?: Maybe<Scalars['Float']['output']>;
  start?: Maybe<Scalars['Int']['output']>;
  /** @deprecated use event instead */
  timeslotId?: Maybe<Scalars['String']['output']>;
};

export type UserMutator = {
  __typename?: 'UserMutator';
  setProfile: Scalars['Int']['output'];
};


export type UserMutatorSetProfileArgs = {
  billingAddress?: InputMaybe<LocationCreateBase>;
  company?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  givenName?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  salary?: InputMaybe<Scalars['Int']['input']>;
  shiftAvailability?: InputMaybe<Scalars['String']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserPagination = {
  __typename?: 'UserPagination';
  limited?: Maybe<Scalars['Int']['output']>;
  skipped?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  users?: Maybe<Array<Maybe<User>>>;
};

export type UserPayment = {
  __typename?: 'UserPayment';
  charges?: Maybe<Array<CustomerCharge>>;
  customer?: Maybe<PaymentCustomer>;
  invoice?: Maybe<FullInvoice>;
  invoices?: Maybe<Array<StripeInvoice>>;
  paymentMethods?: Maybe<Array<PaymentMethod>>;
  pendingInvoiceItems?: Maybe<Array<InvoiceItem>>;
};


export type UserPaymentChargesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};


export type UserPaymentInvoiceArgs = {
  invoiceId: Scalars['String']['input'];
};


export type UserPaymentInvoicesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  starting_after?: InputMaybe<Scalars['String']['input']>;
};


export type UserPaymentPaymentMethodsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type UserSearch = {
  courseRole?: InputMaybe<Scalars['String']['input']>;
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  familyName?: InputMaybe<Array<Scalars['String']['input']>>;
  getLocations?: InputMaybe<Scalars['Boolean']['input']>;
  givenName?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locations?: InputMaybe<Array<Scalars['String']['input']>>;
  phones?: InputMaybe<Array<Scalars['String']['input']>>;
  roleHasAttribute?: InputMaybe<Scalars['String']['input']>;
  roles?: InputMaybe<Array<Scalars['String']['input']>>;
  rolesIntersect?: InputMaybe<Array<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  showDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
  skillForm?: InputMaybe<Scalars['String']['input']>;
  skills?: InputMaybe<Array<Scalars['String']['input']>>;
  skillsIntersect?: InputMaybe<Array<Scalars['String']['input']>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
  zoneDir?: InputMaybe<ZoneDir>;
};

export type UserSearchInput = {
  /** The role a user has on the related job, NOT a system role */
  role: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UserSkillOutput = {
  __typename?: 'UserSkillOutput';
  addedOn?: Maybe<Scalars['Int']['output']>;
  attributes?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  form?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Int']['output']>;
  updatedOn?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<User>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type UserSkillsPagination = {
  __typename?: 'UserSkillsPagination';
  skills: Array<Maybe<OwnedSkill>>;
  total: Scalars['Int']['output'];
  user: Scalars['String']['output'];
};

export type UserStats = {
  __typename?: 'UserStats';
  appointmentStatusCount?: Maybe<Array<Scalars['Int']['output']>>;
};


export type UserStatsAppointmentStatusCountArgs = {
  max?: InputMaybe<Scalars['Int']['input']>;
  min?: InputMaybe<Scalars['Int']['input']>;
  statuses: Array<Scalars['String']['input']>;
};

export type ValidateFormResponseInput = {
  formResponseId: Scalars['String']['input'];
};

export type ValidateFormResponseOutput = {
  __typename?: 'ValidateFormResponseOutput';
  invalidFormFieldResponses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  invalidSectionResponses?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  isFormValid: Scalars['Boolean']['output'];
  unansweredRequiredFields?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ValidateTokenOutput = {
  __typename?: 'ValidateTokenOutput';
  error?: Maybe<Scalars['String']['output']>;
  expiration?: Maybe<Scalars['Int']['output']>;
  isValid: Scalars['Boolean']['output'];
  metadata?: Maybe<Scalars['Metadata']['output']>;
  tokenType?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type ValidationSchema = {
  __typename?: 'ValidationSchema';
  additionalProperties?: Maybe<Scalars['Boolean']['output']>;
  properties?: Maybe<Scalars['ValidationSchemaProperties']['output']>;
  required: Array<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ValueUnion = IntBox | LocationBox | StringArrayBox | StringBox;

export type WebAddress = {
  __typename?: 'WebAddress';
  URI?: Maybe<Scalars['String']['output']>;
};

export type WindowInput = {
  /**  Use international date format 'YYYY-MM-DD, Set it the same as startDate to only query one day' */
  endDate: Scalars['String']['input'];
  /**  The minimum size of the booking window, if any.  */
  minWindowLength?: InputMaybe<Scalars['Int']['input']>;
  /**  Use international date format 'YYYY-MM-DD' */
  startDate: Scalars['String']['input'];
};

export type Zone = {
  __typename?: 'Zone';
  /** Returns a list of the zone's serviceable areas */
  areas?: Maybe<Array<Maybe<Location>>>;
  attributes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Return a list of roles which you are able to context into for this zone
   * @deprecated use contextableRoles
   */
  availableRoles: Array<Role>;
  avatar?: Maybe<Scalars['String']['output']>;
  branding: ZoneBranding;
  /**
   * DIRECT children of this zone. IF you need to get all children,
   * use query.zones
   */
  children: ListZonesOutput;
  color?: Maybe<Scalars['String']['output']>;
  contextable?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Return a list of roles which the signed in user is able to context into for this zone
   *
   * Set idOnly to true to just return the zone id
   */
  contextableRoles: Array<Role>;
  createdAt: Scalars['Int']['output'];
  /** Returns a list of the zone's active default taxes */
  defaultTaxes: Array<Maybe<Tax>>;
  deletedAt?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The domain for this zone
   * If not set, it will resolve the nearest parent zone domain
   * This property is expensive, so avoid using it when listing many zones.
   */
  domain: Scalars['String']['output'];
  history: HistoryPagination;
  id: Scalars['ID']['output'];
  maxDepth?: Maybe<Scalars['Int']['output']>;
  maxSubZones?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  /** The parent of this zone */
  parent?: Maybe<Zone>;
  /**
   * Parents of this zone, from direct parent to greatest parent
   * Always available, even if the user has no permissions on parent zones.
   */
  parents: Array<Zone>;
  /** Timezone for this zone */
  timezone: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Int']['output'];
};


export type ZoneContextableRolesArgs = {
  idOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ZoneHistoryArgs = {
  input?: InputMaybe<ListObjectHistoryInput>;
};

export type ZoneBranding = {
  __typename?: 'ZoneBranding';
  /** The full name of the application being used (eg Move Right) */
  appName: Scalars['String']['output'];
  /** Company name in association with website */
  companyName: Scalars['String']['output'];
  /** Country that the zone is placed in */
  country: Scalars['String']['output'];
  email: Scalars['String']['output'];
  /** Path to ico file, used in tab of browser */
  ico: Scalars['String']['output'];
  /** 48x48px dark icon */
  iconDark48: Scalars['String']['output'];
  /** 64x64px dark icon */
  iconDark64: Scalars['String']['output'];
  /** 128x128px dark icon */
  iconDark128: Scalars['String']['output'];
  /** 196x196px dark icon */
  iconDark196: Scalars['String']['output'];
  /** 256x256px dark icon */
  iconDark256: Scalars['String']['output'];
  /** 512x512px dark icon */
  iconDark512: Scalars['String']['output'];
  /** 1024x1024px dark icon */
  iconDark1024: Scalars['String']['output'];
  /** WidexWidepx dark icon */
  iconDarkWide: Scalars['String']['output'];
  /** 48x48px light icon */
  iconLight48: Scalars['String']['output'];
  /** 64x64px light icon */
  iconLight64: Scalars['String']['output'];
  /** 128x128px light icon */
  iconLight128: Scalars['String']['output'];
  /** 196x196px light icon */
  iconLight196: Scalars['String']['output'];
  /** 256x256px light icon */
  iconLight256: Scalars['String']['output'];
  /** 512x512px light icon */
  iconLight512: Scalars['String']['output'];
  /** 1024x1024px light icon */
  iconLight1024: Scalars['String']['output'];
  /** WidexWidepx light icon */
  iconLightWide: Scalars['String']['output'];
  /** Primary language used by zone */
  language: Scalars['String']['output'];
  /**  A notice to display in the application, such as scheduled maintenance. In JSON format with message, level  */
  notice?: Maybe<Scalars['String']['output']>;
  primaryColor?: Maybe<Scalars['String']['output']>;
  secondaryColor?: Maybe<Scalars['String']['output']>;
  /** The short name of the application being used (eg MR) */
  shortName: Scalars['String']['output'];
  /**
   * Whether this zone is 'Active' or 'Inactive'
   * Inactive zones are to be hidden from the UI
   */
  status: Scalars['String']['output'];
  /** Timezone for this zone */
  timezone: Scalars['String']['output'];
  /** Company website in association with name */
  website: Scalars['String']['output'];
  /** The zone job code (eg TOLE, etc) */
  zoneCode?: Maybe<Scalars['String']['output']>;
  zoneId: Scalars['String']['output'];
};

export type ZoneConfig = {
  __typename?: 'ZoneConfig';
  ACT__ON_ACCESS__TOKEN?: Maybe<Config_String>;
  ACT__ON_CLIENT__ID?: Maybe<Config_String>;
  ACT__ON_CLIENT__SECRET?: Maybe<Config_String>;
  ACT__ON_CONTACT__LISTS?: Maybe<Config_ConfigValueObject>;
  ACT__ON_ENABLED?: Maybe<Config_Boolean>;
  ACT__ON_REFRESH__TOKEN?: Maybe<Config_String>;
  ACT__ON_TOKEN__VALID__UNTIL?: Maybe<Config_String>;
  ADDITIONAL__CONTACT__DETAILS_CREWMANAGER?: Maybe<Config_String>;
  ADDITIONAL__CONTACT__DETAILS_OFFICEMANAGER?: Maybe<Config_String>;
  ADDITIONAL__CONTACT__DETAILS_SALESMANAGER?: Maybe<Config_String>;
  APP_ADMINEMAIL?: Maybe<Config_String>;
  APP_APPNAME?: Maybe<Config_String>;
  APP_LOGOB64?: Maybe<Config_String>;
  APP_NOTICE?: Maybe<Config_App_Notice>;
  APP_PUBLICVAPIDKEY?: Maybe<Config_String>;
  APP_SHORTAPPNAME?: Maybe<Config_String>;
  AREA__RESOLVER_ISDOMAINPARENT?: Maybe<Config_Boolean>;
  AREA__RESOLVER_RADIUS?: Maybe<Config_Float>;
  ATTENTION_COMPLETEDESTIMATEREQUIRESBOOKING?: Maybe<Config_AttentionConfig>;
  ATTENTION_EVENTENDED?: Maybe<Config_AttentionConfig>;
  ATTENTION_EVENTREQUIRESCONFIRMATION?: Maybe<Config_AttentionConfig>;
  ATTENTION_INVOICEOUTSTANDINGBALANCE?: Maybe<Config_AttentionConfig>;
  ATTENTION_JOBNEEDSINVOICE?: Maybe<Config_AttentionConfig>;
  ATTENTION_LEADREQUIRESPHONECALL?: Maybe<Config_AttentionConfig>;
  ATTENTION_LONGOVERDUEINVOICEOUTSTANDINGBALANCE?: Maybe<Config_AttentionConfig>;
  ATTENTION_NEWCOLDLEAD?: Maybe<Config_AttentionConfig>;
  ATTENTION_NEWHOTLEAD?: Maybe<Config_AttentionConfig>;
  ATTENTION_NEWLEAD?: Maybe<Config_AttentionConfig>;
  ATTENTION_NEWWARMLEAD?: Maybe<Config_AttentionConfig>;
  ATTENTION_STALEJOB?: Maybe<Config_AttentionConfig>;
  ATTENTION_URGENTLEAD?: Maybe<Config_AttentionConfig>;
  AUTODIALER_ENABLED?: Maybe<Config_Boolean>;
  AUTODIALER_MODE?: Maybe<Config_String>;
  BRANDING_COMPANYNAME?: Maybe<Config_String>;
  BRANDING_ICO?: Maybe<Config_String>;
  BRANDING_ICONDARK48?: Maybe<Config_String>;
  BRANDING_ICONDARK64?: Maybe<Config_String>;
  BRANDING_ICONDARK128?: Maybe<Config_String>;
  BRANDING_ICONDARK196?: Maybe<Config_String>;
  BRANDING_ICONDARK256?: Maybe<Config_String>;
  BRANDING_ICONDARK512?: Maybe<Config_String>;
  BRANDING_ICONDARK1024?: Maybe<Config_String>;
  BRANDING_ICONDARKWIDE?: Maybe<Config_String>;
  BRANDING_ICONLIGHT48?: Maybe<Config_String>;
  BRANDING_ICONLIGHT64?: Maybe<Config_String>;
  BRANDING_ICONLIGHT128?: Maybe<Config_String>;
  BRANDING_ICONLIGHT196?: Maybe<Config_String>;
  BRANDING_ICONLIGHT256?: Maybe<Config_String>;
  BRANDING_ICONLIGHT512?: Maybe<Config_String>;
  BRANDING_ICONLIGHT1024?: Maybe<Config_String>;
  BRANDING_ICONLIGHTWIDE?: Maybe<Config_String>;
  BRANDING_PRIMARYCOLOR?: Maybe<Config_String>;
  BRANDING_SECONDARYCOLOR?: Maybe<Config_String>;
  BRANDING_TAGLINE?: Maybe<Config_String>;
  BRANDING_WEBSITE?: Maybe<Config_String>;
  CALENDAREVENTS_ARRIVALOFFSET?: Maybe<Config_Float>;
  CALENDAREVENTS_ARRIVALWINDOWPLACEHOLDER?: Maybe<Config_String>;
  CALENDAREVENTS_ARRIVALWINDOWTIMEFORMAT?: Maybe<Config_String>;
  CALENDAREVENTS_CHECKPERMISSIONSTOMODIFYBOOKOFF?: Maybe<Config_Boolean>;
  CALENDAREVENTS_DEPOSITMINTOBOOK?: Maybe<Config_Float>;
  CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX?: Maybe<Config_Boolean>;
  CALENDAREVENTS_ESTIMATELENGTH?: Maybe<Config_Float>;
  CALENDAREVENTS_INCLUDEDOCKTRAVELTIME?: Maybe<Config_Boolean>;
  CALENDAREVENTS_VIRTUALESTIMATELENGTH?: Maybe<Config_Float>;
  CALLRAIL_CREATEJOBINPRECALL?: Maybe<Config_Boolean>;
  CALLRAIL_DEFAULTORIGIN?: Maybe<Config_String>;
  CALLRAIL_DEFAULTSOURCE?: Maybe<Config_String>;
  CALLRAIL_ENABLED?: Maybe<Config_Boolean>;
  CALLRAIL_POSTCALLUPDATESOURCE?: Maybe<Config_Boolean>;
  CREDENTIALS_PRIVATEVAPIDKEY?: Maybe<Config_String>;
  CUSTOMER_TYPES?: Maybe<Config_ConfigValueArray>;
  DASHBOARD_REPORTTYPES?: Maybe<Config_ConfigValueObject>;
  DOCUMENT__DEFAULTS_DAYSTILLDUE?: Maybe<Config_Float>;
  DOCUMENT__DEFAULTS_DOCTYPES?: Maybe<Config_String>;
  EMAIL_ENABLECLICKTRACKING?: Maybe<Config_Boolean>;
  EMAIL_HEADER?: Maybe<Config_String>;
  EMAIL_INBOXDEFAULT?: Maybe<Config_String>;
  EMAIL_REDIRECT?: Maybe<Config_String>;
  EMAIL_REPLYTO?: Maybe<Config_String>;
  EMAIL_SENDDOCUMENTSASUSER?: Maybe<Config_Boolean>;
  EMAIL_SENDGRIDAPIKEY?: Maybe<Config_String>;
  EMAIL_SENDGRIDEVENTKEY?: Maybe<Config_String>;
  EMAIL_SENDGRIDINBOUNDDOMAIN?: Maybe<Config_String>;
  EMAIL_SENDGRIDSYSTEMDOMAIN?: Maybe<Config_String>;
  EMAIL_SENDGRIDWEBHOOKID?: Maybe<Config_String>;
  ESTIMATOR_RESTRICTIONCODE?: Maybe<Config_String>;
  FIND_STARTTIMEINTERVAL?: Maybe<Config_Float>;
  FRANCHISE__INFO_ADDRESS?: Maybe<Config_String>;
  FRANCHISE__INFO_DOCKLOCATIONID?: Maybe<Config_String>;
  FRANCHISE__INFO_EMAIL?: Maybe<Config_String>;
  FRANCHISE__INFO_HQLOCATIONID?: Maybe<Config_String>;
  FRANCHISE__INFO_OWNER?: Maybe<Config_String>;
  FRANCHISE__INFO_PHONE?: Maybe<Config_String>;
  GOOGLEMAPS_USECOMPUTEROUTESAPI?: Maybe<Config_Boolean>;
  GOOGLEMAPS_USENEWPLACESAPI?: Maybe<Config_Boolean>;
  INTAKE_DISTANCELIMIT?: Maybe<Config_String>;
  INTAKE_ENABLEFORWARDING?: Maybe<Config_Boolean>;
  INTAKE_FORWARDIFNOZONE?: Maybe<Config_Boolean>;
  INTAKE_FORWARDTOVONIGOIFNOZONE?: Maybe<Config_Boolean>;
  INTAKE_FORWARDURL?: Maybe<Config_String>;
  INTAKE_GENERATEJOB?: Maybe<Config_Boolean>;
  INTAKE_GENERATEJOBIFNOZONE?: Maybe<Config_Boolean>;
  INTAKE_INTERSTATEZONE?: Maybe<Config_String>;
  INTAKE_NOTIFICATIONRECIPIENTS?: Maybe<Config_String>;
  INTAKE_REDIRECTURL?: Maybe<Config_String>;
  INTAKE_VONIGOFRANCHISEID?: Maybe<Config_String>;
  INTAKE_WEBHOOK?: Maybe<Config_String>;
  INVENTORY_ITEMS?: Maybe<Config_Inventory_Items>;
  INVOICES_DUEHOWMANYDAYSAFTERINVOICEDATE?: Maybe<Config_Float>;
  INVOICE_DISABLEMULTIPLEEVENTS?: Maybe<Config_Boolean>;
  JOBS_BEDROOMSMANDATORY?: Maybe<Config_Boolean>;
  JOBS_CANCELLEDJOBTTL?: Maybe<Config_Float>;
  JOBS_CLOSEDREASONS?: Maybe<Config_Jobs_ClosedReasons>;
  JOBS_DWELLINGTYPEMANDATORY?: Maybe<Config_Boolean>;
  JOBS_HOWHEARDMANDATORY?: Maybe<Config_Boolean>;
  JOBS_HOWHEARDOPTIONS?: Maybe<Config_String>;
  JOBS_INVOICECOMPANYNAME?: Maybe<Config_String>;
  JOBS_INVOICETTL?: Maybe<Config_Float>;
  JOBS_LEADWATCHERS?: Maybe<Config_String>;
  JOBS_NOTIFYWATCHERSBCC?: Maybe<Config_String>;
  JOBS_NOTIFYWATCHERSDOCUMENTCOMPLETED?: Maybe<Config_Boolean>;
  JOBS_ORIGINS?: Maybe<Config_ConfigValueArray>;
  JOBS_WATCHERS?: Maybe<Config_String>;
  JOBS_ZONECODE?: Maybe<Config_String>;
  LEGAL_BUSINESSADDRESS?: Maybe<Config_String>;
  LEGAL_BUSINESSNUMBER?: Maybe<Config_String>;
  LEGAL_FRANCHISEOWNERS?: Maybe<Config_String>;
  LEGAL_LEGALCOMPANYNAME?: Maybe<Config_String>;
  LEGAL_OPERATINGAS?: Maybe<Config_String>;
  LEGAL_OPERATINGFOR?: Maybe<Config_String>;
  LEGAL_POLICYNUMBER?: Maybe<Config_String>;
  LEGAL_TAXNUMBERS?: Maybe<Config_String>;
  NICE__JOBS_FORWARDTOVONIGO?: Maybe<Config_Boolean>;
  NICE__JOBS_GENERATEJOB?: Maybe<Config_Boolean>;
  NICE__JOBS__PRIVATE_CLIENT__SECRET?: Maybe<Config_String>;
  NICE__JOBS__PROTECTED_ACCESS__TOKEN?: Maybe<Config_String>;
  NICE__JOBS__PROTECTED_CLIENT__ID?: Maybe<Config_String>;
  NICE__JOBS__PROTECTED_REFRESH__TOKEN?: Maybe<Config_String>;
  NICE__JOBS__PROTECTED_TOKEN__VALID__UNTIL?: Maybe<Config_Float>;
  OPENAI_APIKEY?: Maybe<Config_String>;
  OPENAI_ORGANIZATION?: Maybe<Config_String>;
  OPENAI_PROJECT?: Maybe<Config_String>;
  PANDADOC_APIKEY?: Maybe<Config_String>;
  PANDADOC_DEFAULTSENDER?: Maybe<Config_String>;
  PANDADOC_SENDCOPYTOEMPLOYEE?: Maybe<Config_Boolean>;
  PANDADOC_SORTCHARGESBY?: Maybe<Config_String>;
  PANDADOC_WEBHOOKKEY?: Maybe<Config_String>;
  PAYMENT__TYPE_AMEX?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_CASH?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_CHECK?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_CREDIT__CARD?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_DEBIT?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_ETRANSFER?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_MASTER__CARD?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_OTHER?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_STRIPE?: Maybe<Config_PaymentType>;
  PAYMENT__TYPE_VISA?: Maybe<Config_PaymentType>;
  PHONEFORWARDING_NUMBER?: Maybe<Config_String>;
  PHONEFORWARDING_TRANSCRIBE?: Maybe<Config_Boolean>;
  PRICINGENGINE_AGENTINSTRUCTIONSPROMPT?: Maybe<Config_String>;
  PRICINGENGINE_CREWSIZEPROMPT?: Maybe<Config_String>;
  PRICINGENGINE_ENABLED?: Maybe<Config_Boolean>;
  PRICINGENGINE_ITINERARYPROMPT?: Maybe<Config_String>;
  PRICINGENGINE_PRICINGPROMPT?: Maybe<Config_String>;
  PRICINGENGINE_VALIDATIONPROMPT?: Maybe<Config_String>;
  PRICING_CHARGESORTMETHOD?: Maybe<Config_String>;
  PRICING_SINGLEMANHOURPRICE?: Maybe<Config_Float>;
  PROMPT_AINAME?: Maybe<Config_String>;
  PROMPT_AIVOICE?: Maybe<Config_String>;
  PROMPT_BUSINESSHOURS?: Maybe<Config_String>;
  PROMPT_INBOUNDCALLROUTINGNUMBERS?: Maybe<Config_String>;
  PROMPT_INBOUNDROUTING?: Maybe<Config_Boolean>;
  PROMPT_INBOUNDSMSAIENABLED?: Maybe<Config_Boolean>;
  PROMPT_SCHEDULECOMMUNICATIONSINSTRUCTIONS?: Maybe<Config_String>;
  PROMPT_SCHEDULECOMMUNICATIONSRINGGROUPS?: Maybe<Config_String>;
  PUBLIC_STRIPEPUBLICKEY?: Maybe<Config_String>;
  QUICKBOOKS_DATA?: Maybe<Config_ConfigValueObject>;
  QUICKBOOKS_DEFAULT__TAX__CODE?: Maybe<Config_String>;
  QUICKBOOKS_ENABLED?: Maybe<Config_Boolean>;
  QUICKBOOKS_PRODUCT__MAP?: Maybe<Config_ConfigValueObject>;
  QUICKBOOKS_PRODUCT__SETTINGS?: Maybe<Config_ConfigValueObject>;
  QUICKBOOKS_REALMID?: Maybe<Config_String>;
  QUICKBOOKS_REFRESHTOKEN?: Maybe<Config_String>;
  QUICKBOOKS_TAXCODE__MAP?: Maybe<Config_ConfigValueObject>;
  QUICKBOOKS_TOKENTYPE?: Maybe<Config_String>;
  ROLE_ADMIN?: Maybe<Config_String>;
  ROLE_CUSTOMER?: Maybe<Config_String>;
  ROLE_EMPLOYEE?: Maybe<Config_String>;
  ROLE_FRANCHISEE?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_CONTACTACCOUNTINGBUTTONTEXT?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_CURRENTDATE?: Maybe<Config_Float>;
  ROLLING__LOCK__DATE_EMAILBODYPREFIX?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_EMAILBODYSUFFIX?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_EMAILSUBJECT?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_EVENTLOCKEDWARNING?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_NEXTDATE?: Maybe<Config_Float>;
  ROLLING__LOCK__DATE_SUPPORTEMAIL?: Maybe<Config_String>;
  ROLLING__LOCK__DATE_UPDATERULE?: Maybe<Config_String>;
  SEARCH_ALLOWCROSSZONEQUERY?: Maybe<Config_Boolean>;
  SMS_HANDLER?: Maybe<Config_String>;
  STANDARD__DOCUMENTS_AUTHORIZATION?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BILL__OF__LADING__FVP?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BILL__OF__LADING__RV?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BOOKING__AGREEMENT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__FORM?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__NO__PP?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__PP?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CONTRACT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CUSTOMER__CONTRACT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_DAMAGE__REPORT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_END__OF__MOVE__CUSTOMER__CHECKLIST?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_ESTIMATE?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_EXISTING__DAMAGES?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_INSURANCE__OPTIONS?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_INVOICE?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_LIABILITY__RELEASE?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_MOVING__CONTRACT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_ON__SITE__ESTIMATE?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_POST__LOAD__WALKTHROUGH?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_POST__UNLOAD__WALKTHROUGH?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_RECEIPT?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_REMINDER?: Maybe<Config_StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_REVISION__TO__ESTIMATE?: Maybe<Config_StandardDocumentsConfig>;
  STRIPE_ACCOUNT?: Maybe<Config_String>;
  STRIPE_ACCOUNTDRAFT?: Maybe<Config_String>;
  STRIPE_ENDPOINTSECRET?: Maybe<Config_String>;
  STRIPE_SECRET?: Maybe<Config_String>;
  SUBSCRIPTION_PLAN?: Maybe<Config_String>;
  SUPPORT_TAWKTOAPIKEY?: Maybe<Config_String>;
  SYSTEM__DETAILS_COUNTRY?: Maybe<Config_String>;
  SYSTEM__DETAILS_FRANCHISENUMBER?: Maybe<Config_String>;
  SYSTEM__DETAILS_LANGUAGE?: Maybe<Config_String>;
  SYSTEM__DETAILS_NAME?: Maybe<Config_String>;
  SYSTEM__DETAILS_STATUS?: Maybe<Config_String>;
  SYSTEM__DETAILS_TIMEZONE?: Maybe<Config_String>;
  TALKDESK_ACCOUNTNAME?: Maybe<Config_String>;
  TALKDESK_CALLBACKCONFIG?: Maybe<Config_Talkdesk_CallbackConfig>;
  TALKDESK_CALLBACKIFDISPOSITIONS?: Maybe<Config_String>;
  TALKDESK_CLIENTID?: Maybe<Config_String>;
  TALKDESK_CLIENTSECRET?: Maybe<Config_String>;
  TALKDESK_CLOSEIFDISPOSITIONS?: Maybe<Config_String>;
  TALKDESK_ENABLED?: Maybe<Config_Boolean>;
  TALKDESK_FROMPHONE?: Maybe<Config_String>;
  TALKDESK_INITIALPRIORITY?: Maybe<Config_Float>;
  TALKDESK_INITIALRINGGROUP?: Maybe<Config_String>;
  TALKDESK_LEGACY__CALLBACK?: Maybe<Config_Boolean>;
  TALKDESK_MAXCALLS?: Maybe<Config_Float>;
  TALKDESK_SENDSMSFLOWURL?: Maybe<Config_String>;
  TALKDESK_TRANSCRIBE?: Maybe<Config_Boolean>;
  TALKDESK_TRIGGERCALLBACKFLOWURL?: Maybe<Config_String>;
  TEMPLATES_DISABLED?: Maybe<Config_String>;
  TEMPLATES_JOBAPPROVALREQUESTED?: Maybe<Config_TemplateConfig>;
  TRANSACTIONS_AUTOSENDRECEIPT?: Maybe<Config_Boolean>;
  TRIGGER_ADD__BASE__TIME?: Maybe<Config_TriggerConfig>;
  TRIGGER_ADD__PRODUCTS?: Maybe<Config_TriggerConfig>;
  TRIGGER_ADD__TIME?: Maybe<Config_TriggerConfig>;
  TRIGGER_ALLOW?: Maybe<Config_TriggerConfig>;
  TRIGGER_DISALLOW?: Maybe<Config_TriggerConfig>;
  TRIGGER_MULTIPLY__BASE__TIME?: Maybe<Config_TriggerConfig>;
  TRIGGER_REQUIRE__APPROVAL?: Maybe<Config_TriggerConfig>;
  TRIGGER_REQUIRE__ESTIMATE?: Maybe<Config_TriggerConfig>;
  TWILIO_APIKEY?: Maybe<Config_String>;
  TWILIO_APISECRET?: Maybe<Config_String>;
  TWILIO_AUTHTOKEN?: Maybe<Config_String>;
  TWILIO_MESSAGINGSERVICEID?: Maybe<Config_String>;
  TWILIO_SID?: Maybe<Config_String>;
  USERS_DEFAULTEMAILDOMAIN?: Maybe<Config_String>;
  USER_HOURLYSALARY?: Maybe<Config_Float>;
  WEBHOOK_USERS?: Maybe<Config_String>;
  YEMBO__INTEGRATION_APIENDPOINT?: Maybe<Config_String>;
  YEMBO__INTEGRATION_DEFAULTEMAIL?: Maybe<Config_String>;
  YEMBO__INTEGRATION_DEVELOPERACCESSTOKEN?: Maybe<Config_String>;
  YEMBO__INTEGRATION_ENABLED?: Maybe<Config_Boolean>;
  YEMBO__INTEGRATION_SANDBOXINTEGRATIONACCESSTOKEN?: Maybe<Config_String>;
  YEMBO__INTEGRATION_URL?: Maybe<Config_String>;
  ZONES_DEFAULT?: Maybe<Config_String>;
  ZONES_INVOICETEMPLATEID?: Maybe<Config_String>;
  ZONES_RECEIPTTEMPLATEID?: Maybe<Config_String>;
};

export enum ZoneConfigKey {
  ActOnAccessToken = 'ACT__ON_ACCESS__TOKEN',
  ActOnClientId = 'ACT__ON_CLIENT__ID',
  ActOnClientSecret = 'ACT__ON_CLIENT__SECRET',
  ActOnContactLists = 'ACT__ON_CONTACT__LISTS',
  ActOnEnabled = 'ACT__ON_ENABLED',
  ActOnRefreshToken = 'ACT__ON_REFRESH__TOKEN',
  ActOnTokenValidUntil = 'ACT__ON_TOKEN__VALID__UNTIL',
  AdditionalContactDetailsCrewmanager = 'ADDITIONAL__CONTACT__DETAILS_CREWMANAGER',
  AdditionalContactDetailsOfficemanager = 'ADDITIONAL__CONTACT__DETAILS_OFFICEMANAGER',
  AdditionalContactDetailsSalesmanager = 'ADDITIONAL__CONTACT__DETAILS_SALESMANAGER',
  AppAdminemail = 'APP_ADMINEMAIL',
  AppAppname = 'APP_APPNAME',
  AppLogob64 = 'APP_LOGOB64',
  AppNotice = 'APP_NOTICE',
  AppPublicvapidkey = 'APP_PUBLICVAPIDKEY',
  AppShortappname = 'APP_SHORTAPPNAME',
  AreaResolverIsdomainparent = 'AREA__RESOLVER_ISDOMAINPARENT',
  AreaResolverRadius = 'AREA__RESOLVER_RADIUS',
  AttentionCompletedestimaterequiresbooking = 'ATTENTION_COMPLETEDESTIMATEREQUIRESBOOKING',
  AttentionEventended = 'ATTENTION_EVENTENDED',
  AttentionEventrequiresconfirmation = 'ATTENTION_EVENTREQUIRESCONFIRMATION',
  AttentionInvoiceoutstandingbalance = 'ATTENTION_INVOICEOUTSTANDINGBALANCE',
  AttentionJobneedsinvoice = 'ATTENTION_JOBNEEDSINVOICE',
  AttentionLeadrequiresphonecall = 'ATTENTION_LEADREQUIRESPHONECALL',
  AttentionLongoverdueinvoiceoutstandingbalance = 'ATTENTION_LONGOVERDUEINVOICEOUTSTANDINGBALANCE',
  AttentionNewcoldlead = 'ATTENTION_NEWCOLDLEAD',
  AttentionNewhotlead = 'ATTENTION_NEWHOTLEAD',
  AttentionNewlead = 'ATTENTION_NEWLEAD',
  AttentionNewwarmlead = 'ATTENTION_NEWWARMLEAD',
  AttentionStalejob = 'ATTENTION_STALEJOB',
  AttentionUrgentlead = 'ATTENTION_URGENTLEAD',
  AutodialerEnabled = 'AUTODIALER_ENABLED',
  AutodialerMode = 'AUTODIALER_MODE',
  BrandingCompanyname = 'BRANDING_COMPANYNAME',
  BrandingIco = 'BRANDING_ICO',
  BrandingIcondark48 = 'BRANDING_ICONDARK48',
  BrandingIcondark64 = 'BRANDING_ICONDARK64',
  BrandingIcondark128 = 'BRANDING_ICONDARK128',
  BrandingIcondark196 = 'BRANDING_ICONDARK196',
  BrandingIcondark256 = 'BRANDING_ICONDARK256',
  BrandingIcondark512 = 'BRANDING_ICONDARK512',
  BrandingIcondark1024 = 'BRANDING_ICONDARK1024',
  BrandingIcondarkwide = 'BRANDING_ICONDARKWIDE',
  BrandingIconlight48 = 'BRANDING_ICONLIGHT48',
  BrandingIconlight64 = 'BRANDING_ICONLIGHT64',
  BrandingIconlight128 = 'BRANDING_ICONLIGHT128',
  BrandingIconlight196 = 'BRANDING_ICONLIGHT196',
  BrandingIconlight256 = 'BRANDING_ICONLIGHT256',
  BrandingIconlight512 = 'BRANDING_ICONLIGHT512',
  BrandingIconlight1024 = 'BRANDING_ICONLIGHT1024',
  BrandingIconlightwide = 'BRANDING_ICONLIGHTWIDE',
  BrandingPrimarycolor = 'BRANDING_PRIMARYCOLOR',
  BrandingSecondarycolor = 'BRANDING_SECONDARYCOLOR',
  BrandingTagline = 'BRANDING_TAGLINE',
  BrandingWebsite = 'BRANDING_WEBSITE',
  CalendareventsArrivaloffset = 'CALENDAREVENTS_ARRIVALOFFSET',
  CalendareventsArrivalwindowplaceholder = 'CALENDAREVENTS_ARRIVALWINDOWPLACEHOLDER',
  CalendareventsArrivalwindowtimeformat = 'CALENDAREVENTS_ARRIVALWINDOWTIMEFORMAT',
  CalendareventsCheckpermissionstomodifybookoff = 'CALENDAREVENTS_CHECKPERMISSIONSTOMODIFYBOOKOFF',
  CalendareventsDepositmintobook = 'CALENDAREVENTS_DEPOSITMINTOBOOK',
  CalendareventsDocktraveltimecheckbox = 'CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX',
  CalendareventsEstimatelength = 'CALENDAREVENTS_ESTIMATELENGTH',
  CalendareventsIncludedocktraveltime = 'CALENDAREVENTS_INCLUDEDOCKTRAVELTIME',
  CalendareventsVirtualestimatelength = 'CALENDAREVENTS_VIRTUALESTIMATELENGTH',
  CallrailCreatejobinprecall = 'CALLRAIL_CREATEJOBINPRECALL',
  CallrailDefaultorigin = 'CALLRAIL_DEFAULTORIGIN',
  CallrailDefaultsource = 'CALLRAIL_DEFAULTSOURCE',
  CallrailEnabled = 'CALLRAIL_ENABLED',
  CallrailPostcallupdatesource = 'CALLRAIL_POSTCALLUPDATESOURCE',
  CredentialsPrivatevapidkey = 'CREDENTIALS_PRIVATEVAPIDKEY',
  CustomerTypes = 'CUSTOMER_TYPES',
  DashboardReporttypes = 'DASHBOARD_REPORTTYPES',
  DocumentDefaultsDaystilldue = 'DOCUMENT__DEFAULTS_DAYSTILLDUE',
  DocumentDefaultsDoctypes = 'DOCUMENT__DEFAULTS_DOCTYPES',
  EmailEnableclicktracking = 'EMAIL_ENABLECLICKTRACKING',
  EmailHeader = 'EMAIL_HEADER',
  EmailInboxdefault = 'EMAIL_INBOXDEFAULT',
  EmailRedirect = 'EMAIL_REDIRECT',
  EmailReplyto = 'EMAIL_REPLYTO',
  EmailSenddocumentsasuser = 'EMAIL_SENDDOCUMENTSASUSER',
  EmailSendgridapikey = 'EMAIL_SENDGRIDAPIKEY',
  EmailSendgrideventkey = 'EMAIL_SENDGRIDEVENTKEY',
  EmailSendgridinbounddomain = 'EMAIL_SENDGRIDINBOUNDDOMAIN',
  EmailSendgridsystemdomain = 'EMAIL_SENDGRIDSYSTEMDOMAIN',
  EmailSendgridwebhookid = 'EMAIL_SENDGRIDWEBHOOKID',
  EstimatorRestrictioncode = 'ESTIMATOR_RESTRICTIONCODE',
  FindStarttimeinterval = 'FIND_STARTTIMEINTERVAL',
  FranchiseInfoAddress = 'FRANCHISE__INFO_ADDRESS',
  FranchiseInfoDocklocationid = 'FRANCHISE__INFO_DOCKLOCATIONID',
  FranchiseInfoEmail = 'FRANCHISE__INFO_EMAIL',
  FranchiseInfoHqlocationid = 'FRANCHISE__INFO_HQLOCATIONID',
  FranchiseInfoOwner = 'FRANCHISE__INFO_OWNER',
  FranchiseInfoPhone = 'FRANCHISE__INFO_PHONE',
  GooglemapsUsecomputeroutesapi = 'GOOGLEMAPS_USECOMPUTEROUTESAPI',
  GooglemapsUsenewplacesapi = 'GOOGLEMAPS_USENEWPLACESAPI',
  IntakeDistancelimit = 'INTAKE_DISTANCELIMIT',
  IntakeEnableforwarding = 'INTAKE_ENABLEFORWARDING',
  IntakeForwardifnozone = 'INTAKE_FORWARDIFNOZONE',
  IntakeForwardtovonigoifnozone = 'INTAKE_FORWARDTOVONIGOIFNOZONE',
  IntakeForwardurl = 'INTAKE_FORWARDURL',
  IntakeGeneratejob = 'INTAKE_GENERATEJOB',
  IntakeGeneratejobifnozone = 'INTAKE_GENERATEJOBIFNOZONE',
  IntakeInterstatezone = 'INTAKE_INTERSTATEZONE',
  IntakeNotificationrecipients = 'INTAKE_NOTIFICATIONRECIPIENTS',
  IntakeRedirecturl = 'INTAKE_REDIRECTURL',
  IntakeVonigofranchiseid = 'INTAKE_VONIGOFRANCHISEID',
  IntakeWebhook = 'INTAKE_WEBHOOK',
  InventoryItems = 'INVENTORY_ITEMS',
  InvoicesDuehowmanydaysafterinvoicedate = 'INVOICES_DUEHOWMANYDAYSAFTERINVOICEDATE',
  InvoiceDisablemultipleevents = 'INVOICE_DISABLEMULTIPLEEVENTS',
  JobsBedroomsmandatory = 'JOBS_BEDROOMSMANDATORY',
  JobsCancelledjobttl = 'JOBS_CANCELLEDJOBTTL',
  JobsClosedreasons = 'JOBS_CLOSEDREASONS',
  JobsDwellingtypemandatory = 'JOBS_DWELLINGTYPEMANDATORY',
  JobsHowheardmandatory = 'JOBS_HOWHEARDMANDATORY',
  JobsHowheardoptions = 'JOBS_HOWHEARDOPTIONS',
  JobsInvoicecompanyname = 'JOBS_INVOICECOMPANYNAME',
  JobsInvoicettl = 'JOBS_INVOICETTL',
  JobsLeadwatchers = 'JOBS_LEADWATCHERS',
  JobsNotifywatchersbcc = 'JOBS_NOTIFYWATCHERSBCC',
  JobsNotifywatchersdocumentcompleted = 'JOBS_NOTIFYWATCHERSDOCUMENTCOMPLETED',
  JobsOrigins = 'JOBS_ORIGINS',
  JobsWatchers = 'JOBS_WATCHERS',
  JobsZonecode = 'JOBS_ZONECODE',
  LegalBusinessaddress = 'LEGAL_BUSINESSADDRESS',
  LegalBusinessnumber = 'LEGAL_BUSINESSNUMBER',
  LegalFranchiseowners = 'LEGAL_FRANCHISEOWNERS',
  LegalLegalcompanyname = 'LEGAL_LEGALCOMPANYNAME',
  LegalOperatingas = 'LEGAL_OPERATINGAS',
  LegalOperatingfor = 'LEGAL_OPERATINGFOR',
  LegalPolicynumber = 'LEGAL_POLICYNUMBER',
  LegalTaxnumbers = 'LEGAL_TAXNUMBERS',
  NiceJobsForwardtovonigo = 'NICE__JOBS_FORWARDTOVONIGO',
  NiceJobsGeneratejob = 'NICE__JOBS_GENERATEJOB',
  NiceJobsPrivateClientSecret = 'NICE__JOBS__PRIVATE_CLIENT__SECRET',
  NiceJobsProtectedAccessToken = 'NICE__JOBS__PROTECTED_ACCESS__TOKEN',
  NiceJobsProtectedClientId = 'NICE__JOBS__PROTECTED_CLIENT__ID',
  NiceJobsProtectedRefreshToken = 'NICE__JOBS__PROTECTED_REFRESH__TOKEN',
  NiceJobsProtectedTokenValidUntil = 'NICE__JOBS__PROTECTED_TOKEN__VALID__UNTIL',
  OpenaiApikey = 'OPENAI_APIKEY',
  OpenaiOrganization = 'OPENAI_ORGANIZATION',
  OpenaiProject = 'OPENAI_PROJECT',
  PandadocApikey = 'PANDADOC_APIKEY',
  PandadocDefaultsender = 'PANDADOC_DEFAULTSENDER',
  PandadocSendcopytoemployee = 'PANDADOC_SENDCOPYTOEMPLOYEE',
  PandadocSortchargesby = 'PANDADOC_SORTCHARGESBY',
  PandadocWebhookkey = 'PANDADOC_WEBHOOKKEY',
  PaymentTypeAmex = 'PAYMENT__TYPE_AMEX',
  PaymentTypeCash = 'PAYMENT__TYPE_CASH',
  PaymentTypeCheck = 'PAYMENT__TYPE_CHECK',
  PaymentTypeCreditCard = 'PAYMENT__TYPE_CREDIT__CARD',
  PaymentTypeDebit = 'PAYMENT__TYPE_DEBIT',
  PaymentTypeEtransfer = 'PAYMENT__TYPE_ETRANSFER',
  PaymentTypeMasterCard = 'PAYMENT__TYPE_MASTER__CARD',
  PaymentTypeOther = 'PAYMENT__TYPE_OTHER',
  PaymentTypeStripe = 'PAYMENT__TYPE_STRIPE',
  PaymentTypeVisa = 'PAYMENT__TYPE_VISA',
  PhoneforwardingNumber = 'PHONEFORWARDING_NUMBER',
  PhoneforwardingTranscribe = 'PHONEFORWARDING_TRANSCRIBE',
  PricingengineAgentinstructionsprompt = 'PRICINGENGINE_AGENTINSTRUCTIONSPROMPT',
  PricingengineCrewsizeprompt = 'PRICINGENGINE_CREWSIZEPROMPT',
  PricingengineEnabled = 'PRICINGENGINE_ENABLED',
  PricingengineItineraryprompt = 'PRICINGENGINE_ITINERARYPROMPT',
  PricingenginePricingprompt = 'PRICINGENGINE_PRICINGPROMPT',
  PricingengineValidationprompt = 'PRICINGENGINE_VALIDATIONPROMPT',
  PricingChargesortmethod = 'PRICING_CHARGESORTMETHOD',
  PricingSinglemanhourprice = 'PRICING_SINGLEMANHOURPRICE',
  PromptAiname = 'PROMPT_AINAME',
  PromptAivoice = 'PROMPT_AIVOICE',
  PromptBusinesshours = 'PROMPT_BUSINESSHOURS',
  PromptInboundcallroutingnumbers = 'PROMPT_INBOUNDCALLROUTINGNUMBERS',
  PromptInboundrouting = 'PROMPT_INBOUNDROUTING',
  PromptInboundsmsaienabled = 'PROMPT_INBOUNDSMSAIENABLED',
  PromptSchedulecommunicationsinstructions = 'PROMPT_SCHEDULECOMMUNICATIONSINSTRUCTIONS',
  PromptSchedulecommunicationsringgroups = 'PROMPT_SCHEDULECOMMUNICATIONSRINGGROUPS',
  PublicStripepublickey = 'PUBLIC_STRIPEPUBLICKEY',
  QuickbooksData = 'QUICKBOOKS_DATA',
  QuickbooksDefaultTaxCode = 'QUICKBOOKS_DEFAULT__TAX__CODE',
  QuickbooksEnabled = 'QUICKBOOKS_ENABLED',
  QuickbooksProductMap = 'QUICKBOOKS_PRODUCT__MAP',
  QuickbooksProductSettings = 'QUICKBOOKS_PRODUCT__SETTINGS',
  QuickbooksRealmid = 'QUICKBOOKS_REALMID',
  QuickbooksRefreshtoken = 'QUICKBOOKS_REFRESHTOKEN',
  QuickbooksTaxcodeMap = 'QUICKBOOKS_TAXCODE__MAP',
  QuickbooksTokentype = 'QUICKBOOKS_TOKENTYPE',
  RoleAdmin = 'ROLE_ADMIN',
  RoleCustomer = 'ROLE_CUSTOMER',
  RoleEmployee = 'ROLE_EMPLOYEE',
  RoleFranchisee = 'ROLE_FRANCHISEE',
  RollingLockDateContactaccountingbuttontext = 'ROLLING__LOCK__DATE_CONTACTACCOUNTINGBUTTONTEXT',
  RollingLockDateCurrentdate = 'ROLLING__LOCK__DATE_CURRENTDATE',
  RollingLockDateEmailbodyprefix = 'ROLLING__LOCK__DATE_EMAILBODYPREFIX',
  RollingLockDateEmailbodysuffix = 'ROLLING__LOCK__DATE_EMAILBODYSUFFIX',
  RollingLockDateEmailsubject = 'ROLLING__LOCK__DATE_EMAILSUBJECT',
  RollingLockDateEventlockedwarning = 'ROLLING__LOCK__DATE_EVENTLOCKEDWARNING',
  RollingLockDateNextdate = 'ROLLING__LOCK__DATE_NEXTDATE',
  RollingLockDateSupportemail = 'ROLLING__LOCK__DATE_SUPPORTEMAIL',
  RollingLockDateUpdaterule = 'ROLLING__LOCK__DATE_UPDATERULE',
  SearchAllowcrosszonequery = 'SEARCH_ALLOWCROSSZONEQUERY',
  SmsHandler = 'SMS_HANDLER',
  StandardDocumentsAuthorization = 'STANDARD__DOCUMENTS_AUTHORIZATION',
  StandardDocumentsBillOfLadingFvp = 'STANDARD__DOCUMENTS_BILL__OF__LADING__FVP',
  StandardDocumentsBillOfLadingRv = 'STANDARD__DOCUMENTS_BILL__OF__LADING__RV',
  StandardDocumentsBookingAgreement = 'STANDARD__DOCUMENTS_BOOKING__AGREEMENT',
  StandardDocumentsClaimForm = 'STANDARD__DOCUMENTS_CLAIM__FORM',
  StandardDocumentsClaimNoPp = 'STANDARD__DOCUMENTS_CLAIM__NO__PP',
  StandardDocumentsClaimPp = 'STANDARD__DOCUMENTS_CLAIM__PP',
  StandardDocumentsContract = 'STANDARD__DOCUMENTS_CONTRACT',
  StandardDocumentsCustomerContract = 'STANDARD__DOCUMENTS_CUSTOMER__CONTRACT',
  StandardDocumentsDamageReport = 'STANDARD__DOCUMENTS_DAMAGE__REPORT',
  StandardDocumentsEndOfMoveCustomerChecklist = 'STANDARD__DOCUMENTS_END__OF__MOVE__CUSTOMER__CHECKLIST',
  StandardDocumentsEstimate = 'STANDARD__DOCUMENTS_ESTIMATE',
  StandardDocumentsExistingDamages = 'STANDARD__DOCUMENTS_EXISTING__DAMAGES',
  StandardDocumentsInsuranceOptions = 'STANDARD__DOCUMENTS_INSURANCE__OPTIONS',
  StandardDocumentsInvoice = 'STANDARD__DOCUMENTS_INVOICE',
  StandardDocumentsLiabilityRelease = 'STANDARD__DOCUMENTS_LIABILITY__RELEASE',
  StandardDocumentsMovingContract = 'STANDARD__DOCUMENTS_MOVING__CONTRACT',
  StandardDocumentsOnSiteEstimate = 'STANDARD__DOCUMENTS_ON__SITE__ESTIMATE',
  StandardDocumentsPostLoadWalkthrough = 'STANDARD__DOCUMENTS_POST__LOAD__WALKTHROUGH',
  StandardDocumentsPostUnloadWalkthrough = 'STANDARD__DOCUMENTS_POST__UNLOAD__WALKTHROUGH',
  StandardDocumentsReceipt = 'STANDARD__DOCUMENTS_RECEIPT',
  StandardDocumentsReminder = 'STANDARD__DOCUMENTS_REMINDER',
  StandardDocumentsRevisionToEstimate = 'STANDARD__DOCUMENTS_REVISION__TO__ESTIMATE',
  StripeAccount = 'STRIPE_ACCOUNT',
  StripeAccountdraft = 'STRIPE_ACCOUNTDRAFT',
  StripeEndpointsecret = 'STRIPE_ENDPOINTSECRET',
  StripeSecret = 'STRIPE_SECRET',
  SubscriptionPlan = 'SUBSCRIPTION_PLAN',
  SupportTawktoapikey = 'SUPPORT_TAWKTOAPIKEY',
  SystemDetailsCountry = 'SYSTEM__DETAILS_COUNTRY',
  SystemDetailsFranchisenumber = 'SYSTEM__DETAILS_FRANCHISENUMBER',
  SystemDetailsLanguage = 'SYSTEM__DETAILS_LANGUAGE',
  SystemDetailsName = 'SYSTEM__DETAILS_NAME',
  SystemDetailsStatus = 'SYSTEM__DETAILS_STATUS',
  SystemDetailsTimezone = 'SYSTEM__DETAILS_TIMEZONE',
  TalkdeskAccountname = 'TALKDESK_ACCOUNTNAME',
  TalkdeskCallbackconfig = 'TALKDESK_CALLBACKCONFIG',
  TalkdeskCallbackifdispositions = 'TALKDESK_CALLBACKIFDISPOSITIONS',
  TalkdeskClientid = 'TALKDESK_CLIENTID',
  TalkdeskClientsecret = 'TALKDESK_CLIENTSECRET',
  TalkdeskCloseifdispositions = 'TALKDESK_CLOSEIFDISPOSITIONS',
  TalkdeskEnabled = 'TALKDESK_ENABLED',
  TalkdeskFromphone = 'TALKDESK_FROMPHONE',
  TalkdeskInitialpriority = 'TALKDESK_INITIALPRIORITY',
  TalkdeskInitialringgroup = 'TALKDESK_INITIALRINGGROUP',
  TalkdeskLegacyCallback = 'TALKDESK_LEGACY__CALLBACK',
  TalkdeskMaxcalls = 'TALKDESK_MAXCALLS',
  TalkdeskSendsmsflowurl = 'TALKDESK_SENDSMSFLOWURL',
  TalkdeskTranscribe = 'TALKDESK_TRANSCRIBE',
  TalkdeskTriggercallbackflowurl = 'TALKDESK_TRIGGERCALLBACKFLOWURL',
  TemplatesDisabled = 'TEMPLATES_DISABLED',
  TemplatesJobapprovalrequested = 'TEMPLATES_JOBAPPROVALREQUESTED',
  TransactionsAutosendreceipt = 'TRANSACTIONS_AUTOSENDRECEIPT',
  TriggerAddBaseTime = 'TRIGGER_ADD__BASE__TIME',
  TriggerAddProducts = 'TRIGGER_ADD__PRODUCTS',
  TriggerAddTime = 'TRIGGER_ADD__TIME',
  TriggerAllow = 'TRIGGER_ALLOW',
  TriggerDisallow = 'TRIGGER_DISALLOW',
  TriggerMultiplyBaseTime = 'TRIGGER_MULTIPLY__BASE__TIME',
  TriggerRequireApproval = 'TRIGGER_REQUIRE__APPROVAL',
  TriggerRequireEstimate = 'TRIGGER_REQUIRE__ESTIMATE',
  TwilioApikey = 'TWILIO_APIKEY',
  TwilioApisecret = 'TWILIO_APISECRET',
  TwilioAuthtoken = 'TWILIO_AUTHTOKEN',
  TwilioMessagingserviceid = 'TWILIO_MESSAGINGSERVICEID',
  TwilioSid = 'TWILIO_SID',
  UsersDefaultemaildomain = 'USERS_DEFAULTEMAILDOMAIN',
  UserHourlysalary = 'USER_HOURLYSALARY',
  WebhookUsers = 'WEBHOOK_USERS',
  YemboIntegrationApiendpoint = 'YEMBO__INTEGRATION_APIENDPOINT',
  YemboIntegrationDefaultemail = 'YEMBO__INTEGRATION_DEFAULTEMAIL',
  YemboIntegrationDeveloperaccesstoken = 'YEMBO__INTEGRATION_DEVELOPERACCESSTOKEN',
  YemboIntegrationEnabled = 'YEMBO__INTEGRATION_ENABLED',
  YemboIntegrationSandboxintegrationaccesstoken = 'YEMBO__INTEGRATION_SANDBOXINTEGRATIONACCESSTOKEN',
  YemboIntegrationUrl = 'YEMBO__INTEGRATION_URL',
  ZonesDefault = 'ZONES_DEFAULT',
  ZonesInvoicetemplateid = 'ZONES_INVOICETEMPLATEID',
  ZonesReceipttemplateid = 'ZONES_RECEIPTTEMPLATEID'
}

export type ZoneConfigValue = {
  __typename?: 'ZoneConfigValue';
  ACT__ON_ACCESS__TOKEN?: Maybe<Scalars['String']['output']>;
  ACT__ON_CLIENT__ID?: Maybe<Scalars['String']['output']>;
  ACT__ON_CLIENT__SECRET?: Maybe<Scalars['String']['output']>;
  ACT__ON_CONTACT__LISTS?: Maybe<Scalars['ConfigValueObject']['output']>;
  ACT__ON_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  ACT__ON_REFRESH__TOKEN?: Maybe<Scalars['String']['output']>;
  ACT__ON_TOKEN__VALID__UNTIL?: Maybe<Scalars['String']['output']>;
  ADDITIONAL__CONTACT__DETAILS_CREWMANAGER?: Maybe<Scalars['String']['output']>;
  ADDITIONAL__CONTACT__DETAILS_OFFICEMANAGER?: Maybe<Scalars['String']['output']>;
  ADDITIONAL__CONTACT__DETAILS_SALESMANAGER?: Maybe<Scalars['String']['output']>;
  APP_ADMINEMAIL?: Maybe<Scalars['String']['output']>;
  APP_APPNAME?: Maybe<Scalars['String']['output']>;
  APP_LOGOB64?: Maybe<Scalars['String']['output']>;
  APP_NOTICE?: Maybe<App_Notice>;
  APP_PUBLICVAPIDKEY?: Maybe<Scalars['String']['output']>;
  APP_SHORTAPPNAME?: Maybe<Scalars['String']['output']>;
  AREA__RESOLVER_ISDOMAINPARENT?: Maybe<Scalars['Boolean']['output']>;
  AREA__RESOLVER_RADIUS?: Maybe<Scalars['Float']['output']>;
  ATTENTION_COMPLETEDESTIMATEREQUIRESBOOKING?: Maybe<AttentionConfig>;
  ATTENTION_EVENTENDED?: Maybe<AttentionConfig>;
  ATTENTION_EVENTREQUIRESCONFIRMATION?: Maybe<AttentionConfig>;
  ATTENTION_INVOICEOUTSTANDINGBALANCE?: Maybe<AttentionConfig>;
  ATTENTION_JOBNEEDSINVOICE?: Maybe<AttentionConfig>;
  ATTENTION_LEADREQUIRESPHONECALL?: Maybe<AttentionConfig>;
  ATTENTION_LONGOVERDUEINVOICEOUTSTANDINGBALANCE?: Maybe<AttentionConfig>;
  ATTENTION_NEWCOLDLEAD?: Maybe<AttentionConfig>;
  ATTENTION_NEWHOTLEAD?: Maybe<AttentionConfig>;
  ATTENTION_NEWLEAD?: Maybe<AttentionConfig>;
  ATTENTION_NEWWARMLEAD?: Maybe<AttentionConfig>;
  ATTENTION_STALEJOB?: Maybe<AttentionConfig>;
  ATTENTION_URGENTLEAD?: Maybe<AttentionConfig>;
  AUTODIALER_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  AUTODIALER_MODE?: Maybe<Scalars['String']['output']>;
  BRANDING_COMPANYNAME?: Maybe<Scalars['String']['output']>;
  BRANDING_ICO?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK48?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK64?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK128?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK196?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK256?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK512?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARK1024?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONDARKWIDE?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT48?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT64?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT128?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT196?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT256?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT512?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHT1024?: Maybe<Scalars['String']['output']>;
  BRANDING_ICONLIGHTWIDE?: Maybe<Scalars['String']['output']>;
  BRANDING_PRIMARYCOLOR?: Maybe<Scalars['String']['output']>;
  BRANDING_SECONDARYCOLOR?: Maybe<Scalars['String']['output']>;
  BRANDING_TAGLINE?: Maybe<Scalars['String']['output']>;
  BRANDING_WEBSITE?: Maybe<Scalars['String']['output']>;
  CALENDAREVENTS_ARRIVALOFFSET?: Maybe<Scalars['Float']['output']>;
  CALENDAREVENTS_ARRIVALWINDOWPLACEHOLDER?: Maybe<Scalars['String']['output']>;
  CALENDAREVENTS_ARRIVALWINDOWTIMEFORMAT?: Maybe<Scalars['String']['output']>;
  CALENDAREVENTS_CHECKPERMISSIONSTOMODIFYBOOKOFF?: Maybe<Scalars['Boolean']['output']>;
  CALENDAREVENTS_DEPOSITMINTOBOOK?: Maybe<Scalars['Float']['output']>;
  CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX?: Maybe<Scalars['Boolean']['output']>;
  CALENDAREVENTS_ESTIMATELENGTH?: Maybe<Scalars['Float']['output']>;
  CALENDAREVENTS_INCLUDEDOCKTRAVELTIME?: Maybe<Scalars['Boolean']['output']>;
  CALENDAREVENTS_VIRTUALESTIMATELENGTH?: Maybe<Scalars['Float']['output']>;
  CALLRAIL_CREATEJOBINPRECALL?: Maybe<Scalars['Boolean']['output']>;
  CALLRAIL_DEFAULTORIGIN?: Maybe<Scalars['String']['output']>;
  CALLRAIL_DEFAULTSOURCE?: Maybe<Scalars['String']['output']>;
  CALLRAIL_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  CALLRAIL_POSTCALLUPDATESOURCE?: Maybe<Scalars['Boolean']['output']>;
  CREDENTIALS_PRIVATEVAPIDKEY?: Maybe<Scalars['String']['output']>;
  CUSTOMER_TYPES?: Maybe<Scalars['ConfigValueArray']['output']>;
  DASHBOARD_REPORTTYPES?: Maybe<Scalars['ConfigValueObject']['output']>;
  DOCUMENT__DEFAULTS_DAYSTILLDUE?: Maybe<Scalars['Float']['output']>;
  DOCUMENT__DEFAULTS_DOCTYPES?: Maybe<Scalars['String']['output']>;
  EMAIL_ENABLECLICKTRACKING?: Maybe<Scalars['Boolean']['output']>;
  EMAIL_HEADER?: Maybe<Scalars['String']['output']>;
  EMAIL_INBOXDEFAULT?: Maybe<Scalars['String']['output']>;
  EMAIL_REDIRECT?: Maybe<Scalars['String']['output']>;
  EMAIL_REPLYTO?: Maybe<Scalars['String']['output']>;
  EMAIL_SENDDOCUMENTSASUSER?: Maybe<Scalars['Boolean']['output']>;
  EMAIL_SENDGRIDAPIKEY?: Maybe<Scalars['String']['output']>;
  EMAIL_SENDGRIDEVENTKEY?: Maybe<Scalars['String']['output']>;
  EMAIL_SENDGRIDINBOUNDDOMAIN?: Maybe<Scalars['String']['output']>;
  EMAIL_SENDGRIDSYSTEMDOMAIN?: Maybe<Scalars['String']['output']>;
  EMAIL_SENDGRIDWEBHOOKID?: Maybe<Scalars['String']['output']>;
  ESTIMATOR_RESTRICTIONCODE?: Maybe<Scalars['String']['output']>;
  FIND_STARTTIMEINTERVAL?: Maybe<Scalars['Float']['output']>;
  FRANCHISE__INFO_ADDRESS?: Maybe<Scalars['String']['output']>;
  FRANCHISE__INFO_DOCKLOCATIONID?: Maybe<Scalars['String']['output']>;
  FRANCHISE__INFO_EMAIL?: Maybe<Scalars['String']['output']>;
  FRANCHISE__INFO_HQLOCATIONID?: Maybe<Scalars['String']['output']>;
  FRANCHISE__INFO_OWNER?: Maybe<Scalars['String']['output']>;
  FRANCHISE__INFO_PHONE?: Maybe<Scalars['String']['output']>;
  GOOGLEMAPS_USECOMPUTEROUTESAPI?: Maybe<Scalars['Boolean']['output']>;
  GOOGLEMAPS_USENEWPLACESAPI?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_DISTANCELIMIT?: Maybe<Scalars['String']['output']>;
  INTAKE_ENABLEFORWARDING?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_FORWARDIFNOZONE?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_FORWARDTOVONIGOIFNOZONE?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_FORWARDURL?: Maybe<Scalars['String']['output']>;
  INTAKE_GENERATEJOB?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_GENERATEJOBIFNOZONE?: Maybe<Scalars['Boolean']['output']>;
  INTAKE_INTERSTATEZONE?: Maybe<Scalars['String']['output']>;
  INTAKE_NOTIFICATIONRECIPIENTS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  INTAKE_REDIRECTURL?: Maybe<Scalars['String']['output']>;
  INTAKE_VONIGOFRANCHISEID?: Maybe<Scalars['String']['output']>;
  INTAKE_WEBHOOK?: Maybe<Scalars['String']['output']>;
  INVENTORY_ITEMS?: Maybe<Array<Maybe<Inventory_Items>>>;
  INVOICES_DUEHOWMANYDAYSAFTERINVOICEDATE?: Maybe<Scalars['Float']['output']>;
  INVOICE_DISABLEMULTIPLEEVENTS?: Maybe<Scalars['Boolean']['output']>;
  JOBS_BEDROOMSMANDATORY?: Maybe<Scalars['Boolean']['output']>;
  JOBS_CANCELLEDJOBTTL?: Maybe<Scalars['Float']['output']>;
  JOBS_CLOSEDREASONS?: Maybe<Array<Maybe<Jobs_ClosedReasons>>>;
  JOBS_DWELLINGTYPEMANDATORY?: Maybe<Scalars['Boolean']['output']>;
  JOBS_HOWHEARDMANDATORY?: Maybe<Scalars['Boolean']['output']>;
  JOBS_HOWHEARDOPTIONS?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  JOBS_INVOICECOMPANYNAME?: Maybe<Scalars['String']['output']>;
  JOBS_INVOICETTL?: Maybe<Scalars['Float']['output']>;
  JOBS_LEADWATCHERS?: Maybe<Scalars['String']['output']>;
  JOBS_NOTIFYWATCHERSBCC?: Maybe<Scalars['String']['output']>;
  JOBS_NOTIFYWATCHERSDOCUMENTCOMPLETED?: Maybe<Scalars['Boolean']['output']>;
  JOBS_ORIGINS?: Maybe<Scalars['ConfigValueArray']['output']>;
  JOBS_WATCHERS?: Maybe<Scalars['String']['output']>;
  JOBS_ZONECODE?: Maybe<Scalars['String']['output']>;
  LEGAL_BUSINESSADDRESS?: Maybe<Scalars['String']['output']>;
  LEGAL_BUSINESSNUMBER?: Maybe<Scalars['String']['output']>;
  LEGAL_FRANCHISEOWNERS?: Maybe<Scalars['String']['output']>;
  LEGAL_LEGALCOMPANYNAME?: Maybe<Scalars['String']['output']>;
  LEGAL_OPERATINGAS?: Maybe<Scalars['String']['output']>;
  LEGAL_OPERATINGFOR?: Maybe<Scalars['String']['output']>;
  LEGAL_POLICYNUMBER?: Maybe<Scalars['String']['output']>;
  LEGAL_TAXNUMBERS?: Maybe<Scalars['String']['output']>;
  NICE__JOBS_FORWARDTOVONIGO?: Maybe<Scalars['Boolean']['output']>;
  NICE__JOBS_GENERATEJOB?: Maybe<Scalars['Boolean']['output']>;
  NICE__JOBS__PRIVATE_CLIENT__SECRET?: Maybe<Scalars['String']['output']>;
  NICE__JOBS__PROTECTED_ACCESS__TOKEN?: Maybe<Scalars['String']['output']>;
  NICE__JOBS__PROTECTED_CLIENT__ID?: Maybe<Scalars['String']['output']>;
  NICE__JOBS__PROTECTED_REFRESH__TOKEN?: Maybe<Scalars['String']['output']>;
  NICE__JOBS__PROTECTED_TOKEN__VALID__UNTIL?: Maybe<Scalars['Float']['output']>;
  OPENAI_APIKEY?: Maybe<Scalars['String']['output']>;
  OPENAI_ORGANIZATION?: Maybe<Scalars['String']['output']>;
  OPENAI_PROJECT?: Maybe<Scalars['String']['output']>;
  PANDADOC_APIKEY?: Maybe<Scalars['String']['output']>;
  PANDADOC_DEFAULTSENDER?: Maybe<Scalars['String']['output']>;
  PANDADOC_SENDCOPYTOEMPLOYEE?: Maybe<Scalars['Boolean']['output']>;
  PANDADOC_SORTCHARGESBY?: Maybe<Scalars['String']['output']>;
  PANDADOC_WEBHOOKKEY?: Maybe<Scalars['String']['output']>;
  PAYMENT__TYPE_AMEX?: Maybe<PaymentType>;
  PAYMENT__TYPE_CASH?: Maybe<PaymentType>;
  PAYMENT__TYPE_CHECK?: Maybe<PaymentType>;
  PAYMENT__TYPE_CREDIT__CARD?: Maybe<PaymentType>;
  PAYMENT__TYPE_DEBIT?: Maybe<PaymentType>;
  PAYMENT__TYPE_ETRANSFER?: Maybe<PaymentType>;
  PAYMENT__TYPE_MASTER__CARD?: Maybe<PaymentType>;
  PAYMENT__TYPE_OTHER?: Maybe<PaymentType>;
  PAYMENT__TYPE_STRIPE?: Maybe<PaymentType>;
  PAYMENT__TYPE_VISA?: Maybe<PaymentType>;
  PHONEFORWARDING_NUMBER?: Maybe<Scalars['String']['output']>;
  PHONEFORWARDING_TRANSCRIBE?: Maybe<Scalars['Boolean']['output']>;
  PRICINGENGINE_AGENTINSTRUCTIONSPROMPT?: Maybe<Scalars['String']['output']>;
  PRICINGENGINE_CREWSIZEPROMPT?: Maybe<Scalars['String']['output']>;
  PRICINGENGINE_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  PRICINGENGINE_ITINERARYPROMPT?: Maybe<Scalars['String']['output']>;
  PRICINGENGINE_PRICINGPROMPT?: Maybe<Scalars['String']['output']>;
  PRICINGENGINE_VALIDATIONPROMPT?: Maybe<Scalars['String']['output']>;
  PRICING_CHARGESORTMETHOD?: Maybe<Scalars['String']['output']>;
  PRICING_SINGLEMANHOURPRICE?: Maybe<Scalars['Float']['output']>;
  PROMPT_AINAME?: Maybe<Scalars['String']['output']>;
  PROMPT_AIVOICE?: Maybe<Scalars['String']['output']>;
  PROMPT_BUSINESSHOURS?: Maybe<Scalars['String']['output']>;
  PROMPT_INBOUNDCALLROUTINGNUMBERS?: Maybe<Scalars['String']['output']>;
  PROMPT_INBOUNDROUTING?: Maybe<Scalars['Boolean']['output']>;
  PROMPT_INBOUNDSMSAIENABLED?: Maybe<Scalars['Boolean']['output']>;
  PROMPT_SCHEDULECOMMUNICATIONSINSTRUCTIONS?: Maybe<Scalars['String']['output']>;
  PROMPT_SCHEDULECOMMUNICATIONSRINGGROUPS?: Maybe<Scalars['String']['output']>;
  PUBLIC_STRIPEPUBLICKEY?: Maybe<Scalars['String']['output']>;
  QUICKBOOKS_DATA?: Maybe<Scalars['ConfigValueObject']['output']>;
  QUICKBOOKS_DEFAULT__TAX__CODE?: Maybe<Scalars['String']['output']>;
  QUICKBOOKS_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  QUICKBOOKS_PRODUCT__MAP?: Maybe<Scalars['ConfigValueObject']['output']>;
  QUICKBOOKS_PRODUCT__SETTINGS?: Maybe<Scalars['ConfigValueObject']['output']>;
  QUICKBOOKS_REALMID?: Maybe<Scalars['String']['output']>;
  QUICKBOOKS_REFRESHTOKEN?: Maybe<Scalars['String']['output']>;
  QUICKBOOKS_TAXCODE__MAP?: Maybe<Scalars['ConfigValueObject']['output']>;
  QUICKBOOKS_TOKENTYPE?: Maybe<Scalars['String']['output']>;
  ROLE_ADMIN?: Maybe<Scalars['String']['output']>;
  ROLE_CUSTOMER?: Maybe<Scalars['String']['output']>;
  ROLE_EMPLOYEE?: Maybe<Scalars['String']['output']>;
  ROLE_FRANCHISEE?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_CONTACTACCOUNTINGBUTTONTEXT?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_CURRENTDATE?: Maybe<Scalars['Float']['output']>;
  ROLLING__LOCK__DATE_EMAILBODYPREFIX?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_EMAILBODYSUFFIX?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_EMAILSUBJECT?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_EVENTLOCKEDWARNING?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_NEXTDATE?: Maybe<Scalars['Float']['output']>;
  ROLLING__LOCK__DATE_SUPPORTEMAIL?: Maybe<Scalars['String']['output']>;
  ROLLING__LOCK__DATE_UPDATERULE?: Maybe<Scalars['String']['output']>;
  SEARCH_ALLOWCROSSZONEQUERY?: Maybe<Scalars['Boolean']['output']>;
  SMS_HANDLER?: Maybe<Scalars['String']['output']>;
  STANDARD__DOCUMENTS_AUTHORIZATION?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BILL__OF__LADING__FVP?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BILL__OF__LADING__RV?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_BOOKING__AGREEMENT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__FORM?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__NO__PP?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CLAIM__PP?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CONTRACT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_CUSTOMER__CONTRACT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_DAMAGE__REPORT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_END__OF__MOVE__CUSTOMER__CHECKLIST?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_ESTIMATE?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_EXISTING__DAMAGES?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_INSURANCE__OPTIONS?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_INVOICE?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_LIABILITY__RELEASE?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_MOVING__CONTRACT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_ON__SITE__ESTIMATE?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_POST__LOAD__WALKTHROUGH?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_POST__UNLOAD__WALKTHROUGH?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_RECEIPT?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_REMINDER?: Maybe<StandardDocumentsConfig>;
  STANDARD__DOCUMENTS_REVISION__TO__ESTIMATE?: Maybe<StandardDocumentsConfig>;
  STRIPE_ACCOUNT?: Maybe<Scalars['String']['output']>;
  STRIPE_ACCOUNTDRAFT?: Maybe<Scalars['String']['output']>;
  STRIPE_ENDPOINTSECRET?: Maybe<Scalars['String']['output']>;
  STRIPE_SECRET?: Maybe<Scalars['String']['output']>;
  SUBSCRIPTION_PLAN?: Maybe<Scalars['String']['output']>;
  SUPPORT_TAWKTOAPIKEY?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_COUNTRY?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_FRANCHISENUMBER?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_LANGUAGE?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_NAME?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_STATUS?: Maybe<Scalars['String']['output']>;
  SYSTEM__DETAILS_TIMEZONE?: Maybe<Scalars['String']['output']>;
  TALKDESK_ACCOUNTNAME?: Maybe<Scalars['String']['output']>;
  TALKDESK_CALLBACKCONFIG?: Maybe<Talkdesk_CallbackConfig>;
  TALKDESK_CALLBACKIFDISPOSITIONS?: Maybe<Scalars['String']['output']>;
  TALKDESK_CLIENTID?: Maybe<Scalars['String']['output']>;
  TALKDESK_CLIENTSECRET?: Maybe<Scalars['String']['output']>;
  TALKDESK_CLOSEIFDISPOSITIONS?: Maybe<Scalars['String']['output']>;
  TALKDESK_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  TALKDESK_FROMPHONE?: Maybe<Scalars['String']['output']>;
  TALKDESK_INITIALPRIORITY?: Maybe<Scalars['Float']['output']>;
  TALKDESK_INITIALRINGGROUP?: Maybe<Scalars['String']['output']>;
  TALKDESK_LEGACY__CALLBACK?: Maybe<Scalars['Boolean']['output']>;
  TALKDESK_MAXCALLS?: Maybe<Scalars['Float']['output']>;
  TALKDESK_SENDSMSFLOWURL?: Maybe<Scalars['String']['output']>;
  TALKDESK_TRANSCRIBE?: Maybe<Scalars['Boolean']['output']>;
  TALKDESK_TRIGGERCALLBACKFLOWURL?: Maybe<Scalars['String']['output']>;
  TEMPLATES_DISABLED?: Maybe<Scalars['String']['output']>;
  TEMPLATES_JOBAPPROVALREQUESTED?: Maybe<TemplateConfig>;
  TRANSACTIONS_AUTOSENDRECEIPT?: Maybe<Scalars['Boolean']['output']>;
  TRIGGER_ADD__BASE__TIME?: Maybe<TriggerConfig>;
  TRIGGER_ADD__PRODUCTS?: Maybe<TriggerConfig>;
  TRIGGER_ADD__TIME?: Maybe<TriggerConfig>;
  TRIGGER_ALLOW?: Maybe<TriggerConfig>;
  TRIGGER_DISALLOW?: Maybe<TriggerConfig>;
  TRIGGER_MULTIPLY__BASE__TIME?: Maybe<TriggerConfig>;
  TRIGGER_REQUIRE__APPROVAL?: Maybe<TriggerConfig>;
  TRIGGER_REQUIRE__ESTIMATE?: Maybe<TriggerConfig>;
  TWILIO_APIKEY?: Maybe<Scalars['String']['output']>;
  TWILIO_APISECRET?: Maybe<Scalars['String']['output']>;
  TWILIO_AUTHTOKEN?: Maybe<Scalars['String']['output']>;
  TWILIO_MESSAGINGSERVICEID?: Maybe<Scalars['String']['output']>;
  TWILIO_SID?: Maybe<Scalars['String']['output']>;
  USERS_DEFAULTEMAILDOMAIN?: Maybe<Scalars['String']['output']>;
  USER_HOURLYSALARY?: Maybe<Scalars['Float']['output']>;
  WEBHOOK_USERS?: Maybe<Scalars['String']['output']>;
  YEMBO__INTEGRATION_APIENDPOINT?: Maybe<Scalars['String']['output']>;
  YEMBO__INTEGRATION_DEFAULTEMAIL?: Maybe<Scalars['String']['output']>;
  YEMBO__INTEGRATION_DEVELOPERACCESSTOKEN?: Maybe<Scalars['String']['output']>;
  YEMBO__INTEGRATION_ENABLED?: Maybe<Scalars['Boolean']['output']>;
  YEMBO__INTEGRATION_SANDBOXINTEGRATIONACCESSTOKEN?: Maybe<Scalars['String']['output']>;
  YEMBO__INTEGRATION_URL?: Maybe<Scalars['String']['output']>;
  ZONES_DEFAULT?: Maybe<Scalars['String']['output']>;
  ZONES_INVOICETEMPLATEID?: Maybe<Scalars['String']['output']>;
  ZONES_RECEIPTTEMPLATEID?: Maybe<Scalars['String']['output']>;
};

/**
 * Filters objects by whether they are in parent (gt, gte),
 * the current (eq, gte, lte), or child (lt, lte) zones.
 *
 * Use "e" variants (lte, gte) to include relative and the current zones.
 *
 * An undefined value will default to "any" which is either parent, current, or child zones.
 */
export enum ZoneDir {
  Any = 'any',
  Eq = 'eq',
  Gt = 'gt',
  Gte = 'gte',
  Lt = 'lt',
  Lte = 'lte'
}

export type ZoneInput = {
  addAreaCodes?: InputMaybe<AddAreaCodesInput>;
  attributes?: InputMaybe<Array<Scalars['String']['input']>>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  configs?: InputMaybe<Array<ConfigValueInput>>;
  contextable?: InputMaybe<Scalars['Boolean']['input']>;
  createPlaceholderAssetsAndAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  createPlaceholderProductsAndPrices?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  maxDepth?: InputMaybe<Scalars['Int']['input']>;
  maxSubZones?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  owner?: InputMaybe<CreateUserInput>;
  removeAreaCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Whether to run migrations upon creating a zone. Default: false */
  runMigrations?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  /** HQ address of the zone to be created */
  zoneHQ?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCalendarEventInput = {
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  attendees?: InputMaybe<Array<InputMaybe<AddAttendeeInput>>>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  duplicateFromOriginId?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  jobId?: InputMaybe<Scalars['String']['input']>;
  locations?: InputMaybe<Array<InputMaybe<CalendarEventLocationInput>>>;
  /**
   * Set metadata on the object. Must be provided in a valid JSON format
   * otherwise it will throw an error. If using double quotes, make
   * sure you escape the string. Eg:
   *
   * `"{\"x\":2,\"y\":\"NotSoSecret\"}"`
   */
  metadata?: InputMaybe<Scalars['String']['input']>;
  recurring?: InputMaybe<RecurringCreateInput>;
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sequentialOrder?: InputMaybe<Scalars['Float']['input']>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  topicText?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type EditCalendarEventInput = {
  associatedId?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  colour?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  end?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the event's end time should be adjusted based on the travel time offset or the estimated time at the location. For example, if the user modifies the travel time offset or the estimated time at the location, the end time should be updated accordingly. Ensure that ignoreInDuration is set to false. */
  modifyEndForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Indicates whether the event's start time should be adjusted based on the travel time from 'BaseStart' to the first location.
   * For example, if the arrival time at 'BaseStart' is 9:00 AM (with an estimated time at 'BaseStart' of 0), and the estimated time at 'BaseStart' is updated to 1 hour, the start time should shift to 8:00 AM to ensure the arrival time remains unchanged.
   */
  modifyStartForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  sequentialOrder?: InputMaybe<Scalars['Float']['input']>;
  setAssets?: InputMaybe<SetAssets>;
  setAttendees?: InputMaybe<SetEventAttendeesInput>;
  setCharges?: InputMaybe<SetChargesInput>;
  setLocations?: InputMaybe<SetEventLocationsInput>;
  /**  Any zones here will be able to see the event, overrides existing zones  */
  setSharedZones?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  setTopics?: InputMaybe<SetEventTopicsInput>;
  shortTitle?: InputMaybe<Scalars['String']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  updateEventSequentialOrder?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IsSuccess = {
  __typename?: 'isSuccess';
  isSuccess: Scalars['Boolean']['output'];
};

export type RecurringCreateInput = {
  dailyInterval?: InputMaybe<Scalars['Int']['input']>;
  dayOfMonth?: InputMaybe<Scalars['Int']['input']>;
  dayOfYear?: InputMaybe<Scalars['Int']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endTime?: InputMaybe<Scalars['Int']['input']>;
  interval: Scalars['String']['input'];
  startTime?: InputMaybe<Scalars['Int']['input']>;
};

export type RemovePageResult = {
  __typename?: 'removePageResult';
  isSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type SetConfig = {
  key: Scalars['String']['input'];
  namespace: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

export type SetUserLocationsOutput = {
  __typename?: 'setUserLocationsOutput';
  locationsAdded?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  locationsRemoved?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  userId: Scalars['String']['output'];
};

export type LogInToActOnMutationVariables = Exact<{
  username: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LogInToActOnMutation = { __typename?: 'Mutation', logInToActOn: boolean };

export type IsAuthenticatedToActOnQueryVariables = Exact<{ [key: string]: never; }>;


export type IsAuthenticatedToActOnQuery = { __typename?: 'Query', isAuthenticatedToActOn: boolean };

export type ContactListsQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactListsQuery = { __typename?: 'Query', contactLists?: { __typename?: 'ListResponse', result: Array<{ __typename?: 'ListEntry', id: string, name: string, description: string }> } | null };

export type GetJobDocumentsQueryVariables = Exact<{
  jobId?: InputMaybe<Scalars['String']['input']>;
  getPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetJobDocumentsQuery = { __typename?: 'Query', artifacts?: { __typename?: 'ListArtifactsOutput', artifacts: Array<{ __typename?: 'Artifact', id: string, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, gcsFileName?: string | null, attributes?: Array<string | null> | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, metadata?: any | null } | null> } | null };

export type ViewArtifactsQueryVariables = Exact<{
  filter?: InputMaybe<ArtifactFilter>;
  getPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ViewArtifactsQuery = { __typename?: 'Query', artifacts?: { __typename?: 'ListArtifactsOutput', total: number, skipped: number, limited: number, artifacts: Array<{ __typename?: 'Artifact', id: string, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, gcsFileName?: string | null, attributes?: Array<string | null> | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, metadata?: any | null } | null> } | null };

export type CreateDocumentMutationVariables = Exact<{
  serviceToUse: Scalars['String']['input'];
  documentsToSend?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  templateIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  sendStandardDocuments?: InputMaybe<Scalars['Boolean']['input']>;
  variables?: InputMaybe<Scalars['DocumentVariablesInput']['input']>;
  send?: InputMaybe<Scalars['Boolean']['input']>;
  sendDocumentExternally?: InputMaybe<Scalars['Boolean']['input']>;
  sendDocumentInternally?: InputMaybe<Scalars['Boolean']['input']>;
  saveArtifact?: InputMaybe<Scalars['Boolean']['input']>;
  commentWithArtifactOn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type CreateDocumentMutation = { __typename?: 'Mutation', createDocument: Array<{ __typename?: 'CreateDocumentOutput', docLink?: string | null, artifact?: { __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null } | null, recipients: Array<{ __typename?: 'DocumentRecipient', email?: string | null, firstName?: string | null, lastName?: string | null, role?: string | null } | null> } | null> };

export type ListArtifactsQueryVariables = Exact<{
  filter?: InputMaybe<ArtifactFilter>;
  getPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListArtifactsQuery = { __typename?: 'Query', artifacts?: { __typename?: 'ListArtifactsOutput', total: number, skipped: number, limited: number, artifacts: Array<{ __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null } | null> } | null };

export type DeleteArtifactsMutationVariables = Exact<{
  artifactIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  deleteResource: Scalars['Boolean']['input'];
}>;


export type DeleteArtifactsMutation = { __typename?: 'Mutation', deleteArtifacts?: boolean | null };

export type DocumentReadyToViewSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DocumentReadyToViewSubscription = { __typename?: 'Subscription', documentReadyToView: { __typename?: 'DocumentReadyToViewOutput', artifactId: string, templateType: string, userId: string } };

export type DocumentSignedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type DocumentSignedSubscription = { __typename?: 'Subscription', documentSigned: { __typename?: 'DocumentSigned', artifactId: string, signedByRole: string } };

export type UpcomingEventsQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpcomingEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', total: number, skipped?: number | null, limited?: number | null, events: Array<{ __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type AssetsQueryVariables = Exact<{
  filter?: InputMaybe<AssetsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetsPagination', total: number, skipped?: number | null, limited?: number | null, assets: Array<{ __typename?: 'Asset', attributes?: Array<string | null> | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, metadata?: any | null, id: string, name: string, type: string, description?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null } | null, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, description?: string | null, contextable?: boolean | null, color?: string | null } | null>, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> } };

export type BaseAssetsQueryVariables = Exact<{
  filter?: InputMaybe<AssetsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type BaseAssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetsPagination', total: number, skipped?: number | null, limited?: number | null, assets: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> } };

export type CreateAssetsMutationVariables = Exact<{
  assets: Array<InputMaybe<CreateAssetInput>> | InputMaybe<CreateAssetInput>;
}>;


export type CreateAssetsMutation = { __typename?: 'Mutation', createAssets: Array<{ __typename: 'Asset', id: string, name: string, type: string, description?: string | null, attributes?: Array<string | null> | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, location?: { __typename: 'Location', id: string } | null }> };

export type ListBaseAssetsQueryVariables = Exact<{
  filter?: InputMaybe<AssetsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListBaseAssetsQuery = { __typename?: 'Query', assets: { __typename?: 'AssetsPagination', assets: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> } };

export type UpdateAssetsMutationVariables = Exact<{
  assets: Array<InputMaybe<UpdateAssetInput>> | InputMaybe<UpdateAssetInput>;
}>;


export type UpdateAssetsMutation = { __typename?: 'Mutation', updateAssets: boolean };

export type DeleteAssetsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
  restore?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteAssetsMutation = { __typename?: 'Mutation', deleteAssets: boolean };

export type ListAuthMethodsQueryVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAuthMethodsQuery = { __typename?: 'Query', authMethods: Array<{ __typename?: 'AuthMethod', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, authMethodType: AuthMethodType, ethereum_network?: number | null, oidc_provider?: string | null, oidc_name?: string | null, password_minLength?: number | null, zone: string }> };

export type AuthenticateMutationVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  twoFactorAuthenticationToken?: InputMaybe<Scalars['String']['input']>;
  rememberLength?: InputMaybe<Scalars['Int']['input']>;
  jwt?: InputMaybe<Scalars['String']['input']>;
  refreshToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type AuthenticateMutation = { __typename?: 'Mutation', authenticate?: { __typename: 'AuthenticateOutput', userId?: string | null, validJWT?: boolean | null, validRefreshToken?: boolean | null, validEmail?: boolean | null, valid2FA?: boolean | null, validPassword?: boolean | null, jwt?: string | null, jwtExpires?: number | null, refreshToken?: string | null, refreshTokenExpires?: number | null, lockedOutTimeLeft?: number | null, lockedOutAttemptsLeft?: number | null, invalidReason?: string | null, invalidCode?: string | null } | null };

export type DeauthenticateMutationVariables = Exact<{ [key: string]: never; }>;


export type DeauthenticateMutation = { __typename?: 'Mutation', deauthenticate?: boolean | null };

export type Disable2FaMutationVariables = Exact<{ [key: string]: never; }>;


export type Disable2FaMutation = { __typename?: 'Mutation', disable2FA: boolean };

export type ConfirmSecretMutationVariables = Exact<{
  token?: InputMaybe<Scalars['String']['input']>;
}>;


export type ConfirmSecretMutation = { __typename?: 'Mutation', confirmSecret: boolean };

export type GenerateSecretMutationVariables = Exact<{ [key: string]: never; }>;


export type GenerateSecretMutation = { __typename?: 'Mutation', generateSecret: { __typename?: 'GenerateSecretOutput', qr: string, secret: string, uri: string } };

export type RequestPasswordResetMutationVariables = Exact<{
  userId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
}>;


export type RequestPasswordResetMutation = { __typename?: 'Mutation', createPasswordResetToken: boolean };

export type ResetPasswordMutationVariables = Exact<{
  token: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', redeemPasswordResetToken: boolean };

export type RedeemInviteTokenMutationVariables = Exact<{
  token: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  givenName: Scalars['String']['input'];
  familyName: Scalars['String']['input'];
  businessName?: InputMaybe<Scalars['String']['input']>;
  businessID?: InputMaybe<Scalars['String']['input']>;
  businessCode?: InputMaybe<Scalars['String']['input']>;
  businessAddress?: InputMaybe<Scalars['String']['input']>;
}>;


export type RedeemInviteTokenMutation = { __typename?: 'Mutation', redeemInviteToken: { __typename?: 'RedeemInviteTokenOutput', userId?: string | null, user?: { __typename?: 'User', id: string, email?: string | null } | null } };

export type AssetsForAvailabilityQueryVariables = Exact<{
  filter?: InputMaybe<AssetsFilter>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type AssetsForAvailabilityQuery = { __typename?: 'Query', assets: { __typename?: 'AssetsPagination', assets: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> } };

export type BookOffEventsQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
}>;


export type BookOffEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', events: Array<{ __typename?: 'CalendarEvent', id: string, title: string, start?: number | null, end?: number | null, type: string, description?: string | null, assets?: Array<{ __typename?: 'Asset', id: string } | null> | null }> } };

export type SearchQueryVariables = Exact<{
  search: Scalars['String']['input'];
}>;


export type SearchQuery = { __typename?: 'Query', search: { __typename?: 'SearchOutput', results: Array<{ __typename?: 'SearchNode', label: string, objectID: string, title: string, subtitle?: string | null, zoneId: string, zone: string, score: number, metadata?: any | null }> } };

export type SubmitFeedbackMutationVariables = Exact<{
  feedback?: InputMaybe<FeedbackInput>;
}>;


export type SubmitFeedbackMutation = { __typename?: 'Mutation', submitFeedback?: boolean | null };

export type AggregationDataOnlyQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  performance?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy: Scalars['String']['input'];
  linkFormat?: InputMaybe<Scalars['String']['input']>;
  dataColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  aggregationColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  columnParams?: InputMaybe<ColumnParams>;
}>;


export type AggregationDataOnlyQuery = { __typename?: 'Query', previewReport: { __typename?: 'PreviewReportOutput', aggregationData?: any | null } };

export type DataOnlyQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  performance?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy: Scalars['String']['input'];
  linkFormat?: InputMaybe<Scalars['String']['input']>;
  dataColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  aggregationColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  columnParams?: InputMaybe<ColumnParams>;
}>;


export type DataOnlyQuery = { __typename?: 'Query', previewReport: { __typename?: 'PreviewReportOutput', data?: any | null } };

export type PreviewReportWithConfigsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  performance?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy: Scalars['String']['input'];
  linkFormat?: InputMaybe<Scalars['String']['input']>;
  dataColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  aggregationColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  columnParams?: InputMaybe<ColumnParams>;
}>;


export type PreviewReportWithConfigsQuery = { __typename?: 'Query', previewReport: { __typename?: 'PreviewReportOutput', data?: any | null }, closureReasonsAndAttentionExplanations?: Array<{ __typename?: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null };

export type DynamicReportsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<DynamicReportsFilter>;
}>;


export type DynamicReportsQuery = { __typename?: 'Query', dynamicReports?: { __typename?: 'ListDynamicReportsOutput', skipped?: number | null, limited?: number | null, total?: number | null, reports: Array<{ __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null }> } | null };

export type BaseDynamicReportFragment = { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null };

export type BaseOptionFragment = { __typename?: 'Option', option: string, label: string };

export type CreateDynamicReportMutationVariables = Exact<{
  name: Scalars['String']['input'];
  description: Scalars['String']['input'];
  parameters?: InputMaybe<DynamicReportParametersInput>;
}>;


export type CreateDynamicReportMutation = { __typename?: 'Mutation', createDynamicReport: string };

export type UpdateDynamicReportMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  parameters?: InputMaybe<DynamicReportParametersInput>;
}>;


export type UpdateDynamicReportMutation = { __typename?: 'Mutation', updateDynamicReport: boolean };

export type CreateDynamicReportsExportTokenMutationVariables = Exact<{
  dynamicReportId: Scalars['String']['input'];
  performance?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateDynamicReportsExportTokenMutation = { __typename?: 'Mutation', createDynamicReportExportToken: { __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, title?: string | null, isValid?: boolean | null, used?: number | null, metadata?: any | null } };

export type GetFullDiscountByIdQueryVariables = Exact<{
  discountId: Scalars['String']['input'];
}>;


export type GetFullDiscountByIdQuery = { __typename?: 'Query', discounts: { __typename?: 'ListDiscountsOutput', total: number, skipped: number, limited: number, discounts: Array<{ __typename?: 'Discount', maxRedemptions?: number | null, timesRedeemed: number, attributes?: Array<string | null> | null, metadata?: any | null, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null } | null> } };

export type DiscountsQueryVariables = Exact<{
  filter?: InputMaybe<DiscountFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type DiscountsQuery = { __typename?: 'Query', discounts: { __typename: 'ListDiscountsOutput', total: number, skipped: number, limited: number, discounts: Array<{ __typename?: 'Discount', maxRedemptions?: number | null, timesRedeemed: number, attributes?: Array<string | null> | null, metadata?: any | null, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null } | null> } };

export type DeleteDiscountsMutationVariables = Exact<{
  discountIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteDiscountsMutation = { __typename?: 'Mutation', deleteDiscounts: boolean };

export type UpdateDiscountsMutationVariables = Exact<{
  updateDiscounts: Array<UpdateDiscountsInput> | UpdateDiscountsInput;
}>;


export type UpdateDiscountsMutation = { __typename?: 'Mutation', updateDiscounts: boolean };

export type UpdateCustomAmountMutationVariables = Exact<{
  appliedId: Scalars['String']['input'];
  customAmount: Scalars['Int']['input'];
}>;


export type UpdateCustomAmountMutation = { __typename?: 'Mutation', updateAppliedCustomAmount: boolean };

export type CreateDiscountsMutationVariables = Exact<{
  createDiscounts: Array<CreateDiscountInput> | CreateDiscountInput;
}>;


export type CreateDiscountsMutation = { __typename?: 'Mutation', createDiscounts: Array<{ __typename: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, description?: string | null, code: string, amount: number, active: boolean, startsAt?: number | null, expiresAt?: number | null, maxRedemptions?: number | null, timesRedeemed: number, attributes?: Array<string | null> | null } | null> };

export type DynamicReportOptionsQueryVariables = Exact<{
  groupBy: Scalars['String']['input'];
}>;


export type DynamicReportOptionsQuery = { __typename?: 'Query', groupByOptions?: Array<{ __typename?: 'Option', option: string, label: string }> | null, periodTypeOptions?: Array<{ __typename?: 'Option', option: string, label: string }> | null, aggregationColumns?: Array<{ __typename?: 'Option', option: string, label: string }> | null, dataColumns?: Array<{ __typename?: 'Option', option: string, label: string }> | null };

export type PreviewReportQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  performance?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  periodType?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<PreviewReportFilter>;
  groupBy: Scalars['String']['input'];
  linkFormat?: InputMaybe<Scalars['String']['input']>;
  dataColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  aggregationColumns?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  columnParams?: InputMaybe<ColumnParams>;
}>;


export type PreviewReportQuery = { __typename?: 'Query', previewReport: { __typename?: 'PreviewReportOutput', total: number, skipped?: number | null, limited?: number | null, data?: any | null, aggregationData?: any | null, groupBy: string }, dataColumns?: Array<{ __typename?: 'Option', option: string, label: string }> | null };

export type ExistingCustomerJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type ExistingCustomerJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', jobs: Array<{ __typename?: 'Job', code?: string | null, id: string } | null> } };

export type EstimatingQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
  jobId: Scalars['String']['input'];
  objects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EstimatingQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', jobs: Array<{ __typename?: 'Job', notes?: string | null, sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, total?: number | null, expenseTotal?: number | null, topicText?: string | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null } | null> }, comments: { __typename?: 'CommentPagination', comments?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null }, fields: { __typename?: 'FieldResult', fields: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null }> } };

export type EstimatingUpdateJobMutationVariables = Exact<{
  updateJobs?: InputMaybe<Array<InputMaybe<UpdateJobInput>> | InputMaybe<UpdateJobInput>>;
}>;


export type EstimatingUpdateJobMutation = { __typename?: 'Mutation', updateJobs: { __typename?: 'UpdateJobsOutput', isSuccess: boolean, transitionedJobs?: Array<{ __typename?: 'TransitionedJob', oldJobId: string, newJobId: string } | null> | null } };

export type EstimatingCreateJobMutationVariables = Exact<{
  stage: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<JobUserInput>> | InputMaybe<JobUserInput>>;
  locations?: InputMaybe<Array<InputMaybe<JobLocationInput>> | InputMaybe<JobLocationInput>>;
  events?: InputMaybe<Array<InputMaybe<EventInput>> | InputMaybe<EventInput>>;
  newCustomers?: InputMaybe<Array<InputMaybe<CreateUserInputWithRole>> | InputMaybe<CreateUserInputWithRole>>;
  sendSelfSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<SetFieldsValuesInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  timelineDays?: InputMaybe<Scalars['Float']['input']>;
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  crewSummary?: InputMaybe<Scalars['Summary']['input']>;
  customerSummary?: InputMaybe<Scalars['Summary']['input']>;
  adminSummary?: InputMaybe<Scalars['Summary']['input']>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
}>;


export type EstimatingCreateJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string } };

export type ListReportsQueryVariables = Exact<{
  getData?: InputMaybe<Array<ReportGetDataOptions> | ReportGetDataOptions>;
  filter?: InputMaybe<ReportsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListReportsQuery = { __typename?: 'Query', reports: { __typename?: 'ListReportsOutput', reports: Array<{ __typename?: 'Report', id: string, name: string, reportType: { __typename?: 'ReportType', id: string }, aggregations?: Array<{ __typename: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, options?: any | null, labels?: Array<string | null> | null, values?: any | null }> | null }> } };

export type ListReportTypesQueryVariables = Exact<{
  filter?: InputMaybe<ReportTypesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListReportTypesQuery = { __typename?: 'Query', reportTypes: { __typename?: 'ListReportTypesOutput', reportTypes: Array<{ __typename?: 'ReportType', id: string, name: string, createdAt: number, updatedAt: number, deletedAt?: number | null, columns?: Array<any> | null, createdBy?: { __typename?: 'User', id: string } | null, aggregations: Array<{ __typename?: 'ReportAggregation', id: string, title?: string | null, type?: string | null, key?: string | null, filters?: Array<{ __typename?: 'ReportAggregationFilter', key?: string | null } | null> | null }> }> } };

export type ListReportTypesWithReportsQueryVariables = Exact<{
  filter?: InputMaybe<ReportTypesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListReportTypesWithReportsQuery = { __typename?: 'Query', reportTypes: { __typename?: 'ListReportTypesOutput', reportTypes: Array<{ __typename?: 'ReportType', id: string, name: string, createdAt: number, updatedAt: number, deletedAt?: number | null, columns?: Array<any> | null, createdBy?: { __typename?: 'User', id: string } | null, reports: { __typename?: 'ListReportsOutput', reports: Array<{ __typename?: 'Report', id: string, status: ReportStatus, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, labels?: Array<string | null> | null, values?: any | null }> | null }> }, aggregations: Array<{ __typename?: 'ReportAggregation', id: string, title?: string | null, type?: string | null, key?: string | null, filters?: Array<{ __typename?: 'ReportAggregationFilter', key?: string | null } | null> | null }> }> } };

export type SvcCreateReportMutationVariables = Exact<{
  input: CreateReportInput;
}>;


export type SvcCreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string, status: ReportStatus, error?: string | null, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, labels?: Array<string | null> | null, key?: string | null, title?: string | null, type?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, options?: any | null, error?: string | null, values?: any | null }> | null } };

export type TestScheduledDynamicReportMutationVariables = Exact<{
  reportId: Scalars['String']['input'];
}>;


export type TestScheduledDynamicReportMutation = { __typename?: 'Mutation', testScheduledDynamicReport: boolean };

export type ResolveServiceAreaQueryVariables = Exact<{
  query: Scalars['String']['input'];
  areaCode?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResolveServiceAreaQuery = { __typename?: 'Query', resolveServiceArea: { __typename?: 'ServiceAreaQueryResult', query: string, placeName?: string | null, placeId?: string | null, matchedArea?: { __typename?: 'ServiceAreaQueryMatch', zoneId: string, zoneName?: string | null, zoneParentId?: string | null, distance?: number | null, territoryMatches?: Array<string> | null, matchType?: MatchedServiceAreaMatchType | null } | null, closestAreas?: Array<{ __typename?: 'ServiceAreaQueryMatch', zoneId: string, zoneName?: string | null, zoneParentId?: string | null, distance?: number | null, territoryMatches?: Array<string> | null }> | null } };

export type AssignObjectsToZonesMutationVariables = Exact<{
  zoneIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  addObjects: Array<Scalars['String']['input']> | Scalars['String']['input'];
  removeObjects: Array<Scalars['String']['input']> | Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
}>;


export type AssignObjectsToZonesMutation = { __typename?: 'Mutation', assignObjectsToZones?: { __typename?: 'AssignObjectsToZonesOutput', objectsAssigned: number, objectsRemoved: number } | null };

export type SetFieldValuesMutationVariables = Exact<{
  fields: Array<SetFieldValueInput> | SetFieldValueInput;
  objects?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  objectLabel: Scalars['String']['input'];
}>;


export type SetFieldValuesMutation = { __typename?: 'Mutation', setFieldsValues: { __typename?: 'SetFieldValueResult', fields: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null }> } };

export type ListFieldsQueryVariables = Exact<{
  filter?: InputMaybe<FieldFilter>;
  objects?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  objectLabels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  showAllUsers?: InputMaybe<Scalars['Boolean']['input']>;
  ignoreDefaults?: InputMaybe<Scalars['Boolean']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  limitValues?: InputMaybe<Scalars['Int']['input']>;
  skipValues?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListFieldsQuery = { __typename?: 'Query', fields: { __typename?: 'FieldResult', fields: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null }> } };

export type BaseArtifactFragment = { __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null };

export type PandadocArtifactFragment = { __typename?: 'Artifact', id: string, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, gcsFileName?: string | null, attributes?: Array<string | null> | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, metadata?: any | null };

export type FullAssetFragment = { __typename?: 'Asset', attributes?: Array<string | null> | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, metadata?: any | null, id: string, name: string, type: string, description?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null } | null, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, description?: string | null, contextable?: boolean | null, color?: string | null } | null>, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type BaseAssetFragment = { __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type FindAssetFragment = { __typename?: 'Asset', id: string, name: string, type: string, metadata?: any | null };

export type AssetBasicDetailsFragment = { __typename?: 'Asset', id: string, name: string, type: string };

export type AssetWithMetadataFragment = { __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type Asset_MetadataFragment = { __typename?: 'Asset', metadata?: any | null };

export type BaseCalendarEventFragment = { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEventBasicdetailsFragment = { __typename?: 'CalendarEvent', id: string, title: string, status?: string | null, start?: number | null, end?: number | null, sequentialOrder?: number | null };

export type CalendarEvent_AssetsFragment = { __typename?: 'CalendarEvent', assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEvent_LocationFragment = { __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null };

export type CalendarEvent_LocationsFragment = { __typename?: 'CalendarEvent', locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null };

export type CalendarEvent_LocationsWithServiceAreaFragment = { __typename?: 'CalendarEvent', locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null };

export type CalendarEvent_ChargesFragment = { __typename?: 'CalendarEvent', charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null };

export type CalendarEvent_JobFragment = { __typename?: 'CalendarEvent', job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null };

export type CalendarEvent_AttendeeFragment = { __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type CalendarEvent_AttendeesFragment = { __typename?: 'CalendarEvent', attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEvent_ZonesFragment = { __typename?: 'CalendarEvent', zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type CalendarEvent_InvoicesFragment = { __typename?: 'CalendarEvent', invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null };

export type FullCalendarEventFragment = { __typename?: 'CalendarEvent', discountedSubTotal?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEventTotalsFragment = { __typename?: 'CalendarEvent', damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, total?: number | null, expenseTotal?: number | null };

export type CalendarEventForCalculatorFragment = { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEventForScheduleFragment = { __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type ScheduledCalendarEventFragment = { __typename?: 'CalendarEvent', discountedSubTotal?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type EventLocationDetailsFragment = { __typename?: 'CalendarEventLocation', type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null };

export type AppliedDiscountFragment = { __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null };

export type CalendarEvent_DiscountsFragment = { __typename?: 'CalendarEvent', discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null };

export type CalendarEventForEstimateFragment = { __typename?: 'CalendarEvent', damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, total?: number | null, expenseTotal?: number | null, topicText?: string | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEventForDetailsFragment = { __typename?: 'CalendarEvent', discountedSubTotalWithoutDamages?: number | null, damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, expenseTotal?: number | null, currency?: string | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null };

export type CalendarEventForSelectEventFragment = { __typename?: 'CalendarEvent', id: string, archivedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, sequentialOrder?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null };

export type BookOffCalendarEventFragment = { __typename?: 'CalendarEvent', id: string, title: string, start?: number | null, end?: number | null, type: string, description?: string | null, assets?: Array<{ __typename?: 'Asset', id: string } | null> | null };

export type BaseChargeFragment = { __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null };

export type ChargeForEstimateFragment = { __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null };

export type ChargeWithJobFragment = { __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, job?: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null } | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null };

export type ChargeBasicDetailsFragment = { __typename?: 'Charge', id: string, attributes?: Array<string | null> | null, productName?: string | null, quantity: number, amount?: number | null };

export type BaseCommentFragment = { __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null };

export type CommentWithRepliesFragment = { __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null };

export type FullConfigFragment = { __typename?: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null };

export type BaseDiscountFragment = { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null };

export type FullDiscountFragment = { __typename?: 'Discount', maxRedemptions?: number | null, timesRedeemed: number, attributes?: Array<string | null> | null, metadata?: any | null, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null };

export type BaseExpenseFragment = { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null };

export type ExpenseForPriceFragment = { __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } };

export type ExpenseForChargeFragment = { __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } };

export type BaseFieldFragment = { __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null };

export type BaseFieldObjectValueFragment = { __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null };

export type HistoryPartsFragment = { __typename?: 'History', id: string, text?: string | null, type?: string | null, ip?: string | null, createdAt?: number | null, vars?: any | null, related?: Array<{ __typename?: 'RelatedHistoryItem', name?: string | null, obj?: { __typename?: 'RelatedHistoryObject', id?: string | null, label?: string | null } | null } | null> | null };

export type FullInvoiceFragment = { __typename?: 'Invoice', metadata?: any | null, id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, signedUrl?: string | null, url?: string | null, metadata?: any | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null }, events: Array<{ __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }>, transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null }> };

export type BaseInvoiceFragment = { __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } };

export type InvoiceBasicDetailsFragment = { __typename?: 'Invoice', id: string, invoiceNumber: number };

export type InvoiceWithArtifactsFragment = { __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } };

export type Invoice_TotalsFragment = { __typename?: 'Invoice', subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number };

export type Invoice_ArtifactsFragment = { __typename?: 'Invoice', artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null };

export type Invoice_JobFragment = { __typename?: 'Invoice', job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } };

export type Invoice_EventsFragment = { __typename?: 'Invoice', events: Array<{ __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> };

export type Invoice_TransactionsFragment = { __typename?: 'Invoice', transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null }> };

export type BaseJobFragment = { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null };

export type Job_TaxesPaidFragment = { __typename?: 'Job', taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null };

export type Job_LocationFragment = { __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null };

export type Job_LocationsFragment = { __typename?: 'Job', locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null };

export type BaseJobUserFragment = { __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null };

export type Job_UsersFragment = { __typename?: 'Job', users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null };

export type Job_ChargesFragment = { __typename?: 'Job', charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> };

export type Job_CalendarEventFragment = { __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null };

export type Job_CalendarEventsFragment = { __typename?: 'Job', events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null };

export type Job_TagsFragment = { __typename?: 'Job', tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null> };

export type Job_TransactionsFragment = { __typename?: 'Job', transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null };

export type Job_ZoneFragment = { __typename?: 'Job', zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null } | null };

export type Job_ZoneWithParentAndTimezoneFragment = { __typename?: 'Job', zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null };

export type Job_DiscountsFragment = { __typename?: 'Job', discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null };

export type Job_MetadataFragment = { __typename?: 'Job', metadata?: any | null };

export type FullJobFragment = { __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null };

export type FullJobWithStagesFragment = { __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, previousStages?: Array<{ __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null> | null, followingStages?: Array<{ __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null };

export type EstimatesJobFragment = { __typename?: 'Job', notes?: string | null, sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, total?: number | null, expenseTotal?: number | null, topicText?: string | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null };

export type JobWithUsersFragment = { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null };

export type JobWithUsersAndTagsFragment = { __typename?: 'Job', firstBookedRevenueGeneratingEvent?: number | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null> };

export type Job_InvoicesFragment = { __typename?: 'Job', invoices: Array<{ __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }> };

export type JobDetailsFragment = { __typename?: 'Job', id: string, code?: string | null, stage: string, state?: string | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, metadata?: any | null, attributes?: Array<string> | null, sharedZones?: Array<string | null> | null, tags: Array<{ __typename?: 'Tag', id: string, color?: string | null, category?: string | null, name: string } | null>, zone?: { __typename?: 'Zone', id: string, type?: string | null, name?: string | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: number }>, transactions?: Array<{ __typename?: 'Transaction', id: string, deletedAt?: number | null, stage: TransactionStage, type?: TransactionType | null, amount?: number | null, currency: string } | null> | null, events?: Array<{ __typename?: 'CalendarEvent', id: string, title: string, status?: string | null, start?: number | null, end?: number | null, sequentialOrder?: number | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string } | null> | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, attributes?: Array<string | null> | null, productName?: string | null, quantity: number, amount?: number | null, product?: { __typename?: 'Product', id: string, name: string } | null, price?: { __typename?: 'Price', id: string, amount: number, priceType?: PriceType | null } | null } | null>, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'JobLocation', locationId?: string | null, locationType?: string | null, location?: { __typename?: 'Location', id: string, addressLineOne?: string | null, addressLineTwo?: string | null, areaCode?: string | null, city?: string | null, country?: string | null } | null } | null> | null };

export type JobDetails_BaseJobFragment = { __typename?: 'Job', id: string, code?: string | null, stage: string, state?: string | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, metadata?: any | null, attributes?: Array<string> | null, sharedZones?: Array<string | null> | null };

export type JobDetails_CalendarEventsFragment = { __typename?: 'Job', events?: Array<{ __typename?: 'CalendarEvent', id: string, title: string, status?: string | null, start?: number | null, end?: number | null, sequentialOrder?: number | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string } | null> | null } | null> | null };

export type JobDetails_ChargesFragment = { __typename?: 'Job', charges: Array<{ __typename?: 'Charge', id: string, attributes?: Array<string | null> | null, productName?: string | null, quantity: number, amount?: number | null, product?: { __typename?: 'Product', id: string, name: string } | null, price?: { __typename?: 'Price', id: string, amount: number, priceType?: PriceType | null } | null } | null> };

export type JobDetails_UsersFragment = { __typename?: 'Job', users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null } | null } | null> | null };

export type JobDetails_LocationsFragment = { __typename?: 'Job', locations?: Array<{ __typename?: 'JobLocation', locationId?: string | null, locationType?: string | null, location?: { __typename?: 'Location', id: string, addressLineOne?: string | null, addressLineTwo?: string | null, areaCode?: string | null, city?: string | null, country?: string | null } | null } | null> | null };

export type CalculateDistanceOutputFragmentFragment = { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null };

export type RouteDistancesFragment = { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null };

export type BaseLocationFragment = { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null };

export type LocationBasicDetailsFragment = { __typename?: 'Location', id: string, addressLineOne?: string | null, addressLineTwo?: string | null, areaCode?: string | null, city?: string | null, country?: string | null };

export type CoordinatesFragment = { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null };

export type BaseNotificationFragment = { __typename?: 'Notification', id: string, type: string, title: string, subtitle?: string | null, body?: string | null, url?: string | null, actionsDisabled?: boolean | null, expiresIn?: number | null, data?: string | null, createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null };

export type FullNotificationFragment = { __typename?: 'Notification', id: string, type: string, title: string, subtitle?: string | null, body?: string | null, url?: string | null, actionsDisabled?: boolean | null, expiresIn?: number | null, data?: string | null, actions?: Array<{ __typename?: 'NotificationAction', type?: string | null, name: string, formattedName: string, value?: string | null, valueType?: string | null, extraInfo?: string | null, extraInfoType?: string | null, extraInfoQuickOptions?: Array<string> | null }> | null, recipients: Array<{ __typename?: 'NotificationRecipient', recipientId: string, readAt?: number | null, push?: boolean | null }>, createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null };

export type Notification_TimestampsFragment = { __typename?: 'Notification', createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null };

export type Notification_ActionsFragment = { __typename?: 'Notification', actions?: Array<{ __typename?: 'NotificationAction', type?: string | null, name: string, formattedName: string, value?: string | null, valueType?: string | null, extraInfo?: string | null, extraInfoType?: string | null, extraInfoQuickOptions?: Array<string> | null }> | null };

export type Notification_RecipientsFragment = { __typename?: 'Notification', recipients: Array<{ __typename?: 'NotificationRecipient', recipientId: string, readAt?: number | null, push?: boolean | null }> };

export type BasePriceFragment = { __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null };

export type PriceBasicDetailsFragment = { __typename?: 'Price', id: string, amount: number, priceType?: PriceType | null };

export type FullPriceFragment = { __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, metadata?: any | null, product: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null }, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null };

export type Price_MetadataFragment = { __typename?: 'Price', metadata?: any | null };

export type Price_ProductFragment = { __typename?: 'Price', product: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } };

export type Price_UserFragment = { __typename?: 'Price', user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type Price_ZoneFragment = { __typename?: 'Price', zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null };

export type Price_TaxesFragment = { __typename?: 'Price', taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null };

export type Price_ExpensesFragment = { __typename?: 'Price', expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null };

export type BasePriceFieldsFragment = { __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null };

export type PriceForBusinessProductsFragment = { __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null };

export type PriceForEstimatingFragment = { __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null };

export type BaseProductFragment = { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null };

export type ProductBasicDetailsFragment = { __typename?: 'Product', id: string, name: string };

export type FullProductFragment = { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null>, prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null }> };

export type Product_MetadataFragment = { __typename?: 'Product', metadata?: any | null };

export type Product_ZonesFragment = { __typename?: 'Product', zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> };

export type Product_PricesFragment = { __typename?: 'Product', prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null }> };

export type BaseReportTypeFragment = { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string };

export type ReportType_ZonesFragment = { __typename?: 'ReportType', zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type ReportTypeWithZonesFragment = { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type ReportType_SchemaFragment = { __typename?: 'ReportType', variableSchema: string, returnValue?: string | null, columns?: Array<any> | null };

export type ReportType_CreatedByFragment = { __typename?: 'ReportType', createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type ReportType_DescriptionFragment = { __typename?: 'ReportType', description?: string | null };

export type FullReportTypeFragment = { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string, returnValue?: string | null, columns?: Array<any> | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, reports: { __typename?: 'ListReportsOutput', total?: number | null, skipped?: number | null, limited?: number | null, reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null }> }, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type ReportType_ReportsFragment = { __typename?: 'ReportType', reports: { __typename?: 'ListReportsOutput', total?: number | null, skipped?: number | null, limited?: number | null, reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null }> } };

export type ReportType_ReportsWithZonesFragment = { __typename?: 'ReportType', reports: { __typename?: 'ListReportsOutput', total?: number | null, skipped?: number | null, limited?: number | null, reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> } };

export type BaseScheduledReportFragment = { __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null };

export type ScheduledReport_CreatedByFragment = { __typename?: 'ScheduledReport', createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type ScheduledReport_ReportTypeFragment = { __typename?: 'ScheduledReport', reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null };

export type ScheduledReport_DynamicReportFragment = { __typename?: 'ScheduledReport', dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null };

export type ScheduledReport_ZonesFragment = { __typename?: 'ScheduledReport', zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type ScheduledReport_AggregationsFragment = { __typename?: 'ScheduledReport', aggregations?: Array<{ __typename?: 'ReportAggregationDelta', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, options?: any | null, delta?: any | null, deltaName?: string | null, filters?: Array<{ __typename?: 'ReportAggregationFilter', key?: string | null, typeIs?: Array<string | null> | null, exactly?: Array<string | null> | null, contains?: Array<string | null> | null, endsWith?: Array<string | null> | null, startsWith?: Array<string | null> | null, matches?: Array<string | null> | null, gt?: number | null, lt?: number | null, gte?: number | null, lte?: number | null } | null> | null, values?: Array<{ __typename?: 'ScheduledReportAggregateValue', reportId?: string | null, createdAt?: number | null, values?: any | null, error?: string | null }> | null }> | null };

export type ScheduledReportEssentialsFragment = { __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type BaseReportFragment = { __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null };

export type BaseReportAggregationResultFragment = { __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null };

export type Report_AggregationsFragment = { __typename?: 'Report', aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null }> | null };

export type Report_DataFragment = { __typename?: 'Report', csv?: string | null, jsonURL?: string | null };

export type Report_ZonesFragment = { __typename?: 'Report', zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type Report_ScheduledReportFragment = { __typename?: 'Report', scheduledReport?: { __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } | null };

export type FullReportFragment = { __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, csv?: string | null, jsonURL?: string | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null }> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type BaseRoleFragment = { __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null };

export type RoleWithZonesFragment = { __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type BaseTagFragment = { __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null };

export type TagBasicDetailsFragment = { __typename?: 'Tag', id: string, color?: string | null, category?: string | null, name: string };

export type Tag_TaggedObjectFragment = { __typename?: 'Tag', objects?: Array<{ __typename?: 'TaggedObject', id: string, taggedPrivately: boolean, taggedBy: string, order?: number | null } | null> | null };

export type FullTagFragment = { __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null, objects?: Array<{ __typename?: 'TaggedObject', id: string, taggedPrivately: boolean, taggedBy: string, order?: number | null } | null> | null };

export type BaseTaxFragment = { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null };

export type Tax_ZonesFragment = { __typename?: 'Tax', zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type BaseTokenFragment = { __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, emails?: Array<string | null> | null, title?: string | null, validOn?: number | null, used?: number | null, maxUses?: number | null, metadata?: any | null, isValid?: boolean | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null } | null> | null };

export type BaseTransactionFragment = { __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null };

export type TransactionBasicDetailsFragment = { __typename?: 'Transaction', id: string, deletedAt?: number | null, stage: TransactionStage, type?: TransactionType | null, amount?: number | null, currency: string };

export type Transaction_PaymentTypeFragment = { __typename?: 'Transaction', paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null };

export type FullTransactionFragment = { __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null };

export type Transaction_InvoiceFragment = { __typename?: 'Transaction', invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null };

export type JobsV2TransactionFragment = { __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber: number } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null };

export type BaseUserFragment = { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null };

export type UserBasicDetailsFragment = { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null };

export type UserWithBillingAddressFragment = { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null };

export type FullUserFragment = { __typename?: 'User', twoFactorEnabled?: boolean | null, id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, roles?: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> | null, deletedAt?: { __typename?: 'DateTime', date: string } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null };

export type BaseZoneFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null };

export type ZoneBasicDetailsFragment = { __typename?: 'Zone', id: string, type?: string | null, name?: string | null };

export type BaseZoneWithParentFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null };

export type BaseZoneWithTimezoneFragment = { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null };

export type BaseZoneWithParentsFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> };

export type BaseZoneWithChildrenFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } };

export type BaseZoneWithFamilyFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }>, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } };

export type BaseZoneWithAreasFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, areas?: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> | null };

export type BaseZoneWithAreasAndChildrenFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, areas?: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> | null, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } };

export type BaseRuleFragment = { __typename?: 'Rule', id: string, condition: any, describedConditions?: string | null, triggerDescription: string, actionDescription: string, attributes?: Array<string> | null, createdAt: number, updatedAt: number, deletedAt?: number | null, metadata?: any | null, delay?: number | null, delayUnit?: string | null, offset?: number | null, offsetUnit?: string | null, trigger: { __typename?: 'RuleTrigger', id: string, name?: string | null, description?: string | null, describedForRule?: string | null, properties?: any | null }, action: { __typename?: 'RuleAction', id: string, name?: string | null, description: string, describedForRule?: string | null, properties?: any | null } };

export type ListRulesQueryVariables = Exact<{
  filter?: InputMaybe<RulesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListRulesQuery = { __typename?: 'Query', rules: { __typename?: 'ListRulesOutput', total: number, rules: Array<{ __typename?: 'Rule', id: string, condition: any, describedConditions?: string | null, triggerDescription: string, actionDescription: string, attributes?: Array<string> | null, createdAt: number, updatedAt: number, deletedAt?: number | null, metadata?: any | null, delay?: number | null, delayUnit?: string | null, offset?: number | null, offsetUnit?: string | null, trigger: { __typename?: 'RuleTrigger', id: string, name?: string | null, description?: string | null, describedForRule?: string | null, properties?: any | null }, action: { __typename?: 'RuleAction', id: string, name?: string | null, description: string, describedForRule?: string | null, properties?: any | null } } | null> } };

export type CreateRulesMutationVariables = Exact<{
  rules: Array<CreateRuleInput> | CreateRuleInput;
}>;


export type CreateRulesMutation = { __typename?: 'Mutation', createRules: Array<{ __typename?: 'Rule', id: string, condition: any, describedConditions?: string | null, triggerDescription: string, actionDescription: string, attributes?: Array<string> | null, createdAt: number, updatedAt: number, deletedAt?: number | null, metadata?: any | null, delay?: number | null, delayUnit?: string | null, offset?: number | null, offsetUnit?: string | null, trigger: { __typename?: 'RuleTrigger', id: string, name?: string | null, description?: string | null, describedForRule?: string | null, properties?: any | null }, action: { __typename?: 'RuleAction', id: string, name?: string | null, description: string, describedForRule?: string | null, properties?: any | null } }> };

export type UpdateRulesMutationVariables = Exact<{
  rules: Array<UpdateRuleInput> | UpdateRuleInput;
}>;


export type UpdateRulesMutation = { __typename?: 'Mutation', updateRules: Array<{ __typename?: 'Rule', id: string, condition: any, describedConditions?: string | null, triggerDescription: string, actionDescription: string, attributes?: Array<string> | null, createdAt: number, updatedAt: number, deletedAt?: number | null, metadata?: any | null, delay?: number | null, delayUnit?: string | null, offset?: number | null, offsetUnit?: string | null, trigger: { __typename?: 'RuleTrigger', id: string, name?: string | null, description?: string | null, describedForRule?: string | null, properties?: any | null }, action: { __typename?: 'RuleAction', id: string, name?: string | null, description: string, describedForRule?: string | null, properties?: any | null } }> };

export type DeleteRulesMutationVariables = Exact<{
  ruleIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteRulesMutation = { __typename?: 'Mutation', deleteRules: Array<string> };

export type RuleOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type RuleOptionsQuery = { __typename?: 'Query', ruleOptions: { __typename?: 'RuleOptions', triggers: Array<{ __typename?: 'RuleTrigger', id: string, name?: string | null, description?: string | null, properties?: any | null }>, actions: Array<{ __typename?: 'RuleAction', id: string, name?: string | null, description: string, properties?: any | null }> } };

export type CreateZonesMutationVariables = Exact<{
  parent: Scalars['String']['input'];
  zones: Array<ZoneInput> | ZoneInput;
}>;


export type CreateZonesMutation = { __typename?: 'Mutation', createZones: Array<{ __typename: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, description?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null }> };

export type UpdateZonesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  edit: ZoneInput;
  parent?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateZonesMutation = { __typename?: 'Mutation', updateZones: Array<{ __typename: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, description?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null }> };

export type DeleteAreaMutationVariables = Exact<{
  areaId: Scalars['String']['input'];
}>;


export type DeleteAreaMutation = { __typename?: 'Mutation', removeZones?: { __typename?: 'RemoveZonesOutput', zonesRemoved: number } | null };

export type GetCurrentZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCurrentZoneQuery = { __typename?: 'Query', currentZone: { __typename?: 'Zone', id: string } };

export type ListHistoryQueryVariables = Exact<{
  input?: InputMaybe<ListHistoryInput>;
}>;


export type ListHistoryQuery = { __typename?: 'Query', history?: { __typename?: 'HistoryPagination', total?: number | null, history?: Array<{ __typename?: 'History', id: string, text?: string | null, type?: string | null, ip?: string | null, createdAt?: number | null, vars?: any | null, related?: Array<{ __typename?: 'RelatedHistoryItem', name?: string | null, obj?: { __typename?: 'RelatedHistoryObject', id?: string | null, label?: string | null } | null } | null> | null }> | null } | null };

export type ListHistoryDataOnlyQueryVariables = Exact<{
  input?: InputMaybe<ListHistoryInput>;
}>;


export type ListHistoryDataOnlyQuery = { __typename?: 'Query', history?: { __typename?: 'HistoryPagination', history?: Array<{ __typename?: 'History', id: string, text?: string | null, type?: string | null, ip?: string | null, createdAt?: number | null, vars?: any | null, related?: Array<{ __typename?: 'RelatedHistoryItem', name?: string | null, obj?: { __typename?: 'RelatedHistoryObject', id?: string | null, label?: string | null } | null } | null> | null }> | null } | null };

export type InvoicesQueryVariables = Exact<{
  filter?: InputMaybe<InvoiceFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type InvoicesQuery = { __typename?: 'Query', invoices?: { __typename?: 'InvoicePage', skipped: number, limited: number, total?: number | null, invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }> } | null };

export type InvoiceDetailsQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
}>;


export type InvoiceDetailsQuery = { __typename?: 'Query', invoices?: { __typename?: 'InvoicePage', invoices: Array<{ __typename?: 'Invoice', metadata?: any | null, id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, signedUrl?: string | null, url?: string | null, metadata?: any | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null }, events: Array<{ __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }>, transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null }> }> } | null };

export type CreateInvoiceMutationVariables = Exact<{
  invoices: Array<CreateInvoiceInput> | CreateInvoiceInput;
}>;


export type CreateInvoiceMutation = { __typename?: 'Mutation', createInvoice?: { __typename?: 'CreateInvoiceOutput', invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> } | null };

export type SendInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type SendInvoicesMutation = { __typename?: 'Mutation', sendInvoices: { __typename?: 'SendInvoiceOutput', sent: boolean, updated: boolean } };

export type UpdateInvoicesMutationVariables = Exact<{
  invoices: Array<UpdateInvoiceInput> | UpdateInvoiceInput;
}>;


export type UpdateInvoicesMutation = { __typename?: 'Mutation', updateInvoices: boolean };

export type GetInvoiceLinksMutationVariables = Exact<{
  invoiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  role: Scalars['String']['input'];
}>;


export type GetInvoiceLinksMutation = { __typename?: 'Mutation', getLinks: Array<string> };

export type DeleteInvoicesMutationVariables = Exact<{
  invoiceIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteInvoicesMutation = { __typename?: 'Mutation', deleteInvoices: boolean };

export type JobPageListJobsQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type JobPageListJobsQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', total: number, skipped?: number | null, limited?: number | null, jobs: Array<{ __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, previousStages?: Array<{ __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null> | null, followingStages?: Array<{ __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null } | null> } };

export type JobsPageQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type JobsPageQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', skipped?: number | null, limited?: number | null, jobs: Array<{ __typename?: 'Job', firstBookedRevenueGeneratingEvent?: number | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null> } | null> } };

export type JobsPageCountQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  resolve?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type JobsPageCountQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', total: number } };

export type JobDetailsV2Fragment = { __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, fields?: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null } | null> | null, comments?: { __typename?: 'CommentPagination', total?: number | null, comments?: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }>, artifacts?: Array<{ __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber: number } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null };

export type JobsV2PageQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
  resolve: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type JobsV2PageQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', total: number, skipped?: number | null, limited?: number | null, jobs: Array<{ __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, fields?: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null } | null> | null, comments?: { __typename?: 'CommentPagination', total?: number | null, comments?: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }>, artifacts?: Array<{ __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber: number } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null } | null> } };

export type JobsV2GetEventQueryVariables = Exact<{
  eventId: Scalars['String']['input'];
}>;


export type JobsV2GetEventQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', total: number, skipped?: number | null, limited?: number | null, events: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, discountTotal?: number | null, taxTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, subTotal?: number | null, damageTotal?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, discountedAmount?: number | null, appliedCustomAmount?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type GenerateChargesWithAiQueryVariables = Exact<{
  input: GenerateChargesWithAiInput;
}>;


export type GenerateChargesWithAiQuery = { __typename?: 'Query', generateChargesWithAI: { __typename?: 'GenerateChargesWithAIOutput', crewSize?: number | null, crewSizeExplanation?: string | null, salesAgentInstructions: string, itinerary?: Array<{ __typename?: 'ItineraryItem', name?: string | null, location?: string | null, description?: string | null, type?: string | null, duration?: number | null } | null> | null, selectedProducts: Array<{ __typename?: 'SelectedProduct', id: string, priceId: string, reason: string, quantity: number, name: string }> } };

export type AssignCrewWithAiQueryVariables = Exact<{
  input: AssignCrewWithAiInput;
}>;


export type AssignCrewWithAiQuery = { __typename?: 'Query', assignCrewWithAI: { __typename?: 'AssignCrewWithAIOutput', reasoning: string, jobAssignments: Array<{ __typename?: 'JobAssignment', jobId: string, assignedMembers: Array<{ __typename?: 'AssignedMember', memberId: string, role: string, reasonForSelection: string }> }> } };

export type CreateNewJobMutationVariables = Exact<{
  zoneId?: InputMaybe<Scalars['String']['input']>;
  stage: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<JobUserInput>> | InputMaybe<JobUserInput>>;
  locations?: InputMaybe<Array<InputMaybe<JobLocationInput>> | InputMaybe<JobLocationInput>>;
  events?: InputMaybe<Array<InputMaybe<EventInput>> | InputMaybe<EventInput>>;
  newCustomers?: InputMaybe<Array<InputMaybe<CreateUserInputWithRole>> | InputMaybe<CreateUserInputWithRole>>;
  sendSelfSurvey?: InputMaybe<Scalars['Boolean']['input']>;
  fields?: InputMaybe<SetFieldsValuesInput>;
  currency?: InputMaybe<Scalars['String']['input']>;
  depositRequired?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  timeline?: InputMaybe<Scalars['String']['input']>;
  timelineDays?: InputMaybe<Scalars['Float']['input']>;
  jobCategory?: InputMaybe<Scalars['String']['input']>;
  closedReason?: InputMaybe<Scalars['String']['input']>;
  crewSummary?: InputMaybe<Scalars['Summary']['input']>;
  customerSummary?: InputMaybe<Scalars['Summary']['input']>;
  adminSummary?: InputMaybe<Scalars['Summary']['input']>;
}>;


export type CreateNewJobMutation = { __typename?: 'Mutation', createJob: { __typename?: 'Job', id: string, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null } };

export type LocationsQueryVariables = Exact<{
  filter?: InputMaybe<LocationsFilter>;
}>;


export type LocationsQuery = { __typename?: 'Query', locations: { __typename: 'LocationPagination', total?: number | null, skipped?: number | null, limited?: number | null, locations: Array<{ __typename: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, coordinates?: { __typename: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> } };

export type CreateLocationsMutationVariables = Exact<{
  input: LocationsCreateInput;
}>;


export type CreateLocationsMutation = { __typename?: 'Mutation', createLocations: { __typename?: 'LocationPagination', locations: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> } };

export type RemoveLocationsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveLocationsMutation = { __typename?: 'Mutation', removeLocations?: { __typename?: 'LocationDeleteOutput', removedLocations: Array<string | null> } | null };

export type EditLocationsMutationVariables = Exact<{
  ids: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  edit?: InputMaybe<LocationsEditInput>;
}>;


export type EditLocationsMutation = { __typename?: 'Mutation', editLocations: { __typename?: 'LocationEditOutput', editedLocations: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> } };

export type ListIntakeTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type ListIntakeTokensQuery = { __typename?: 'Query', tokens: { __typename?: 'ListTokensOutput', total?: number | null, nodes?: Array<{ __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, emails?: Array<string | null> | null, title?: string | null, validOn?: number | null, used?: number | null, maxUses?: number | null, metadata?: any | null, isValid?: boolean | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null } | null> | null } | null> | null } };

export type CreateLeadSourceTokenMutationVariables = Exact<{
  input: LeadSourceTokenInput;
}>;


export type CreateLeadSourceTokenMutation = { __typename?: 'Mutation', createLeadSourceToken: { __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, emails?: Array<string | null> | null, title?: string | null, validOn?: number | null, used?: number | null, maxUses?: number | null, metadata?: any | null, isValid?: boolean | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null } | null> | null } };

export type GetNiceJobsRefreshTokenQueryVariables = Exact<{
  code: Scalars['String']['input'];
}>;


export type GetNiceJobsRefreshTokenQuery = { __typename?: 'Query', getNiceJobsRefreshToken?: string | null };

export type DeleteProductsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  restore?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProductsMutation = { __typename?: 'Mutation', deleteProducts: boolean };

export type UpdateProductsMutationVariables = Exact<{
  products: Array<UpdateProductInput> | UpdateProductInput;
}>;


export type UpdateProductsMutation = { __typename?: 'Mutation', updateProducts: boolean };

export type AttentionItemsQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AttentionItemsFilter>;
}>;


export type AttentionItemsQuery = { __typename?: 'Query', attentionItems: { __typename?: 'ListAttentionItemsOutput', total: number, items: Array<{ __typename?: 'CalendarEvent', id: string, attentionScore?: number | null, attentionExplanation?: Array<string> | null, action?: string | null, type: string, start?: number | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } | { __typename?: 'Job', id: string, attentionScore?: number | null, attentionExplanation?: Array<string> | null, action?: string | null, stage: string, state?: string | null, code?: string | null, createdAt?: number | null, events?: Array<{ __typename?: 'CalendarEvent', id: string, title: string, status?: string | null, start?: number | null, type: string } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | { __typename?: 'User', id: string, attentionScore?: number | null, attentionExplanation?: Array<string> | null, action?: string | null, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null } | null> } };

export type AttentionItemsTotalQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<AttentionItemsFilter>;
}>;


export type AttentionItemsTotalQuery = { __typename?: 'Query', attentionItems: { __typename?: 'ListAttentionItemsOutput', total: number } };

export type AttentionItemsSummaryQueryVariables = Exact<{
  filter?: InputMaybe<AttentionItemsSummaryFilter>;
}>;


export type AttentionItemsSummaryQuery = { __typename?: 'Query', attentionItemsSummary: Array<{ __typename?: 'AttentionItemsSummary', attentionExplanation: string, items: number }> };

export type FullAvailabilityTemplateFragment = { __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null };

export type AvailabilityQueryVariables = Exact<{
  objectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  zone?: InputMaybe<Scalars['String']['input']>;
  excludeEvents?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type AvailabilityQuery = { __typename?: 'Query', availabilities: Array<{ __typename?: 'AvailabilityOutput', objectId: string, dayAvailability?: Array<{ __typename?: 'DayAvailability', date?: string | null, availability?: Array<{ __typename?: 'Availability', start: number, end: number } | null> | null }> | null } | null> };

export type FullAvailabilityConfigurationFragment = { __typename?: 'AvailabilityConfiguration', id?: string | null, objectId?: string | null, templates?: Array<{ __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null } | null> | null, overrides?: Array<{ __typename?: 'AvailabilityOverride', dates: Array<string>, template?: { __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null } | null } | null> | null };

export type ListAvailabilityConfigurationQueryVariables = Exact<{
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  zoneId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListAvailabilityConfigurationQuery = { __typename?: 'Query', availabilityConfigurations?: Array<{ __typename?: 'AvailabilityConfiguration', id?: string | null, objectId?: string | null, templates?: Array<{ __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null } | null> | null, overrides?: Array<{ __typename?: 'AvailabilityOverride', dates: Array<string>, template?: { __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null } | null } | null> | null } | null> | null };

export type UpdateAvailabilityConfigMutationVariables = Exact<{
  input: UpdateAvailabilityConfigurationInput;
}>;


export type UpdateAvailabilityConfigMutation = { __typename?: 'Mutation', updateAvailabilityConfiguration?: boolean | null };

export type AvailabilityTemplatesQueryVariables = Exact<{
  input?: InputMaybe<AvailabilityTemplateInput>;
}>;


export type AvailabilityTemplatesQuery = { __typename?: 'Query', availabilityTemplates?: Array<{ __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null }> | null };

export type CreateAvailabilityTemplateMutationVariables = Exact<{
  input: CreateAvailabilityTemplateInput;
}>;


export type CreateAvailabilityTemplateMutation = { __typename?: 'Mutation', createAvailabilityTemplate?: { __typename?: 'AvailabilityTemplate', id: string, name?: string | null, startDate?: string | null, endDate?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, availability?: { __typename?: 'AvailabilityByDayOfTheWeek', monday?: Array<number | null> | null, tuesday?: Array<number | null> | null, wednesday?: Array<number | null> | null, thursday?: Array<number | null> | null, friday?: Array<number | null> | null, saturday?: Array<number | null> | null, sunday?: Array<number | null> | null } | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null> | null } | null };

export type UpdateAvailabilityTemplateMutationVariables = Exact<{
  input: UpdateAvailabilityTemplateInput;
}>;


export type UpdateAvailabilityTemplateMutation = { __typename?: 'Mutation', updateAvailabilityTemplate?: boolean | null };

export type DeleteAvailabilityTemplatesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteAvailabilityTemplatesMutation = { __typename?: 'Mutation', deleteAvailabilityTemplates?: boolean | null };

export type CreateCalendarEventMutationVariables = Exact<{
  calendarEvents: Array<InputMaybe<CreateCalendarEventInput>> | InputMaybe<CreateCalendarEventInput>;
  effectSubZones?: InputMaybe<Scalars['Boolean']['input']>;
  skipTotalUpdate?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCalendarEventMutation = { __typename?: 'Mutation', createCalendarEvent: { __typename?: 'CalendarEventPagination', events: Array<{ __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type ListCalendarEventsQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListCalendarEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', total: number, skipped?: number | null, limited?: number | null, events: Array<{ __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type ListCalendarEventsForSelectEventQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListCalendarEventsForSelectEventQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', events: Array<{ __typename?: 'CalendarEvent', id: string, archivedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, sequentialOrder?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null }> } };

export type RemoveCalendarEventsMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  notifyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
  cancellationReason?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveCalendarEventsMutation = { __typename?: 'Mutation', removeCalendarEvent: boolean };

export type EditCalendarEventByIdMutationVariables = Exact<{
  edit: EditCalendarEventInput;
  id: Scalars['String']['input'];
}>;


export type EditCalendarEventByIdMutation = { __typename?: 'Mutation', editCalendarEvent: boolean };

export type ListChargesQueryVariables = Exact<{
  filter?: InputMaybe<ChargesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListChargesQuery = { __typename?: 'Query', charges: { __typename?: 'ChargesPagination', charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, job?: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null } | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> } };

export type CreateChargeMutationVariables = Exact<{
  charges: Array<CreateChargeInput> | CreateChargeInput;
  userId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateChargeMutation = { __typename?: 'Mutation', createCharges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null }> | null };

export type UpdateChargesMutationVariables = Exact<{
  charges: Array<ChargeUpdate> | ChargeUpdate;
}>;


export type UpdateChargesMutation = { __typename?: 'Mutation', updateCharges?: boolean | null };

export type CommentsQueryVariables = Exact<{
  filter?: InputMaybe<ListCommentFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type CommentsQuery = { __typename?: 'Query', comments: { __typename?: 'CommentPagination', total?: number | null, skipped?: number | null, limited?: number | null, comments?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null } };

export type ListCommentsWithRepliesQueryVariables = Exact<{
  filter?: InputMaybe<ListCommentFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sortBy?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListCommentsWithRepliesQuery = { __typename?: 'Query', comments: { __typename?: 'CommentPagination', total?: number | null, skipped?: number | null, limited?: number | null, comments?: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> | null } };

export type CreateCommentMutationVariables = Exact<{
  input?: InputMaybe<AddCommentInput>;
}>;


export type CreateCommentMutation = { __typename?: 'Mutation', addComment: { __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null } };

export type UpdateCommentsMutationVariables = Exact<{
  input?: InputMaybe<UpdateCommentInput>;
}>;


export type UpdateCommentsMutation = { __typename?: 'Mutation', updateComments: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> };

export type DeleteCommentsMutationVariables = Exact<{
  input?: InputMaybe<DeleteCommentInput>;
}>;


export type DeleteCommentsMutation = { __typename?: 'Mutation', deleteComments: { __typename?: 'DeleteCommentsOutput', commentsDeleted: Array<string> } };

export type ListExpensesQueryVariables = Exact<{
  filter?: InputMaybe<ExpensesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListExpensesQuery = { __typename?: 'Query', expenses: { __typename?: 'ExpensesPagination', expenses: Array<{ __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } | null> } };

export type LockWindowMutationVariables = Exact<{
  start: Scalars['Int']['input'];
  end: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  colour?: InputMaybe<Scalars['String']['input']>;
  topicIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  topicText?: InputMaybe<Scalars['String']['input']>;
  assetIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  jobId: Scalars['String']['input'];
  eventId?: InputMaybe<Scalars['String']['input']>;
  attributes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  locations?: InputMaybe<Array<InputMaybe<CalendarEventLocationInput>> | InputMaybe<CalendarEventLocationInput>>;
  overrideUnavailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  overrideAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  updateEventSequentialOrder?: InputMaybe<Scalars['Boolean']['input']>;
  modifyStartForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  modifyEndForTravel?: InputMaybe<Scalars['Boolean']['input']>;
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type LockWindowMutation = { __typename?: 'Mutation', lockWindow: { __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } };

export type FindQueryVariables = Exact<{
  timeWindow: WindowInput;
  usersFilter?: InputMaybe<UserSearch>;
  assetsFilter?: InputMaybe<AssetsFilter>;
  minNumUsers?: InputMaybe<Scalars['Int']['input']>;
  minNumAssets?: InputMaybe<Scalars['Int']['input']>;
  overrideAvailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  overrideUnavailabilities?: InputMaybe<Scalars['Boolean']['input']>;
  zoneInput?: InputMaybe<Scalars['String']['input']>;
  excludedEventIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type FindQuery = { __typename?: 'Query', find: { __typename?: 'FindOutput', windowCount: number, userCount: number, assetCount: number, windows: Array<{ __typename?: 'BookingWindow', start: number, end: number, startTimes: Array<number | null>, users: Array<{ __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null>, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, metadata?: any | null } | null> | null } | null> } };

export type CalculateDistanceQueryVariables = Exact<{
  locationIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startingTime?: InputMaybe<Scalars['Int']['input']>;
  units?: InputMaybe<Scalars['String']['input']>;
}>;


export type CalculateDistanceQuery = { __typename?: 'Query', calculateDistance?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null };

export type JobPromotedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type JobPromotedSubscription = { __typename?: 'Subscription', jobPromoted: { __typename?: 'JobPromotedOutput', jobId: string, reason: string } };

export type JobClosedSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type JobClosedSubscription = { __typename?: 'Subscription', jobClosed: { __typename?: 'JobClosedOutput', jobId: string, reason: string } };

export type JobChangedSubscriptionVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type JobChangedSubscription = { __typename?: 'Subscription', job: { __typename?: 'JobChangedEvent', jobId: string, action: string, time: number, input?: any | null, output?: any | null, sessionId?: string | null, actionId?: string | null, userId?: string | null, userName?: string | null, job?: { __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, fields?: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null } | null> | null, comments?: { __typename?: 'CommentPagination', total?: number | null, comments?: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }>, artifacts?: Array<{ __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber: number } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null } | null } };

export type JobDetailsQueryVariables = Exact<{
  jobId: Scalars['String']['input'];
  getDeleted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type JobDetailsQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', jobs: Array<{ __typename?: 'Job', id: string, code?: string | null, stage: string, state?: string | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, metadata?: any | null, attributes?: Array<string> | null, sharedZones?: Array<string | null> | null, tags: Array<{ __typename?: 'Tag', id: string, color?: string | null, category?: string | null, name: string } | null>, zone?: { __typename?: 'Zone', id: string, type?: string | null, name?: string | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, invoiceNumber: number }>, transactions?: Array<{ __typename?: 'Transaction', id: string, deletedAt?: number | null, stage: TransactionStage, type?: TransactionType | null, amount?: number | null, currency: string } | null> | null, events?: Array<{ __typename?: 'CalendarEvent', id: string, title: string, status?: string | null, start?: number | null, end?: number | null, sequentialOrder?: number | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string } | null> | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, attributes?: Array<string | null> | null, productName?: string | null, quantity: number, amount?: number | null, product?: { __typename?: 'Product', id: string, name: string } | null, price?: { __typename?: 'Price', id: string, amount: number, priceType?: PriceType | null } | null } | null>, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, givenName?: string | null, familyName?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'JobLocation', locationId?: string | null, locationType?: string | null, location?: { __typename?: 'Location', id: string, addressLineOne?: string | null, addressLineTwo?: string | null, areaCode?: string | null, city?: string | null, country?: string | null } | null } | null> | null } | null> } };

export type UpdateJobArchivedMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  archived: Scalars['Boolean']['input'];
}>;


export type UpdateJobArchivedMutation = { __typename?: 'Mutation', updateJobs: { __typename?: 'UpdateJobsOutput', isSuccess: boolean, transitionedJobs?: Array<{ __typename?: 'TransitionedJob', oldJobId: string, newJobId: string } | null> | null } };

export type UpdateJobMutationVariables = Exact<{
  updateJobs: Array<InputMaybe<UpdateJobInput>> | InputMaybe<UpdateJobInput>;
}>;


export type UpdateJobMutation = { __typename?: 'Mutation', updateJobs: { __typename?: 'UpdateJobsOutput', isSuccess: boolean, jobs?: Array<{ __typename?: 'Job', sharedZones?: Array<string | null> | null, id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null, metadata?: any | null, fields?: Array<{ __typename?: 'Field', id: string, name: string, type: string, values?: Array<{ __typename?: 'FieldObjectValue', objectId?: string | null, value?: any | null, isDefault?: boolean | null }> | null } | null> | null, comments?: { __typename?: 'CommentPagination', total?: number | null, comments?: Array<{ __typename?: 'Comment', replyIds?: Array<string> | null, id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, thread?: { __typename?: 'CommentThread', metadata?: any | null, mode?: string | null, subject?: string | null, id: string } | null, replies?: Array<{ __typename?: 'Comment', id: string, text: string, contents?: string | null, requiredAccessLevel?: Access_Type | null, system?: boolean | null, authorName?: string | null, isReply?: boolean | null, attributes?: Array<string> | null, createdAt: number, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, metadata?: any | null, zoneIds?: Array<string> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null, thread?: { __typename?: 'CommentThread', id: string, mode?: string | null } | null }> | null, author?: { __typename?: 'User', id: string, familyName?: string | null, givenName?: string | null } | null }> | null } | null, invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, artifacts?: Array<{ __typename?: 'Artifact', id: string, name: string, contentType: string, attributes?: Array<string | null> | null, metadata?: any | null, url?: string | null, signedUrl?: string | null } | null> | null, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }>, artifacts?: Array<{ __typename?: 'Artifact', id: string, attributes?: Array<string | null> | null, name: string, namespace: string, fileSize: number, contentType: string, public: boolean, author?: string | null, signedPolicy?: string | null, signedUrl?: string | null, url?: string | null, createdAt: number, metadata?: any | null }> | null, transactions?: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, invoiceNumber: number } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> | null, distances?: { __typename?: 'RouteDistances', start_end?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, dock_start?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, start_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null, end_dock?: { __typename?: 'CalculateDistanceOutput', averageTime?: number | null, estimatedTime?: number | null, totalDistance?: number | null, distanceUnits?: string | null, flagTrip?: boolean | null, distances?: Array<{ __typename?: 'Distance', startLocation?: string | null, endLocation?: string | null, averageTime?: number | null, estimatedTime?: number | null, distance?: number | null, distanceUnits?: string | null } | null> | null } | null } | null, locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null, charges: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null>, events?: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, damageTotal?: number | null, discountTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, taxTotal?: number | null, expenseTotal?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null } | null> | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, color?: string | null, category?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null } | null>, zone?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', timezone: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, discountedAmount?: number | null, appliedCustomAmount?: number | null, redeemedAt?: number | null, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null, event?: { __typename?: 'CalendarEvent', id: string, type: string, end?: number | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null } | null } | null> | null, taxesPaid?: Array<{ __typename?: 'TaxPaid', paid: number, tax: { __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } }> | null } | null> | null } };

export type DeleteJobMutationVariables = Exact<{
  jobIds: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type DeleteJobMutation = { __typename?: 'Mutation', deleteJobs: boolean };

export type SendDocumentMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  recipientRole: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type SendDocumentMutation = { __typename?: 'Mutation', sendDocument: boolean };

export type ResendDocumentMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  message?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResendDocumentMutation = { __typename?: 'Mutation', resendDocument: boolean };

export type ListPermissionsQueryVariables = Exact<{
  input?: InputMaybe<ListPermissionsInput>;
}>;


export type ListPermissionsQuery = { __typename?: 'Query', permissions: { __typename: 'ListPermissionsResult', map?: Array<{ __typename: 'Permission', permission: string, mappedPermission?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, zone: string, role: string, zoneDepth: number, restrictions?: string | null }> | null } };

export type CreatePricesMutationVariables = Exact<{
  prices: Array<CreatePriceInput> | CreatePriceInput;
  zoneId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreatePricesMutation = { __typename?: 'Mutation', createPrices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, metadata?: any | null, product: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null }, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null } | null> };

export type UpdatePricesMutationVariables = Exact<{
  prices: Array<UpdatePriceInput> | UpdatePriceInput;
  effectExistingCharges?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdatePricesMutation = { __typename?: 'Mutation', updatePrices: boolean };

export type DeletePricesMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
  restore?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeletePricesMutation = { __typename?: 'Mutation', deletePrices: boolean };

export type ListPricesQueryVariables = Exact<{
  filter?: InputMaybe<PricesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListPricesQuery = { __typename?: 'Query', prices: { __typename?: 'PricesPagination', prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, metadata?: any | null, product: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null }, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null } | null> } };

export type ListProductsQueryVariables = Exact<{
  filter?: InputMaybe<ProductsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  pricesFilter?: InputMaybe<PricesFilter>;
}>;


export type ListProductsQuery = { __typename?: 'Query', products: { __typename?: 'ProductsPagination', total: number, skipped?: number | null, limited?: number | null, products: Array<{ __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null, prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, name?: string | null, color?: string | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null }>, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null> } };

export type ListProductsForEstimatingQueryVariables = Exact<{
  filter?: InputMaybe<ProductsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  pricesFilter?: InputMaybe<PricesFilter>;
}>;


export type ListProductsForEstimatingQuery = { __typename?: 'Query', products: { __typename?: 'ProductsPagination', total: number, skipped?: number | null, limited?: number | null, products: Array<{ __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null, prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null }>, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null> } };

export type CreateProductsMutationVariables = Exact<{
  products: Array<CreateProductInput> | CreateProductInput;
}>;


export type CreateProductsMutation = { __typename?: 'Mutation', createProducts: Array<{ __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null> };

export type TagsQueryVariables = Exact<{
  filter?: InputMaybe<TagFilter>;
  order?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagsQuery = { __typename?: 'Query', tags: { __typename?: 'TagResult', total?: number | null, tags: Array<{ __typename?: 'Tag', id: string, name: string, objectType: string, category?: string | null, color?: string | null, private?: boolean | null, attributes?: Array<string> | null, order?: number | null }> } };

export type AddTagsToObjectsMutationVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  objects: Array<Scalars['String']['input']> | Scalars['String']['input'];
  private?: InputMaybe<Scalars['Boolean']['input']>;
  order?: InputMaybe<Scalars['Float']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type AddTagsToObjectsMutation = { __typename?: 'Mutation', addTagsToObjects: { __typename?: 'UseObjectTagResult', tags: Array<string>, objects: Array<string> } };

export type RemoveTagsFromObjectsMutationVariables = Exact<{
  tags: Array<Scalars['String']['input']> | Scalars['String']['input'];
  objects: Array<Scalars['String']['input']> | Scalars['String']['input'];
  objectLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type RemoveTagsFromObjectsMutation = { __typename?: 'Mutation', removeTagsFromObjects: { __typename?: 'UseObjectTagResult', tags: Array<string>, objects: Array<string> } };

export type SetTagsOnObjectMutationVariables = Exact<{
  filter?: InputMaybe<TagFilter>;
  tags?: InputMaybe<Array<InputMaybe<TagRelationship>> | InputMaybe<TagRelationship>>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SetTagsOnObjectMutation = { __typename?: 'Mutation', tags: { __typename?: 'TagMutator', setObjectTags?: boolean | null } };

export type ListTaxesQueryVariables = Exact<{
  filter?: InputMaybe<TaxesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListTaxesQuery = { __typename?: 'Query', taxes: { __typename?: 'ListTaxesOutput', total?: number | null, skipped?: number | null, limited?: number | null, taxes: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } | null> } };

export type QuillTemplateFieldsFragment = { __typename?: 'QuillTemplate', id: string, name?: string | null, contents?: string | null, location?: QuillTemplateLocation | null, isDefault?: boolean | null, subjectContents?: string | null, zoneId?: string | null };

export type AddQuillTemplateMutationVariables = Exact<{
  input: AddQuillTemplateInput;
}>;


export type AddQuillTemplateMutation = { __typename?: 'Mutation', addQuillTemplate: { __typename?: 'AddQuillTemplateOutput', template: { __typename?: 'QuillTemplate', id: string, name?: string | null, contents?: string | null, location?: QuillTemplateLocation | null, isDefault?: boolean | null, subjectContents?: string | null, zoneId?: string | null } } };

export type UpdateQuillTemplateMutationVariables = Exact<{
  input: UpdateQuillTemplateInput;
}>;


export type UpdateQuillTemplateMutation = { __typename?: 'Mutation', updateQuillTemplate: { __typename?: 'UpdateQuillTemplateOutput', templates?: Array<{ __typename?: 'QuillTemplate', id: string, name?: string | null, contents?: string | null, location?: QuillTemplateLocation | null, isDefault?: boolean | null, subjectContents?: string | null, zoneId?: string | null }> | null } };

export type DeleteQuillTemplateMutationVariables = Exact<{
  input: DeleteQuillTemplateInput;
}>;


export type DeleteQuillTemplateMutation = { __typename?: 'Mutation', deleteQuillTemplate: { __typename?: 'DeleteQuillTemplatesOutput', templatesDeleted: Array<string> } };

export type ListQuillTemplatesQueryVariables = Exact<{
  filter?: InputMaybe<ListTemplatesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListQuillTemplatesQuery = { __typename?: 'Query', templates: { __typename?: 'QuillTemplatesPagination', total?: number | null, skipped?: number | null, limited?: number | null, templates?: Array<{ __typename?: 'QuillTemplate', id: string, name?: string | null, contents?: string | null, location?: QuillTemplateLocation | null, isDefault?: boolean | null, subjectContents?: string | null, zoneId?: string | null }> | null } };

export type BaseCompanyInfoFragment = { __typename?: 'CompanyInfo', CompanyName: string, LegalName: string, Country: string, CompanyAddr?: { __typename?: 'QuickbooksAddress', Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string } | null, LegalAddr?: { __typename?: 'QuickbooksAddress', Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string } | null, PrimaryPhone?: { __typename?: 'Phone', FreeFormNumber?: string | null } | null, Email: { __typename?: 'QuickbooksEmailAddress', Address: string }, WebAddr?: { __typename?: 'WebAddress', URI?: string | null } | null, NameValue: Array<{ __typename?: 'NameValuePair', Name: string, Value: string }> };

export type BaseQuickbooksAddressFragment = { __typename?: 'QuickbooksAddress', Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string };

export type BaseQuickbooksAccountFragment = { __typename?: 'QuickbooksAccount', Id: string, AccountType: string, AccountSubType?: string | null, CurrentBalance: number, Active: boolean, FullQualifiedName?: string | null, Name: string };

export type BaseQuickbooksItemFragment = { __typename?: 'QuickbooksItem', FullyQualifiedName: string, Name: string, Type: string, Taxable: boolean, sparse: boolean, Active: boolean, UnitPrice: number, Id: string, Description?: string | null };

export type BaseQuickbooksTaxCodeFragment = { __typename?: 'QuickbooksTaxCode', Name: string, Description?: string | null, Active: boolean, Hidden?: boolean | null, Taxable: boolean, TaxGroup: boolean, domain: string, sparse: boolean, Id: string };

export type QuickbooksTaxCodeWithSalesTaxListFragment = { __typename?: 'QuickbooksTaxCode', Name: string, Description?: string | null, Active: boolean, Hidden?: boolean | null, Taxable: boolean, TaxGroup: boolean, domain: string, sparse: boolean, Id: string, SalesTaxRateList: { __typename?: 'QuickbooksTaxRateList', TaxRateDetail: Array<{ __typename?: 'QuickbooksTaxRateDetail', TaxRateRef: { __typename?: 'ReferenceType', value: string } }> } };

export type QuickbooksAuthUriQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksAuthUriQuery = { __typename?: 'Query', quickbooksAuthUri: string };

export type CompanyInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type CompanyInfoQuery = { __typename?: 'Query', companyInfo: { __typename?: 'CompanyInfo', CompanyName: string, LegalName: string, Country: string, CompanyAddr?: { __typename?: 'QuickbooksAddress', Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string } | null, LegalAddr?: { __typename?: 'QuickbooksAddress', Line1: string, City: string, CountrySubDivisionCode: string, PostalCode: string } | null, PrimaryPhone?: { __typename?: 'Phone', FreeFormNumber?: string | null } | null, Email: { __typename?: 'QuickbooksEmailAddress', Address: string }, WebAddr?: { __typename?: 'WebAddress', URI?: string | null } | null, NameValue: Array<{ __typename?: 'NameValuePair', Name: string, Value: string }> } };

export type QuickbooksAccountsQueryVariables = Exact<{
  filter: QuickbooksAccountFilter;
}>;


export type QuickbooksAccountsQuery = { __typename?: 'Query', quickbooksAccounts: Array<{ __typename?: 'QuickbooksAccount', Id: string, AccountType: string, AccountSubType?: string | null, CurrentBalance: number, Active: boolean, FullQualifiedName?: string | null, Name: string }> };

export type QuickbooksItemsQueryVariables = Exact<{
  filter: QuickbooksItemFilter;
}>;


export type QuickbooksItemsQuery = { __typename?: 'Query', quickbooksItems: Array<{ __typename?: 'QuickbooksItem', FullyQualifiedName: string, Name: string, Type: string, Taxable: boolean, sparse: boolean, Active: boolean, UnitPrice: number, Id: string, Description?: string | null }> };

export type QuickbooksTaxCodesQueryVariables = Exact<{ [key: string]: never; }>;


export type QuickbooksTaxCodesQuery = { __typename?: 'Query', quickbooksTaxCodes: Array<{ __typename?: 'QuickbooksTaxCode', Name: string, Description?: string | null, Active: boolean, Hidden?: boolean | null, Taxable: boolean, TaxGroup: boolean, domain: string, sparse: boolean, Id: string, SalesTaxRateList: { __typename?: 'QuickbooksTaxRateList', TaxRateDetail: Array<{ __typename?: 'QuickbooksTaxRateDetail', TaxRateRef: { __typename?: 'ReferenceType', value: string } }> } }> };

export type DisconnectFromQuickbooksMutationVariables = Exact<{ [key: string]: never; }>;


export type DisconnectFromQuickbooksMutation = { __typename?: 'Mutation', disconnectFromQuickbooks: boolean };

export type ExportInvoiceToQuickbooksMutationVariables = Exact<{
  invoiceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type ExportInvoiceToQuickbooksMutation = { __typename?: 'Mutation', exportInvoiceToQuickbooks: string };

export type CreateScheduledReportMutationVariables = Exact<{
  input: CreateScheduledReportInput;
}>;


export type CreateScheduledReportMutation = { __typename?: 'Mutation', createScheduledReport: { __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } };

export type DeleteScheduledReportsMutationVariables = Exact<{
  input: DeleteScheduledReportInput;
}>;


export type DeleteScheduledReportsMutation = { __typename?: 'Mutation', deleteScheduledReports: { __typename?: 'DeleteScheduledReportOutput', deleted: Array<string> } };

export type UpdateScheduledReportsMutationVariables = Exact<{
  input: UpdateScheduledReportInput;
}>;


export type UpdateScheduledReportsMutation = { __typename?: 'Mutation', updateScheduledReports: Array<{ __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> };

export type ReportDetailsListQueryVariables = Exact<{
  filter?: InputMaybe<ReportsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  getData?: InputMaybe<Array<ReportGetDataOptions> | ReportGetDataOptions>;
}>;


export type ReportDetailsListQuery = { __typename?: 'Query', reports: { __typename?: 'ListReportsOutput', reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', variableSchema: string, returnValue?: string | null, columns?: Array<any> | null, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null }> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, scheduledReport?: { __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } | null }> } };

export type ReportPageListQueryVariables = Exact<{
  filter?: InputMaybe<ReportsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  getData?: InputMaybe<Array<ReportGetDataOptions> | ReportGetDataOptions>;
}>;


export type ReportPageListQuery = { __typename?: 'Query', reports: { __typename?: 'ListReportsOutput', reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, csv?: string | null, jsonURL?: string | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null }> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> } };

export type ReportTypePageListQueryVariables = Exact<{
  filter?: InputMaybe<ReportTypesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
  reportsSkip?: InputMaybe<Scalars['Int']['input']>;
  reportsLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ReportTypePageListQuery = { __typename?: 'Query', reportTypes: { __typename?: 'ListReportTypesOutput', reportTypes: Array<{ __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string, returnValue?: string | null, columns?: Array<any> | null, reports: { __typename?: 'ListReportsOutput', total?: number | null, skipped?: number | null, limited?: number | null, reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> }, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> } };

export type ListScheduledReportsQueryVariables = Exact<{
  filter?: InputMaybe<ScheduledReportsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListScheduledReportsQuery = { __typename?: 'Query', scheduledReports: { __typename?: 'ListScheduledReportsOutput', scheduledReports?: Array<{ __typename?: 'ScheduledReport', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, notifyUsers?: Array<string> | null, notifyRoles?: Array<string> | null, webhooks?: Array<string> | null, name: string, variables?: string | null, nextRun?: number | null, lastRun?: number | null, attributes?: Array<string> | null, start?: number | null, end?: number | null, time: string, tz?: string | null, saveData?: boolean | null, reportType?: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string } | null, dynamicReport?: { __typename?: 'DynamicReport', id: string, name: string, description: string, dataColumns?: Array<string> | null, aggregationColumns?: Array<string> | null, sort?: string | null, start?: number | null, end?: number | null, period: string, periodType: string, groupBy: string, filter?: string | null } | null, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> | null } };

export type ReportTypesListQueryVariables = Exact<{
  filter?: InputMaybe<ReportTypesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReportTypesListQuery = { __typename?: 'Query', reportTypes: { __typename?: 'ListReportTypesOutput', total?: number | null, reportTypes: Array<{ __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> } };

export type CreateExportTokenMutationVariables = Exact<{
  reportTypeId: Scalars['String']['input'];
}>;


export type CreateExportTokenMutation = { __typename?: 'Mutation', createExportToken: { __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, title?: string | null, isValid?: boolean | null, used?: number | null, metadata?: any | null } };

export type CalendarEventDetailsQueryVariables = Exact<{
  calendarEventId: Scalars['String']['input'];
}>;


export type CalendarEventDetailsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', total: number, skipped?: number | null, limited?: number | null, events: Array<{ __typename?: 'CalendarEvent', discountedSubTotalWithoutDamages?: number | null, damageTotal?: number | null, subTotal?: number | null, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, expenseTotal?: number | null, currency?: string | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type NotifyMutationVariables = Exact<{
  type: Scalars['String']['input'];
  users?: InputMaybe<Array<InputMaybe<NotifyUserInput>> | InputMaybe<NotifyUserInput>>;
  roleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  data?: InputMaybe<Scalars['NotificationDataInput']['input']>;
  eventId?: InputMaybe<Scalars['String']['input']>;
  onReply?: InputMaybe<Scalars['String']['input']>;
}>;


export type NotifyMutation = { __typename?: 'Mutation', notify: boolean };

export type ScheduleQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  objectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  zone?: InputMaybe<Scalars['String']['input']>;
}>;


export type ScheduleQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', events: Array<{ __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> }, availabilities: Array<{ __typename?: 'AvailabilityOutput', objectId: string, dayAvailability?: Array<{ __typename?: 'DayAvailability', date?: string | null, availability?: Array<{ __typename?: 'Availability', start: number, end: number } | null> | null }> | null } | null> };

export type ScheduleEventsQueryVariables = Exact<{
  filter?: InputMaybe<CalendarEventsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ScheduleEventsQuery = { __typename?: 'Query', calendarEvents: { __typename?: 'CalendarEventPagination', events: Array<{ __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type AvailabiltiesQueryVariables = Exact<{
  objectIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  startDate: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
}>;


export type AvailabiltiesQuery = { __typename?: 'Query', availabilities: Array<{ __typename: 'AvailabilityOutput', objectId: string, dayAvailability?: Array<{ __typename: 'DayAvailability', date?: string | null, availability?: Array<{ __typename: 'Availability', start: number, end: number } | null> | null }> | null } | null> };

export type AvailableZoneFragment = { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, contextableRoles: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null }>, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null };

export type AvailableZonesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  objectLabel?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvailableZonesQuery = { __typename?: 'Query', availableZones?: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, contextableRoles: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null }>, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null }> | null };

export type AvailableZonesAndCurrentZoneQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
}>;


export type AvailableZonesAndCurrentZoneQuery = { __typename?: 'Query', availableZones?: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, contextableRoles: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null }>, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null }> | null, currentZone: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null } };

export type FullPermissionFragment = { __typename: 'Permission', permission: string, mappedPermission?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, zone: string, role: string, zoneDepth: number, restrictions?: string | null };

export type BaseCommentModeFragment = { __typename?: 'CommentMode', id: string, name: string, icon?: string | null, system?: boolean | null, description?: string | null, hidden?: boolean | null, showSubject?: boolean | null };

export type CurrentBrandingQueryVariables = Exact<{
  zoneId?: InputMaybe<Scalars['String']['input']>;
  features: Array<Scalars['String']['input']> | Scalars['String']['input'];
  configKeys: Array<ZoneConfigKey> | ZoneConfigKey;
  filter?: InputMaybe<ProductsFilter>;
  pricesFilter?: InputMaybe<PricesFilter>;
  templatesFilter?: InputMaybe<ListTemplatesFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type CurrentBrandingQuery = { __typename?: 'Query', features: Array<string>, branding: { __typename?: 'ZoneBranding', appName: string, shortName: string, ico: string, notice?: string | null, iconLight48: string, iconLight64: string, iconLight128: string, iconLight196: string, iconLight256: string, iconLight512: string, iconLight1024: string, iconLightWide: string, iconDark48: string, iconDark64: string, iconDark128: string, iconDark196: string, iconDark256: string, iconDark512: string, iconDark1024: string, iconDarkWide: string, website: string, companyName: string, primaryColor?: string | null, secondaryColor?: string | null, timezone: string, country: string, language: string, email: string, zoneCode?: string | null, zoneId: string, status: string }, permissions: { __typename: 'ListPermissionsResult', permissions: Array<{ __typename: 'Permission', permission: string, mappedPermission?: string | null, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, zone: string, role: string, zoneDepth: number, restrictions?: string | null }> }, getZoneConfigValues?: { __typename?: 'ZoneConfigValue', INVOICE_DISABLEMULTIPLEEVENTS?: boolean | null, JOBS_HOWHEARDOPTIONS?: Array<string | null> | null, JOBS_HOWHEARDMANDATORY?: boolean | null, JOBS_ORIGINS?: any | null, CUSTOMER_TYPES?: any | null, JOBS_DWELLINGTYPEMANDATORY?: boolean | null, JOBS_BEDROOMSMANDATORY?: boolean | null, ROLE_CUSTOMER?: string | null, YEMBO__INTEGRATION_ENABLED?: boolean | null, FRANCHISE__INFO_DOCKLOCATIONID?: string | null, CALENDAREVENTS_ESTIMATELENGTH?: number | null, CALENDAREVENTS_VIRTUALESTIMATELENGTH?: number | null, ROLLING__LOCK__DATE_CURRENTDATE?: number | null, FIND_STARTTIMEINTERVAL?: number | null, CALENDAREVENTS_INCLUDEDOCKTRAVELTIME?: boolean | null, CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX?: boolean | null, CALENDAREVENTS_DEPOSITMINTOBOOK?: number | null, PRICINGENGINE_ENABLED?: boolean | null, JOBS_CLOSEDREASONS?: Array<{ __typename?: 'Jobs_ClosedReasons', id?: string | null, title?: string | null, stages?: Array<string | null> | null } | null> | null, INVENTORY_ITEMS?: Array<{ __typename?: 'Inventory_Items', reviewerName?: string | null, label?: string | null, volume?: string | null, weight?: string | null, isoCode1?: string | null, isoCode2?: string | null, isoCode3?: string | null, isBulky?: boolean | null, isValuable?: boolean | null, isSpecialEquipment?: boolean | null, is3rdPartyServicing?: boolean | null, isProGear?: boolean | null, isAssembleDisassemble?: boolean | null } | null> | null } | null, products: { __typename?: 'ProductsPagination', total: number, skipped?: number | null, limited?: number | null, products: Array<{ __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null, prices: Array<{ __typename?: 'Price', id: string, name?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, active: boolean, amount: number, priceType?: PriceType | null, currency: string, attributes?: Array<string | null> | null, zone?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, taxes?: Array<{ __typename?: 'Tax', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, type: string, active: boolean, isZoneDefault: boolean, percentage: number, name: string, description?: string | null, attributes?: Array<string> | null }> | null, expensesV2?: Array<{ __typename?: 'PriceExpense', unitCost: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null }>, zones: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null> }, commentModes?: Array<{ __typename?: 'CommentMode', id: string, name: string, icon?: string | null, system?: boolean | null, description?: string | null, hidden?: boolean | null, showSubject?: boolean | null }> | null, templates: { __typename?: 'QuillTemplatesPagination', total?: number | null, skipped?: number | null, limited?: number | null, templates?: Array<{ __typename?: 'QuillTemplate', id: string, name?: string | null, contents?: string | null, location?: QuillTemplateLocation | null, isDefault?: boolean | null, subjectContents?: string | null, zoneId?: string | null }> | null } };

export type CurrentZoneQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentZoneQuery = { __typename?: 'Query', currentZone: { __typename?: 'Zone', domain: string, id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null } };

export type CreateReportMutationVariables = Exact<{
  waitForCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  input: CreateReportInput;
}>;


export type CreateReportMutation = { __typename?: 'Mutation', createReport: { __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, csv?: string | null, jsonURL?: string | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, aggregations?: Array<{ __typename?: 'ReportAggregationResult', id: string, title?: string | null, type?: string | null, key?: string | null, secondaryType?: string | null, otherKeys?: Array<string> | null, values?: any | null, labels?: Array<string | null> | null, error?: string | null, format?: string | null, options?: any | null }> | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null } };

export type GetReportDataQueryVariables = Exact<{
  filter?: InputMaybe<ReportsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetReportDataQuery = { __typename?: 'Query', reports: { __typename?: 'ListReportsOutput', reports: Array<{ __typename?: 'Report', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, version?: number | null, name: string, variables?: string | null, status: ReportStatus, error?: string | null, saveData?: boolean | null, saveReport?: boolean | null, saveAggregations?: boolean | null, csv?: string | null, jsonURL?: string | null, reportType: { __typename?: 'ReportType', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, attributes?: Array<string> | null, description?: string | null, version?: number | null, variableSchema: string }, createdBy?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null }> } };

export type RolesQueryVariables = Exact<{
  search?: InputMaybe<RoleSearch>;
}>;


export type RolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> };

export type TawkToSecretQueryVariables = Exact<{ [key: string]: never; }>;


export type TawkToSecretQuery = { __typename?: 'Query', tawkToSecret?: string | null };

export type AssignRolesMutationVariables = Exact<{
  users: Array<Scalars['String']['input']> | Scalars['String']['input'];
  roles: Array<Scalars['String']['input']> | Scalars['String']['input'];
  inheritZones?: InputMaybe<Scalars['Boolean']['input']>;
  unassignMissing?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AssignRolesMutation = { __typename?: 'Mutation', assignRoles: { __typename?: 'AssignRolesOutput', usersAssigned: Array<string>, rolesAssigned: Array<string>, rolesRemoved: Array<string>, zonesAssigned: Array<string> } };

export type CreateUserMutationVariables = Exact<{
  roles?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  zones?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  inheritRoleZones?: InputMaybe<Scalars['Boolean']['input']>;
  sendInvite?: InputMaybe<Scalars['Boolean']['input']>;
  users?: InputMaybe<Array<CreateUserInput> | CreateUserInput>;
}>;


export type CreateUserMutation = { __typename?: 'Mutation', createUsers: { __typename: 'CreateUserResult', total?: number | null, failedUsers?: Array<{ __typename: 'FailedUserInput', error?: string | null, user?: { __typename: 'FailedUser', email?: string | null } | null } | null> | null, users?: Array<{ __typename: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, roles?: Array<{ __typename: 'Role', id: string, name: string }> | null, zones?: { __typename: 'ListZonesOutput', nodes: Array<{ __typename: 'Zone', id: string, name?: string | null } | null> } | null } | null> | null } };

export type EditProfileMutationVariables = Exact<{
  id: Scalars['String']['input'];
  givenName?: InputMaybe<Scalars['String']['input']>;
  familyName?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<LocationCreateBase>;
  salary?: InputMaybe<Scalars['Int']['input']>;
  shiftAvailability?: InputMaybe<Scalars['String']['input']>;
  zoneIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type EditProfileMutation = { __typename?: 'Mutation', users: { __typename?: 'UserMutator', setProfile: number } };

export type CreateYemboMoveMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
}>;


export type CreateYemboMoveMutation = { __typename?: 'Mutation', createYemboMove: { __typename?: 'CreateYemboMoveOutput', customerLink: string, employeeLink: string } };

export type CreateYemboSelfSurveyMutationVariables = Exact<{
  jobId: Scalars['String']['input'];
  sendEmail?: InputMaybe<Scalars['Boolean']['input']>;
  sendSms?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateYemboSelfSurveyMutation = { __typename?: 'Mutation', createYemboSelfSurvey: { __typename?: 'CreateYemboSelfSurveyOutput', link: string, employeeLink?: string | null } };

export type ListBaseZonesQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListBaseZonesQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null };

export type ListZonesWithParentsQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListZonesWithParentsQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }> } | null> } | null };

export type ListZonesWithChildrenQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListZonesWithChildrenQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } } | null> } | null };

export type ListZonesWithFamilyQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListZonesWithFamilyQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, parent?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, parents: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null }>, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } } | null> } | null };

export type ListZonesWithAreasQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  deepResolveObjects?: InputMaybe<Scalars['Boolean']['input']>;
  objectFilter?: InputMaybe<ListZonesObjectFilter>;
}>;


export type ListZonesWithAreasQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, areas?: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> | null } | null> } | null };

export type ListZonesWithAreasAndChildrenQueryVariables = Exact<{
  filter?: InputMaybe<ListZonesFilter>;
  sort?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ListZonesWithAreasAndChildrenQuery = { __typename?: 'Query', zones?: { __typename?: 'ListZonesOutput', total: number, nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null, areas?: Array<{ __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null> | null, children: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } } | null> } | null };

export type BaseConfigValueFragment = { __typename?: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null };

export type ZoneConfigStringFragment = { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null };

export type ZoneConfigValueFloatFragment = { __typename?: 'Config_Float', id?: string | null, key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_Float', key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_Float', key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null }> | null };

export type QuickBooksConfigValuesFragment = { __typename?: 'ZoneConfigValue', QUICKBOOKS_ENABLED?: boolean | null, QUICKBOOKS_PRODUCT__MAP?: any | null, QUICKBOOKS_TAXCODE__MAP?: any | null };

export type ConfigValueWithOverridingConfigsFragment = { __typename?: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null };

export type GetConfigValuesQueryVariables = Exact<{
  omitZone?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetConfigValuesQuery = { __typename?: 'Query', getConfigValues?: Array<{ __typename: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null }> | null };

export type GetConfigValuesWithOverridingConfigsQueryVariables = Exact<{
  omitZone?: InputMaybe<Scalars['Boolean']['input']>;
  keys?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetConfigValuesWithOverridingConfigsQuery = { __typename?: 'Query', getConfigValues?: Array<{ __typename?: 'ConfigValue', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null }> | null };

export type SetConfigValuesMutationVariables = Exact<{
  omitZone?: InputMaybe<Scalars['Boolean']['input']>;
  configs: Array<ConfigValueInput> | ConfigValueInput;
}>;


export type SetConfigValuesMutation = { __typename?: 'Mutation', setConfigValues?: Array<{ __typename: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'ConfigValue', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null }> | null };

export type ClearConfigValuesMutationVariables = Exact<{
  keys?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type ClearConfigValuesMutation = { __typename?: 'Mutation', clearConfigValues: boolean };

export type GetQuickBooksConfigQueryVariables = Exact<{
  keys: Array<ZoneConfigKey> | ZoneConfigKey;
}>;


export type GetQuickBooksConfigQuery = { __typename?: 'Query', getZoneConfigValues?: { __typename?: 'ZoneConfigValue', QUICKBOOKS_ENABLED?: boolean | null, QUICKBOOKS_PRODUCT__MAP?: any | null, QUICKBOOKS_TAXCODE__MAP?: any | null } | null };

export type GetEstimatorRestrictionCodeConfigQueryVariables = Exact<{
  keys: Array<ZoneConfigKey> | ZoneConfigKey;
}>;


export type GetEstimatorRestrictionCodeConfigQuery = { __typename?: 'Query', getZoneConfigValues?: { __typename?: 'ZoneConfigValue', ESTIMATOR_RESTRICTIONCODE?: string | null } | null };

export type GetRollingLockDateConfigsQueryVariables = Exact<{
  keys: Array<ZoneConfigKey> | ZoneConfigKey;
  getOverridingConfigs?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRollingLockDateConfigsQuery = { __typename?: 'Query', getZoneConfigs?: { __typename?: 'ZoneConfig', ROLLING__LOCK__DATE_CURRENTDATE?: { __typename?: 'Config_Float', id?: string | null, key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_Float', key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_Float', key: string, zone?: string | null, value?: number | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_CONTACTACCOUNTINGBUTTONTEXT?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_SUPPORTEMAIL?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_EMAILSUBJECT?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_EMAILBODYPREFIX?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_EMAILBODYSUFFIX?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null, ROLLING__LOCK__DATE_EVENTLOCKEDWARNING?: { __typename?: 'Config_String', id?: string | null, key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null, fallback?: { __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null } | null, overridingConfigs?: Array<{ __typename?: 'Config_String', key: string, zone?: string | null, value?: string | null, createdAt?: number | null, updatedAt?: number | null }> | null } | null } | null };

export type GetJobLocationsQueryVariables = Exact<{
  filter?: InputMaybe<JobsFilter>;
}>;


export type GetJobLocationsQuery = { __typename?: 'Query', jobs: { __typename?: 'ListJobsOutput', jobs: Array<{ __typename?: 'Job', locations?: Array<{ __typename?: 'JobLocation', locationType?: string | null, locationId?: string | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null> } };

export type CreateChargesMutationVariables = Exact<{
  charges: Array<CreateChargeInput> | CreateChargeInput;
  userId: Scalars['String']['input'];
}>;


export type CreateChargesMutation = { __typename?: 'Mutation', createCharges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null }> | null };

export type CreateIcalTokenMutationVariables = Exact<{
  name: Scalars['String']['input'];
  assetIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type CreateIcalTokenMutation = { __typename?: 'Mutation', createIcalToken: { __typename?: 'Token', id: string, createdAt?: number | null, token?: string | null, tokenType?: string | null, expiration?: number | null, emails?: Array<string | null> | null, title?: string | null, validOn?: number | null, used?: number | null, maxUses?: number | null, metadata?: any | null, isValid?: boolean | null, zones?: Array<{ __typename?: 'Zone', id: string, name?: string | null } | null> | null } };

export type EditUserPasswordMutationVariables = Exact<{
  id: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type EditUserPasswordMutation = { __typename?: 'Mutation', editUserPassword: boolean };

export type DeleteUsersMutationVariables = Exact<{
  userIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  hardDelete?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteUsersMutation = { __typename?: 'Mutation', deleteUsers: boolean };

export type TransactionsQueryVariables = Exact<{
  filter?: InputMaybe<TransactionsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransactionsQuery = { __typename?: 'Query', transactions: { __typename?: 'ListTransactionsOutput', total: number, skipped: number, limited: number, transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> } };

export type TransactionsWithoutTotalQueryVariables = Exact<{
  filter?: InputMaybe<TransactionsFilter>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type TransactionsWithoutTotalQuery = { __typename?: 'Query', transactions: { __typename?: 'ListTransactionsOutput', skipped: number, limited: number, transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> } };

export type TransactionsAvailableForInvoiceQueryVariables = Exact<{
  invoiceId: Scalars['String']['input'];
  invoiceJobId: Scalars['String']['input'];
}>;


export type TransactionsAvailableForInvoiceQuery = { __typename?: 'Query', transactions: { __typename?: 'ListTransactionsOutput', transactions: Array<{ __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } | null> }, invoices?: { __typename?: 'InvoicePage', invoices: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } }> } | null };

export type CreateTransactionMutationVariables = Exact<{
  amount: Scalars['Int']['input'];
  customerId: Scalars['String']['input'];
  jobId: Scalars['String']['input'];
  invoiceId?: InputMaybe<Scalars['String']['input']>;
  type: TransactionType;
  paymentTypeId: Scalars['String']['input'];
  stage?: InputMaybe<TransactionStage>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  disableSendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateTransactionMutation = { __typename?: 'Mutation', createTransaction: { __typename?: 'CreateTransactionOutput', client_secret?: string | null, transaction: { __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } } };

export type UpdateTransactionMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
  stage?: InputMaybe<TransactionStage>;
  disableSendReceipt?: InputMaybe<Scalars['Boolean']['input']>;
  metadata?: InputMaybe<Scalars['Metadata']['input']>;
  invoiceId?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateTransactionMutation = { __typename?: 'Mutation', updateTransaction: { __typename?: 'Transaction', id: string, createdAt: number, deletedAt?: number | null, archivedAt?: number | null, paidAt?: number | null, amount?: number | null, currency: string, stage: TransactionStage, type?: TransactionType | null, metadata?: any | null, job: { __typename?: 'Job', id: string, collectionId: string, code?: string | null, stage: string, state?: string | null, jobCategory?: string | null, attributes?: Array<string> | null, currency: string, depositRequired?: number | null, subTotal: number, taxTotal: number, total: number, paidTotal: number, damageTotal: number, discountTotal: number, discountedSubTotal: number, discountedSubTotalWithoutDamages: number, expenseTotal: number, pendingTotal: number, archivedAt?: number | null, closedAt?: number | null, closedReason?: string | null, deletedAt?: number | null, createdAt?: number | null, timeline?: string | null, timelineDays?: number | null, eventsOrderChangedByUser?: boolean | null, crewSummary?: any | null, adminSummary?: any | null, customerSummary?: any | null }, customer?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null, invoice?: { __typename?: 'Invoice', id: string, openedAt?: number | null, sentAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null, paymentType?: { __typename?: 'PaymentType', id: string, key?: string | null, name?: string | null, provider?: string | null, enabled?: boolean | null, createdAt?: number | null, updatedAt?: number | null } | null } };

export type DeleteTransactionByIdMutationVariables = Exact<{
  transactionId: Scalars['String']['input'];
}>;


export type DeleteTransactionByIdMutation = { __typename?: 'Mutation', deleteTransactions: boolean };

export type UserPageUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserPageUsersQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', skipped?: number | null, limited?: number | null, users?: Array<{ __typename?: 'User', twoFactorEnabled?: boolean | null, id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, roles?: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> | null, deletedAt?: { __typename?: 'DateTime', date: string } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null };

export type UserPageCountQueryVariables = Exact<{
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type UserPageCountQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', total?: number | null } | null };

export type ListUsersQueryVariables = Exact<{
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListUsersQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', total?: number | null, skipped?: number | null, limited?: number | null, users?: Array<{ __typename?: 'User', twoFactorEnabled?: boolean | null, id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, roles?: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> | null, deletedAt?: { __typename?: 'DateTime', date: string } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null };

export type ListFullUsersWithoutCountQueryVariables = Exact<{
  filter?: InputMaybe<UserSearch>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Scalars['String']['input']>;
}>;


export type ListFullUsersWithoutCountQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', users?: Array<{ __typename?: 'User', twoFactorEnabled?: boolean | null, id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, roles?: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> | null, deletedAt?: { __typename?: 'DateTime', date: string } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null> | null } | null };

export type UserFullNotificationsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  filter?: InputMaybe<NotificationsFilter>;
}>;


export type UserFullNotificationsQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', users?: Array<{ __typename?: 'User', notifications: { __typename?: 'NotificationsPagination', total: number, skipped?: number | null, limited?: number | null, notifications: Array<{ __typename?: 'Notification', id: string, type: string, title: string, subtitle?: string | null, body?: string | null, url?: string | null, actionsDisabled?: boolean | null, expiresIn?: number | null, data?: string | null, actions?: Array<{ __typename?: 'NotificationAction', type?: string | null, name: string, formattedName: string, value?: string | null, valueType?: string | null, extraInfo?: string | null, extraInfoType?: string | null, extraInfoQuickOptions?: Array<string> | null }> | null, recipients: Array<{ __typename?: 'NotificationRecipient', recipientId: string, readAt?: number | null, push?: boolean | null }>, createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null } | null> } } | null> | null } | null };

export type LatestAndUnreadNotificationsQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  latestLimit?: InputMaybe<Scalars['Int']['input']>;
  unreadLimit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LatestAndUnreadNotificationsQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', users?: Array<{ __typename?: 'User', latest: { __typename?: 'NotificationsPagination', notifications: Array<{ __typename?: 'Notification', id: string, type: string, title: string, subtitle?: string | null, body?: string | null, url?: string | null, actionsDisabled?: boolean | null, expiresIn?: number | null, data?: string | null, actions?: Array<{ __typename?: 'NotificationAction', type?: string | null, name: string, formattedName: string, value?: string | null, valueType?: string | null, extraInfo?: string | null, extraInfoType?: string | null, extraInfoQuickOptions?: Array<string> | null }> | null, recipients: Array<{ __typename?: 'NotificationRecipient', recipientId: string, readAt?: number | null, push?: boolean | null }>, createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null } | null> }, unread: { __typename?: 'NotificationsPagination', total: number } } | null> | null } | null };

export type UserNotificationByIdQueryVariables = Exact<{
  userId: Scalars['String']['input'];
  notificationId: Scalars['String']['input'];
}>;


export type UserNotificationByIdQuery = { __typename?: 'Query', usersv2?: { __typename?: 'UserPagination', users?: Array<{ __typename?: 'User', notifications: { __typename?: 'NotificationsPagination', notifications: Array<{ __typename?: 'Notification', id: string, type: string, title: string, subtitle?: string | null, body?: string | null, url?: string | null, actionsDisabled?: boolean | null, expiresIn?: number | null, data?: string | null, actions?: Array<{ __typename?: 'NotificationAction', type?: string | null, name: string, formattedName: string, value?: string | null, valueType?: string | null, extraInfo?: string | null, extraInfoType?: string | null, extraInfoQuickOptions?: Array<string> | null }> | null, recipients: Array<{ __typename?: 'NotificationRecipient', recipientId: string, readAt?: number | null, push?: boolean | null }>, createdAt: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string }, updatedAt?: { __typename?: 'DateTime', date: string, time: string, fullString: string, unix: string } | null } | null> } } | null> | null } | null };

export type ListRolesQueryVariables = Exact<{
  search?: InputMaybe<RoleSearch>;
}>;


export type ListRolesQuery = { __typename?: 'Query', roles: Array<{ __typename?: 'Role', id: string, color?: string | null, name: string, attributes?: Array<string> | null, description?: string | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null }> };

export type EditCalendarEventMutationVariables = Exact<{
  edit: EditCalendarEventInput;
  ids?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  assocIds?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  disablePropogation?: InputMaybe<Scalars['Boolean']['input']>;
  notifyAttendees?: InputMaybe<Scalars['Boolean']['input']>;
  notifyDispatch?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EditCalendarEventMutation = { __typename?: 'Mutation', editCalendarEvent: boolean };

export type RemoveCalendarEventMutationVariables = Exact<{
  ids: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveCalendarEventMutation = { __typename?: 'Mutation', removeCalendarEvent: boolean };

export type BulkEditCalendarEventMutationVariables = Exact<{
  edits: Array<SingleEditInput> | SingleEditInput;
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type BulkEditCalendarEventMutation = { __typename?: 'Mutation', bulkEditCalendarEvent: { __typename?: 'CalendarEventPagination', total: number, events: Array<{ __typename?: 'CalendarEvent', sequentialOrder?: number | null, discountTotal?: number | null, taxTotal?: number | null, discountedSubTotal?: number | null, discountedSubTotalWithoutDamages?: number | null, subTotal?: number | null, damageTotal?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export type BulkEditCalendarEventOnScheduleMutationVariables = Exact<{
  edits: Array<SingleEditInput> | SingleEditInput;
}>;


export type BulkEditCalendarEventOnScheduleMutation = { __typename?: 'Mutation', bulkEditCalendarEvent: { __typename?: 'CalendarEventPagination', total: number, events: Array<{ __typename?: 'CalendarEvent', discountedSubTotal?: number | null, sequentialOrder?: number | null, id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, charges?: Array<{ __typename?: 'Charge', id: string, discountTotal?: number | null, discountedSubTotal?: number | null, taxTotal?: number | null, total?: number | null, chargeSubTotal?: number | null, expenseTotal?: number | null, amount?: number | null, productName?: string | null, eventType?: string | null, currency: string, quantity: number, createdAt?: number | null, updatedAt?: number | null, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null, order?: number | null, expensesV2?: Array<{ __typename?: 'ChargeExpense', unitCost: number, amount: number, expense: { __typename?: 'Expense', id: string, name?: string | null, description?: string | null, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, attributes?: Array<string | null> | null, metadata?: any | null } }> | null, product?: { __typename?: 'Product', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name: string, category?: string | null, order?: number | null, active: boolean, description?: string | null, unitLabel?: string | null, attributes?: Array<string | null> | null, metadata?: any | null } | null, price?: { __typename?: 'Price', id: string, name?: string | null, amount: number, priceType?: PriceType | null } | null, user?: { __typename?: 'User', id: string } | null, calendarEvent?: { __typename?: 'CalendarEvent', id: string, createdAt: number, updatedAt: number, archivedAt?: number | null, deletedAt?: number | null, associatedId?: string | null, title: string, shortTitle?: string | null, description?: string | null, status?: string | null, notes?: string | null, attributes?: Array<string | null> | null, start?: number | null, end?: number | null, roles?: Array<string | null> | null, type: string, colour?: string | null, topicText?: string | null, total?: number | null, subTotal?: number | null, discountedSubTotal?: number | null, sharedZones?: Array<string | null> | null, metadata?: any | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null } | null, discounts?: Array<{ __typename?: 'DiscountDetails', appliedId: string, appliedAt: number, redeemedAt?: number | null, appliedCustomAmount?: number | null, discountedAmount?: number | null, eventId: string, discount: { __typename?: 'Discount', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, archivedAt?: number | null, name: string, description?: string | null, code: string, amount: number, customAmountRange?: Array<number> | null, discountType: DiscountTypes, active: boolean, startsAt?: number | null, expiresAt?: number | null }, appliedBy?: { __typename?: 'User', id: string } | null } | null> | null, taxes?: Array<{ __typename?: 'Tax', id: string, name: string, percentage: number, active: boolean } | null> | null } | null> | null, attendees?: Array<{ __typename?: 'Attendee', role: string, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null, job?: { __typename?: 'Job', id: string, code?: string | null, closedAt?: number | null, currency: string, total: number, paidTotal: number, customerSummary?: any | null, adminSummary?: any | null, crewSummary?: any | null, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } | null, zones?: { __typename?: 'ListZonesOutput', nodes: Array<{ __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null> } | null, locations?: Array<{ __typename?: 'CalendarEventLocation', id: string, type?: string | null, order: number, estimatedTimeAtLocation?: number | null, travelTimeToNextLocation?: number | null, travelTimeToNextLocationOffset?: number | null, actualTimeAtLocation?: number | null, actualTimeToNextLocation?: number | null, distanceToNextLocation?: number | null, distanceUnits?: string | null, ignoreInDuration?: boolean | null, location?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, serviceArea?: { __typename?: 'Zone', id: string, createdAt: number, updatedAt: number, deletedAt?: number | null, name?: string | null, type?: string | null, contextable?: boolean | null, avatar?: string | null, color?: string | null, description?: string | null, attributes?: Array<string> | null } | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null }> | null, invoices?: Array<{ __typename?: 'Invoice', id: string, createdAt: number, updatedAt: string, invoiceDate: number, dueDate: number, currency: string, sentAt?: number | null, openedAt?: number | null, voidedAt?: number | null, deletedAt?: number | null, invoiceNumber: number, metadata?: any | null, subTotal: number, taxTotal: number, discountTotal: number, paidTotal: number, total: number, damageTotal: number, discountedSubTotalWithoutDamages: number, job: { __typename?: 'Job', id: string, code?: string | null, total: number, paidTotal: number, users?: Array<{ __typename?: 'JobUser', role?: string | null, user?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null, billingAddress?: { __typename?: 'Location', id: string, individualCapacity?: number | null, addressLineOne?: string | null, addressLineTwo?: string | null, name?: string | null, areaCode?: string | null, city?: string | null, countryJurisdiction?: string | null, country?: string | null, parentId?: string | null, attributes?: Array<string | null> | null, coordinates?: { __typename?: 'Coordinates', latitude: number, longitude: number, height?: number | null } | null } | null } | null } | null> | null } } | null> | null, assets?: Array<{ __typename?: 'Asset', id: string, name: string, type: string, description?: string | null, metadata?: any | null, owner?: { __typename?: 'User', id: string, email?: string | null, phone?: string | null, givenName?: string | null, familyName?: string | null, company?: string | null, salary?: number | null, shiftAvailability?: string | null } | null } | null> | null }> } };

export const BaseOptionFragmentDoc = gql`
    fragment BaseOption on Option {
  option
  label
}
    `;
export const PandadocArtifactFragmentDoc = gql`
    fragment PandadocArtifact on Artifact {
  id
  name
  namespace
  fileSize
  contentType
  public
  author
  gcsFileName
  attributes
  signedPolicy
  signedUrl
  url
  createdAt
  updatedAt
  archivedAt
  deletedAt
  metadata
}
    `;
export const BaseUserFragmentDoc = gql`
    fragment BaseUser on User {
  id
  email
  phone
  givenName
  familyName
  company
  salary
  shiftAvailability
}
    `;
export const BaseAssetFragmentDoc = gql`
    fragment BaseAsset on Asset {
  id
  name
  owner {
    ...BaseUser
  }
  type
  description
}
    ${BaseUserFragmentDoc}`;
export const FullAssetFragmentDoc = gql`
    fragment FullAsset on Asset {
  ...BaseAsset
  attributes
  createdAt
  updatedAt
  deletedAt
  location {
    id
    individualCapacity
    addressLineOne
    addressLineTwo
    name
    areaCode
    city
    countryJurisdiction
    country
    parentId
  }
  metadata
  zones {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    description
    contextable
    color
  }
}
    ${BaseAssetFragmentDoc}`;
export const FindAssetFragmentDoc = gql`
    fragment FindAsset on Asset {
  id
  name
  type
  metadata
}
    `;
export const Asset_MetadataFragmentDoc = gql`
    fragment Asset_Metadata on Asset {
  metadata
}
    `;
export const AssetWithMetadataFragmentDoc = gql`
    fragment AssetWithMetadata on Asset {
  ...BaseAsset
  ...Asset_Metadata
}
    ${BaseAssetFragmentDoc}
${Asset_MetadataFragmentDoc}`;
export const CalendarEvent_AssetsFragmentDoc = gql`
    fragment CalendarEvent_Assets on CalendarEvent {
  assets {
    ...AssetWithMetadata
  }
}
    ${AssetWithMetadataFragmentDoc}`;
export const CoordinatesFragmentDoc = gql`
    fragment Coordinates on Coordinates {
  latitude
  longitude
  height
}
    `;
export const BaseLocationFragmentDoc = gql`
    fragment BaseLocation on Location {
  id
  individualCapacity
  addressLineOne
  addressLineTwo
  name
  areaCode
  city
  countryJurisdiction
  country
  parentId
  attributes
  coordinates {
    ...Coordinates
  }
}
    ${CoordinatesFragmentDoc}`;
export const EventLocationDetailsFragmentDoc = gql`
    fragment EventLocationDetails on CalendarEventLocation {
  type
  order
  estimatedTimeAtLocation
  travelTimeToNextLocation
  travelTimeToNextLocationOffset
  actualTimeAtLocation
  actualTimeToNextLocation
  distanceToNextLocation
  distanceUnits
  ignoreInDuration
}
    `;
export const CalendarEvent_LocationFragmentDoc = gql`
    fragment CalendarEvent_Location on CalendarEventLocation {
  id
  location {
    ...BaseLocation
  }
  ...EventLocationDetails
}
    ${BaseLocationFragmentDoc}
${EventLocationDetailsFragmentDoc}`;
export const CalendarEvent_LocationsFragmentDoc = gql`
    fragment CalendarEvent_Locations on CalendarEvent {
  locations {
    ...CalendarEvent_Location
  }
}
    ${CalendarEvent_LocationFragmentDoc}`;
export const CalendarEvent_AttendeeFragmentDoc = gql`
    fragment CalendarEvent_Attendee on Attendee {
  user {
    ...BaseUser
  }
  role
}
    ${BaseUserFragmentDoc}`;
export const CalendarEvent_AttendeesFragmentDoc = gql`
    fragment CalendarEvent_Attendees on CalendarEvent {
  attendees {
    ...CalendarEvent_Attendee
  }
}
    ${CalendarEvent_AttendeeFragmentDoc}`;
export const BaseCalendarEventFragmentDoc = gql`
    fragment BaseCalendarEvent on CalendarEvent {
  id
  createdAt
  updatedAt
  archivedAt
  deletedAt
  associatedId
  title
  shortTitle
  description
  status
  notes
  attributes
  start
  end
  roles
  type
  colour
  topicText
  total
  subTotal
  discountedSubTotal
  sharedZones
  metadata
  ...CalendarEvent_Assets
  ...CalendarEvent_Locations
  ...CalendarEvent_Attendees
}
    ${CalendarEvent_AssetsFragmentDoc}
${CalendarEvent_LocationsFragmentDoc}
${CalendarEvent_AttendeesFragmentDoc}`;
export const Product_MetadataFragmentDoc = gql`
    fragment Product_Metadata on Product {
  metadata
}
    `;
export const BaseProductFragmentDoc = gql`
    fragment BaseProduct on Product {
  id
  createdAt
  updatedAt
  deletedAt
  name
  category
  order
  active
  description
  unitLabel
  attributes
  ...Product_Metadata
}
    ${Product_MetadataFragmentDoc}`;
export const Invoice_TotalsFragmentDoc = gql`
    fragment Invoice_Totals on Invoice {
  subTotal
  taxTotal
  discountTotal
  paidTotal
  total
  damageTotal
  discountedSubTotalWithoutDamages
}
    `;
export const UserWithBillingAddressFragmentDoc = gql`
    fragment UserWithBillingAddress on User {
  ...BaseUser
  billingAddress {
    ...BaseLocation
  }
}
    ${BaseUserFragmentDoc}
${BaseLocationFragmentDoc}`;
export const BaseJobUserFragmentDoc = gql`
    fragment BaseJobUser on JobUser {
  user {
    ...UserWithBillingAddress
  }
  role
}
    ${UserWithBillingAddressFragmentDoc}`;
export const Job_UsersFragmentDoc = gql`
    fragment Job_Users on Job {
  users {
    ...BaseJobUser
  }
}
    ${BaseJobUserFragmentDoc}`;
export const Invoice_JobFragmentDoc = gql`
    fragment Invoice_Job on Invoice {
  job {
    id
    code
    total
    paidTotal
    ...Job_Users
  }
}
    ${Job_UsersFragmentDoc}`;
export const BaseInvoiceFragmentDoc = gql`
    fragment BaseInvoice on Invoice {
  id
  createdAt
  updatedAt
  invoiceDate
  dueDate
  currency
  sentAt
  openedAt
  voidedAt
  deletedAt
  invoiceNumber
  metadata
  ...Invoice_Totals
  ...Invoice_Job
}
    ${Invoice_TotalsFragmentDoc}
${Invoice_JobFragmentDoc}`;
export const CalendarEvent_InvoicesFragmentDoc = gql`
    fragment CalendarEvent_Invoices on CalendarEvent {
  invoices {
    ...BaseInvoice
  }
}
    ${BaseInvoiceFragmentDoc}`;
export const BaseDiscountFragmentDoc = gql`
    fragment BaseDiscount on Discount {
  id
  createdAt
  updatedAt
  deletedAt
  archivedAt
  name
  description
  code
  amount
  customAmountRange
  discountType
  active
  startsAt
  expiresAt
}
    `;
export const AppliedDiscountFragmentDoc = gql`
    fragment AppliedDiscount on DiscountDetails {
  discount {
    ...BaseDiscount
  }
  appliedId
  appliedAt
  redeemedAt
  appliedCustomAmount
  discountedAmount
  eventId
  appliedBy {
    id
  }
}
    ${BaseDiscountFragmentDoc}`;
export const BaseChargeFragmentDoc = gql`
    fragment BaseCharge on Charge {
  id
  product {
    ...BaseProduct
  }
  discountTotal
  discountedSubTotal
  taxTotal
  total
  chargeSubTotal
  expenseTotal
  amount
  productName
  price {
    id
    name
    amount
    priceType
  }
  user {
    id
  }
  calendarEvent {
    ...BaseCalendarEvent
    ...CalendarEvent_Invoices
  }
  eventType
  currency
  quantity
  discounts {
    ...AppliedDiscount
  }
  taxes {
    id
    name
    percentage
    active
  }
  createdAt
  updatedAt
  deletedAt
  archivedAt
  attributes
  metadata
  order
}
    ${BaseProductFragmentDoc}
${BaseCalendarEventFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}
${AppliedDiscountFragmentDoc}`;
export const BaseExpenseFragmentDoc = gql`
    fragment BaseExpense on Expense {
  id
  name
  description
  createdAt
  updatedAt
  deletedAt
  archivedAt
  attributes
  metadata
}
    `;
export const ExpenseForChargeFragmentDoc = gql`
    fragment ExpenseForCharge on ChargeExpense {
  expense {
    ...BaseExpense
  }
  unitCost
  amount
}
    ${BaseExpenseFragmentDoc}`;
export const CalendarEvent_ChargesFragmentDoc = gql`
    fragment CalendarEvent_Charges on CalendarEvent {
  charges {
    ...BaseCharge
    expensesV2 {
      ...ExpenseForCharge
    }
  }
}
    ${BaseChargeFragmentDoc}
${ExpenseForChargeFragmentDoc}`;
export const CalendarEvent_JobFragmentDoc = gql`
    fragment CalendarEvent_Job on CalendarEvent {
  job {
    id
    code
    closedAt
    currency
    total
    paidTotal
    customerSummary
    adminSummary
    crewSummary
    ...Job_Users
  }
}
    ${Job_UsersFragmentDoc}`;
export const BaseZoneFragmentDoc = gql`
    fragment BaseZone on Zone {
  id
  createdAt
  updatedAt
  deletedAt
  name
  type
  contextable
  avatar
  color
  description
  attributes
}
    `;
export const CalendarEvent_ZonesFragmentDoc = gql`
    fragment CalendarEvent_Zones on CalendarEvent {
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const CalendarEvent_LocationsWithServiceAreaFragmentDoc = gql`
    fragment CalendarEvent_LocationsWithServiceArea on CalendarEvent {
  locations {
    id
    location {
      ...BaseLocation
      serviceArea {
        ...BaseZone
      }
    }
    ...EventLocationDetails
  }
}
    ${BaseLocationFragmentDoc}
${BaseZoneFragmentDoc}
${EventLocationDetailsFragmentDoc}`;
export const FullCalendarEventFragmentDoc = gql`
    fragment FullCalendarEvent on CalendarEvent {
  ...BaseCalendarEvent
  ...CalendarEvent_Charges
  ...CalendarEvent_Attendees
  ...CalendarEvent_Job
  ...CalendarEvent_Zones
  ...CalendarEvent_LocationsWithServiceArea
  discountedSubTotal
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEvent_ChargesFragmentDoc}
${CalendarEvent_AttendeesFragmentDoc}
${CalendarEvent_JobFragmentDoc}
${CalendarEvent_ZonesFragmentDoc}
${CalendarEvent_LocationsWithServiceAreaFragmentDoc}`;
export const ScheduledCalendarEventFragmentDoc = gql`
    fragment ScheduledCalendarEvent on CalendarEvent {
  ...FullCalendarEvent
}
    ${FullCalendarEventFragmentDoc}`;
export const CalendarEventForScheduleFragmentDoc = gql`
    fragment CalendarEventForSchedule on CalendarEvent {
  ...BaseCalendarEvent
  ...CalendarEvent_Charges
  ...CalendarEvent_Attendees
  ...CalendarEvent_Job
  ...CalendarEvent_Zones
  ...CalendarEvent_LocationsWithServiceArea
  ...CalendarEvent_Invoices
  discountedSubTotal
  sequentialOrder
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEvent_ChargesFragmentDoc}
${CalendarEvent_AttendeesFragmentDoc}
${CalendarEvent_JobFragmentDoc}
${CalendarEvent_ZonesFragmentDoc}
${CalendarEvent_LocationsWithServiceAreaFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}`;
export const CalendarEventForDetailsFragmentDoc = gql`
    fragment CalendarEventForDetails on CalendarEvent {
  ...CalendarEventForSchedule
  discountedSubTotalWithoutDamages
  damageTotal
  subTotal
  discountTotal
  discountedSubTotal
  taxTotal
  expenseTotal
  currency
  ...CalendarEvent_Invoices
}
    ${CalendarEventForScheduleFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}`;
export const CalendarEventForSelectEventFragmentDoc = gql`
    fragment CalendarEventForSelectEvent on CalendarEvent {
  id
  archivedAt
  associatedId
  title
  shortTitle
  description
  status
  notes
  attributes
  start
  end
  sequentialOrder
  roles
  type
  colour
  ...CalendarEvent_Invoices
}
    ${CalendarEvent_InvoicesFragmentDoc}`;
export const BookOffCalendarEventFragmentDoc = gql`
    fragment BookOffCalendarEvent on CalendarEvent {
  id
  title
  start
  end
  type
  description
  assets {
    id
  }
}
    `;
export const BaseJobFragmentDoc = gql`
    fragment BaseJob on Job {
  id
  collectionId
  code
  stage
  state
  jobCategory
  attributes
  currency
  depositRequired
  subTotal
  taxTotal
  total
  paidTotal
  damageTotal
  discountTotal
  discountedSubTotal
  discountedSubTotalWithoutDamages
  expenseTotal
  pendingTotal
  archivedAt
  closedAt
  closedReason
  deletedAt
  createdAt
  timeline
  timelineDays
  eventsOrderChangedByUser
  crewSummary
  adminSummary
  customerSummary
}
    `;
export const ChargeWithJobFragmentDoc = gql`
    fragment ChargeWithJob on Charge {
  ...BaseCharge
  job {
    ...BaseJob
  }
  expensesV2 {
    ...ExpenseForCharge
  }
}
    ${BaseChargeFragmentDoc}
${BaseJobFragmentDoc}
${ExpenseForChargeFragmentDoc}`;
export const FullConfigFragmentDoc = gql`
    fragment FullConfig on ConfigValue {
  id
  key
  zone
  value
  createdAt
  updatedAt
}
    `;
export const FullDiscountFragmentDoc = gql`
    fragment FullDiscount on Discount {
  ...BaseDiscount
  maxRedemptions
  timesRedeemed
  attributes
  metadata
}
    ${BaseDiscountFragmentDoc}`;
export const HistoryPartsFragmentDoc = gql`
    fragment HistoryParts on History {
  id
  text
  type
  ip
  createdAt
  type
  vars
  related {
    name
    obj {
      id
      label
    }
  }
}
    `;
export const Invoice_EventsFragmentDoc = gql`
    fragment Invoice_Events on Invoice {
  events {
    ...BaseCalendarEvent
  }
}
    ${BaseCalendarEventFragmentDoc}`;
export const Transaction_PaymentTypeFragmentDoc = gql`
    fragment Transaction_PaymentType on Transaction {
  paymentType {
    id
    key
    name
    provider
    enabled
    createdAt
    updatedAt
  }
}
    `;
export const BaseTransactionFragmentDoc = gql`
    fragment BaseTransaction on Transaction {
  id
  createdAt
  deletedAt
  archivedAt
  paidAt
  amount
  currency
  stage
  type
  ...Transaction_PaymentType
  metadata
}
    ${Transaction_PaymentTypeFragmentDoc}`;
export const Invoice_TransactionsFragmentDoc = gql`
    fragment Invoice_Transactions on Invoice {
  transactions {
    ...BaseTransaction
  }
}
    ${BaseTransactionFragmentDoc}`;
export const FullInvoiceFragmentDoc = gql`
    fragment FullInvoice on Invoice {
  ...BaseInvoice
  ...Invoice_Job
  ...Invoice_Events
  ...Invoice_Transactions
  metadata
  artifacts {
    id
    name
    contentType
    attributes
    signedUrl
    url
    metadata
  }
}
    ${BaseInvoiceFragmentDoc}
${Invoice_JobFragmentDoc}
${Invoice_EventsFragmentDoc}
${Invoice_TransactionsFragmentDoc}`;
export const Job_LocationFragmentDoc = gql`
    fragment Job_Location on JobLocation {
  locationType
  locationId
  location {
    ...BaseLocation
  }
}
    ${BaseLocationFragmentDoc}`;
export const Job_LocationsFragmentDoc = gql`
    fragment Job_Locations on Job {
  locations {
    ...Job_Location
  }
}
    ${Job_LocationFragmentDoc}`;
export const Job_ChargesFragmentDoc = gql`
    fragment Job_Charges on Job {
  charges {
    ...BaseCharge
    expensesV2 {
      ...ExpenseForCharge
    }
  }
}
    ${BaseChargeFragmentDoc}
${ExpenseForChargeFragmentDoc}`;
export const CalendarEvent_DiscountsFragmentDoc = gql`
    fragment CalendarEvent_Discounts on CalendarEvent {
  discounts {
    ...AppliedDiscount
  }
}
    ${AppliedDiscountFragmentDoc}`;
export const CalendarEventTotalsFragmentDoc = gql`
    fragment CalendarEventTotals on CalendarEvent {
  damageTotal
  subTotal
  discountTotal
  discountedSubTotal
  discountedSubTotalWithoutDamages
  taxTotal
  total
  expenseTotal
}
    `;
export const CalendarEventForCalculatorFragmentDoc = gql`
    fragment CalendarEventForCalculator on CalendarEvent {
  ...BaseCalendarEvent
  ...CalendarEvent_Charges
  ...CalendarEvent_Discounts
  ...CalendarEventTotals
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEvent_ChargesFragmentDoc}
${CalendarEvent_DiscountsFragmentDoc}
${CalendarEventTotalsFragmentDoc}`;
export const Job_CalendarEventFragmentDoc = gql`
    fragment Job_CalendarEvent on CalendarEvent {
  ...BaseCalendarEvent
  ...CalendarEventForCalculator
  ...CalendarEvent_Invoices
  sequentialOrder
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEventForCalculatorFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}`;
export const Job_CalendarEventsFragmentDoc = gql`
    fragment Job_CalendarEvents on Job {
  events {
    ...Job_CalendarEvent
  }
}
    ${Job_CalendarEventFragmentDoc}`;
export const BaseTagFragmentDoc = gql`
    fragment BaseTag on Tag {
  id
  name
  objectType
  color
  category
  private
  attributes
  order
}
    `;
export const Job_TagsFragmentDoc = gql`
    fragment Job_Tags on Job {
  tags {
    ...BaseTag
  }
}
    ${BaseTagFragmentDoc}`;
export const BaseZoneWithParentsFragmentDoc = gql`
    fragment BaseZoneWithParents on Zone {
  ...BaseZone
  parent {
    ...BaseZone
  }
  parents {
    ...BaseZone
  }
}
    ${BaseZoneFragmentDoc}`;
export const Job_ZoneWithParentAndTimezoneFragmentDoc = gql`
    fragment Job_ZoneWithParentAndTimezone on Job {
  zone {
    ...BaseZoneWithParents
    timezone
    parent {
      ...BaseZone
      timezone
    }
  }
}
    ${BaseZoneWithParentsFragmentDoc}
${BaseZoneFragmentDoc}`;
export const Job_DiscountsFragmentDoc = gql`
    fragment Job_Discounts on Job {
  discounts {
    discount {
      ...BaseDiscount
    }
    appliedId
    appliedAt
    discountedAmount
    appliedCustomAmount
    redeemedAt
    appliedBy {
      id
    }
    event {
      id
      type
      end
      ...CalendarEvent_Invoices
    }
  }
}
    ${BaseDiscountFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}`;
export const BaseTaxFragmentDoc = gql`
    fragment BaseTax on Tax {
  id
  createdAt
  updatedAt
  deletedAt
  type
  active
  isZoneDefault
  percentage
  name
  description
  attributes
}
    `;
export const Job_TaxesPaidFragmentDoc = gql`
    fragment Job_TaxesPaid on Job {
  taxesPaid {
    paid
    tax {
      ...BaseTax
      zones {
        nodes {
          ...BaseZone
        }
      }
    }
  }
}
    ${BaseTaxFragmentDoc}
${BaseZoneFragmentDoc}`;
export const Job_MetadataFragmentDoc = gql`
    fragment Job_Metadata on Job {
  metadata
}
    `;
export const Job_TransactionsFragmentDoc = gql`
    fragment Job_Transactions on Job {
  transactions {
    ...BaseTransaction
  }
}
    ${BaseTransactionFragmentDoc}`;
export const CalculateDistanceOutputFragmentFragmentDoc = gql`
    fragment CalculateDistanceOutputFragment on CalculateDistanceOutput {
  distances {
    startLocation
    endLocation
    averageTime
    estimatedTime
    distance
    distanceUnits
  }
  averageTime
  estimatedTime
  totalDistance
  distanceUnits
  flagTrip
}
    `;
export const RouteDistancesFragmentDoc = gql`
    fragment RouteDistances on RouteDistances {
  start_end {
    ...CalculateDistanceOutputFragment
  }
  dock_start {
    ...CalculateDistanceOutputFragment
  }
  start_dock {
    ...CalculateDistanceOutputFragment
  }
  end_dock {
    ...CalculateDistanceOutputFragment
  }
}
    ${CalculateDistanceOutputFragmentFragmentDoc}`;
export const FullJobFragmentDoc = gql`
    fragment FullJob on Job {
  ...BaseJob
  ...Job_Locations
  ...Job_Users
  ...Job_Charges
  ...Job_CalendarEvents
  ...Job_Tags
  ...Job_ZoneWithParentAndTimezone
  ...Job_Discounts
  ...Job_TaxesPaid
  ...Job_Metadata
  ...Job_Transactions
  sharedZones
  distances {
    ...RouteDistances
  }
}
    ${BaseJobFragmentDoc}
${Job_LocationsFragmentDoc}
${Job_UsersFragmentDoc}
${Job_ChargesFragmentDoc}
${Job_CalendarEventsFragmentDoc}
${Job_TagsFragmentDoc}
${Job_ZoneWithParentAndTimezoneFragmentDoc}
${Job_DiscountsFragmentDoc}
${Job_TaxesPaidFragmentDoc}
${Job_MetadataFragmentDoc}
${Job_TransactionsFragmentDoc}
${RouteDistancesFragmentDoc}`;
export const FullJobWithStagesFragmentDoc = gql`
    fragment FullJobWithStages on Job {
  ...FullJob
  previousStages {
    ...BaseJob
    ...Job_Locations
  }
  followingStages {
    ...BaseJob
    ...Job_Locations
  }
}
    ${FullJobFragmentDoc}
${BaseJobFragmentDoc}
${Job_LocationsFragmentDoc}`;
export const ChargeForEstimateFragmentDoc = gql`
    fragment ChargeForEstimate on Charge {
  ...BaseCharge
  expensesV2 {
    ...ExpenseForCharge
  }
}
    ${BaseChargeFragmentDoc}
${ExpenseForChargeFragmentDoc}`;
export const CalendarEventForEstimateFragmentDoc = gql`
    fragment CalendarEventForEstimate on CalendarEvent {
  ...BaseCalendarEvent
  ...CalendarEvent_Charges
  damageTotal
  subTotal
  discountTotal
  discountedSubTotal
  discountedSubTotalWithoutDamages
  taxTotal
  total
  expenseTotal
  topicText
  sequentialOrder
  ...CalendarEvent_Invoices
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEvent_ChargesFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}`;
export const BaseZoneWithParentFragmentDoc = gql`
    fragment BaseZoneWithParent on Zone {
  ...BaseZone
  parent {
    ...BaseZone
  }
}
    ${BaseZoneFragmentDoc}`;
export const Job_ZoneFragmentDoc = gql`
    fragment Job_Zone on Job {
  zone {
    ...BaseZoneWithParent
  }
}
    ${BaseZoneWithParentFragmentDoc}`;
export const EstimatesJobFragmentDoc = gql`
    fragment EstimatesJob on Job {
  ...BaseJob
  ...Job_Locations
  ...Job_Users
  ...Job_Transactions
  charges {
    ...ChargeForEstimate
  }
  events {
    ...CalendarEventForEstimate
  }
  ...Job_Tags
  ...Job_Metadata
  ...Job_Zone
  ...Job_Discounts
  taxesPaid {
    tax {
      ...BaseTax
      zones {
        nodes {
          ...BaseZone
        }
      }
    }
    paid
  }
  notes
  sharedZones
}
    ${BaseJobFragmentDoc}
${Job_LocationsFragmentDoc}
${Job_UsersFragmentDoc}
${Job_TransactionsFragmentDoc}
${ChargeForEstimateFragmentDoc}
${CalendarEventForEstimateFragmentDoc}
${Job_TagsFragmentDoc}
${Job_MetadataFragmentDoc}
${Job_ZoneFragmentDoc}
${Job_DiscountsFragmentDoc}
${BaseTaxFragmentDoc}
${BaseZoneFragmentDoc}`;
export const JobWithUsersFragmentDoc = gql`
    fragment JobWithUsers on Job {
  ...BaseJob
  ...Job_Users
}
    ${BaseJobFragmentDoc}
${Job_UsersFragmentDoc}`;
export const JobWithUsersAndTagsFragmentDoc = gql`
    fragment JobWithUsersAndTags on Job {
  ...BaseJob
  ...Job_Users
  ...Job_Tags
  firstBookedRevenueGeneratingEvent
}
    ${BaseJobFragmentDoc}
${Job_UsersFragmentDoc}
${Job_TagsFragmentDoc}`;
export const Job_InvoicesFragmentDoc = gql`
    fragment Job_Invoices on Job {
  invoices {
    id
    openedAt
    sentAt
    voidedAt
    deletedAt
    invoiceNumber
    ...Invoice_Job
  }
}
    ${Invoice_JobFragmentDoc}`;
export const JobDetails_BaseJobFragmentDoc = gql`
    fragment JobDetails_BaseJob on Job {
  id
  code
  stage
  state
  currency
  depositRequired
  subTotal
  taxTotal
  total
  paidTotal
  damageTotal
  discountTotal
  discountedSubTotal
  discountedSubTotalWithoutDamages
  pendingTotal
  archivedAt
  closedAt
  closedReason
  deletedAt
  createdAt
  metadata
  attributes
  sharedZones
}
    `;
export const CalendarEventBasicdetailsFragmentDoc = gql`
    fragment CalendarEventBasicdetails on CalendarEvent {
  id
  title
  status
  start
  end
  sequentialOrder
}
    `;
export const AssetBasicDetailsFragmentDoc = gql`
    fragment AssetBasicDetails on Asset {
  id
  name
  type
}
    `;
export const JobDetails_CalendarEventsFragmentDoc = gql`
    fragment JobDetails_CalendarEvents on Job {
  events {
    ...CalendarEventBasicdetails
    assets {
      ...AssetBasicDetails
    }
  }
}
    ${CalendarEventBasicdetailsFragmentDoc}
${AssetBasicDetailsFragmentDoc}`;
export const ChargeBasicDetailsFragmentDoc = gql`
    fragment ChargeBasicDetails on Charge {
  id
  attributes
  productName
  quantity
  amount
}
    `;
export const ProductBasicDetailsFragmentDoc = gql`
    fragment ProductBasicDetails on Product {
  id
  name
}
    `;
export const PriceBasicDetailsFragmentDoc = gql`
    fragment PriceBasicDetails on Price {
  id
  amount
  priceType
}
    `;
export const JobDetails_ChargesFragmentDoc = gql`
    fragment JobDetails_Charges on Job {
  charges {
    ...ChargeBasicDetails
    product {
      ...ProductBasicDetails
    }
    price {
      ...PriceBasicDetails
    }
  }
}
    ${ChargeBasicDetailsFragmentDoc}
${ProductBasicDetailsFragmentDoc}
${PriceBasicDetailsFragmentDoc}`;
export const UserBasicDetailsFragmentDoc = gql`
    fragment UserBasicDetails on User {
  id
  givenName
  familyName
}
    `;
export const JobDetails_UsersFragmentDoc = gql`
    fragment JobDetails_Users on Job {
  users {
    user {
      ...UserBasicDetails
    }
    role
  }
}
    ${UserBasicDetailsFragmentDoc}`;
export const LocationBasicDetailsFragmentDoc = gql`
    fragment LocationBasicDetails on Location {
  id
  addressLineOne
  addressLineTwo
  areaCode
  city
  country
}
    `;
export const JobDetails_LocationsFragmentDoc = gql`
    fragment JobDetails_Locations on Job {
  locations {
    locationId
    locationType
    location {
      ...LocationBasicDetails
    }
  }
}
    ${LocationBasicDetailsFragmentDoc}`;
export const TagBasicDetailsFragmentDoc = gql`
    fragment TagBasicDetails on Tag {
  id
  color
  category
  name
}
    `;
export const ZoneBasicDetailsFragmentDoc = gql`
    fragment ZoneBasicDetails on Zone {
  id
  type
  name
}
    `;
export const InvoiceBasicDetailsFragmentDoc = gql`
    fragment InvoiceBasicDetails on Invoice {
  id
  invoiceNumber
}
    `;
export const TransactionBasicDetailsFragmentDoc = gql`
    fragment TransactionBasicDetails on Transaction {
  id
  deletedAt
  stage
  type
  amount
  currency
}
    `;
export const JobDetailsFragmentDoc = gql`
    fragment JobDetails on Job {
  ...JobDetails_BaseJob
  ...JobDetails_CalendarEvents
  ...JobDetails_Charges
  ...JobDetails_Users
  ...JobDetails_Locations
  tags {
    ...TagBasicDetails
  }
  zone {
    ...ZoneBasicDetails
  }
  invoices {
    ...InvoiceBasicDetails
  }
  transactions {
    ...TransactionBasicDetails
  }
}
    ${JobDetails_BaseJobFragmentDoc}
${JobDetails_CalendarEventsFragmentDoc}
${JobDetails_ChargesFragmentDoc}
${JobDetails_UsersFragmentDoc}
${JobDetails_LocationsFragmentDoc}
${TagBasicDetailsFragmentDoc}
${ZoneBasicDetailsFragmentDoc}
${InvoiceBasicDetailsFragmentDoc}
${TransactionBasicDetailsFragmentDoc}`;
export const Notification_TimestampsFragmentDoc = gql`
    fragment Notification_Timestamps on Notification {
  createdAt {
    date
    time
    fullString
    unix
  }
  updatedAt {
    date
    time
    fullString
    unix
  }
}
    `;
export const BaseNotificationFragmentDoc = gql`
    fragment BaseNotification on Notification {
  id
  type
  title
  subtitle
  body
  url
  actionsDisabled
  expiresIn
  data
  ...Notification_Timestamps
}
    ${Notification_TimestampsFragmentDoc}`;
export const Notification_ActionsFragmentDoc = gql`
    fragment Notification_Actions on Notification {
  actions {
    type
    name
    formattedName
    value
    valueType
    extraInfo
    extraInfoType
    extraInfoQuickOptions
  }
}
    `;
export const Notification_RecipientsFragmentDoc = gql`
    fragment Notification_Recipients on Notification {
  recipients {
    recipientId
    readAt
    push
  }
}
    `;
export const FullNotificationFragmentDoc = gql`
    fragment FullNotification on Notification {
  ...BaseNotification
  ...Notification_Actions
  ...Notification_Recipients
}
    ${BaseNotificationFragmentDoc}
${Notification_ActionsFragmentDoc}
${Notification_RecipientsFragmentDoc}`;
export const BasePriceFragmentDoc = gql`
    fragment BasePrice on Price {
  id
  name
  createdAt
  updatedAt
  deletedAt
  active
  amount
  priceType
  currency
  attributes
}
    `;
export const Price_MetadataFragmentDoc = gql`
    fragment Price_Metadata on Price {
  metadata
}
    `;
export const Price_ProductFragmentDoc = gql`
    fragment Price_Product on Price {
  product {
    ...BaseProduct
  }
}
    ${BaseProductFragmentDoc}`;
export const Price_UserFragmentDoc = gql`
    fragment Price_User on Price {
  user {
    ...BaseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const Price_TaxesFragmentDoc = gql`
    fragment Price_Taxes on Price {
  taxes {
    ...BaseTax
  }
}
    ${BaseTaxFragmentDoc}`;
export const Price_ZoneFragmentDoc = gql`
    fragment Price_Zone on Price {
  zone {
    ...BaseZone
  }
}
    ${BaseZoneFragmentDoc}`;
export const ExpenseForPriceFragmentDoc = gql`
    fragment ExpenseForPrice on PriceExpense {
  expense {
    ...BaseExpense
  }
  unitCost
}
    ${BaseExpenseFragmentDoc}`;
export const Price_ExpensesFragmentDoc = gql`
    fragment Price_Expenses on Price {
  expensesV2 {
    ...ExpenseForPrice
  }
}
    ${ExpenseForPriceFragmentDoc}`;
export const FullPriceFragmentDoc = gql`
    fragment FullPrice on Price {
  ...BasePrice
  ...Price_Metadata
  ...Price_Product
  ...Price_User
  ...Price_Taxes
  ...Price_Zone
  ...Price_Expenses
}
    ${BasePriceFragmentDoc}
${Price_MetadataFragmentDoc}
${Price_ProductFragmentDoc}
${Price_UserFragmentDoc}
${Price_TaxesFragmentDoc}
${Price_ZoneFragmentDoc}
${Price_ExpensesFragmentDoc}`;
export const BasePriceFieldsFragmentDoc = gql`
    fragment BasePriceFields on Price {
  ...BasePrice
  ...Price_Taxes
  ...Price_Expenses
}
    ${BasePriceFragmentDoc}
${Price_TaxesFragmentDoc}
${Price_ExpensesFragmentDoc}`;
export const PriceForBusinessProductsFragmentDoc = gql`
    fragment PriceForBusinessProducts on Price {
  ...BasePriceFields
  zone {
    id
    name
    color
  }
}
    ${BasePriceFieldsFragmentDoc}`;
export const PriceForEstimatingFragmentDoc = gql`
    fragment PriceForEstimating on Price {
  ...BasePriceFields
  ...Price_Zone
}
    ${BasePriceFieldsFragmentDoc}
${Price_ZoneFragmentDoc}`;
export const Product_ZonesFragmentDoc = gql`
    fragment Product_Zones on Product {
  zones {
    ...BaseZone
  }
}
    ${BaseZoneFragmentDoc}`;
export const Product_PricesFragmentDoc = gql`
    fragment Product_Prices on Product {
  prices {
    ...BasePrice
    ...Price_Taxes
    zone {
      id
      name
      color
    }
  }
}
    ${BasePriceFragmentDoc}
${Price_TaxesFragmentDoc}`;
export const FullProductFragmentDoc = gql`
    fragment FullProduct on Product {
  ...BaseProduct
  ...Product_Zones
  ...Product_Prices
}
    ${BaseProductFragmentDoc}
${Product_ZonesFragmentDoc}
${Product_PricesFragmentDoc}`;
export const BaseReportTypeFragmentDoc = gql`
    fragment BaseReportType on ReportType {
  id
  createdAt
  updatedAt
  deletedAt
  name
  attributes
  description
  version
  variableSchema
}
    `;
export const ReportType_ZonesFragmentDoc = gql`
    fragment ReportType_Zones on ReportType {
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const ReportTypeWithZonesFragmentDoc = gql`
    fragment ReportTypeWithZones on ReportType {
  ...BaseReportType
  ...ReportType_Zones
}
    ${BaseReportTypeFragmentDoc}
${ReportType_ZonesFragmentDoc}`;
export const ReportType_SchemaFragmentDoc = gql`
    fragment ReportType_Schema on ReportType {
  variableSchema
  returnValue
  columns
}
    `;
export const ReportType_CreatedByFragmentDoc = gql`
    fragment ReportType_CreatedBy on ReportType {
  createdBy {
    ...BaseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const BaseReportFragmentDoc = gql`
    fragment BaseReport on Report {
  id
  createdAt
  updatedAt
  deletedAt
  version
  name
  variables
  status
  error
  saveData
  saveReport
  saveAggregations
  reportType {
    ...BaseReportType
  }
  createdBy {
    ...BaseUser
  }
}
    ${BaseReportTypeFragmentDoc}
${BaseUserFragmentDoc}`;
export const ReportType_ReportsFragmentDoc = gql`
    fragment ReportType_Reports on ReportType {
  reports {
    total
    skipped
    limited
    reports {
      ...BaseReport
    }
  }
}
    ${BaseReportFragmentDoc}`;
export const ReportType_DescriptionFragmentDoc = gql`
    fragment ReportType_Description on ReportType {
  description
}
    `;
export const FullReportTypeFragmentDoc = gql`
    fragment FullReportType on ReportType {
  ...BaseReportType
  ...ReportType_Schema
  ...ReportType_CreatedBy
  ...ReportType_Reports
  ...ReportType_Zones
  ...ReportType_Description
}
    ${BaseReportTypeFragmentDoc}
${ReportType_SchemaFragmentDoc}
${ReportType_CreatedByFragmentDoc}
${ReportType_ReportsFragmentDoc}
${ReportType_ZonesFragmentDoc}
${ReportType_DescriptionFragmentDoc}`;
export const Report_ZonesFragmentDoc = gql`
    fragment Report_Zones on Report {
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const ReportType_ReportsWithZonesFragmentDoc = gql`
    fragment ReportType_ReportsWithZones on ReportType {
  reports {
    total
    skipped
    limited
    reports {
      ...BaseReport
      ...Report_Zones
    }
  }
}
    ${BaseReportFragmentDoc}
${Report_ZonesFragmentDoc}`;
export const ScheduledReport_AggregationsFragmentDoc = gql`
    fragment ScheduledReport_Aggregations on ScheduledReport {
  aggregations {
    id
    title
    type
    key
    secondaryType
    otherKeys
    options
    filters {
      key
      typeIs
      exactly
      contains
      endsWith
      startsWith
      matches
      gt
      lt
      gte
      lte
    }
    values {
      reportId
      createdAt
      values
      error
    }
    delta
    deltaName
  }
}
    `;
export const BaseScheduledReportFragmentDoc = gql`
    fragment BaseScheduledReport on ScheduledReport {
  id
  createdAt
  updatedAt
  deletedAt
  notifyUsers
  notifyRoles
  webhooks
  name
  variables
  nextRun
  lastRun
  attributes
  start
  end
  time
  tz
  saveData
}
    `;
export const ScheduledReport_ReportTypeFragmentDoc = gql`
    fragment ScheduledReport_ReportType on ScheduledReport {
  reportType {
    ...BaseReportType
  }
}
    ${BaseReportTypeFragmentDoc}`;
export const BaseDynamicReportFragmentDoc = gql`
    fragment BaseDynamicReport on DynamicReport {
  id
  name
  description
  dataColumns
  aggregationColumns
  sort
  start
  end
  period
  periodType
  groupBy
  filter
}
    `;
export const ScheduledReport_DynamicReportFragmentDoc = gql`
    fragment ScheduledReport_DynamicReport on ScheduledReport {
  dynamicReport {
    ...BaseDynamicReport
  }
}
    ${BaseDynamicReportFragmentDoc}`;
export const ScheduledReport_CreatedByFragmentDoc = gql`
    fragment ScheduledReport_CreatedBy on ScheduledReport {
  createdBy {
    ...BaseUser
  }
}
    ${BaseUserFragmentDoc}`;
export const ScheduledReport_ZonesFragmentDoc = gql`
    fragment ScheduledReport_Zones on ScheduledReport {
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const ScheduledReportEssentialsFragmentDoc = gql`
    fragment ScheduledReportEssentials on ScheduledReport {
  ...BaseScheduledReport
  ...ScheduledReport_ReportType
  ...ScheduledReport_DynamicReport
  ...ScheduledReport_CreatedBy
  ...ScheduledReport_Zones
}
    ${BaseScheduledReportFragmentDoc}
${ScheduledReport_ReportTypeFragmentDoc}
${ScheduledReport_DynamicReportFragmentDoc}
${ScheduledReport_CreatedByFragmentDoc}
${ScheduledReport_ZonesFragmentDoc}`;
export const Report_ScheduledReportFragmentDoc = gql`
    fragment Report_ScheduledReport on Report {
  scheduledReport {
    ...ScheduledReportEssentials
  }
}
    ${ScheduledReportEssentialsFragmentDoc}`;
export const BaseReportAggregationResultFragmentDoc = gql`
    fragment BaseReportAggregationResult on ReportAggregationResult {
  id
  title
  type
  key
  secondaryType
  otherKeys
  values
  labels
  error
  format
  options
}
    `;
export const Report_AggregationsFragmentDoc = gql`
    fragment Report_Aggregations on Report {
  aggregations {
    ...BaseReportAggregationResult
  }
}
    ${BaseReportAggregationResultFragmentDoc}`;
export const Report_DataFragmentDoc = gql`
    fragment Report_Data on Report {
  csv
  jsonURL
}
    `;
export const FullReportFragmentDoc = gql`
    fragment FullReport on Report {
  ...BaseReport
  ...Report_Aggregations
  ...Report_Data
  ...Report_Zones
}
    ${BaseReportFragmentDoc}
${Report_AggregationsFragmentDoc}
${Report_DataFragmentDoc}
${Report_ZonesFragmentDoc}`;
export const Tag_TaggedObjectFragmentDoc = gql`
    fragment Tag_TaggedObject on Tag {
  objects {
    id
    taggedPrivately
    taggedBy
    order
  }
}
    `;
export const FullTagFragmentDoc = gql`
    fragment FullTag on Tag {
  ...BaseTag
  ...Tag_TaggedObject
}
    ${BaseTagFragmentDoc}
${Tag_TaggedObjectFragmentDoc}`;
export const Tax_ZonesFragmentDoc = gql`
    fragment Tax_Zones on Tax {
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const BaseTokenFragmentDoc = gql`
    fragment BaseToken on Token {
  id
  createdAt
  token
  tokenType
  expiration
  emails
  title
  validOn
  zones {
    id
    name
  }
  used
  maxUses
  metadata
  isValid
}
    `;
export const Transaction_InvoiceFragmentDoc = gql`
    fragment Transaction_Invoice on Transaction {
  invoice {
    id
    openedAt
    sentAt
    voidedAt
    deletedAt
    invoiceNumber
    ...Invoice_Job
  }
}
    ${Invoice_JobFragmentDoc}`;
export const FullTransactionFragmentDoc = gql`
    fragment FullTransaction on Transaction {
  ...BaseTransaction
  job {
    ...BaseJob
  }
  customer {
    ...BaseUser
  }
  ...Transaction_Invoice
}
    ${BaseTransactionFragmentDoc}
${BaseJobFragmentDoc}
${BaseUserFragmentDoc}
${Transaction_InvoiceFragmentDoc}`;
export const BaseRoleFragmentDoc = gql`
    fragment BaseRole on Role {
  id
  color
  name
  attributes
  description
}
    `;
export const RoleWithZonesFragmentDoc = gql`
    fragment RoleWithZones on Role {
  ...BaseRole
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseRoleFragmentDoc}
${BaseZoneFragmentDoc}`;
export const FullUserFragmentDoc = gql`
    fragment FullUser on User {
  ...UserWithBillingAddress
  roles {
    ...RoleWithZones
  }
  twoFactorEnabled
  deletedAt {
    date
  }
  zones {
    nodes {
      ...BaseZone
    }
  }
}
    ${UserWithBillingAddressFragmentDoc}
${RoleWithZonesFragmentDoc}
${BaseZoneFragmentDoc}`;
export const BaseZoneWithTimezoneFragmentDoc = gql`
    fragment BaseZoneWithTimezone on Zone {
  ...BaseZone
  timezone
}
    ${BaseZoneFragmentDoc}`;
export const BaseZoneWithChildrenFragmentDoc = gql`
    fragment BaseZoneWithChildren on Zone {
  ...BaseZone
  children {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const BaseZoneWithFamilyFragmentDoc = gql`
    fragment BaseZoneWithFamily on Zone {
  ...BaseZone
  parent {
    ...BaseZone
  }
  parents {
    ...BaseZone
  }
  children {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;
export const BaseZoneWithAreasFragmentDoc = gql`
    fragment BaseZoneWithAreas on Zone {
  ...BaseZone
  areas {
    ...BaseLocation
  }
}
    ${BaseZoneFragmentDoc}
${BaseLocationFragmentDoc}`;
export const BaseZoneWithAreasAndChildrenFragmentDoc = gql`
    fragment BaseZoneWithAreasAndChildren on Zone {
  ...BaseZone
  areas {
    ...BaseLocation
  }
  children {
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}
${BaseLocationFragmentDoc}`;
export const BaseRuleFragmentDoc = gql`
    fragment BaseRule on Rule {
  id
  trigger {
    id
    name
    description
    describedForRule
    properties
  }
  condition
  describedConditions
  triggerDescription
  actionDescription
  action {
    id
    name
    description
    describedForRule
    properties
  }
  attributes
  createdAt
  updatedAt
  deletedAt
  metadata
  delay
  delayUnit
  offset
  offsetUnit
}
    `;
export const BaseFieldObjectValueFragmentDoc = gql`
    fragment BaseFieldObjectValue on FieldObjectValue {
  objectId
  value
  isDefault
}
    `;
export const BaseFieldFragmentDoc = gql`
    fragment BaseField on Field {
  id
  values {
    ...BaseFieldObjectValue
  }
  name
  type
}
    ${BaseFieldObjectValueFragmentDoc}`;
export const BaseCommentFragmentDoc = gql`
    fragment BaseComment on Comment {
  id
  text
  contents
  requiredAccessLevel
  system
  authorName
  author {
    id
    familyName
    givenName
  }
  isReply
  thread {
    id
    mode
  }
  attributes
  createdAt
  updatedAt
  deletedAt
  archivedAt
  metadata
  zoneIds
}
    `;
export const CommentWithRepliesFragmentDoc = gql`
    fragment CommentWithReplies on Comment {
  ...BaseComment
  thread {
    metadata
    mode
    subject
  }
  replyIds
  replies {
    ...BaseComment
  }
}
    ${BaseCommentFragmentDoc}`;
export const Invoice_ArtifactsFragmentDoc = gql`
    fragment Invoice_Artifacts on Invoice {
  artifacts {
    id
    name
    contentType
    attributes
    metadata
    url
    signedUrl
  }
}
    `;
export const InvoiceWithArtifactsFragmentDoc = gql`
    fragment InvoiceWithArtifacts on Invoice {
  ...BaseInvoice
  ...Invoice_Artifacts
}
    ${BaseInvoiceFragmentDoc}
${Invoice_ArtifactsFragmentDoc}`;
export const BaseArtifactFragmentDoc = gql`
    fragment BaseArtifact on Artifact {
  id
  attributes
  name
  namespace
  fileSize
  contentType
  public
  author
  signedPolicy
  signedUrl
  url
  createdAt
  metadata
}
    `;
export const JobsV2TransactionFragmentDoc = gql`
    fragment JobsV2Transaction on Transaction {
  ...BaseTransaction
  customer {
    ...BaseUser
  }
  invoice {
    ...InvoiceBasicDetails
  }
}
    ${BaseTransactionFragmentDoc}
${BaseUserFragmentDoc}
${InvoiceBasicDetailsFragmentDoc}`;
export const JobDetailsV2FragmentDoc = gql`
    fragment JobDetailsV2 on Job {
  ...FullJob
  fields {
    ...BaseField
  }
  comments {
    total
    comments {
      ...CommentWithReplies
    }
  }
  invoices {
    ...InvoiceWithArtifacts
  }
  artifacts {
    ...BaseArtifact
  }
  transactions {
    ...JobsV2Transaction
  }
}
    ${FullJobFragmentDoc}
${BaseFieldFragmentDoc}
${CommentWithRepliesFragmentDoc}
${InvoiceWithArtifactsFragmentDoc}
${BaseArtifactFragmentDoc}
${JobsV2TransactionFragmentDoc}`;
export const FullAvailabilityTemplateFragmentDoc = gql`
    fragment FullAvailabilityTemplate on AvailabilityTemplate {
  id
  name
  startDate
  endDate
  availability {
    monday
    tuesday
    wednesday
    thursday
    friday
    saturday
    sunday
  }
  zones {
    id
    name
    color
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const FullAvailabilityConfigurationFragmentDoc = gql`
    fragment FullAvailabilityConfiguration on AvailabilityConfiguration {
  id
  objectId
  templates {
    ...FullAvailabilityTemplate
  }
  overrides {
    dates
    template {
      ...FullAvailabilityTemplate
    }
  }
}
    ${FullAvailabilityTemplateFragmentDoc}`;
export const QuillTemplateFieldsFragmentDoc = gql`
    fragment QuillTemplateFields on QuillTemplate {
  id
  name
  contents
  location
  isDefault
  subjectContents
  zoneId
}
    `;
export const BaseQuickbooksAddressFragmentDoc = gql`
    fragment BaseQuickbooksAddress on QuickbooksAddress {
  Line1
  City
  CountrySubDivisionCode
  PostalCode
}
    `;
export const BaseCompanyInfoFragmentDoc = gql`
    fragment BaseCompanyInfo on CompanyInfo {
  CompanyName
  LegalName
  CompanyAddr {
    ...BaseQuickbooksAddress
  }
  LegalAddr {
    ...BaseQuickbooksAddress
  }
  PrimaryPhone {
    FreeFormNumber
  }
  Country
  Email {
    Address
  }
  WebAddr {
    URI
  }
  NameValue {
    Name
    Value
  }
}
    ${BaseQuickbooksAddressFragmentDoc}`;
export const BaseQuickbooksAccountFragmentDoc = gql`
    fragment BaseQuickbooksAccount on QuickbooksAccount {
  Id
  AccountType
  AccountSubType
  CurrentBalance
  Active
  FullQualifiedName
  Name
}
    `;
export const BaseQuickbooksItemFragmentDoc = gql`
    fragment BaseQuickbooksItem on QuickbooksItem {
  FullyQualifiedName
  Name
  Type
  Taxable
  sparse
  Active
  UnitPrice
  Id
  Description
}
    `;
export const BaseQuickbooksTaxCodeFragmentDoc = gql`
    fragment BaseQuickbooksTaxCode on QuickbooksTaxCode {
  Name
  Description
  Active
  Hidden
  Taxable
  TaxGroup
  domain
  sparse
  Id
}
    `;
export const QuickbooksTaxCodeWithSalesTaxListFragmentDoc = gql`
    fragment QuickbooksTaxCodeWithSalesTaxList on QuickbooksTaxCode {
  ...BaseQuickbooksTaxCode
  SalesTaxRateList {
    TaxRateDetail {
      TaxRateRef {
        value
      }
    }
  }
}
    ${BaseQuickbooksTaxCodeFragmentDoc}`;
export const AvailableZoneFragmentDoc = gql`
    fragment AvailableZone on Zone {
  ...BaseZoneWithParent
  contextableRoles {
    ...BaseRole
  }
}
    ${BaseZoneWithParentFragmentDoc}
${BaseRoleFragmentDoc}`;
export const FullPermissionFragmentDoc = gql`
    fragment FullPermission on Permission {
  permission
  mappedPermission
  createdAt
  updatedAt
  deletedAt
  zone
  role
  zoneDepth
  restrictions
  __typename
}
    `;
export const BaseCommentModeFragmentDoc = gql`
    fragment BaseCommentMode on CommentMode {
  id
  name
  icon
  system
  description
  hidden
  showSubject
}
    `;
export const ZoneConfigStringFragmentDoc = gql`
    fragment ZoneConfigString on Config_String {
  id
  key
  zone
  value
  fallback {
    key
    zone
    value
    createdAt
    updatedAt
  }
  overridingConfigs {
    key
    zone
    value
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}
    `;
export const ZoneConfigValueFloatFragmentDoc = gql`
    fragment ZoneConfigValueFloat on Config_Float {
  id
  key
  zone
  value
  fallback {
    key
    zone
    value
    createdAt
    updatedAt
  }
  overridingConfigs {
    key
    zone
    value
    createdAt
    updatedAt
  }
  createdAt
  updatedAt
}
    `;
export const QuickBooksConfigValuesFragmentDoc = gql`
    fragment QuickBooksConfigValues on ZoneConfigValue {
  QUICKBOOKS_ENABLED
  QUICKBOOKS_PRODUCT__MAP
  QUICKBOOKS_TAXCODE__MAP
}
    `;
export const BaseConfigValueFragmentDoc = gql`
    fragment BaseConfigValue on ConfigValue {
  id
  key
  zone
  value
  createdAt
  updatedAt
}
    `;
export const ConfigValueWithOverridingConfigsFragmentDoc = gql`
    fragment ConfigValueWithOverridingConfigs on ConfigValue {
  ...BaseConfigValue
  fallback {
    key
    zone
    value
    createdAt
    updatedAt
  }
  overridingConfigs {
    key
    zone
    value
    createdAt
    updatedAt
  }
}
    ${BaseConfigValueFragmentDoc}`;
export const LogInToActOnDocument = gql`
    mutation LogInToActOn($username: String!, $password: String!) {
  logInToActOn(username: $username, password: $password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LogInToActOnGQL extends Apollo.Mutation<LogInToActOnMutation, LogInToActOnMutationVariables> {
    document = LogInToActOnDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IsAuthenticatedToActOnDocument = gql`
    query IsAuthenticatedToActOn {
  isAuthenticatedToActOn
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IsAuthenticatedToActOnGQL extends Apollo.Query<IsAuthenticatedToActOnQuery, IsAuthenticatedToActOnQueryVariables> {
    document = IsAuthenticatedToActOnDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContactListsDocument = gql`
    query ContactLists {
  contactLists {
    result {
      id
      name
      description
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContactListsGQL extends Apollo.Query<ContactListsQuery, ContactListsQueryVariables> {
    document = ContactListsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJobDocumentsDocument = gql`
    query getJobDocuments($jobId: String, $getPrivate: Boolean, $sortBy: String, $skip: Int, $limit: Int) {
  artifacts(
    filter: {relatedObjectIds: [$jobId], relatedToObjectsOfType: "Job", zoneDir: any, hasAnyAttributes: ["pandadoc"]}
    getPrivate: $getPrivate
    sortBy: $sortBy
    skip: $skip
    limit: $limit
  ) {
    artifacts {
      ...PandadocArtifact
    }
  }
}
    ${PandadocArtifactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJobDocumentsGQL extends Apollo.Query<GetJobDocumentsQuery, GetJobDocumentsQueryVariables> {
    document = GetJobDocumentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ViewArtifactsDocument = gql`
    query viewArtifacts($filter: ArtifactFilter, $getPrivate: Boolean, $sortBy: String, $skip: Int, $limit: Int) {
  artifacts(
    filter: $filter
    getPrivate: $getPrivate
    sortBy: $sortBy
    skip: $skip
    limit: $limit
  ) {
    artifacts {
      ...PandadocArtifact
    }
    total
    skipped
    limited
  }
}
    ${PandadocArtifactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ViewArtifactsGQL extends Apollo.Query<ViewArtifactsQuery, ViewArtifactsQueryVariables> {
    document = ViewArtifactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDocumentDocument = gql`
    mutation createDocument($serviceToUse: String!, $documentsToSend: [String!], $templateIds: [String!], $userId: String, $sendStandardDocuments: Boolean, $variables: DocumentVariablesInput, $send: Boolean, $sendDocumentExternally: Boolean, $sendDocumentInternally: Boolean, $saveArtifact: Boolean, $commentWithArtifactOn: [String]) {
  createDocument(
    serviceToUse: $serviceToUse
    documentsToSend: $documentsToSend
    templateIds: $templateIds
    userId: $userId
    variables: $variables
    send: $send
    sendStandardDocuments: $sendStandardDocuments
    sendDocumentExternally: $sendDocumentExternally
    sendDocumentInternally: $sendDocumentInternally
    saveArtifact: $saveArtifact
    commentWithArtifactOn: $commentWithArtifactOn
  ) {
    docLink
    artifact {
      ...BaseArtifact
    }
    recipients {
      email
      firstName
      lastName
      role
    }
  }
}
    ${BaseArtifactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDocumentGQL extends Apollo.Mutation<CreateDocumentMutation, CreateDocumentMutationVariables> {
    document = CreateDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListArtifactsDocument = gql`
    query listArtifacts($filter: ArtifactFilter, $getPrivate: Boolean, $sortBy: String, $skip: Int, $limit: Int) {
  artifacts(
    filter: $filter
    getPrivate: $getPrivate
    sortBy: $sortBy
    skip: $skip
    limit: $limit
  ) {
    total
    skipped
    limited
    artifacts {
      ...BaseArtifact
    }
  }
}
    ${BaseArtifactFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListArtifactsGQL extends Apollo.Query<ListArtifactsQuery, ListArtifactsQueryVariables> {
    document = ListArtifactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteArtifactsDocument = gql`
    mutation deleteArtifacts($artifactIds: [String!]!, $deleteResource: Boolean!) {
  deleteArtifacts(artifactIds: $artifactIds, deleteResource: $deleteResource)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteArtifactsGQL extends Apollo.Mutation<DeleteArtifactsMutation, DeleteArtifactsMutationVariables> {
    document = DeleteArtifactsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentReadyToViewDocument = gql`
    subscription DocumentReadyToView {
  documentReadyToView {
    artifactId
    templateType
    userId
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentReadyToViewGQL extends Apollo.Subscription<DocumentReadyToViewSubscription, DocumentReadyToViewSubscriptionVariables> {
    document = DocumentReadyToViewDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DocumentSignedDocument = gql`
    subscription DocumentSigned {
  documentSigned {
    artifactId
    signedByRole
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DocumentSignedGQL extends Apollo.Subscription<DocumentSignedSubscription, DocumentSignedSubscriptionVariables> {
    document = DocumentSignedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpcomingEventsDocument = gql`
    query upcomingEvents($filter: CalendarEventsFilter, $skip: Int, $limit: Int) {
  calendarEvents(filter: $filter, skip: $skip, limit: $limit) {
    total
    skipped
    limited
    events {
      ...CalendarEventForSchedule
    }
  }
}
    ${CalendarEventForScheduleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpcomingEventsGQL extends Apollo.Query<UpcomingEventsQuery, UpcomingEventsQueryVariables> {
    document = UpcomingEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssetsDocument = gql`
    query assets($filter: AssetsFilter, $skip: Int, $limit: Int, $sort: String) {
  assets(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    skipped
    limited
    assets {
      ...FullAsset
    }
  }
}
    ${FullAssetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AssetsGQL extends Apollo.Query<AssetsQuery, AssetsQueryVariables> {
    document = AssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BaseAssetsDocument = gql`
    query baseAssets($filter: AssetsFilter, $skip: Int, $limit: Int, $sort: String) {
  assets(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    skipped
    limited
    assets {
      ...BaseAsset
    }
  }
}
    ${BaseAssetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BaseAssetsGQL extends Apollo.Query<BaseAssetsQuery, BaseAssetsQueryVariables> {
    document = BaseAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAssetsDocument = gql`
    mutation createAssets($assets: [CreateAssetInput]!) {
  createAssets(assets: $assets) {
    id
    name
    type
    description
    location {
      id
      __typename
    }
    attributes
    createdAt
    updatedAt
    deletedAt
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAssetsGQL extends Apollo.Mutation<CreateAssetsMutation, CreateAssetsMutationVariables> {
    document = CreateAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListBaseAssetsDocument = gql`
    query listBaseAssets($filter: AssetsFilter, $limit: Int) {
  assets(filter: $filter, limit: $limit) {
    assets {
      ...BaseAsset
    }
  }
}
    ${BaseAssetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListBaseAssetsGQL extends Apollo.Query<ListBaseAssetsQuery, ListBaseAssetsQueryVariables> {
    document = ListBaseAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAssetsDocument = gql`
    mutation updateAssets($assets: [UpdateAssetInput]!) {
  updateAssets(assets: $assets)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAssetsGQL extends Apollo.Mutation<UpdateAssetsMutation, UpdateAssetsMutationVariables> {
    document = UpdateAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAssetsDocument = gql`
    mutation deleteAssets($ids: [String]!, $hardDelete: Boolean, $restore: Boolean) {
  deleteAssets(ids: $ids, hardDelete: $hardDelete, restore: $restore)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAssetsGQL extends Apollo.Mutation<DeleteAssetsMutation, DeleteAssetsMutationVariables> {
    document = DeleteAssetsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListAuthMethodsDocument = gql`
    query listAuthMethods($userId: String) {
  authMethods(userId: $userId) {
    id
    createdAt
    updatedAt
    deletedAt
    authMethodType
    ethereum_network
    oidc_provider
    oidc_name
    password_minLength
    zone
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListAuthMethodsGQL extends Apollo.Query<ListAuthMethodsQuery, ListAuthMethodsQueryVariables> {
    document = ListAuthMethodsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AuthenticateDocument = gql`
    mutation authenticate($id: String, $zone: String, $email: String, $password: String, $twoFactorAuthenticationToken: String, $rememberLength: Int, $jwt: String, $refreshToken: String) {
  authenticate(
    useCookies: true
    id: $id
    zone: $zone
    email: $email
    password: $password
    rememberLength: $rememberLength
    twoFactorAuthenticationToken: $twoFactorAuthenticationToken
    jwt: $jwt
    refreshToken: $refreshToken
  ) {
    userId
    validJWT
    validRefreshToken
    validEmail
    valid2FA
    validPassword
    jwt
    jwtExpires
    refreshToken
    refreshTokenExpires
    lockedOutTimeLeft
    lockedOutAttemptsLeft
    invalidReason
    invalidCode
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AuthenticateGQL extends Apollo.Mutation<AuthenticateMutation, AuthenticateMutationVariables> {
    document = AuthenticateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeauthenticateDocument = gql`
    mutation deauthenticate {
  deauthenticate
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeauthenticateGQL extends Apollo.Mutation<DeauthenticateMutation, DeauthenticateMutationVariables> {
    document = DeauthenticateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const Disable2FaDocument = gql`
    mutation disable2FA {
  disable2FA
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class Disable2FaGQL extends Apollo.Mutation<Disable2FaMutation, Disable2FaMutationVariables> {
    document = Disable2FaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ConfirmSecretDocument = gql`
    mutation confirmSecret($token: String) {
  confirmSecret(token: $token)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ConfirmSecretGQL extends Apollo.Mutation<ConfirmSecretMutation, ConfirmSecretMutationVariables> {
    document = ConfirmSecretDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateSecretDocument = gql`
    mutation generateSecret {
  generateSecret {
    qr
    secret
    uri
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateSecretGQL extends Apollo.Mutation<GenerateSecretMutation, GenerateSecretMutationVariables> {
    document = GenerateSecretDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RequestPasswordResetDocument = gql`
    mutation requestPasswordReset($userId: String, $email: String) {
  createPasswordResetToken(userId: $userId, email: $email)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RequestPasswordResetGQL extends Apollo.Mutation<RequestPasswordResetMutation, RequestPasswordResetMutationVariables> {
    document = RequestPasswordResetDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation resetPassword($token: String!, $newPassword: String!) {
  redeemPasswordResetToken(token: $token, newPassword: $newPassword)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RedeemInviteTokenDocument = gql`
    mutation redeemInviteToken($token: String!, $email: String!, $password: String!, $givenName: String!, $familyName: String!, $businessName: String, $businessID: String, $businessCode: String, $businessAddress: String) {
  redeemInviteToken(
    token: $token
    email: $email
    password: $password
    givenName: $givenName
    familyName: $familyName
    businessName: $businessName
    businessID: $businessID
    businessCode: $businessCode
    businessAddress: $businessAddress
  ) {
    userId
    user {
      id
      email
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RedeemInviteTokenGQL extends Apollo.Mutation<RedeemInviteTokenMutation, RedeemInviteTokenMutationVariables> {
    document = RedeemInviteTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssetsForAvailabilityDocument = gql`
    query AssetsForAvailability($filter: AssetsFilter, $limit: Int) {
  assets(filter: $filter, limit: $limit) {
    assets {
      ...BaseAsset
    }
  }
}
    ${BaseAssetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AssetsForAvailabilityGQL extends Apollo.Query<AssetsForAvailabilityQuery, AssetsForAvailabilityQueryVariables> {
    document = AssetsForAvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BookOffEventsDocument = gql`
    query BookOffEvents($filter: CalendarEventsFilter) {
  calendarEvents(filter: $filter) {
    events {
      ...BookOffCalendarEvent
    }
  }
}
    ${BookOffCalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BookOffEventsGQL extends Apollo.Query<BookOffEventsQuery, BookOffEventsQueryVariables> {
    document = BookOffEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SearchDocument = gql`
    query search($search: String!) {
  search(input: {search: $search}) {
    results {
      label
      objectID
      title
      subtitle
      zoneId
      zone
      score
      metadata
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SearchGQL extends Apollo.Query<SearchQuery, SearchQueryVariables> {
    document = SearchDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SubmitFeedbackDocument = gql`
    mutation submitFeedback($feedback: FeedbackInput) {
  submitFeedback(feedback: $feedback)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SubmitFeedbackGQL extends Apollo.Mutation<SubmitFeedbackMutation, SubmitFeedbackMutationVariables> {
    document = SubmitFeedbackDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AggregationDataOnlyDocument = gql`
    query AggregationDataOnly($skip: Int, $limit: Int, $performance: String, $sort: String, $start: Int!, $end: Int!, $periodType: String, $filter: PreviewReportFilter, $groupBy: String!, $linkFormat: String, $dataColumns: [String], $aggregationColumns: [String], $columnParams: ColumnParams) {
  previewReport(
    skip: $skip
    limit: $limit
    performance: $performance
    sort: $sort
    start: $start
    end: $end
    periodType: $periodType
    filter: $filter
    groupBy: $groupBy
    linkFormat: $linkFormat
    dataColumns: $dataColumns
    aggregationColumns: $aggregationColumns
    columnParams: $columnParams
  ) {
    aggregationData
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AggregationDataOnlyGQL extends Apollo.Query<AggregationDataOnlyQuery, AggregationDataOnlyQueryVariables> {
    document = AggregationDataOnlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DataOnlyDocument = gql`
    query DataOnly($skip: Int, $limit: Int, $performance: String, $sort: String, $start: Int!, $end: Int!, $periodType: String, $filter: PreviewReportFilter, $groupBy: String!, $linkFormat: String, $dataColumns: [String], $aggregationColumns: [String], $columnParams: ColumnParams) {
  previewReport(
    skip: $skip
    limit: $limit
    performance: $performance
    sort: $sort
    start: $start
    end: $end
    periodType: $periodType
    filter: $filter
    groupBy: $groupBy
    linkFormat: $linkFormat
    dataColumns: $dataColumns
    aggregationColumns: $aggregationColumns
    columnParams: $columnParams
  ) {
    data
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataOnlyGQL extends Apollo.Query<DataOnlyQuery, DataOnlyQueryVariables> {
    document = DataOnlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewReportWithConfigsDocument = gql`
    query PreviewReportWithConfigs($skip: Int, $limit: Int, $performance: String, $sort: String, $start: Int!, $end: Int!, $periodType: String, $filter: PreviewReportFilter, $groupBy: String!, $linkFormat: String, $dataColumns: [String], $aggregationColumns: [String], $columnParams: ColumnParams) {
  previewReport(
    skip: $skip
    limit: $limit
    performance: $performance
    sort: $sort
    start: $start
    end: $end
    periodType: $periodType
    filter: $filter
    groupBy: $groupBy
    linkFormat: $linkFormat
    dataColumns: $dataColumns
    aggregationColumns: $aggregationColumns
    columnParams: $columnParams
  ) {
    data
  }
  closureReasonsAndAttentionExplanations: getConfigValues(
    keys: ["jobs.closedReasons", "attention.*"]
  ) {
    ...BaseConfigValue
  }
}
    ${BaseConfigValueFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewReportWithConfigsGQL extends Apollo.Query<PreviewReportWithConfigsQuery, PreviewReportWithConfigsQueryVariables> {
    document = PreviewReportWithConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DynamicReportsDocument = gql`
    query DynamicReports($skip: Int, $limit: Int, $filter: DynamicReportsFilter) {
  dynamicReports(skip: $skip, limit: $limit, filter: $filter) {
    skipped
    limited
    total
    reports {
      ...BaseDynamicReport
    }
  }
}
    ${BaseDynamicReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DynamicReportsGQL extends Apollo.Query<DynamicReportsQuery, DynamicReportsQueryVariables> {
    document = DynamicReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDynamicReportDocument = gql`
    mutation CreateDynamicReport($name: String!, $description: String!, $parameters: DynamicReportParametersInput) {
  createDynamicReport(
    name: $name
    description: $description
    parameters: $parameters
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDynamicReportGQL extends Apollo.Mutation<CreateDynamicReportMutation, CreateDynamicReportMutationVariables> {
    document = CreateDynamicReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDynamicReportDocument = gql`
    mutation UpdateDynamicReport($reportId: String!, $name: String, $description: String, $parameters: DynamicReportParametersInput) {
  updateDynamicReport(
    reportId: $reportId
    name: $name
    description: $description
    parameters: $parameters
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDynamicReportGQL extends Apollo.Mutation<UpdateDynamicReportMutation, UpdateDynamicReportMutationVariables> {
    document = UpdateDynamicReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDynamicReportsExportTokenDocument = gql`
    mutation createDynamicReportsExportToken($dynamicReportId: String!, $performance: String) {
  createDynamicReportExportToken(
    dynamicReportId: $dynamicReportId
    performance: $performance
  ) {
    id
    createdAt
    token
    tokenType
    expiration
    title
    isValid
    used
    metadata
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDynamicReportsExportTokenGQL extends Apollo.Mutation<CreateDynamicReportsExportTokenMutation, CreateDynamicReportsExportTokenMutationVariables> {
    document = CreateDynamicReportsExportTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetFullDiscountByIdDocument = gql`
    query getFullDiscountById($discountId: String!) {
  discounts(
    filter: {discountIds: [$discountId], showDeleted: true}
    skip: 0
    limit: 1
  ) {
    total
    skipped
    limited
    discounts {
      ...FullDiscount
    }
  }
}
    ${FullDiscountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetFullDiscountByIdGQL extends Apollo.Query<GetFullDiscountByIdQuery, GetFullDiscountByIdQueryVariables> {
    document = GetFullDiscountByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DiscountsDocument = gql`
    query discounts($filter: DiscountFilter, $skip: Int, $limit: Int) {
  discounts(filter: $filter, skip: $skip, limit: $limit) {
    total
    skipped
    limited
    discounts {
      ...FullDiscount
    }
    __typename
  }
}
    ${FullDiscountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DiscountsGQL extends Apollo.Query<DiscountsQuery, DiscountsQueryVariables> {
    document = DiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteDiscountsDocument = gql`
    mutation deleteDiscounts($discountIds: [String!]!) {
  deleteDiscounts(discountIds: $discountIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteDiscountsGQL extends Apollo.Mutation<DeleteDiscountsMutation, DeleteDiscountsMutationVariables> {
    document = DeleteDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateDiscountsDocument = gql`
    mutation updateDiscounts($updateDiscounts: [UpdateDiscountsInput!]!) {
  updateDiscounts(updateDiscounts: $updateDiscounts)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateDiscountsGQL extends Apollo.Mutation<UpdateDiscountsMutation, UpdateDiscountsMutationVariables> {
    document = UpdateDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCustomAmountDocument = gql`
    mutation updateCustomAmount($appliedId: String!, $customAmount: Int!) {
  updateAppliedCustomAmount(appliedId: $appliedId, customAmount: $customAmount)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCustomAmountGQL extends Apollo.Mutation<UpdateCustomAmountMutation, UpdateCustomAmountMutationVariables> {
    document = UpdateCustomAmountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateDiscountsDocument = gql`
    mutation createDiscounts($createDiscounts: [CreateDiscountInput!]!) {
  createDiscounts(createDiscounts: $createDiscounts) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    description
    code
    amount
    active
    startsAt
    expiresAt
    maxRedemptions
    timesRedeemed
    attributes
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateDiscountsGQL extends Apollo.Mutation<CreateDiscountsMutation, CreateDiscountsMutationVariables> {
    document = CreateDiscountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DynamicReportOptionsDocument = gql`
    query DynamicReportOptions($groupBy: String!) {
  groupByOptions {
    ...BaseOption
  }
  periodTypeOptions {
    ...BaseOption
  }
  aggregationColumns {
    ...BaseOption
  }
  dataColumns(groupBy: $groupBy) {
    ...BaseOption
  }
}
    ${BaseOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class DynamicReportOptionsGQL extends Apollo.Query<DynamicReportOptionsQuery, DynamicReportOptionsQueryVariables> {
    document = DynamicReportOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PreviewReportDocument = gql`
    query PreviewReport($skip: Int, $limit: Int, $performance: String, $sort: String, $start: Int!, $end: Int!, $periodType: String, $filter: PreviewReportFilter, $groupBy: String!, $linkFormat: String, $dataColumns: [String], $aggregationColumns: [String], $columnParams: ColumnParams) {
  previewReport(
    skip: $skip
    limit: $limit
    performance: $performance
    sort: $sort
    start: $start
    end: $end
    periodType: $periodType
    filter: $filter
    groupBy: $groupBy
    linkFormat: $linkFormat
    dataColumns: $dataColumns
    aggregationColumns: $aggregationColumns
    columnParams: $columnParams
  ) {
    total
    skipped
    limited
    data
    aggregationData
    groupBy
  }
  dataColumns(groupBy: $groupBy) {
    ...BaseOption
  }
}
    ${BaseOptionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class PreviewReportGQL extends Apollo.Query<PreviewReportQuery, PreviewReportQueryVariables> {
    document = PreviewReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExistingCustomerJobsDocument = gql`
    query existingCustomerJobs($filter: JobsFilter, $skip: Int, $limit: Int, $sort: String, $resolve: [String]) {
  jobs(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    resolve: $resolve
  ) {
    jobs {
      code
      id
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExistingCustomerJobsGQL extends Apollo.Query<ExistingCustomerJobsQuery, ExistingCustomerJobsQueryVariables> {
    document = ExistingCustomerJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimatingDocument = gql`
    query estimating($filter: JobsFilter, $jobId: String!, $objects: [String]) {
  jobs(
    filter: $filter
    limit: 1
    resolve: ["discounts", "stages", "users", "locations"]
  ) {
    jobs {
      ...EstimatesJob
    }
  }
  comments(
    filter: {hasAnyAttributes: ["inventory", "generated-inventory"], objectIds: [$jobId], objectType: "Job"}
  ) {
    comments {
      ...BaseComment
    }
  }
  fields(
    filter: {namespaces: ["customer", "startLocation", "endLocation", "booking", "misc", "inventory"]}
    objects: $objects
    objectLabels: ["Job"]
    limit: 150
    ignoreDefaults: true
  ) {
    fields {
      ...BaseField
    }
  }
}
    ${EstimatesJobFragmentDoc}
${BaseCommentFragmentDoc}
${BaseFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimatingGQL extends Apollo.Query<EstimatingQuery, EstimatingQueryVariables> {
    document = EstimatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimatingUpdateJobDocument = gql`
    mutation estimatingUpdateJob($updateJobs: [UpdateJobInput]) {
  updateJobs(updateJobs: $updateJobs) {
    transitionedJobs {
      oldJobId
      newJobId
    }
    isSuccess
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimatingUpdateJobGQL extends Apollo.Mutation<EstimatingUpdateJobMutation, EstimatingUpdateJobMutationVariables> {
    document = EstimatingUpdateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EstimatingCreateJobDocument = gql`
    mutation estimatingCreateJob($stage: String!, $users: [JobUserInput], $locations: [JobLocationInput], $events: [EventInput], $newCustomers: [CreateUserInputWithRole], $sendSelfSurvey: Boolean, $fields: SetFieldsValuesInput, $currency: String, $depositRequired: Int, $metadata: Metadata, $timeline: String, $timelineDays: Float, $jobCategory: String, $crewSummary: Summary, $customerSummary: Summary, $adminSummary: Summary, $closedReason: String, $zoneId: String) {
  createJob(
    stage: $stage
    users: $users
    locations: $locations
    events: $events
    newCustomers: $newCustomers
    sendSelfSurvey: $sendSelfSurvey
    fields: $fields
    currency: $currency
    depositRequired: $depositRequired
    metadata: $metadata
    timeline: $timeline
    timelineDays: $timelineDays
    jobCategory: $jobCategory
    crewSummary: $crewSummary
    customerSummary: $customerSummary
    adminSummary: $adminSummary
    closedReason: $closedReason
    zoneId: $zoneId
  ) {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EstimatingCreateJobGQL extends Apollo.Mutation<EstimatingCreateJobMutation, EstimatingCreateJobMutationVariables> {
    document = EstimatingCreateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListReportsDocument = gql`
    query ListReports($getData: [ReportGetDataOptions!], $filter: ReportsFilter, $skip: Int, $limit: Int, $sort: String) {
  reports(
    getData: $getData
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
  ) {
    reports {
      id
      name
      reportType {
        id
      }
      aggregations {
        id
        title
        type
        key
        secondaryType
        options
        labels
        values
        __typename
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListReportsGQL extends Apollo.Query<ListReportsQuery, ListReportsQueryVariables> {
    document = ListReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListReportTypesDocument = gql`
    query ListReportTypes($filter: ReportTypesFilter, $skip: Int, $limit: Int, $sort: String) {
  reportTypes(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    reportTypes {
      id
      name
      createdAt
      updatedAt
      deletedAt
      columns
      createdBy {
        id
      }
      aggregations {
        id
        title
        type
        key
        filters {
          key
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListReportTypesGQL extends Apollo.Query<ListReportTypesQuery, ListReportTypesQueryVariables> {
    document = ListReportTypesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListReportTypesWithReportsDocument = gql`
    query ListReportTypesWithReports($filter: ReportTypesFilter, $skip: Int, $limit: Int, $sort: String) {
  reportTypes(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    reportTypes {
      id
      name
      createdAt
      updatedAt
      deletedAt
      columns
      createdBy {
        id
      }
      reports {
        reports {
          id
          status
          aggregations {
            id
            title
            type
            labels
            values
          }
        }
      }
      aggregations {
        id
        title
        type
        key
        filters {
          key
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListReportTypesWithReportsGQL extends Apollo.Query<ListReportTypesWithReportsQuery, ListReportTypesWithReportsQueryVariables> {
    document = ListReportTypesWithReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SvcCreateReportDocument = gql`
    mutation svcCreateReport($input: CreateReportInput!) {
  createReport(input: $input) {
    id
    status
    error
    aggregations {
      id
      labels
      key
      title
      type
      secondaryType
      otherKeys
      options
      error
      values
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SvcCreateReportGQL extends Apollo.Mutation<SvcCreateReportMutation, SvcCreateReportMutationVariables> {
    document = SvcCreateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TestScheduledDynamicReportDocument = gql`
    mutation TestScheduledDynamicReport($reportId: String!) {
  testScheduledDynamicReport(reportId: $reportId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TestScheduledDynamicReportGQL extends Apollo.Mutation<TestScheduledDynamicReportMutation, TestScheduledDynamicReportMutationVariables> {
    document = TestScheduledDynamicReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResolveServiceAreaDocument = gql`
    query resolveServiceArea($query: String!, $areaCode: String) {
  resolveServiceArea(query: $query, areaCode: $areaCode) {
    query
    placeName
    placeId
    matchedArea {
      zoneId
      zoneName
      zoneParentId
      distance
      territoryMatches
      matchType
    }
    closestAreas {
      zoneId
      zoneName
      zoneParentId
      distance
      territoryMatches
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResolveServiceAreaGQL extends Apollo.Query<ResolveServiceAreaQuery, ResolveServiceAreaQueryVariables> {
    document = ResolveServiceAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignObjectsToZonesDocument = gql`
    mutation assignObjectsToZones($zoneIds: [String!]!, $addObjects: [String!]!, $removeObjects: [String!]!, $label: String) {
  assignObjectsToZones(
    zoneIds: $zoneIds
    addObjects: $addObjects
    removeObjects: $removeObjects
    label: $label
  ) {
    objectsAssigned
    objectsRemoved
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignObjectsToZonesGQL extends Apollo.Mutation<AssignObjectsToZonesMutation, AssignObjectsToZonesMutationVariables> {
    document = AssignObjectsToZonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetFieldValuesDocument = gql`
    mutation setFieldValues($fields: [SetFieldValueInput!]!, $objects: [String!], $objectLabel: String!) {
  setFieldsValues(fields: $fields, objects: $objects, objectLabel: $objectLabel) {
    fields {
      ...BaseField
    }
  }
}
    ${BaseFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class SetFieldValuesGQL extends Apollo.Mutation<SetFieldValuesMutation, SetFieldValuesMutationVariables> {
    document = SetFieldValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListFieldsDocument = gql`
    query listFields($filter: FieldFilter, $objects: [String], $objectLabels: [String], $showAllUsers: Boolean, $ignoreDefaults: Boolean, $sort: String, $skip: Int, $limit: Int, $limitValues: Int, $skipValues: Int) {
  fields(
    filter: $filter
    objects: $objects
    objectLabels: $objectLabels
    showAllUsers: $showAllUsers
    ignoreDefaults: $ignoreDefaults
    sort: $sort
    skip: $skip
    limit: $limit
    limitValues: $limitValues
    skipValues: $skipValues
  ) {
    fields {
      ...BaseField
    }
  }
}
    ${BaseFieldFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListFieldsGQL extends Apollo.Query<ListFieldsQuery, ListFieldsQueryVariables> {
    document = ListFieldsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListRulesDocument = gql`
    query listRules($filter: RulesFilter, $skip: Int, $limit: Int, $sort: String) {
  rules(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    rules {
      ...BaseRule
    }
  }
}
    ${BaseRuleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListRulesGQL extends Apollo.Query<ListRulesQuery, ListRulesQueryVariables> {
    document = ListRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateRulesDocument = gql`
    mutation createRules($rules: [CreateRuleInput!]!) {
  createRules(rules: $rules) {
    ...BaseRule
  }
}
    ${BaseRuleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateRulesGQL extends Apollo.Mutation<CreateRulesMutation, CreateRulesMutationVariables> {
    document = CreateRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateRulesDocument = gql`
    mutation updateRules($rules: [UpdateRuleInput!]!) {
  updateRules(rules: $rules) {
    ...BaseRule
  }
}
    ${BaseRuleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateRulesGQL extends Apollo.Mutation<UpdateRulesMutation, UpdateRulesMutationVariables> {
    document = UpdateRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteRulesDocument = gql`
    mutation deleteRules($ruleIds: [String!]!) {
  deleteRules(ruleIds: $ruleIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteRulesGQL extends Apollo.Mutation<DeleteRulesMutation, DeleteRulesMutationVariables> {
    document = DeleteRulesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RuleOptionsDocument = gql`
    query ruleOptions {
  ruleOptions {
    triggers {
      id
      name
      description
      properties
    }
    actions {
      id
      name
      description
      properties
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RuleOptionsGQL extends Apollo.Query<RuleOptionsQuery, RuleOptionsQueryVariables> {
    document = RuleOptionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateZonesDocument = gql`
    mutation createZones($parent: String!, $zones: [ZoneInput!]!) {
  createZones(parent: $parent, zones: $zones) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    description
    contextable
    avatar
    color
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateZonesGQL extends Apollo.Mutation<CreateZonesMutation, CreateZonesMutationVariables> {
    document = CreateZonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateZonesDocument = gql`
    mutation updateZones($ids: [String!]!, $edit: ZoneInput!, $parent: String) {
  updateZones(ids: $ids, edit: $edit, parent: $parent) {
    id
    createdAt
    updatedAt
    deletedAt
    name
    type
    description
    contextable
    avatar
    color
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateZonesGQL extends Apollo.Mutation<UpdateZonesMutation, UpdateZonesMutationVariables> {
    document = UpdateZonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAreaDocument = gql`
    mutation deleteArea($areaId: String!) {
  removeZones(ids: [$areaId], hardDelete: true) {
    zonesRemoved
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAreaGQL extends Apollo.Mutation<DeleteAreaMutation, DeleteAreaMutationVariables> {
    document = DeleteAreaDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetCurrentZoneDocument = gql`
    query getCurrentZone {
  currentZone {
    id
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetCurrentZoneGQL extends Apollo.Query<GetCurrentZoneQuery, GetCurrentZoneQueryVariables> {
    document = GetCurrentZoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListHistoryDocument = gql`
    query ListHistory($input: ListHistoryInput) {
  history(input: $input) {
    history {
      ...HistoryParts
    }
    total
  }
}
    ${HistoryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListHistoryGQL extends Apollo.Query<ListHistoryQuery, ListHistoryQueryVariables> {
    document = ListHistoryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListHistoryDataOnlyDocument = gql`
    query ListHistoryDataOnly($input: ListHistoryInput) {
  history(input: $input) {
    history {
      ...HistoryParts
    }
  }
}
    ${HistoryPartsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListHistoryDataOnlyGQL extends Apollo.Query<ListHistoryDataOnlyQuery, ListHistoryDataOnlyQueryVariables> {
    document = ListHistoryDataOnlyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoicesDocument = gql`
    query invoices($filter: InvoiceFilter, $skip: Int, $limit: Int, $sort: String) {
  invoices(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    skipped
    limited
    total
    invoices {
      ...InvoiceWithArtifacts
    }
  }
}
    ${InvoiceWithArtifactsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoicesGQL extends Apollo.Query<InvoicesQuery, InvoicesQueryVariables> {
    document = InvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const InvoiceDetailsDocument = gql`
    query invoiceDetails($invoiceId: String!) {
  invoices(filter: {ids: [$invoiceId], showDeleted: true}, skip: 0, limit: 1) {
    invoices {
      ...FullInvoice
    }
  }
}
    ${FullInvoiceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class InvoiceDetailsGQL extends Apollo.Query<InvoiceDetailsQuery, InvoiceDetailsQueryVariables> {
    document = InvoiceDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateInvoiceDocument = gql`
    mutation CreateInvoice($invoices: [CreateInvoiceInput!]!) {
  createInvoice(invoices: $invoices) {
    invoices {
      ...InvoiceWithArtifacts
    }
  }
}
    ${InvoiceWithArtifactsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateInvoiceGQL extends Apollo.Mutation<CreateInvoiceMutation, CreateInvoiceMutationVariables> {
    document = CreateInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendInvoicesDocument = gql`
    mutation SendInvoices($invoiceIds: [String!]!) {
  sendInvoices(invoiceIds: $invoiceIds) {
    sent
    updated
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendInvoicesGQL extends Apollo.Mutation<SendInvoicesMutation, SendInvoicesMutationVariables> {
    document = SendInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateInvoicesDocument = gql`
    mutation UpdateInvoices($invoices: [UpdateInvoiceInput!]!) {
  updateInvoices(invoices: $invoices)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateInvoicesGQL extends Apollo.Mutation<UpdateInvoicesMutation, UpdateInvoicesMutationVariables> {
    document = UpdateInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetInvoiceLinksDocument = gql`
    mutation GetInvoiceLinks($invoiceIds: [String!]!, $role: String!) {
  getLinks(invoiceIds: $invoiceIds, role: $role)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetInvoiceLinksGQL extends Apollo.Mutation<GetInvoiceLinksMutation, GetInvoiceLinksMutationVariables> {
    document = GetInvoiceLinksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteInvoicesDocument = gql`
    mutation DeleteInvoices($invoiceIds: [String!]!) {
  deleteInvoices(invoiceIds: $invoiceIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteInvoicesGQL extends Apollo.Mutation<DeleteInvoicesMutation, DeleteInvoicesMutationVariables> {
    document = DeleteInvoicesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobPageListJobsDocument = gql`
    query JobPageListJobs($filter: JobsFilter, $skip: Int, $limit: Int, $sort: String, $resolve: [String]) {
  jobs(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    resolve: $resolve
  ) {
    total
    skipped
    limited
    jobs {
      ...FullJobWithStages
    }
  }
}
    ${FullJobWithStagesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobPageListJobsGQL extends Apollo.Query<JobPageListJobsQuery, JobPageListJobsQueryVariables> {
    document = JobPageListJobsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobsPageDocument = gql`
    query JobsPage($filter: JobsFilter, $skip: Int, $limit: Int, $sort: String, $resolve: [String]) {
  jobs(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    resolve: $resolve
  ) {
    skipped
    limited
    jobs {
      ...JobWithUsersAndTags
    }
  }
}
    ${JobWithUsersAndTagsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobsPageGQL extends Apollo.Query<JobsPageQuery, JobsPageQueryVariables> {
    document = JobsPageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobsPageCountDocument = gql`
    query JobsPageCount($filter: JobsFilter, $skip: Int, $limit: Int, $sort: String, $resolve: [String]) {
  jobs(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    resolve: $resolve
  ) {
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobsPageCountGQL extends Apollo.Query<JobsPageCountQuery, JobsPageCountQueryVariables> {
    document = JobsPageCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobsV2PageDocument = gql`
    query JobsV2Page($jobId: String!, $resolve: [String!]!) {
  jobs(filter: {jobIds: [$jobId]}, resolve: $resolve) {
    total
    skipped
    limited
    jobs {
      ...JobDetailsV2
    }
  }
}
    ${JobDetailsV2FragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobsV2PageGQL extends Apollo.Query<JobsV2PageQuery, JobsV2PageQueryVariables> {
    document = JobsV2PageDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobsV2GetEventDocument = gql`
    query JobsV2GetEvent($eventId: String!) {
  calendarEvents(filter: {ids: [$eventId]}) {
    total
    skipped
    limited
    events {
      ...BaseCalendarEvent
      ...CalendarEvent_Invoices
      sequentialOrder
      discountTotal
      taxTotal
      discountedSubTotal
      discountedSubTotalWithoutDamages
      subTotal
      damageTotal
      discounts {
        discount {
          ...BaseDiscount
        }
        appliedId
        appliedAt
        redeemedAt
        discountedAmount
        appliedCustomAmount
        appliedBy {
          id
        }
      }
    }
  }
}
    ${BaseCalendarEventFragmentDoc}
${CalendarEvent_InvoicesFragmentDoc}
${BaseDiscountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobsV2GetEventGQL extends Apollo.Query<JobsV2GetEventQuery, JobsV2GetEventQueryVariables> {
    document = JobsV2GetEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GenerateChargesWithAiDocument = gql`
    query generateChargesWithAI($input: GenerateChargesWithAIInput!) {
  generateChargesWithAI(input: $input) {
    crewSize
    crewSizeExplanation
    itinerary {
      name
      location
      description
      type
      duration
    }
    selectedProducts {
      id
      priceId
      reason
      quantity
      name
    }
    salesAgentInstructions
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GenerateChargesWithAiGQL extends Apollo.Query<GenerateChargesWithAiQuery, GenerateChargesWithAiQueryVariables> {
    document = GenerateChargesWithAiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignCrewWithAiDocument = gql`
    query assignCrewWithAI($input: AssignCrewWithAIInput!) {
  assignCrewWithAI(input: $input) {
    jobAssignments {
      jobId
      assignedMembers {
        memberId
        role
        reasonForSelection
      }
    }
    reasoning
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignCrewWithAiGQL extends Apollo.Query<AssignCrewWithAiQuery, AssignCrewWithAiQueryVariables> {
    document = AssignCrewWithAiDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateNewJobDocument = gql`
    mutation createNewJob($zoneId: String, $stage: String!, $users: [JobUserInput], $locations: [JobLocationInput], $events: [EventInput], $newCustomers: [CreateUserInputWithRole], $sendSelfSurvey: Boolean, $fields: SetFieldsValuesInput, $currency: String, $depositRequired: Int, $metadata: Metadata, $timeline: String, $timelineDays: Float, $jobCategory: String, $closedReason: String, $crewSummary: Summary, $customerSummary: Summary, $adminSummary: Summary) {
  createJob(
    zoneId: $zoneId
    stage: $stage
    users: $users
    locations: $locations
    events: $events
    newCustomers: $newCustomers
    sendSelfSurvey: $sendSelfSurvey
    fields: $fields
    currency: $currency
    depositRequired: $depositRequired
    metadata: $metadata
    timeline: $timeline
    timelineDays: $timelineDays
    jobCategory: $jobCategory
    closedReason: $closedReason
    crewSummary: $crewSummary
    customerSummary: $customerSummary
    adminSummary: $adminSummary
  ) {
    id
    zone {
      ...BaseZone
      timezone
      parents {
        ...BaseZone
      }
    }
  }
}
    ${BaseZoneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateNewJobGQL extends Apollo.Mutation<CreateNewJobMutation, CreateNewJobMutationVariables> {
    document = CreateNewJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LocationsDocument = gql`
    query locations($filter: LocationsFilter) {
  locations(filter: $filter) {
    total
    skipped
    limited
    locations {
      id
      individualCapacity
      addressLineOne
      addressLineTwo
      name
      areaCode
      city
      countryJurisdiction
      country
      parentId
      coordinates {
        latitude
        longitude
        height
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LocationsGQL extends Apollo.Query<LocationsQuery, LocationsQueryVariables> {
    document = LocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLocationsDocument = gql`
    mutation createLocations($input: LocationsCreateInput!) {
  createLocations(input: $input) {
    locations {
      ...BaseLocation
    }
  }
}
    ${BaseLocationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLocationsGQL extends Apollo.Mutation<CreateLocationsMutation, CreateLocationsMutationVariables> {
    document = CreateLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveLocationsDocument = gql`
    mutation removeLocations($ids: [String]!) {
  removeLocations(ids: $ids) {
    removedLocations
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveLocationsGQL extends Apollo.Mutation<RemoveLocationsMutation, RemoveLocationsMutationVariables> {
    document = RemoveLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditLocationsDocument = gql`
    mutation editLocations($ids: [String]!, $edit: LocationsEditInput) {
  editLocations(ids: $ids, edit: $edit) {
    editedLocations {
      ...BaseLocation
    }
  }
}
    ${BaseLocationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class EditLocationsGQL extends Apollo.Mutation<EditLocationsMutation, EditLocationsMutationVariables> {
    document = EditLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListIntakeTokensDocument = gql`
    query listIntakeTokens {
  tokens(limit: 1000, filter: {tokenType: "leadsource"}) {
    total
    nodes {
      ...BaseToken
    }
  }
}
    ${BaseTokenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListIntakeTokensGQL extends Apollo.Query<ListIntakeTokensQuery, ListIntakeTokensQueryVariables> {
    document = ListIntakeTokensDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateLeadSourceTokenDocument = gql`
    mutation createLeadSourceToken($input: LeadSourceTokenInput!) {
  createLeadSourceToken(input: $input) {
    ...BaseToken
  }
}
    ${BaseTokenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateLeadSourceTokenGQL extends Apollo.Mutation<CreateLeadSourceTokenMutation, CreateLeadSourceTokenMutationVariables> {
    document = CreateLeadSourceTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetNiceJobsRefreshTokenDocument = gql`
    query getNiceJobsRefreshToken($code: String!) {
  getNiceJobsRefreshToken(authorizationCode: $code)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetNiceJobsRefreshTokenGQL extends Apollo.Query<GetNiceJobsRefreshTokenQuery, GetNiceJobsRefreshTokenQueryVariables> {
    document = GetNiceJobsRefreshTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteProductsDocument = gql`
    mutation deleteProducts($ids: [String!]!, $restore: Boolean) {
  deleteProducts(ids: $ids, restore: $restore)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteProductsGQL extends Apollo.Mutation<DeleteProductsMutation, DeleteProductsMutationVariables> {
    document = DeleteProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateProductsDocument = gql`
    mutation UpdateProducts($products: [UpdateProductInput!]!) {
  updateProducts(products: $products)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateProductsGQL extends Apollo.Mutation<UpdateProductsMutation, UpdateProductsMutationVariables> {
    document = UpdateProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttentionItemsDocument = gql`
    query attentionItems($skip: Int, $limit: Int, $filter: AttentionItemsFilter) {
  attentionItems(skip: $skip, limit: $limit, filter: $filter) {
    total
    items {
      ... on Job {
        id
        attentionScore
        attentionExplanation
        action
        stage
        state
        code
        createdAt
        ...Job_Users
        events {
          id
          title
          status
          start
          type
        }
      }
      ... on User {
        id
        attentionScore
        attentionExplanation
        action
        email
        phone
        givenName
        familyName
      }
      ... on CalendarEvent {
        id
        attentionScore
        attentionExplanation
        action
        type
        start
        ...CalendarEvent_Attendees
        ...CalendarEvent_Job
        ...CalendarEvent_Zones
      }
    }
  }
}
    ${Job_UsersFragmentDoc}
${CalendarEvent_AttendeesFragmentDoc}
${CalendarEvent_JobFragmentDoc}
${CalendarEvent_ZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AttentionItemsGQL extends Apollo.Query<AttentionItemsQuery, AttentionItemsQueryVariables> {
    document = AttentionItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttentionItemsTotalDocument = gql`
    query attentionItemsTotal($skip: Int, $limit: Int, $filter: AttentionItemsFilter) {
  attentionItems(skip: $skip, limit: $limit, filter: $filter) {
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttentionItemsTotalGQL extends Apollo.Query<AttentionItemsTotalQuery, AttentionItemsTotalQueryVariables> {
    document = AttentionItemsTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AttentionItemsSummaryDocument = gql`
    query attentionItemsSummary($filter: AttentionItemsSummaryFilter) {
  attentionItemsSummary(filter: $filter) {
    attentionExplanation
    items
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AttentionItemsSummaryGQL extends Apollo.Query<AttentionItemsSummaryQuery, AttentionItemsSummaryQueryVariables> {
    document = AttentionItemsSummaryDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityDocument = gql`
    query availability($objectIds: [String!]!, $startDate: String!, $endDate: String, $zone: String, $excludeEvents: [String!]) {
  availabilities(
    objectIds: $objectIds
    zone: $zone
    startDate: $startDate
    endDate: $endDate
    excludeEvents: $excludeEvents
  ) {
    objectId
    dayAvailability {
      date
      availability {
        start
        end
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityGQL extends Apollo.Query<AvailabilityQuery, AvailabilityQueryVariables> {
    document = AvailabilityDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListAvailabilityConfigurationDocument = gql`
    query listAvailabilityConfiguration($objectIds: [String], $startDate: String, $endDate: String, $zoneId: String) {
  availabilityConfigurations(
    objectIds: $objectIds
    zoneId: $zoneId
    startDate: $startDate
    endDate: $endDate
  ) {
    ...FullAvailabilityConfiguration
  }
}
    ${FullAvailabilityConfigurationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListAvailabilityConfigurationGQL extends Apollo.Query<ListAvailabilityConfigurationQuery, ListAvailabilityConfigurationQueryVariables> {
    document = ListAvailabilityConfigurationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAvailabilityConfigDocument = gql`
    mutation updateAvailabilityConfig($input: UpdateAvailabilityConfigurationInput!) {
  updateAvailabilityConfiguration(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAvailabilityConfigGQL extends Apollo.Mutation<UpdateAvailabilityConfigMutation, UpdateAvailabilityConfigMutationVariables> {
    document = UpdateAvailabilityConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabilityTemplatesDocument = gql`
    query availabilityTemplates($input: AvailabilityTemplateInput) {
  availabilityTemplates(input: $input) {
    ...FullAvailabilityTemplate
  }
}
    ${FullAvailabilityTemplateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabilityTemplatesGQL extends Apollo.Query<AvailabilityTemplatesQuery, AvailabilityTemplatesQueryVariables> {
    document = AvailabilityTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateAvailabilityTemplateDocument = gql`
    mutation createAvailabilityTemplate($input: CreateAvailabilityTemplateInput!) {
  createAvailabilityTemplate(input: $input) {
    ...FullAvailabilityTemplate
  }
}
    ${FullAvailabilityTemplateFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateAvailabilityTemplateGQL extends Apollo.Mutation<CreateAvailabilityTemplateMutation, CreateAvailabilityTemplateMutationVariables> {
    document = CreateAvailabilityTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAvailabilityTemplateDocument = gql`
    mutation updateAvailabilityTemplate($input: UpdateAvailabilityTemplateInput!) {
  updateAvailabilityTemplate(input: $input)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAvailabilityTemplateGQL extends Apollo.Mutation<UpdateAvailabilityTemplateMutation, UpdateAvailabilityTemplateMutationVariables> {
    document = UpdateAvailabilityTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteAvailabilityTemplatesDocument = gql`
    mutation deleteAvailabilityTemplates($ids: [String!]!) {
  deleteAvailabilityTemplates(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteAvailabilityTemplatesGQL extends Apollo.Mutation<DeleteAvailabilityTemplatesMutation, DeleteAvailabilityTemplatesMutationVariables> {
    document = DeleteAvailabilityTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCalendarEventDocument = gql`
    mutation createCalendarEvent($calendarEvents: [createCalendarEventInput]!, $effectSubZones: Boolean, $skipTotalUpdate: Boolean) {
  createCalendarEvent(
    calendarEvents: $calendarEvents
    effectSubZones: $effectSubZones
    skipTotalUpdate: $skipTotalUpdate
  ) {
    events {
      ...BaseCalendarEvent
    }
  }
}
    ${BaseCalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCalendarEventGQL extends Apollo.Mutation<CreateCalendarEventMutation, CreateCalendarEventMutationVariables> {
    document = CreateCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCalendarEventsDocument = gql`
    query listCalendarEvents($filter: CalendarEventsFilter, $skip: Int, $limit: Int) {
  calendarEvents(filter: $filter, skip: $skip, limit: $limit) {
    total
    skipped
    limited
    events {
      ...BaseCalendarEvent
    }
  }
}
    ${BaseCalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCalendarEventsGQL extends Apollo.Query<ListCalendarEventsQuery, ListCalendarEventsQueryVariables> {
    document = ListCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCalendarEventsForSelectEventDocument = gql`
    query listCalendarEventsForSelectEvent($filter: CalendarEventsFilter, $skip: Int, $limit: Int) {
  calendarEvents(filter: $filter, skip: $skip, limit: $limit) {
    events {
      ...CalendarEventForSelectEvent
    }
  }
}
    ${CalendarEventForSelectEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCalendarEventsForSelectEventGQL extends Apollo.Query<ListCalendarEventsForSelectEventQuery, ListCalendarEventsForSelectEventQueryVariables> {
    document = ListCalendarEventsForSelectEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCalendarEventsDocument = gql`
    mutation removeCalendarEvents($ids: [String!]!, $notifyAttendees: Boolean, $notifyDispatch: Boolean, $cancellationReason: String) {
  removeCalendarEvent(
    ids: $ids
    notifyAttendees: $notifyAttendees
    notifyDispatch: $notifyDispatch
    cancellationReason: $cancellationReason
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCalendarEventsGQL extends Apollo.Mutation<RemoveCalendarEventsMutation, RemoveCalendarEventsMutationVariables> {
    document = RemoveCalendarEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditCalendarEventByIdDocument = gql`
    mutation editCalendarEventById($edit: editCalendarEventInput!, $id: String!) {
  editCalendarEvent(edit: $edit, ids: [$id])
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditCalendarEventByIdGQL extends Apollo.Mutation<EditCalendarEventByIdMutation, EditCalendarEventByIdMutationVariables> {
    document = EditCalendarEventByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListChargesDocument = gql`
    query ListCharges($filter: ChargesFilter, $skip: Int, $limit: Int) {
  charges(filter: $filter, skip: $skip, limit: $limit) {
    charges {
      ...ChargeWithJob
    }
  }
}
    ${ChargeWithJobFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListChargesGQL extends Apollo.Query<ListChargesQuery, ListChargesQueryVariables> {
    document = ListChargesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChargeDocument = gql`
    mutation createCharge($charges: [CreateChargeInput!]!, $userId: String) {
  createCharges(charges: $charges, userId: $userId) {
    ...BaseCharge
  }
}
    ${BaseChargeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChargeGQL extends Apollo.Mutation<CreateChargeMutation, CreateChargeMutationVariables> {
    document = CreateChargeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateChargesDocument = gql`
    mutation updateCharges($charges: [ChargeUpdate!]!) {
  updateCharges(charges: $charges)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateChargesGQL extends Apollo.Mutation<UpdateChargesMutation, UpdateChargesMutationVariables> {
    document = UpdateChargesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CommentsDocument = gql`
    query comments($filter: ListCommentFilter, $skip: Int, $limit: Int, $sortBy: String) {
  comments(filter: $filter, skip: $skip, limit: $limit, sortBy: $sortBy) {
    comments {
      ...BaseComment
    }
    total
    skipped
    limited
  }
}
    ${BaseCommentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CommentsGQL extends Apollo.Query<CommentsQuery, CommentsQueryVariables> {
    document = CommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListCommentsWithRepliesDocument = gql`
    query listCommentsWithReplies($filter: ListCommentFilter, $skip: Int, $limit: Int, $sortBy: String) {
  comments(filter: $filter, skip: $skip, limit: $limit, sortBy: $sortBy) {
    comments {
      ...CommentWithReplies
    }
    total
    skipped
    limited
  }
}
    ${CommentWithRepliesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListCommentsWithRepliesGQL extends Apollo.Query<ListCommentsWithRepliesQuery, ListCommentsWithRepliesQueryVariables> {
    document = ListCommentsWithRepliesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateCommentDocument = gql`
    mutation createComment($input: AddCommentInput) {
  addComment(input: $input) {
    ...CommentWithReplies
  }
}
    ${CommentWithRepliesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateCommentGQL extends Apollo.Mutation<CreateCommentMutation, CreateCommentMutationVariables> {
    document = CreateCommentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateCommentsDocument = gql`
    mutation updateComments($input: UpdateCommentInput) {
  updateComments(input: $input) {
    ...CommentWithReplies
  }
}
    ${CommentWithRepliesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateCommentsGQL extends Apollo.Mutation<UpdateCommentsMutation, UpdateCommentsMutationVariables> {
    document = UpdateCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteCommentsDocument = gql`
    mutation deleteComments($input: DeleteCommentInput) {
  deleteComments(input: $input) {
    commentsDeleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteCommentsGQL extends Apollo.Mutation<DeleteCommentsMutation, DeleteCommentsMutationVariables> {
    document = DeleteCommentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListExpensesDocument = gql`
    query ListExpenses($filter: ExpensesFilter, $skip: Int, $limit: Int) {
  expenses(filter: $filter, skip: $skip, limit: $limit) {
    expenses {
      ...BaseExpense
    }
  }
}
    ${BaseExpenseFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListExpensesGQL extends Apollo.Query<ListExpensesQuery, ListExpensesQueryVariables> {
    document = ListExpensesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LockWindowDocument = gql`
    mutation lockWindow($start: Int!, $end: Int!, $type: String!, $title: String, $colour: String, $topicIds: [String], $topicText: String, $assetIds: [String], $metadata: Metadata, $jobId: String!, $eventId: String, $attributes: [String], $locations: [CalendarEventLocationInput], $overrideUnavailabilities: Boolean, $overrideAvailabilities: Boolean, $updateEventSequentialOrder: Boolean, $modifyStartForTravel: Boolean, $modifyEndForTravel: Boolean, $restrictionsEnabled: Boolean) {
  lockWindow(
    start: $start
    end: $end
    type: $type
    title: $title
    colour: $colour
    topicIds: $topicIds
    topicText: $topicText
    assetIds: $assetIds
    metadata: $metadata
    jobId: $jobId
    eventId: $eventId
    attributes: $attributes
    locations: $locations
    overrideUnavailabilities: $overrideUnavailabilities
    overrideAvailabilities: $overrideAvailabilities
    updateEventSequentialOrder: $updateEventSequentialOrder
    modifyStartForTravel: $modifyStartForTravel
    modifyEndForTravel: $modifyEndForTravel
    restrictionsEnabled: $restrictionsEnabled
  ) {
    ...CalendarEventForSchedule
  }
}
    ${CalendarEventForScheduleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LockWindowGQL extends Apollo.Mutation<LockWindowMutation, LockWindowMutationVariables> {
    document = LockWindowDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const FindDocument = gql`
    query find($timeWindow: WindowInput!, $usersFilter: UserSearch, $assetsFilter: AssetsFilter, $minNumUsers: Int, $minNumAssets: Int, $overrideAvailabilities: Boolean, $overrideUnavailabilities: Boolean, $zoneInput: String, $excludedEventIds: [String]) {
  find(
    timeWindow: $timeWindow
    usersFilter: $usersFilter
    assetsFilter: $assetsFilter
    minNumUsers: $minNumUsers
    minNumAssets: $minNumAssets
    overrideAvailabilities: $overrideAvailabilities
    overrideUnavailabilities: $overrideUnavailabilities
    zoneInput: $zoneInput
    excludedEventIds: $excludedEventIds
  ) {
    windowCount
    userCount
    assetCount
    windows {
      start
      end
      startTimes
      users {
        ...BaseUser
      }
      assets {
        ...FindAsset
      }
    }
  }
}
    ${BaseUserFragmentDoc}
${FindAssetFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class FindGQL extends Apollo.Query<FindQuery, FindQueryVariables> {
    document = FindDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalculateDistanceDocument = gql`
    query calculateDistance($locationIds: [String!]!, $startingTime: Int, $units: String) {
  calculateDistance(
    locationIds: $locationIds
    startingTime: $startingTime
    units: $units
  ) {
    distances {
      startLocation
      endLocation
      averageTime
      estimatedTime
      distance
      distanceUnits
    }
    averageTime
    estimatedTime
    totalDistance
    distanceUnits
    flagTrip
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CalculateDistanceGQL extends Apollo.Query<CalculateDistanceQuery, CalculateDistanceQueryVariables> {
    document = CalculateDistanceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobPromotedDocument = gql`
    subscription JobPromoted {
  jobPromoted {
    jobId
    reason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobPromotedGQL extends Apollo.Subscription<JobPromotedSubscription, JobPromotedSubscriptionVariables> {
    document = JobPromotedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobClosedDocument = gql`
    subscription JobClosed {
  jobClosed {
    jobId
    reason
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class JobClosedGQL extends Apollo.Subscription<JobClosedSubscription, JobClosedSubscriptionVariables> {
    document = JobClosedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobChangedDocument = gql`
    subscription jobChanged($jobId: String!) {
  job(jobId: $jobId) {
    jobId
    action
    time
    input
    output
    job {
      ...JobDetailsV2
    }
    sessionId
    actionId
    userId
    userName
  }
}
    ${JobDetailsV2FragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobChangedGQL extends Apollo.Subscription<JobChangedSubscription, JobChangedSubscriptionVariables> {
    document = JobChangedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const JobDetailsDocument = gql`
    query jobDetails($jobId: String!, $getDeleted: Boolean) {
  jobs(
    filter: {jobAncestorIds: [$jobId], getDeleted: $getDeleted}
    resolve: ["stages", "locations", "users"]
  ) {
    jobs {
      ...JobDetails
    }
  }
}
    ${JobDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class JobDetailsGQL extends Apollo.Query<JobDetailsQuery, JobDetailsQueryVariables> {
    document = JobDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateJobArchivedDocument = gql`
    mutation updateJobArchived($jobId: String!, $archived: Boolean!) {
  updateJobs(updateJobs: [{jobId: $jobId, archiveJob: $archived}]) {
    transitionedJobs {
      oldJobId
      newJobId
    }
    isSuccess
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateJobArchivedGQL extends Apollo.Mutation<UpdateJobArchivedMutation, UpdateJobArchivedMutationVariables> {
    document = UpdateJobArchivedDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateJobDocument = gql`
    mutation updateJob($updateJobs: [UpdateJobInput]!) {
  updateJobs(updateJobs: $updateJobs) {
    isSuccess
    jobs {
      ...JobDetailsV2
    }
  }
}
    ${JobDetailsV2FragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateJobGQL extends Apollo.Mutation<UpdateJobMutation, UpdateJobMutationVariables> {
    document = UpdateJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteJobDocument = gql`
    mutation deleteJob($jobIds: [String]!) {
  deleteJobs(jobIds: $jobIds)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteJobGQL extends Apollo.Mutation<DeleteJobMutation, DeleteJobMutationVariables> {
    document = DeleteJobDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SendDocumentDocument = gql`
    mutation SendDocument($artifactId: String!, $recipientRole: String!, $message: String) {
  sendDocument(
    artifactId: $artifactId
    recipientRole: $recipientRole
    message: $message
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SendDocumentGQL extends Apollo.Mutation<SendDocumentMutation, SendDocumentMutationVariables> {
    document = SendDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResendDocumentDocument = gql`
    mutation ResendDocument($artifactId: String!, $subject: String!, $message: String) {
  resendDocument(artifactId: $artifactId, subject: $subject, message: $message)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResendDocumentGQL extends Apollo.Mutation<ResendDocumentMutation, ResendDocumentMutationVariables> {
    document = ResendDocumentDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPermissionsDocument = gql`
    query listPermissions($input: ListPermissionsInput) {
  permissions(input: $input) {
    map {
      permission
      mappedPermission
      createdAt
      updatedAt
      deletedAt
      zone
      role
      zoneDepth
      restrictions
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPermissionsGQL extends Apollo.Query<ListPermissionsQuery, ListPermissionsQueryVariables> {
    document = ListPermissionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreatePricesDocument = gql`
    mutation createPrices($prices: [CreatePriceInput!]!, $zoneId: String) {
  createPrices(prices: $prices, zoneId: $zoneId) {
    ...FullPrice
  }
}
    ${FullPriceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreatePricesGQL extends Apollo.Mutation<CreatePricesMutation, CreatePricesMutationVariables> {
    document = CreatePricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdatePricesDocument = gql`
    mutation updatePrices($prices: [UpdatePriceInput!]!, $effectExistingCharges: Boolean) {
  updatePrices(prices: $prices, effectExistingCharges: $effectExistingCharges)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdatePricesGQL extends Apollo.Mutation<UpdatePricesMutation, UpdatePricesMutationVariables> {
    document = UpdatePricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeletePricesDocument = gql`
    mutation DeletePrices($ids: [String!]!, $restore: Boolean) {
  deletePrices(ids: $ids, restore: $restore)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeletePricesGQL extends Apollo.Mutation<DeletePricesMutation, DeletePricesMutationVariables> {
    document = DeletePricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListPricesDocument = gql`
    query ListPrices($filter: PricesFilter, $skip: Int, $limit: Int) {
  prices(filter: $filter, skip: $skip, limit: $limit) {
    prices {
      ...FullPrice
    }
  }
}
    ${FullPriceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListPricesGQL extends Apollo.Query<ListPricesQuery, ListPricesQueryVariables> {
    document = ListPricesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListProductsDocument = gql`
    query ListProducts($filter: ProductsFilter, $skip: Int, $limit: Int, $sort: String, $pricesFilter: PricesFilter) {
  products(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    skipped
    limited
    products {
      ...BaseProduct
      ...Product_Zones
      prices(filter: $pricesFilter) {
        ...PriceForBusinessProducts
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${Product_ZonesFragmentDoc}
${PriceForBusinessProductsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListProductsGQL extends Apollo.Query<ListProductsQuery, ListProductsQueryVariables> {
    document = ListProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListProductsForEstimatingDocument = gql`
    query ListProductsForEstimating($filter: ProductsFilter, $skip: Int, $limit: Int, $sort: String, $pricesFilter: PricesFilter) {
  products(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    skipped
    limited
    products {
      ...BaseProduct
      ...Product_Zones
      prices(filter: $pricesFilter) {
        ...PriceForEstimating
      }
    }
  }
}
    ${BaseProductFragmentDoc}
${Product_ZonesFragmentDoc}
${PriceForEstimatingFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListProductsForEstimatingGQL extends Apollo.Query<ListProductsForEstimatingQuery, ListProductsForEstimatingQueryVariables> {
    document = ListProductsForEstimatingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateProductsDocument = gql`
    mutation CreateProducts($products: [CreateProductInput!]!) {
  createProducts(products: $products) {
    ...BaseProduct
  }
}
    ${BaseProductFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateProductsGQL extends Apollo.Mutation<CreateProductsMutation, CreateProductsMutationVariables> {
    document = CreateProductsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TagsDocument = gql`
    query tags($filter: TagFilter, $order: String) {
  tags(filter: $filter, order: $order) {
    tags {
      id
      name
      objectType
      category
      color
      private
      attributes
      order
    }
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TagsGQL extends Apollo.Query<TagsQuery, TagsQueryVariables> {
    document = TagsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddTagsToObjectsDocument = gql`
    mutation addTagsToObjects($tags: [String!]!, $objects: [String!]!, $private: Boolean, $order: Float, $objectLabel: String) {
  addTagsToObjects(
    tags: $tags
    objects: $objects
    private: $private
    order: $order
    objectLabel: $objectLabel
  ) {
    tags
    objects
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AddTagsToObjectsGQL extends Apollo.Mutation<AddTagsToObjectsMutation, AddTagsToObjectsMutationVariables> {
    document = AddTagsToObjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveTagsFromObjectsDocument = gql`
    mutation removeTagsFromObjects($tags: [String!]!, $objects: [String!]!, $objectLabel: String) {
  removeTagsFromObjects(tags: $tags, objects: $objects, objectLabel: $objectLabel) {
    tags
    objects
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveTagsFromObjectsGQL extends Apollo.Mutation<RemoveTagsFromObjectsMutation, RemoveTagsFromObjectsMutationVariables> {
    document = RemoveTagsFromObjectsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetTagsOnObjectDocument = gql`
    mutation setTagsOnObject($filter: TagFilter, $tags: [TagRelationship], $objectId: String, $objectLabel: String, $order: Boolean) {
  tags(filter: $filter) {
    setObjectTags(
      tags: $tags
      objectId: $objectId
      objectLabel: $objectLabel
      order: $order
    )
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetTagsOnObjectGQL extends Apollo.Mutation<SetTagsOnObjectMutation, SetTagsOnObjectMutationVariables> {
    document = SetTagsOnObjectDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListTaxesDocument = gql`
    query ListTaxes($filter: TaxesFilter, $skip: Int, $limit: Int) {
  taxes(filter: $filter, skip: $skip, limit: $limit) {
    total
    skipped
    limited
    taxes {
      ...BaseTax
      ...Tax_Zones
    }
  }
}
    ${BaseTaxFragmentDoc}
${Tax_ZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListTaxesGQL extends Apollo.Query<ListTaxesQuery, ListTaxesQueryVariables> {
    document = ListTaxesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AddQuillTemplateDocument = gql`
    mutation AddQuillTemplate($input: AddQuillTemplateInput!) {
  addQuillTemplate(input: $input) {
    template {
      ...QuillTemplateFields
    }
  }
}
    ${QuillTemplateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AddQuillTemplateGQL extends Apollo.Mutation<AddQuillTemplateMutation, AddQuillTemplateMutationVariables> {
    document = AddQuillTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateQuillTemplateDocument = gql`
    mutation UpdateQuillTemplate($input: UpdateQuillTemplateInput!) {
  updateQuillTemplate(input: $input) {
    templates {
      ...QuillTemplateFields
    }
  }
}
    ${QuillTemplateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateQuillTemplateGQL extends Apollo.Mutation<UpdateQuillTemplateMutation, UpdateQuillTemplateMutationVariables> {
    document = UpdateQuillTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteQuillTemplateDocument = gql`
    mutation DeleteQuillTemplate($input: DeleteQuillTemplateInput!) {
  deleteQuillTemplate(input: $input) {
    templatesDeleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteQuillTemplateGQL extends Apollo.Mutation<DeleteQuillTemplateMutation, DeleteQuillTemplateMutationVariables> {
    document = DeleteQuillTemplateDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListQuillTemplatesDocument = gql`
    query ListQuillTemplates($filter: ListTemplatesFilter, $skip: Int, $limit: Int) {
  templates(filter: $filter, skip: $skip, limit: $limit) {
    templates {
      ...QuillTemplateFields
    }
    total
    skipped
    limited
  }
}
    ${QuillTemplateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListQuillTemplatesGQL extends Apollo.Query<ListQuillTemplatesQuery, ListQuillTemplatesQueryVariables> {
    document = ListQuillTemplatesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuickbooksAuthUriDocument = gql`
    query QuickbooksAuthUri {
  quickbooksAuthUri
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class QuickbooksAuthUriGQL extends Apollo.Query<QuickbooksAuthUriQuery, QuickbooksAuthUriQueryVariables> {
    document = QuickbooksAuthUriDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyInfoDocument = gql`
    query CompanyInfo {
  companyInfo {
    ...BaseCompanyInfo
  }
}
    ${BaseCompanyInfoFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyInfoGQL extends Apollo.Query<CompanyInfoQuery, CompanyInfoQueryVariables> {
    document = CompanyInfoDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuickbooksAccountsDocument = gql`
    query QuickbooksAccounts($filter: QuickbooksAccountFilter!) {
  quickbooksAccounts(filter: $filter) {
    ...BaseQuickbooksAccount
  }
}
    ${BaseQuickbooksAccountFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuickbooksAccountsGQL extends Apollo.Query<QuickbooksAccountsQuery, QuickbooksAccountsQueryVariables> {
    document = QuickbooksAccountsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuickbooksItemsDocument = gql`
    query QuickbooksItems($filter: QuickbooksItemFilter!) {
  quickbooksItems(filter: $filter) {
    ...BaseQuickbooksItem
  }
}
    ${BaseQuickbooksItemFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuickbooksItemsGQL extends Apollo.Query<QuickbooksItemsQuery, QuickbooksItemsQueryVariables> {
    document = QuickbooksItemsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const QuickbooksTaxCodesDocument = gql`
    query QuickbooksTaxCodes {
  quickbooksTaxCodes {
    ...QuickbooksTaxCodeWithSalesTaxList
  }
}
    ${QuickbooksTaxCodeWithSalesTaxListFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class QuickbooksTaxCodesGQL extends Apollo.Query<QuickbooksTaxCodesQuery, QuickbooksTaxCodesQueryVariables> {
    document = QuickbooksTaxCodesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DisconnectFromQuickbooksDocument = gql`
    mutation DisconnectFromQuickbooks {
  disconnectFromQuickbooks
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DisconnectFromQuickbooksGQL extends Apollo.Mutation<DisconnectFromQuickbooksMutation, DisconnectFromQuickbooksMutationVariables> {
    document = DisconnectFromQuickbooksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExportInvoiceToQuickbooksDocument = gql`
    mutation ExportInvoiceToQuickbooks($invoiceId: String) {
  exportInvoiceToQuickbooks(invoiceId: $invoiceId)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExportInvoiceToQuickbooksGQL extends Apollo.Mutation<ExportInvoiceToQuickbooksMutation, ExportInvoiceToQuickbooksMutationVariables> {
    document = ExportInvoiceToQuickbooksDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateScheduledReportDocument = gql`
    mutation createScheduledReport($input: CreateScheduledReportInput!) {
  createScheduledReport(input: $input) {
    ...ScheduledReportEssentials
  }
}
    ${ScheduledReportEssentialsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateScheduledReportGQL extends Apollo.Mutation<CreateScheduledReportMutation, CreateScheduledReportMutationVariables> {
    document = CreateScheduledReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteScheduledReportsDocument = gql`
    mutation deleteScheduledReports($input: DeleteScheduledReportInput!) {
  deleteScheduledReports(input: $input) {
    deleted
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteScheduledReportsGQL extends Apollo.Mutation<DeleteScheduledReportsMutation, DeleteScheduledReportsMutationVariables> {
    document = DeleteScheduledReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateScheduledReportsDocument = gql`
    mutation updateScheduledReports($input: UpdateScheduledReportInput!) {
  updateScheduledReports(input: $input) {
    ...ScheduledReportEssentials
  }
}
    ${ScheduledReportEssentialsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateScheduledReportsGQL extends Apollo.Mutation<UpdateScheduledReportsMutation, UpdateScheduledReportsMutationVariables> {
    document = UpdateScheduledReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportDetailsListDocument = gql`
    query reportDetailsList($filter: ReportsFilter, $skip: Int, $limit: Int, $sort: String, $getData: [ReportGetDataOptions!]) {
  reports(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    getData: $getData
  ) {
    reports {
      ...BaseReport
      ...Report_Aggregations
      ...Report_Zones
      ...Report_ScheduledReport
      reportType {
        ...ReportType_Schema
      }
    }
  }
}
    ${BaseReportFragmentDoc}
${Report_AggregationsFragmentDoc}
${Report_ZonesFragmentDoc}
${Report_ScheduledReportFragmentDoc}
${ReportType_SchemaFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportDetailsListGQL extends Apollo.Query<ReportDetailsListQuery, ReportDetailsListQueryVariables> {
    document = ReportDetailsListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportPageListDocument = gql`
    query reportPageList($filter: ReportsFilter, $skip: Int, $limit: Int, $sort: String, $getData: [ReportGetDataOptions!]) {
  reports(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    getData: $getData
  ) {
    reports {
      ...FullReport
    }
  }
}
    ${FullReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportPageListGQL extends Apollo.Query<ReportPageListQuery, ReportPageListQueryVariables> {
    document = ReportPageListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportTypePageListDocument = gql`
    query reportTypePageList($filter: ReportTypesFilter, $skip: Int, $limit: Int, $sort: String, $reportsSkip: Int, $reportsLimit: Int) {
  reportTypes(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    reportTypes {
      ...BaseReportType
      ...ReportType_Schema
      ...ReportType_Zones
      ...ReportType_Description
      reports(skip: $reportsSkip, limit: $reportsLimit) {
        total
        skipped
        limited
        reports {
          ...BaseReport
          ...Report_Zones
        }
      }
    }
  }
}
    ${BaseReportTypeFragmentDoc}
${ReportType_SchemaFragmentDoc}
${ReportType_ZonesFragmentDoc}
${ReportType_DescriptionFragmentDoc}
${BaseReportFragmentDoc}
${Report_ZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportTypePageListGQL extends Apollo.Query<ReportTypePageListQuery, ReportTypePageListQueryVariables> {
    document = ReportTypePageListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListScheduledReportsDocument = gql`
    query ListScheduledReports($filter: ScheduledReportsFilter, $skip: Int, $limit: Int, $sort: String) {
  scheduledReports(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    scheduledReports {
      ...ScheduledReportEssentials
    }
  }
}
    ${ScheduledReportEssentialsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListScheduledReportsGQL extends Apollo.Query<ListScheduledReportsQuery, ListScheduledReportsQueryVariables> {
    document = ListScheduledReportsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ReportTypesListDocument = gql`
    query reportTypesList($filter: ReportTypesFilter, $skip: Int, $limit: Int, $sort: String) {
  reportTypes(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    reportTypes {
      ...ReportTypeWithZones
    }
  }
}
    ${ReportTypeWithZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ReportTypesListGQL extends Apollo.Query<ReportTypesListQuery, ReportTypesListQueryVariables> {
    document = ReportTypesListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateExportTokenDocument = gql`
    mutation createExportToken($reportTypeId: String!) {
  createExportToken(reportTypeId: $reportTypeId) {
    id
    createdAt
    token
    tokenType
    expiration
    title
    isValid
    used
    metadata
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateExportTokenGQL extends Apollo.Mutation<CreateExportTokenMutation, CreateExportTokenMutationVariables> {
    document = CreateExportTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CalendarEventDetailsDocument = gql`
    query calendarEventDetails($calendarEventId: String!) {
  calendarEvents(
    filter: {ids: [$calendarEventId], showCancelled: true, softDeleted: true}
    skip: 0
    limit: 1
  ) {
    total
    skipped
    limited
    events {
      ...CalendarEventForDetails
    }
  }
}
    ${CalendarEventForDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CalendarEventDetailsGQL extends Apollo.Query<CalendarEventDetailsQuery, CalendarEventDetailsQueryVariables> {
    document = CalendarEventDetailsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const NotifyDocument = gql`
    mutation notify($type: String!, $users: [NotifyUserInput], $roleIds: [String], $data: NotificationDataInput, $eventId: String, $onReply: String) {
  notify(
    type: $type
    users: $users
    roleIds: $roleIds
    data: $data
    eventId: $eventId
    onReply: $onReply
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class NotifyGQL extends Apollo.Mutation<NotifyMutation, NotifyMutationVariables> {
    document = NotifyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleDocument = gql`
    query schedule($filter: CalendarEventsFilter, $skip: Int, $limit: Int, $objectIds: [String!]!, $startDate: String!, $endDate: String!, $zone: String) {
  calendarEvents(filter: $filter, skip: $skip, limit: $limit) {
    events {
      ...CalendarEventForSchedule
    }
  }
  availabilities(
    objectIds: $objectIds
    startDate: $startDate
    endDate: $endDate
    zone: $zone
  ) {
    objectId
    dayAvailability {
      date
      availability {
        start
        end
      }
    }
  }
}
    ${CalendarEventForScheduleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleGQL extends Apollo.Query<ScheduleQuery, ScheduleQueryVariables> {
    document = ScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ScheduleEventsDocument = gql`
    query scheduleEvents($filter: CalendarEventsFilter, $skip: Int, $limit: Int) {
  calendarEvents(filter: $filter, skip: $skip, limit: $limit) {
    events {
      ...CalendarEventForSchedule
    }
  }
}
    ${CalendarEventForScheduleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ScheduleEventsGQL extends Apollo.Query<ScheduleEventsQuery, ScheduleEventsQueryVariables> {
    document = ScheduleEventsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailabiltiesDocument = gql`
    query availabilties($objectIds: [String!]!, $startDate: String!, $endDate: String!) {
  availabilities(objectIds: $objectIds, startDate: $startDate, endDate: $endDate) {
    objectId
    dayAvailability {
      date
      availability {
        start
        end
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailabiltiesGQL extends Apollo.Query<AvailabiltiesQuery, AvailabiltiesQueryVariables> {
    document = AvailabiltiesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailableZonesDocument = gql`
    query availableZones($skip: Int, $limit: Int, $search: String, $objectId: String, $objectLabel: String) {
  availableZones(
    skip: $skip
    limit: $limit
    search: $search
    objectId: $objectId
    objectLabel: $objectLabel
  ) {
    ...AvailableZone
  }
}
    ${AvailableZoneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailableZonesGQL extends Apollo.Query<AvailableZonesQuery, AvailableZonesQueryVariables> {
    document = AvailableZonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AvailableZonesAndCurrentZoneDocument = gql`
    query availableZonesAndCurrentZone($skip: Int, $limit: Int, $search: String) {
  availableZones(skip: $skip, limit: $limit, search: $search) {
    ...AvailableZone
  }
  currentZone {
    ...BaseZoneWithParent
  }
}
    ${AvailableZoneFragmentDoc}
${BaseZoneWithParentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class AvailableZonesAndCurrentZoneGQL extends Apollo.Query<AvailableZonesAndCurrentZoneQuery, AvailableZonesAndCurrentZoneQueryVariables> {
    document = AvailableZonesAndCurrentZoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentBrandingDocument = gql`
    query currentBranding($zoneId: String, $features: [String!]!, $configKeys: [ZoneConfigKey!]!, $filter: ProductsFilter, $pricesFilter: PricesFilter, $templatesFilter: ListTemplatesFilter, $skip: Int, $limit: Int, $sort: String) {
  branding(zoneId: $zoneId) {
    appName
    shortName
    ico
    notice
    iconLight48
    iconLight64
    iconLight128
    iconLight196
    iconLight256
    iconLight512
    iconLight1024
    iconLightWide
    iconDark48
    iconDark64
    iconDark128
    iconDark196
    iconDark256
    iconDark512
    iconDark1024
    iconDarkWide
    website
    companyName
    primaryColor
    secondaryColor
    timezone
    country
    language
    email
    zoneCode
    zoneId
    status
  }
  permissions {
    permissions {
      ...FullPermission
    }
    __typename
  }
  features(features: $features)
  getZoneConfigValues(keys: $configKeys) {
    JOBS_CLOSEDREASONS {
      id
      title
      stages
    }
    INVENTORY_ITEMS {
      reviewerName
      label
      volume
      weight
      isoCode1
      isoCode2
      isoCode3
      isBulky
      isValuable
      isSpecialEquipment
      is3rdPartyServicing
      isProGear
      isAssembleDisassemble
    }
    INVOICE_DISABLEMULTIPLEEVENTS
    JOBS_HOWHEARDOPTIONS
    JOBS_HOWHEARDMANDATORY
    JOBS_ORIGINS
    CUSTOMER_TYPES
    JOBS_DWELLINGTYPEMANDATORY
    JOBS_BEDROOMSMANDATORY
    ROLE_CUSTOMER
    YEMBO__INTEGRATION_ENABLED
    FRANCHISE__INFO_DOCKLOCATIONID
    CALENDAREVENTS_ESTIMATELENGTH
    CALENDAREVENTS_VIRTUALESTIMATELENGTH
    ROLLING__LOCK__DATE_CURRENTDATE
    FIND_STARTTIMEINTERVAL
    CALENDAREVENTS_INCLUDEDOCKTRAVELTIME
    CALENDAREVENTS_DOCKTRAVELTIMECHECKBOX
    CALENDAREVENTS_DEPOSITMINTOBOOK
    PRICINGENGINE_ENABLED
  }
  products(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    total
    skipped
    limited
    products {
      ...BaseProduct
      ...Product_Zones
      prices(filter: $pricesFilter) {
        ...PriceForEstimating
      }
    }
  }
  commentModes {
    ...BaseCommentMode
  }
  templates(skip: $skip, limit: $limit, filter: $templatesFilter) {
    templates {
      ...QuillTemplateFields
    }
    total
    skipped
    limited
  }
}
    ${FullPermissionFragmentDoc}
${BaseProductFragmentDoc}
${Product_ZonesFragmentDoc}
${PriceForEstimatingFragmentDoc}
${BaseCommentModeFragmentDoc}
${QuillTemplateFieldsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentBrandingGQL extends Apollo.Query<CurrentBrandingQuery, CurrentBrandingQueryVariables> {
    document = CurrentBrandingDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CurrentZoneDocument = gql`
    query currentZone {
  currentZone {
    ...BaseZoneWithParent
    domain
  }
}
    ${BaseZoneWithParentFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CurrentZoneGQL extends Apollo.Query<CurrentZoneQuery, CurrentZoneQueryVariables> {
    document = CurrentZoneDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateReportDocument = gql`
    mutation createReport($waitForCompletion: Boolean, $input: CreateReportInput!) {
  createReport(waitForCompletion: $waitForCompletion, input: $input) {
    ...FullReport
  }
}
    ${FullReportFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateReportGQL extends Apollo.Mutation<CreateReportMutation, CreateReportMutationVariables> {
    document = CreateReportDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetReportDataDocument = gql`
    query getReportData($filter: ReportsFilter, $skip: Int, $limit: Int, $sort: String) {
  reports(
    filter: $filter
    skip: $skip
    limit: $limit
    sort: $sort
    getData: [json]
  ) {
    reports {
      ...BaseReport
      ...Report_Data
    }
  }
}
    ${BaseReportFragmentDoc}
${Report_DataFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetReportDataGQL extends Apollo.Query<GetReportDataQuery, GetReportDataQueryVariables> {
    document = GetReportDataDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RolesDocument = gql`
    query roles($search: RoleSearch) {
  roles(search: $search) {
    ...RoleWithZones
  }
}
    ${RoleWithZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RolesGQL extends Apollo.Query<RolesQuery, RolesQueryVariables> {
    document = RolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TawkToSecretDocument = gql`
    query TawkToSecret {
  tawkToSecret
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TawkToSecretGQL extends Apollo.Query<TawkToSecretQuery, TawkToSecretQueryVariables> {
    document = TawkToSecretDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const AssignRolesDocument = gql`
    mutation assignRoles($users: [String!]!, $roles: [String!]!, $inheritZones: Boolean, $unassignMissing: Boolean) {
  assignRoles(
    users: $users
    roles: $roles
    inheritZones: $inheritZones
    unassignMissing: $unassignMissing
  ) {
    usersAssigned
    rolesAssigned
    rolesRemoved
    zonesAssigned
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class AssignRolesGQL extends Apollo.Mutation<AssignRolesMutation, AssignRolesMutationVariables> {
    document = AssignRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateUserDocument = gql`
    mutation createUser($roles: [String!], $zones: [String!], $inheritRoleZones: Boolean, $sendInvite: Boolean, $users: [CreateUserInput!]) {
  createUsers(
    roles: $roles
    zones: $zones
    inheritRoleZones: $inheritRoleZones
    sendInvite: $sendInvite
    users: $users
  ) {
    total
    failedUsers {
      user {
        email
        __typename
      }
      error
      __typename
    }
    users {
      id
      email
      phone
      givenName
      familyName
      company
      roles {
        id
        name
        __typename
      }
      zones {
        nodes {
          id
          name
          __typename
        }
        __typename
      }
      __typename
    }
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateUserGQL extends Apollo.Mutation<CreateUserMutation, CreateUserMutationVariables> {
    document = CreateUserDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditProfileDocument = gql`
    mutation editProfile($id: String!, $givenName: String, $familyName: String, $phone: String, $email: String, $company: String, $billingAddress: LocationCreateBase, $salary: Int, $shiftAvailability: String, $zoneIds: [String!]) {
  users(filter: {userIds: [$id], showDeactivated: true}) {
    setProfile(
      givenName: $givenName
      familyName: $familyName
      phone: $phone
      email: $email
      company: $company
      billingAddress: $billingAddress
      salary: $salary
      shiftAvailability: $shiftAvailability
      zoneIds: $zoneIds
    )
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditProfileGQL extends Apollo.Mutation<EditProfileMutation, EditProfileMutationVariables> {
    document = EditProfileDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateYemboMoveDocument = gql`
    mutation createYemboMove($jobId: String!) {
  createYemboMove(jobId: $jobId) {
    customerLink
    employeeLink
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateYemboMoveGQL extends Apollo.Mutation<CreateYemboMoveMutation, CreateYemboMoveMutationVariables> {
    document = CreateYemboMoveDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateYemboSelfSurveyDocument = gql`
    mutation createYemboSelfSurvey($jobId: String!, $sendEmail: Boolean, $sendSms: Boolean) {
  createYemboSelfSurvey(jobId: $jobId, sendEmail: $sendEmail, sendSms: $sendSms) {
    link
    employeeLink
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateYemboSelfSurveyGQL extends Apollo.Mutation<CreateYemboSelfSurveyMutation, CreateYemboSelfSurveyMutationVariables> {
    document = CreateYemboSelfSurveyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListBaseZonesDocument = gql`
    query ListBaseZones($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int) {
  zones(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    total
    nodes {
      ...BaseZone
    }
  }
}
    ${BaseZoneFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListBaseZonesGQL extends Apollo.Query<ListBaseZonesQuery, ListBaseZonesQueryVariables> {
    document = ListBaseZonesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListZonesWithParentsDocument = gql`
    query ListZonesWithParents($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int) {
  zones(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    total
    nodes {
      ...BaseZoneWithParents
    }
  }
}
    ${BaseZoneWithParentsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListZonesWithParentsGQL extends Apollo.Query<ListZonesWithParentsQuery, ListZonesWithParentsQueryVariables> {
    document = ListZonesWithParentsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListZonesWithChildrenDocument = gql`
    query ListZonesWithChildren($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int) {
  zones(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    total
    nodes {
      ...BaseZoneWithChildren
    }
  }
}
    ${BaseZoneWithChildrenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListZonesWithChildrenGQL extends Apollo.Query<ListZonesWithChildrenQuery, ListZonesWithChildrenQueryVariables> {
    document = ListZonesWithChildrenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListZonesWithFamilyDocument = gql`
    query ListZonesWithFamily($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int) {
  zones(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    total
    nodes {
      ...BaseZoneWithFamily
    }
  }
}
    ${BaseZoneWithFamilyFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListZonesWithFamilyGQL extends Apollo.Query<ListZonesWithFamilyQuery, ListZonesWithFamilyQueryVariables> {
    document = ListZonesWithFamilyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListZonesWithAreasDocument = gql`
    query ListZonesWithAreas($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int, $deepResolveObjects: Boolean, $objectFilter: ListZonesObjectFilter) {
  zones(
    filter: $filter
    sort: $sort
    skip: $skip
    limit: $limit
    deepResolveObjects: $deepResolveObjects
    objectFilter: $objectFilter
  ) {
    total
    nodes {
      ...BaseZoneWithAreas
    }
  }
}
    ${BaseZoneWithAreasFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListZonesWithAreasGQL extends Apollo.Query<ListZonesWithAreasQuery, ListZonesWithAreasQueryVariables> {
    document = ListZonesWithAreasDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListZonesWithAreasAndChildrenDocument = gql`
    query ListZonesWithAreasAndChildren($filter: ListZonesFilter, $sort: String, $skip: Int, $limit: Int) {
  zones(filter: $filter, sort: $sort, skip: $skip, limit: $limit) {
    total
    nodes {
      ...BaseZoneWithAreasAndChildren
    }
  }
}
    ${BaseZoneWithAreasAndChildrenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListZonesWithAreasAndChildrenGQL extends Apollo.Query<ListZonesWithAreasAndChildrenQuery, ListZonesWithAreasAndChildrenQueryVariables> {
    document = ListZonesWithAreasAndChildrenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigValuesDocument = gql`
    query getConfigValues($omitZone: Boolean, $keys: [String]) {
  getConfigValues(omitZone: $omitZone, keys: $keys) {
    id
    key
    zone
    value
    fallback {
      key
      zone
      value
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigValuesGQL extends Apollo.Query<GetConfigValuesQuery, GetConfigValuesQueryVariables> {
    document = GetConfigValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetConfigValuesWithOverridingConfigsDocument = gql`
    query getConfigValuesWithOverridingConfigs($omitZone: Boolean, $keys: [String]) {
  getConfigValues(omitZone: $omitZone, keys: $keys) {
    ...ConfigValueWithOverridingConfigs
  }
}
    ${ConfigValueWithOverridingConfigsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetConfigValuesWithOverridingConfigsGQL extends Apollo.Query<GetConfigValuesWithOverridingConfigsQuery, GetConfigValuesWithOverridingConfigsQueryVariables> {
    document = GetConfigValuesWithOverridingConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const SetConfigValuesDocument = gql`
    mutation setConfigValues($omitZone: Boolean, $configs: [ConfigValueInput!]!) {
  setConfigValues(omitZone: $omitZone, configs: $configs) {
    key
    zone
    value
    fallback {
      key
      zone
      value
      createdAt
      updatedAt
    }
    createdAt
    updatedAt
    __typename
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class SetConfigValuesGQL extends Apollo.Mutation<SetConfigValuesMutation, SetConfigValuesMutationVariables> {
    document = SetConfigValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ClearConfigValuesDocument = gql`
    mutation ClearConfigValues($keys: [String!]) {
  clearConfigValues(keys: $keys)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ClearConfigValuesGQL extends Apollo.Mutation<ClearConfigValuesMutation, ClearConfigValuesMutationVariables> {
    document = ClearConfigValuesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetQuickBooksConfigDocument = gql`
    query GetQuickBooksConfig($keys: [ZoneConfigKey!]!) {
  getZoneConfigValues(keys: $keys) {
    ...QuickBooksConfigValues
  }
}
    ${QuickBooksConfigValuesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetQuickBooksConfigGQL extends Apollo.Query<GetQuickBooksConfigQuery, GetQuickBooksConfigQueryVariables> {
    document = GetQuickBooksConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetEstimatorRestrictionCodeConfigDocument = gql`
    query GetEstimatorRestrictionCodeConfig($keys: [ZoneConfigKey!]!) {
  getZoneConfigValues(keys: $keys) {
    ESTIMATOR_RESTRICTIONCODE
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GetEstimatorRestrictionCodeConfigGQL extends Apollo.Query<GetEstimatorRestrictionCodeConfigQuery, GetEstimatorRestrictionCodeConfigQueryVariables> {
    document = GetEstimatorRestrictionCodeConfigDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetRollingLockDateConfigsDocument = gql`
    query GetRollingLockDateConfigs($keys: [ZoneConfigKey!]!, $getOverridingConfigs: Boolean = true) {
  getZoneConfigs(keys: $keys, getOverridingConfigs: $getOverridingConfigs) {
    ROLLING__LOCK__DATE_CURRENTDATE {
      ...ZoneConfigValueFloat
    }
    ROLLING__LOCK__DATE_CONTACTACCOUNTINGBUTTONTEXT {
      ...ZoneConfigString
    }
    ROLLING__LOCK__DATE_SUPPORTEMAIL {
      ...ZoneConfigString
    }
    ROLLING__LOCK__DATE_EMAILSUBJECT {
      ...ZoneConfigString
    }
    ROLLING__LOCK__DATE_EMAILBODYPREFIX {
      ...ZoneConfigString
    }
    ROLLING__LOCK__DATE_EMAILBODYSUFFIX {
      ...ZoneConfigString
    }
    ROLLING__LOCK__DATE_EVENTLOCKEDWARNING {
      ...ZoneConfigString
    }
  }
}
    ${ZoneConfigValueFloatFragmentDoc}
${ZoneConfigStringFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetRollingLockDateConfigsGQL extends Apollo.Query<GetRollingLockDateConfigsQuery, GetRollingLockDateConfigsQueryVariables> {
    document = GetRollingLockDateConfigsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GetJobLocationsDocument = gql`
    query getJobLocations($filter: JobsFilter) {
  jobs(filter: $filter, resolve: ["locations"]) {
    jobs {
      ...Job_Locations
    }
  }
}
    ${Job_LocationsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class GetJobLocationsGQL extends Apollo.Query<GetJobLocationsQuery, GetJobLocationsQueryVariables> {
    document = GetJobLocationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateChargesDocument = gql`
    mutation createCharges($charges: [CreateChargeInput!]!, $userId: String!) {
  createCharges(charges: $charges, userId: $userId) {
    ...BaseCharge
  }
}
    ${BaseChargeFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateChargesGQL extends Apollo.Mutation<CreateChargesMutation, CreateChargesMutationVariables> {
    document = CreateChargesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateIcalTokenDocument = gql`
    mutation createIcalToken($name: String!, $assetIds: [String!], $eventTypes: [String!]) {
  createIcalToken(name: $name, assetIds: $assetIds, eventTypes: $eventTypes) {
    ...BaseToken
  }
}
    ${BaseTokenFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateIcalTokenGQL extends Apollo.Mutation<CreateIcalTokenMutation, CreateIcalTokenMutationVariables> {
    document = CreateIcalTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditUserPasswordDocument = gql`
    mutation EditUserPassword($id: String!, $password: String!) {
  editUserPassword(id: $id, password: $password)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditUserPasswordGQL extends Apollo.Mutation<EditUserPasswordMutation, EditUserPasswordMutationVariables> {
    document = EditUserPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteUsersDocument = gql`
    mutation DeleteUsers($userIds: [String!]!, $hardDelete: Boolean) {
  deleteUsers(userIds: $userIds, hardDelete: $hardDelete)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteUsersGQL extends Apollo.Mutation<DeleteUsersMutation, DeleteUsersMutationVariables> {
    document = DeleteUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransactionsDocument = gql`
    query transactions($filter: TransactionsFilter, $skip: Int, $limit: Int, $sort: String) {
  transactions(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    transactions {
      ...FullTransaction
    }
    total
    skipped
    limited
  }
}
    ${FullTransactionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TransactionsGQL extends Apollo.Query<TransactionsQuery, TransactionsQueryVariables> {
    document = TransactionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransactionsWithoutTotalDocument = gql`
    query transactionsWithoutTotal($filter: TransactionsFilter, $skip: Int, $limit: Int, $sort: String) {
  transactions(filter: $filter, skip: $skip, limit: $limit, sort: $sort) {
    transactions {
      ...FullTransaction
    }
    skipped
    limited
  }
}
    ${FullTransactionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TransactionsWithoutTotalGQL extends Apollo.Query<TransactionsWithoutTotalQuery, TransactionsWithoutTotalQueryVariables> {
    document = TransactionsWithoutTotalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const TransactionsAvailableForInvoiceDocument = gql`
    query transactionsAvailableForInvoice($invoiceId: String!, $invoiceJobId: String!) {
  transactions(filter: {jobId: $invoiceJobId}, limit: -1) {
    transactions {
      ...FullTransaction
    }
  }
  invoices(filter: {ids: [$invoiceId]}, limit: 1) {
    invoices {
      ...BaseInvoice
    }
  }
}
    ${FullTransactionFragmentDoc}
${BaseInvoiceFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class TransactionsAvailableForInvoiceGQL extends Apollo.Query<TransactionsAvailableForInvoiceQuery, TransactionsAvailableForInvoiceQueryVariables> {
    document = TransactionsAvailableForInvoiceDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateTransactionDocument = gql`
    mutation createTransaction($amount: Int!, $customerId: String!, $jobId: String!, $invoiceId: String, $type: TransactionType!, $paymentTypeId: String!, $stage: TransactionStage, $metadata: Metadata, $disableSendReceipt: Boolean) {
  createTransaction(
    amount: $amount
    customerId: $customerId
    jobId: $jobId
    invoiceId: $invoiceId
    type: $type
    paymentTypeId: $paymentTypeId
    stage: $stage
    metadata: $metadata
    disableSendReceipt: $disableSendReceipt
  ) {
    transaction {
      ...FullTransaction
    }
    client_secret
  }
}
    ${FullTransactionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateTransactionGQL extends Apollo.Mutation<CreateTransactionMutation, CreateTransactionMutationVariables> {
    document = CreateTransactionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateTransactionDocument = gql`
    mutation updateTransaction($transactionId: String!, $stage: TransactionStage, $disableSendReceipt: Boolean, $metadata: Metadata, $invoiceId: String) {
  updateTransaction(
    transactionId: $transactionId
    stage: $stage
    disableSendReceipt: $disableSendReceipt
    metadata: $metadata
    invoiceId: $invoiceId
  ) {
    ...FullTransaction
  }
}
    ${FullTransactionFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateTransactionGQL extends Apollo.Mutation<UpdateTransactionMutation, UpdateTransactionMutationVariables> {
    document = UpdateTransactionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const DeleteTransactionByIdDocument = gql`
    mutation deleteTransactionById($transactionId: String!) {
  deleteTransactions(ids: [$transactionId])
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DeleteTransactionByIdGQL extends Apollo.Mutation<DeleteTransactionByIdMutation, DeleteTransactionByIdMutationVariables> {
    document = DeleteTransactionByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPageUsersDocument = gql`
    query userPageUsers($filter: UserSearch, $limit: Int, $skip: Int, $sort: String) {
  usersv2(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    skipped
    limited
    users {
      ...FullUser
    }
  }
}
    ${FullUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPageUsersGQL extends Apollo.Query<UserPageUsersQuery, UserPageUsersQueryVariables> {
    document = UserPageUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserPageCountDocument = gql`
    query userPageCount($filter: UserSearch, $limit: Int, $skip: Int, $sort: String) {
  usersv2(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    total
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UserPageCountGQL extends Apollo.Query<UserPageCountQuery, UserPageCountQueryVariables> {
    document = UserPageCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListUsersDocument = gql`
    query listUsers($filter: UserSearch, $limit: Int, $skip: Int, $sort: String) {
  usersv2(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    total
    skipped
    limited
    users {
      ...FullUser
    }
  }
}
    ${FullUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListUsersGQL extends Apollo.Query<ListUsersQuery, ListUsersQueryVariables> {
    document = ListUsersDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListFullUsersWithoutCountDocument = gql`
    query listFullUsersWithoutCount($filter: UserSearch, $limit: Int, $skip: Int, $sort: String) {
  usersv2(filter: $filter, limit: $limit, skip: $skip, sort: $sort) {
    users {
      ...FullUser
    }
  }
}
    ${FullUserFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListFullUsersWithoutCountGQL extends Apollo.Query<ListFullUsersWithoutCountQuery, ListFullUsersWithoutCountQueryVariables> {
    document = ListFullUsersWithoutCountDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserFullNotificationsDocument = gql`
    query userFullNotifications($userId: String!, $limit: Int, $skip: Int, $filter: NotificationsFilter) {
  usersv2(filter: {userIds: [$userId]}, limit: 1) {
    users {
      notifications(limit: $limit, skip: $skip, filter: $filter) {
        total
        skipped
        limited
        notifications {
          ...FullNotification
        }
      }
    }
  }
}
    ${FullNotificationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserFullNotificationsGQL extends Apollo.Query<UserFullNotificationsQuery, UserFullNotificationsQueryVariables> {
    document = UserFullNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LatestAndUnreadNotificationsDocument = gql`
    query latestAndUnreadNotifications($userId: String!, $latestLimit: Int, $unreadLimit: Int) {
  usersv2(filter: {userIds: [$userId]}, limit: 1) {
    users {
      latest: notifications(limit: $latestLimit) {
        notifications {
          ...FullNotification
        }
      }
      unread: notifications(limit: $unreadLimit, filter: {hasBeenRead: false}) {
        total
      }
    }
  }
}
    ${FullNotificationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LatestAndUnreadNotificationsGQL extends Apollo.Query<LatestAndUnreadNotificationsQuery, LatestAndUnreadNotificationsQueryVariables> {
    document = LatestAndUnreadNotificationsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserNotificationByIdDocument = gql`
    query UserNotificationById($userId: String!, $notificationId: String!) {
  usersv2(filter: {userIds: [$userId]}, limit: 1) {
    users {
      notifications(setRead: true, filter: {notificationIds: [$notificationId]}) {
        notifications {
          ...FullNotification
        }
      }
    }
  }
}
    ${FullNotificationFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserNotificationByIdGQL extends Apollo.Query<UserNotificationByIdQuery, UserNotificationByIdQueryVariables> {
    document = UserNotificationByIdDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ListRolesDocument = gql`
    query ListRoles($search: RoleSearch) {
  roles(search: $search) {
    ...RoleWithZones
  }
}
    ${RoleWithZonesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ListRolesGQL extends Apollo.Query<ListRolesQuery, ListRolesQueryVariables> {
    document = ListRolesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const EditCalendarEventDocument = gql`
    mutation EditCalendarEvent($edit: editCalendarEventInput!, $ids: [String!], $assocIds: [String!], $disablePropogation: Boolean, $notifyAttendees: Boolean, $notifyDispatch: Boolean) {
  editCalendarEvent(
    edit: $edit
    ids: $ids
    assocIds: $assocIds
    disablePropogation: $disablePropogation
    notifyAttendees: $notifyAttendees
    notifyDispatch: $notifyDispatch
  )
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class EditCalendarEventGQL extends Apollo.Mutation<EditCalendarEventMutation, EditCalendarEventMutationVariables> {
    document = EditCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveCalendarEventDocument = gql`
    mutation removeCalendarEvent($ids: [String!]!) {
  removeCalendarEvent(ids: $ids)
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveCalendarEventGQL extends Apollo.Mutation<RemoveCalendarEventMutation, RemoveCalendarEventMutationVariables> {
    document = RemoveCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkEditCalendarEventDocument = gql`
    mutation BulkEditCalendarEvent($edits: [SingleEditInput!]!, $restrictionsEnabled: Boolean) {
  bulkEditCalendarEvent(edits: $edits, restrictionsEnabled: $restrictionsEnabled) {
    total
    events {
      ...BaseCalendarEvent
      sequentialOrder
      discountTotal
      taxTotal
      discountedSubTotal
      discountedSubTotalWithoutDamages
      subTotal
      damageTotal
    }
  }
}
    ${BaseCalendarEventFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkEditCalendarEventGQL extends Apollo.Mutation<BulkEditCalendarEventMutation, BulkEditCalendarEventMutationVariables> {
    document = BulkEditCalendarEventDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const BulkEditCalendarEventOnScheduleDocument = gql`
    mutation BulkEditCalendarEventOnSchedule($edits: [SingleEditInput!]!) {
  bulkEditCalendarEvent(edits: $edits) {
    total
    events {
      ...CalendarEventForSchedule
    }
  }
}
    ${CalendarEventForScheduleFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class BulkEditCalendarEventOnScheduleGQL extends Apollo.Mutation<BulkEditCalendarEventOnScheduleMutation, BulkEditCalendarEventOnScheduleMutationVariables> {
    document = BulkEditCalendarEventOnScheduleDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }